/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Api
 * Plate OS - Advanced Nutrition Intelligence Platform API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptLegalBody,
  AccountExportJob,
  AccountExportLatestResponse,
  AcquisitionAffiliate,
  AcquisitionAffiliateInput,
  AcquisitionAffiliates,
  AcquisitionAssessment,
  AcquisitionAssessmentInput,
  AcquisitionClaimInput,
  AcquisitionConsent,
  AcquisitionConsentInput,
  AcquisitionCostInput,
  AcquisitionCostResult,
  AcquisitionEventInput,
  AcquisitionLeadInput,
  AcquisitionMaps,
  AcquisitionMapsExport,
  AcquisitionOk,
  AcquisitionPreview,
  AcquisitionReport,
  AcquisitionSynthetic,
  AcquisitionTouchInput,
  AcquisitionWithdrawalInput,
  ActiveGoalRouteResponse,
  AdminBillingSubscriptionPage,
  AdminHealthReportRetentionPolicy,
  AdminHealthReportRetentionPolicyInput,
  AdminMemberBilling,
  AdminNotificationCheck,
  AdminNotificationCheckInput,
  AdminNotificationHealth,
  AdminSecurityReadiness,
  AgeIneligibilityInput,
  AssignGeneticReviewWork200,
  AudienceCampaignConfirmation,
  AudienceCampaignDetail,
  AudienceCampaignDraftInput,
  AudienceCampaignList,
  AudienceCampaignPreview,
  AudienceCampaignPreviewInput,
  AudienceCampaignResponse,
  AudienceCampaignRetryResponse,
  AudienceCampaignSendInput,
  AuthResponse,
  BarcodeLookupBody,
  BarcodeLookupResponse,
  BatchLogsResponse,
  BillingAlertCoordination,
  BillingAlertDelivery,
  BillingCancellationPreview,
  BillingCancellationPreviewInput,
  BillingOperation,
  BillingOperationInput,
  BillingOperationRetryInput,
  BillingReadiness,
  BillingRefundPreview,
  BillingRefundPreviewInput,
  BillingSyncHealth,
  BillingUrl,
  BloodLabDeleteResult,
  BloodLabExtractBody,
  BloodLabExtractPendingResult,
  BloodLabExtractResult,
  BloodLabExtractionCompletedResult,
  BloodLabExtractionStatusResult,
  BloodLabImportBody,
  BloodLabSaveBody,
  BloodLabSaveResult,
  BloodLabView,
  BulkLogUpdateInput,
  BulkUpdateNutritionLogs200,
  CameraIdentifyBody,
  CameraIdentifyResponse,
  CancelBackendOptimizerRun401,
  CancelBackendOptimizerRun403,
  CancelBackendOptimizerRun409,
  CancelBackendOptimizerRun503,
  CoachAccessStatus,
  CoachAiCompletionCreated,
  CoachAiCompletionHistory,
  CoachAiCompletionsToday,
  CoachAiRecommendationsResponse,
  CoachAiUndoResult,
  CoachAlternativeInput,
  CoachAlternativeResult,
  CoachAssignmentMutation,
  CoachAssignmentQuote,
  CoachAssignmentTarget,
  CoachDashboard,
  CoachDismissals,
  CoachManagedUsers,
  CoachPreferenceInput,
  CoachPreferenceState,
  CoachRemoveManagedUserBody,
  CompanionCatalog,
  CompanionCommandInput,
  CompanionExplanation,
  CompareGeneticCatalogCandidatesParams,
  CompleteGmailConnectParams,
  ConfirmLogBody,
  ConfirmLogResponse,
  ConfirmWellnessDocumentFactsBody,
  ContentFeedItem,
  CopyLogsInput,
  CopyNutritionLogs201,
  CreateBackendOptimizerSnapshot201,
  CreateBackendOptimizerSnapshot400,
  CreateBackendOptimizerSnapshot401,
  CreateBackendOptimizerSnapshot403,
  CreateBackendOptimizerSnapshot409,
  CreateBackendOptimizerSnapshot503,
  CreateBatchLogs400,
  CreateBatchLogsBody,
  CreateCoachAiCompletionBody,
  CreateEvidenceBody,
  CreateFoodBody,
  CreateGoalRouteRequest,
  CreateGoalRouteResponse,
  CreateLogBody,
  CreateTimelapseRequest,
  CreateTimelapseResponse,
  CrmAssignmentInput,
  CrmAssignmentResult,
  CrmDefinitionInput,
  CrmDefinitionResponse,
  CrmDefinitionUpdate,
  CrmDefinitionsResponse,
  CrmMemberAssignmentsResponse,
  CrmPermission,
  CrmPermissionInput,
  CrmSavedAudienceInput,
  CrmSavedAudienceResponse,
  CrmSavedAudienceUpdate,
  CrmSavedAudiencesResponse,
  CrmStatus,
  CrmSyncInput,
  CrmSyncResult,
  DashboardKpis,
  DecideWellnessSuggestionBody,
  DeepCommandAiAnalysisRequest,
  DeepCommandAiAnalysisStatus,
  DeepCommandAiPreferenceRequest,
  DeepCommandAiPreferenceResponse,
  DeepCommandMethodologyResponse,
  DelegatedSession,
  DelegatedSessionHistoryPage,
  DelegatedSessionInput,
  DelegatedSessionState,
  DeleteAccountBody,
  DeletePlate200,
  DeletePlateParams,
  DisconnectGlucoseParams,
  DisconnectGlucoseResponse,
  DiscoveryInput,
  DiscoveryJob,
  DiscoveryResearch,
  DiscoveryResearchImport,
  DiscoveryReviewInput,
  DiscoveryWithdrawalInput,
  DismissCoachSignalBody,
  DnaDeepCommandMatrix,
  DnaReportCatalog,
  DnaReportCheckoutInput,
  DnaReportCheckoutResult,
  DnaReportContent,
  ErrorResponse,
  Evidence,
  EvidenceListResponse,
  ExportAcquisitionPublicReportParams,
  ExportDelegatedSessionHistoryParams,
  Food,
  FoodCorrectionInput,
  FoodIdentityInput,
  FoodLog,
  FoodLogListResponse,
  FoodSearchResponse,
  ForecastResult,
  ForgotPasswordBody,
  ForgotPasswordResponse,
  GeneticCatalogComparison,
  GeneticCatalogList,
  GeneticConsentBody,
  GeneticConsentStatus,
  GeneticDeleteBody,
  GeneticDeleteResult,
  GeneticIngestResult,
  GeneticKnowledgeDecisionInput,
  GeneticQuestionnaireBody,
  GeneticReviewAssignmentInput,
  GeneticReviewNotificationReadInput,
  GeneticReviewWork,
  GeneticUploadBody,
  GeneticUploadResult,
  GeneticView,
  GetAcquisitionReportParams,
  GetAdminMemberBillingParams,
  GetBackendOptimizer401,
  GetBackendOptimizer403,
  GetBackendOptimizer503,
  GetBackendOptimizerManifest401,
  GetBackendOptimizerManifest403,
  GetBackendOptimizerRun401,
  GetBackendOptimizerRun403,
  GetBackendOptimizerRun404,
  GetBackendOptimizerRun503,
  GetBloodLabsParams,
  GetCoachAiCompletionHistoryParams,
  GetCoachAiRecommendationsBody,
  GetDashboardKpisParams,
  GetDeepCommandAiAnalysisParams,
  GetDelegatedSessionHistoryParams,
  GetDnaDeepCommandMatrixParams,
  GetForecastParams,
  GetGlucoseMealResponseParams,
  GetGlucoseReadingsParams,
  GetGmailThreadsParams,
  GetGroupHealthParams,
  GetHealthDocumentFileParams,
  GetMealReadRevision200,
  GetMemberBillingParams,
  GetMetricsPlateParams,
  GetMicrobiomeCategoryParams,
  GetMicrobiomeSummaryParams,
  GetNutrientGoalScoreParams,
  GetNutritionProgressParams,
  GetNutritionReportParams,
  GetSnapshotRangeParams,
  GetStatusDistributionParams,
  GetTemporaryProRolloutParams,
  GetWomensHealthReferenceTemplateParams,
  GetWomensHealthReferences200,
  GlossaryTerm,
  GlucoseMealResponse,
  GlucoseReadingsResponse,
  GmailConnectInput,
  GmailConnectResult,
  GmailDisconnectResult,
  GmailLabelMappingsInput,
  GmailLabelMappingsResponse,
  GmailLabelsResponse,
  GmailLabelsUpdated,
  GmailMailboxBudgetPause,
  GmailOverview,
  GmailReplyInput,
  GmailReplyRecoveryInput,
  GmailReplyRecoveryResult,
  GmailReplyResolutionInput,
  GmailReplyResult,
  GmailSyncResult,
  GmailThreadLabelsInput,
  GmailThreadResponse,
  GmailThreadsResponse,
  GmailWorkspaceConnectionResult,
  GroceryList,
  GroceryListDetail,
  GroupHealth,
  HealthDocument,
  HealthDocumentClassificationConsent,
  HealthDocumentDeleteResult,
  HealthDocumentList,
  HealthDocumentUpdate,
  HealthDocumentUpload,
  HealthSnapshotDetail,
  HealthSnapshotDownload,
  HealthSnapshotList,
  HealthStatus,
  ImportBackendOptimizerMeasurement400,
  ImportBackendOptimizerMeasurement401,
  ImportBackendOptimizerMeasurement403,
  ImportBackendOptimizerMeasurement404,
  ImportBackendOptimizerMeasurement409,
  ImportBackendOptimizerMeasurement503,
  ImportGlucoseBody,
  ImportGlucoseResponse,
  ImportNutritionLogs201,
  IntelligenceContext,
  Intervention,
  InterventionActionInput,
  InterventionAdherenceInput,
  InterventionAdherenceObservation,
  InterventionCohortOutcome,
  InterventionContextInput,
  InterventionEvent,
  InterventionLearningConsent,
  InterventionLearningConsentInput,
  InterventionOutcomeAnalysis,
  InterventionOutcomeInput,
  InterventionRecommendationInput,
  InterventionTimelineEntry,
  LatestGlucoseResponse,
  LegalAcceptanceList,
  ListAudienceCampaignsParams,
  ListContentFeedParams,
  ListCrmDefinitionsParams,
  ListEvidenceParams,
  ListFoodsParams,
  ListGlossaryTermsParams,
  ListHealthDocumentsParams,
  ListLogsParams,
  ListMetricsParams,
  ListProgressPhotosParams,
  ListRecentLogsParams,
  ListSnapCorrections200,
  LogRecipe201,
  LogReusableMeal201,
  LoginUserBody,
  MarketingPreference,
  MarketingPreferences,
  MarketingPreferencesInput,
  MemberBilling,
  MemberIntakeStart,
  MemberIntakeStatus,
  MessageResponse,
  Metric,
  MetricsPlateResponse,
  MicrobiomeCategoryDetail,
  MicrobiomeSummary,
  MobileHandoffApproval,
  MobileHandoffCode,
  MobileHandoffRedemption,
  MobileHandoffTicket,
  NrsCurrent,
  NutrientGoalScoreResponse,
  NutritionContextOptIn,
  NutritionImportInput,
  NutritionLogInput,
  NutritionProgress,
  NutritionRecoveryContext,
  NutritionReport,
  NutritionTarget,
  NutritionTargetInput,
  OnboardingStatus,
  OptimizerAcknowledgement,
  OptimizerControlsPatch,
  OptimizerDocument,
  OptimizerFeedbackRequest,
  OptimizerMeasurementProof,
  OptimizerOverview,
  OptimizerRunDetail,
  OptimizerRunRequest,
  OptimizerSnapshot,
  PaidSubscriptionVerification,
  PaidSubscriptionVerificationInput,
  PersonalizationCore,
  PlanWorkflowEnvelope,
  PlanWorkflowMutation,
  PlanWorkflowPreview,
  PlanWorkflowPreviewInput,
  PlateTalkChatBody,
  PlateTalkChatResponse,
  ProgressPhoto,
  ProgressPhotoListResponse,
  ProgressPhotoUpdate,
  ProgressVideoListResponse,
  ProgressVideoStatusResponse,
  PushCanaryOpenRequest,
  PushCanaryRegistrationRequest,
  PushCanaryRegistrationResponse,
  PushCanaryStatusResponse,
  PushHistoryResponse,
  PushPreferencesResponse,
  PushSettingsResponse,
  PushSettingsUpdateResponse,
  QuickLogBody,
  QuickLogResponse,
  ReadGeneticReviewNotification200,
  ReceiptScanBody,
  ReceiptScanResponse,
  RecentLogItem,
  Recipe,
  RecipeInput,
  RecipeShare,
  RecipeShareInput,
  ReconcileFoodIdentity200,
  RecordGeneticKnowledgeDecision201,
  RegisterPushTokenRequest,
  RegisterUserBody,
  ResetPasswordBody,
  ResolveGmailThreadReply200,
  ReusableMeal,
  ReusableMealInput,
  ReviewBackendOptimizerRun400,
  ReviewBackendOptimizerRun401,
  ReviewBackendOptimizerRun403,
  ReviewBackendOptimizerRun404,
  ReviewBackendOptimizerRun409,
  ReviewBackendOptimizerRun503,
  ReviewerQualificationChange,
  ReviewerQualificationEvent,
  ReviewerQualificationRoster,
  SearchAdminBillingSubscriptionsParams,
  SearchDelegationSubjects200Item,
  SearchDelegationSubjectsParams,
  SearchFoodsParams,
  SendTestPushRequest,
  SendTestPushResponse,
  SmartSwapDashboard,
  SnapCorrectionBody,
  SnapCorrectionResponse,
  SnapPlateStreamBody,
  Snapshot,
  SnapshotRange,
  StaffWelcomeEvidenceInput,
  StaffWelcomeReconciliation,
  StartBackendOptimizerRun202,
  StartBackendOptimizerRun400,
  StartBackendOptimizerRun401,
  StartBackendOptimizerRun403,
  StartBackendOptimizerRun404,
  StartBackendOptimizerRun409,
  StartBackendOptimizerRun429,
  StartBackendOptimizerRun503,
  StatusCount,
  SuccessResponse,
  TemporaryProAllowlist,
  TemporaryProAmendmentInput,
  TemporaryProAmendmentPreview,
  TemporaryProApplyResult,
  TemporaryProApprovalInput,
  TemporaryProError,
  TemporaryProPreview,
  TemporaryProResumePreview,
  TemporaryProStatus,
  TemporaryProSummary,
  TestPushDeliveryResponse,
  UnregisterPushTokenRequest,
  UpdateBackendOptimizer400,
  UpdateBackendOptimizer401,
  UpdateBackendOptimizer403,
  UpdateBackendOptimizer409,
  UpdateBackendOptimizer503,
  UpdateFoodBody,
  UpdateGoalRouteRequest,
  UpdateGoalRouteResponse,
  UpdateLogBody,
  UpdatePushPreferencesRequest,
  UpdatePushSettingsRequest,
  UpdateUserBody,
  UpdateVoiceControlsBody,
  UploadProgressPhotoRequest,
  UploadProgressPhotoResponse,
  User,
  VoiceHealth,
  VoiceProposal,
  VoiceSession,
  VoiceSessionState,
  WearablesConnectInput,
  WearablesConnectResult,
  WearablesDisconnectResult,
  WearablesProviders,
  WearablesRefreshStatusResult,
  WearablesStatus,
  WearablesSummary,
  WellnessControls,
  WellnessView,
  WomensHealthCommand,
  WomensHealthReferenceInput,
  WomensHealthReferenceStage,
  WomensHealthView,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetCompanionCatalogUrl = () => {
  return `/api/companion/catalog`;
};

/**
 * @summary Public app guides and member navigation commands
 */
export const getCompanionCatalog = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CompanionCatalog> => {
  return customFetch<CompanionCatalog>(getGetCompanionCatalogUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCompanionCatalogQueryKey = () => {
  return [`/api/companion/catalog`] as const;
};

export const getGetCompanionCatalogQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompanionCatalog>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCompanionCatalog>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCompanionCatalogQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCompanionCatalog>>
  > = ({ signal }) => getCompanionCatalog({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCompanionCatalog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCompanionCatalogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompanionCatalog>>
>;
export type GetCompanionCatalogQueryError = ErrorType<unknown>;

/**
 * @summary Public app guides and member navigation commands
 */

export function useGetCompanionCatalog<
  TData = Awaited<ReturnType<typeof getCompanionCatalog>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCompanionCatalog>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCompanionCatalogQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getExplainCompanionCommandUrl = () => {
  return `/api/companion/explain`;
};

/**
 * @summary Explain one allowlisted app command with Grok
 */
export const explainCompanionCommand = async (
  companionCommandInput: CompanionCommandInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<CompanionExplanation> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CompanionExplanation>(getExplainCompanionCommandUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(companionCommandInput),
  });
};

export const getExplainCompanionCommandMutationKey = () =>
  ["explainCompanionCommand"] as const;

export const getExplainCompanionCommandMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof explainCompanionCommand>>,
    TError,
    ExplainCompanionCommandMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof explainCompanionCommand>>,
  TError,
  ExplainCompanionCommandMutationVariables,
  TContext
> => {
  const mutationKey = getExplainCompanionCommandMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof explainCompanionCommand>>,
    ExplainCompanionCommandMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return explainCompanionCommand(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExplainCompanionCommandMutationResult = NonNullable<
  Awaited<ReturnType<typeof explainCompanionCommand>>
>;
export type ExplainCompanionCommandMutationBody =
  BodyType<CompanionCommandInput>;
export type ExplainCompanionCommandMutationError = ErrorType<void>;
export type ExplainCompanionCommandMutationVariables = {
  data: BodyType<CompanionCommandInput>;
};

/**
 * @summary Explain one allowlisted app command with Grok
 */
export const useExplainCompanionCommand = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof explainCompanionCommand>>,
    TError,
    ExplainCompanionCommandMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof explainCompanionCommand>>,
  TError,
  ExplainCompanionCommandMutationVariables,
  TContext
> => {
  return useMutation(getExplainCompanionCommandMutationOptions(options));
};

export const getGetBackendOptimizerUrl = () => {
  return `/api/admin/agents/optimizer`;
};

/**
 * @summary Shared optimizer controls, UTC budget and bounded history
 */
export const getBackendOptimizer = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<OptimizerOverview> => {
  return customFetch<OptimizerOverview>(getGetBackendOptimizerUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBackendOptimizerQueryKey = () => {
  return [`/api/admin/agents/optimizer`] as const;
};

export const getGetBackendOptimizerQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackendOptimizer>>,
  TError = ErrorType<
    GetBackendOptimizer401 | GetBackendOptimizer403 | GetBackendOptimizer503
  >,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackendOptimizer>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBackendOptimizerQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackendOptimizer>>
  > = ({ signal }) => getBackendOptimizer({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBackendOptimizer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBackendOptimizerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackendOptimizer>>
>;
export type GetBackendOptimizerQueryError = ErrorType<
  GetBackendOptimizer401 | GetBackendOptimizer403 | GetBackendOptimizer503
>;

/**
 * @summary Shared optimizer controls, UTC budget and bounded history
 */

export function useGetBackendOptimizer<
  TData = Awaited<ReturnType<typeof getBackendOptimizer>>,
  TError = ErrorType<
    GetBackendOptimizer401 | GetBackendOptimizer403 | GetBackendOptimizer503
  >,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackendOptimizer>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBackendOptimizerQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateBackendOptimizerUrl = () => {
  return `/api/admin/agents/optimizer`;
};

/**
 * @summary Review cap, pricing, cadence, pause and kill switch controls
 */
export const updateBackendOptimizer = async (
  optimizerControlsPatch: OptimizerControlsPatch,
  options?: Parameters<typeof customFetch>[1],
): Promise<OptimizerOverview> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<OptimizerOverview>(getUpdateBackendOptimizerUrl(), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(optimizerControlsPatch),
  });
};

export const getUpdateBackendOptimizerMutationKey = () =>
  ["updateBackendOptimizer"] as const;

export const getUpdateBackendOptimizerMutationOptions = <
  TError = ErrorType<
    | UpdateBackendOptimizer400
    | UpdateBackendOptimizer401
    | UpdateBackendOptimizer403
    | UpdateBackendOptimizer409
    | UpdateBackendOptimizer503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBackendOptimizer>>,
    TError,
    UpdateBackendOptimizerMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBackendOptimizer>>,
  TError,
  UpdateBackendOptimizerMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateBackendOptimizerMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBackendOptimizer>>,
    UpdateBackendOptimizerMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateBackendOptimizer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBackendOptimizerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBackendOptimizer>>
>;
export type UpdateBackendOptimizerMutationBody =
  BodyType<OptimizerControlsPatch>;
export type UpdateBackendOptimizerMutationError = ErrorType<
  | UpdateBackendOptimizer400
  | UpdateBackendOptimizer401
  | UpdateBackendOptimizer403
  | UpdateBackendOptimizer409
  | UpdateBackendOptimizer503
>;
export type UpdateBackendOptimizerMutationVariables = {
  data: BodyType<OptimizerControlsPatch>;
};

/**
 * @summary Review cap, pricing, cadence, pause and kill switch controls
 */
export const useUpdateBackendOptimizer = <
  TError = ErrorType<
    | UpdateBackendOptimizer400
    | UpdateBackendOptimizer401
    | UpdateBackendOptimizer403
    | UpdateBackendOptimizer409
    | UpdateBackendOptimizer503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBackendOptimizer>>,
    TError,
    UpdateBackendOptimizerMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateBackendOptimizer>>,
  TError,
  UpdateBackendOptimizerMutationVariables,
  TContext
> => {
  return useMutation(getUpdateBackendOptimizerMutationOptions(options));
};

export const getGetBackendOptimizerManifestUrl = () => {
  return `/api/admin/agents/optimizer/manifest`;
};

/**
 * @summary Value-free versioned schema and access allowlist
 */
export const getBackendOptimizerManifest = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<OptimizerDocument> => {
  return customFetch<OptimizerDocument>(getGetBackendOptimizerManifestUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBackendOptimizerManifestQueryKey = () => {
  return [`/api/admin/agents/optimizer/manifest`] as const;
};

export const getGetBackendOptimizerManifestQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackendOptimizerManifest>>,
  TError = ErrorType<
    GetBackendOptimizerManifest401 | GetBackendOptimizerManifest403
  >,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackendOptimizerManifest>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackendOptimizerManifestQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackendOptimizerManifest>>
  > = ({ signal }) =>
    getBackendOptimizerManifest({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBackendOptimizerManifest>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBackendOptimizerManifestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackendOptimizerManifest>>
>;
export type GetBackendOptimizerManifestQueryError = ErrorType<
  GetBackendOptimizerManifest401 | GetBackendOptimizerManifest403
>;

/**
 * @summary Value-free versioned schema and access allowlist
 */

export function useGetBackendOptimizerManifest<
  TData = Awaited<ReturnType<typeof getBackendOptimizerManifest>>,
  TError = ErrorType<
    GetBackendOptimizerManifest401 | GetBackendOptimizerManifest403
  >,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackendOptimizerManifest>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBackendOptimizerManifestQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateBackendOptimizerSnapshotUrl = () => {
  return `/api/admin/agents/optimizer/snapshots`;
};

/**
 * @summary Approve bounded non-sensitive evidence with freshness and provenance
 */
export const createBackendOptimizerSnapshot = async (
  optimizerSnapshot: OptimizerSnapshot,
  options?: Parameters<typeof customFetch>[1],
): Promise<CreateBackendOptimizerSnapshot201> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CreateBackendOptimizerSnapshot201>(
    getCreateBackendOptimizerSnapshotUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(optimizerSnapshot),
    },
  );
};

export const getCreateBackendOptimizerSnapshotMutationKey = () =>
  ["createBackendOptimizerSnapshot"] as const;

export const getCreateBackendOptimizerSnapshotMutationOptions = <
  TError = ErrorType<
    | CreateBackendOptimizerSnapshot400
    | CreateBackendOptimizerSnapshot401
    | CreateBackendOptimizerSnapshot403
    | CreateBackendOptimizerSnapshot409
    | CreateBackendOptimizerSnapshot503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBackendOptimizerSnapshot>>,
    TError,
    CreateBackendOptimizerSnapshotMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBackendOptimizerSnapshot>>,
  TError,
  CreateBackendOptimizerSnapshotMutationVariables,
  TContext
> => {
  const mutationKey = getCreateBackendOptimizerSnapshotMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBackendOptimizerSnapshot>>,
    CreateBackendOptimizerSnapshotMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createBackendOptimizerSnapshot(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBackendOptimizerSnapshotMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBackendOptimizerSnapshot>>
>;
export type CreateBackendOptimizerSnapshotMutationBody =
  BodyType<OptimizerSnapshot>;
export type CreateBackendOptimizerSnapshotMutationError = ErrorType<
  | CreateBackendOptimizerSnapshot400
  | CreateBackendOptimizerSnapshot401
  | CreateBackendOptimizerSnapshot403
  | CreateBackendOptimizerSnapshot409
  | CreateBackendOptimizerSnapshot503
>;
export type CreateBackendOptimizerSnapshotMutationVariables = {
  data: BodyType<OptimizerSnapshot>;
};

/**
 * @summary Approve bounded non-sensitive evidence with freshness and provenance
 */
export const useCreateBackendOptimizerSnapshot = <
  TError = ErrorType<
    | CreateBackendOptimizerSnapshot400
    | CreateBackendOptimizerSnapshot401
    | CreateBackendOptimizerSnapshot403
    | CreateBackendOptimizerSnapshot409
    | CreateBackendOptimizerSnapshot503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBackendOptimizerSnapshot>>,
    TError,
    CreateBackendOptimizerSnapshotMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBackendOptimizerSnapshot>>,
  TError,
  CreateBackendOptimizerSnapshotMutationVariables,
  TContext
> => {
  return useMutation(getCreateBackendOptimizerSnapshotMutationOptions(options));
};

export const getStartBackendOptimizerRunUrl = () => {
  return `/api/admin/agents/optimizer/runs`;
};

/**
 * @summary Queue bounded review; reserve every round before any paid invocation
 */
export const startBackendOptimizerRun = async (
  optimizerRunRequest: OptimizerRunRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<StartBackendOptimizerRun202> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<StartBackendOptimizerRun202>(
    getStartBackendOptimizerRunUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(optimizerRunRequest),
    },
  );
};

export const getStartBackendOptimizerRunMutationKey = () =>
  ["startBackendOptimizerRun"] as const;

export const getStartBackendOptimizerRunMutationOptions = <
  TError = ErrorType<
    | StartBackendOptimizerRun400
    | StartBackendOptimizerRun401
    | StartBackendOptimizerRun403
    | StartBackendOptimizerRun404
    | StartBackendOptimizerRun409
    | StartBackendOptimizerRun429
    | StartBackendOptimizerRun503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startBackendOptimizerRun>>,
    TError,
    StartBackendOptimizerRunMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startBackendOptimizerRun>>,
  TError,
  StartBackendOptimizerRunMutationVariables,
  TContext
> => {
  const mutationKey = getStartBackendOptimizerRunMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startBackendOptimizerRun>>,
    StartBackendOptimizerRunMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return startBackendOptimizerRun(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartBackendOptimizerRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof startBackendOptimizerRun>>
>;
export type StartBackendOptimizerRunMutationBody =
  BodyType<OptimizerRunRequest>;
export type StartBackendOptimizerRunMutationError = ErrorType<
  | StartBackendOptimizerRun400
  | StartBackendOptimizerRun401
  | StartBackendOptimizerRun403
  | StartBackendOptimizerRun404
  | StartBackendOptimizerRun409
  | StartBackendOptimizerRun429
  | StartBackendOptimizerRun503
>;
export type StartBackendOptimizerRunMutationVariables = {
  data: BodyType<OptimizerRunRequest>;
};

/**
 * @summary Queue bounded review; reserve every round before any paid invocation
 */
export const useStartBackendOptimizerRun = <
  TError = ErrorType<
    | StartBackendOptimizerRun400
    | StartBackendOptimizerRun401
    | StartBackendOptimizerRun403
    | StartBackendOptimizerRun404
    | StartBackendOptimizerRun409
    | StartBackendOptimizerRun429
    | StartBackendOptimizerRun503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startBackendOptimizerRun>>,
    TError,
    StartBackendOptimizerRunMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startBackendOptimizerRun>>,
  TError,
  StartBackendOptimizerRunMutationVariables,
  TContext
> => {
  return useMutation(getStartBackendOptimizerRunMutationOptions(options));
};

export const getGetBackendOptimizerRunUrl = (id: string) => {
  return `/api/admin/agents/optimizer/runs/${id}`;
};

/**
 * @summary Attributed rounds, briefs, performance gate, ledger and review decisions
 */
export const getBackendOptimizerRun = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<OptimizerRunDetail> => {
  return customFetch<OptimizerRunDetail>(getGetBackendOptimizerRunUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetBackendOptimizerRunQueryKey = (id: string) => {
  return [`/api/admin/agents/optimizer/runs/${id}`] as const;
};

export const getGetBackendOptimizerRunQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackendOptimizerRun>>,
  TError = ErrorType<
    | GetBackendOptimizerRun401
    | GetBackendOptimizerRun403
    | GetBackendOptimizerRun404
    | GetBackendOptimizerRun503
  >,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackendOptimizerRun>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackendOptimizerRunQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackendOptimizerRun>>
  > = ({ signal }) => getBackendOptimizerRun(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBackendOptimizerRun>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBackendOptimizerRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackendOptimizerRun>>
>;
export type GetBackendOptimizerRunQueryError = ErrorType<
  | GetBackendOptimizerRun401
  | GetBackendOptimizerRun403
  | GetBackendOptimizerRun404
  | GetBackendOptimizerRun503
>;

/**
 * @summary Attributed rounds, briefs, performance gate, ledger and review decisions
 */

export function useGetBackendOptimizerRun<
  TData = Awaited<ReturnType<typeof getBackendOptimizerRun>>,
  TError = ErrorType<
    | GetBackendOptimizerRun401
    | GetBackendOptimizerRun403
    | GetBackendOptimizerRun404
    | GetBackendOptimizerRun503
  >,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackendOptimizerRun>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBackendOptimizerRunQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCancelBackendOptimizerRunUrl = (id: string) => {
  return `/api/admin/agents/optimizer/runs/${id}`;
};

/**
 * @summary Cancel without releasing submitted or uncertain provider charges
 */
export const cancelBackendOptimizerRun = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<OptimizerAcknowledgement> => {
  return customFetch<OptimizerAcknowledgement>(
    getCancelBackendOptimizerRunUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getCancelBackendOptimizerRunMutationKey = () =>
  ["cancelBackendOptimizerRun"] as const;

export const getCancelBackendOptimizerRunMutationOptions = <
  TError = ErrorType<
    | CancelBackendOptimizerRun401
    | CancelBackendOptimizerRun403
    | CancelBackendOptimizerRun409
    | CancelBackendOptimizerRun503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelBackendOptimizerRun>>,
    TError,
    CancelBackendOptimizerRunMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelBackendOptimizerRun>>,
  TError,
  CancelBackendOptimizerRunMutationVariables,
  TContext
> => {
  const mutationKey = getCancelBackendOptimizerRunMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelBackendOptimizerRun>>,
    CancelBackendOptimizerRunMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return cancelBackendOptimizerRun(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelBackendOptimizerRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelBackendOptimizerRun>>
>;

export type CancelBackendOptimizerRunMutationError = ErrorType<
  | CancelBackendOptimizerRun401
  | CancelBackendOptimizerRun403
  | CancelBackendOptimizerRun409
  | CancelBackendOptimizerRun503
>;
export type CancelBackendOptimizerRunMutationVariables = { id: string };

/**
 * @summary Cancel without releasing submitted or uncertain provider charges
 */
export const useCancelBackendOptimizerRun = <
  TError = ErrorType<
    | CancelBackendOptimizerRun401
    | CancelBackendOptimizerRun403
    | CancelBackendOptimizerRun409
    | CancelBackendOptimizerRun503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelBackendOptimizerRun>>,
    TError,
    CancelBackendOptimizerRunMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelBackendOptimizerRun>>,
  TError,
  CancelBackendOptimizerRunMutationVariables,
  TContext
> => {
  return useMutation(getCancelBackendOptimizerRunMutationOptions(options));
};

export const getReviewBackendOptimizerRunUrl = (id: string) => {
  return `/api/admin/agents/optimizer/runs/${id}/feedback`;
};

/**
 * @summary Record review only; never execute SQL, source changes or deployment
 */
export const reviewBackendOptimizerRun = async (
  id: string,
  optimizerFeedbackRequest: OptimizerFeedbackRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<OptimizerAcknowledgement> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<OptimizerAcknowledgement>(
    getReviewBackendOptimizerRunUrl(id),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(optimizerFeedbackRequest),
    },
  );
};

export const getReviewBackendOptimizerRunMutationKey = () =>
  ["reviewBackendOptimizerRun"] as const;

export const getReviewBackendOptimizerRunMutationOptions = <
  TError = ErrorType<
    | ReviewBackendOptimizerRun400
    | ReviewBackendOptimizerRun401
    | ReviewBackendOptimizerRun403
    | ReviewBackendOptimizerRun404
    | ReviewBackendOptimizerRun409
    | ReviewBackendOptimizerRun503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviewBackendOptimizerRun>>,
    TError,
    ReviewBackendOptimizerRunMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reviewBackendOptimizerRun>>,
  TError,
  ReviewBackendOptimizerRunMutationVariables,
  TContext
> => {
  const mutationKey = getReviewBackendOptimizerRunMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reviewBackendOptimizerRun>>,
    ReviewBackendOptimizerRunMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return reviewBackendOptimizerRun(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReviewBackendOptimizerRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof reviewBackendOptimizerRun>>
>;
export type ReviewBackendOptimizerRunMutationBody =
  BodyType<OptimizerFeedbackRequest>;
export type ReviewBackendOptimizerRunMutationError = ErrorType<
  | ReviewBackendOptimizerRun400
  | ReviewBackendOptimizerRun401
  | ReviewBackendOptimizerRun403
  | ReviewBackendOptimizerRun404
  | ReviewBackendOptimizerRun409
  | ReviewBackendOptimizerRun503
>;
export type ReviewBackendOptimizerRunMutationVariables = {
  id: string;
  data: BodyType<OptimizerFeedbackRequest>;
};

/**
 * @summary Record review only; never execute SQL, source changes or deployment
 */
export const useReviewBackendOptimizerRun = <
  TError = ErrorType<
    | ReviewBackendOptimizerRun400
    | ReviewBackendOptimizerRun401
    | ReviewBackendOptimizerRun403
    | ReviewBackendOptimizerRun404
    | ReviewBackendOptimizerRun409
    | ReviewBackendOptimizerRun503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviewBackendOptimizerRun>>,
    TError,
    ReviewBackendOptimizerRunMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reviewBackendOptimizerRun>>,
  TError,
  ReviewBackendOptimizerRunMutationVariables,
  TContext
> => {
  return useMutation(getReviewBackendOptimizerRunMutationOptions(options));
};

export const getImportBackendOptimizerMeasurementUrl = (id: string) => {
  return `/api/admin/agents/optimizer/runs/${id}/measurements`;
};

/**
 * @summary Review signed isolated-development measurement evidence; never benchmark production
 */
export const importBackendOptimizerMeasurement = async (
  id: string,
  optimizerMeasurementProof: OptimizerMeasurementProof,
  options?: Parameters<typeof customFetch>[1],
): Promise<OptimizerAcknowledgement> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<OptimizerAcknowledgement>(
    getImportBackendOptimizerMeasurementUrl(id),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(optimizerMeasurementProof),
    },
  );
};

export const getImportBackendOptimizerMeasurementMutationKey = () =>
  ["importBackendOptimizerMeasurement"] as const;

export const getImportBackendOptimizerMeasurementMutationOptions = <
  TError = ErrorType<
    | ImportBackendOptimizerMeasurement400
    | ImportBackendOptimizerMeasurement401
    | ImportBackendOptimizerMeasurement403
    | ImportBackendOptimizerMeasurement404
    | ImportBackendOptimizerMeasurement409
    | ImportBackendOptimizerMeasurement503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importBackendOptimizerMeasurement>>,
    TError,
    ImportBackendOptimizerMeasurementMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importBackendOptimizerMeasurement>>,
  TError,
  ImportBackendOptimizerMeasurementMutationVariables,
  TContext
> => {
  const mutationKey = getImportBackendOptimizerMeasurementMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importBackendOptimizerMeasurement>>,
    ImportBackendOptimizerMeasurementMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return importBackendOptimizerMeasurement(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportBackendOptimizerMeasurementMutationResult = NonNullable<
  Awaited<ReturnType<typeof importBackendOptimizerMeasurement>>
>;
export type ImportBackendOptimizerMeasurementMutationBody =
  BodyType<OptimizerMeasurementProof>;
export type ImportBackendOptimizerMeasurementMutationError = ErrorType<
  | ImportBackendOptimizerMeasurement400
  | ImportBackendOptimizerMeasurement401
  | ImportBackendOptimizerMeasurement403
  | ImportBackendOptimizerMeasurement404
  | ImportBackendOptimizerMeasurement409
  | ImportBackendOptimizerMeasurement503
>;
export type ImportBackendOptimizerMeasurementMutationVariables = {
  id: string;
  data: BodyType<OptimizerMeasurementProof>;
};

/**
 * @summary Review signed isolated-development measurement evidence; never benchmark production
 */
export const useImportBackendOptimizerMeasurement = <
  TError = ErrorType<
    | ImportBackendOptimizerMeasurement400
    | ImportBackendOptimizerMeasurement401
    | ImportBackendOptimizerMeasurement403
    | ImportBackendOptimizerMeasurement404
    | ImportBackendOptimizerMeasurement409
    | ImportBackendOptimizerMeasurement503
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importBackendOptimizerMeasurement>>,
    TError,
    ImportBackendOptimizerMeasurementMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importBackendOptimizerMeasurement>>,
  TError,
  ImportBackendOptimizerMeasurementMutationVariables,
  TContext
> => {
  return useMutation(
    getImportBackendOptimizerMeasurementMutationOptions(options),
  );
};

export const getGetAdminSecurityReadinessUrl = () => {
  return `/api/admin/dashboard/security-readiness`;
};

/**
 * Requires a current human admin role, recent verified second factor and awaited audit. Read-only metadata; no agreements, member records or approval mutation. Missing, expired or revision-mismatched evidence stays blocked. Not a compliance or SOC 2 attestation.
 * @summary Read the private technical readiness register
 */
export const getAdminSecurityReadiness = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AdminSecurityReadiness> => {
  return customFetch<AdminSecurityReadiness>(
    getGetAdminSecurityReadinessUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminSecurityReadinessQueryKey = () => {
  return [`/api/admin/dashboard/security-readiness`] as const;
};

export const getGetAdminSecurityReadinessQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminSecurityReadiness>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSecurityReadiness>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminSecurityReadinessQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminSecurityReadiness>>
  > = ({ signal }) => getAdminSecurityReadiness({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSecurityReadiness>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminSecurityReadinessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminSecurityReadiness>>
>;
export type GetAdminSecurityReadinessQueryError = ErrorType<void>;

/**
 * @summary Read the private technical readiness register
 */

export function useGetAdminSecurityReadiness<
  TData = Awaited<ReturnType<typeof getAdminSecurityReadiness>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminSecurityReadiness>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminSecurityReadinessQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWellnessSuggestionsUrl = () => {
  return `/api/wellness-suggestions`;
};

/**
 * @summary Read optional wellness proposals after revalidating eligible sources
 */
export const getWellnessSuggestions = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<WellnessView> => {
  return customFetch<WellnessView>(getGetWellnessSuggestionsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWellnessSuggestionsQueryKey = () => {
  return [`/api/wellness-suggestions`] as const;
};

export const getGetWellnessSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWellnessSuggestions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWellnessSuggestions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWellnessSuggestionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWellnessSuggestions>>
  > = ({ signal }) => getWellnessSuggestions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWellnessSuggestions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWellnessSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWellnessSuggestions>>
>;
export type GetWellnessSuggestionsQueryError = ErrorType<unknown>;

/**
 * @summary Read optional wellness proposals after revalidating eligible sources
 */

export function useGetWellnessSuggestions<
  TData = Awaited<ReturnType<typeof getWellnessSuggestions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWellnessSuggestions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWellnessSuggestionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateWellnessControlsUrl = () => {
  return `/api/wellness-suggestions`;
};

/**
 * @summary Explicit purpose permissions and refresh controls
 */
export const updateWellnessControls = async (
  wellnessControls: WellnessControls,
  options?: Parameters<typeof customFetch>[1],
): Promise<WellnessView> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<WellnessView>(getUpdateWellnessControlsUrl(), {
    ...options,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(wellnessControls),
  });
};

export const getUpdateWellnessControlsMutationKey = () =>
  ["updateWellnessControls"] as const;

export const getUpdateWellnessControlsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWellnessControls>>,
    TError,
    UpdateWellnessControlsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWellnessControls>>,
  TError,
  UpdateWellnessControlsMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateWellnessControlsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWellnessControls>>,
    UpdateWellnessControlsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateWellnessControls(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWellnessControlsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWellnessControls>>
>;
export type UpdateWellnessControlsMutationBody = BodyType<WellnessControls>;
export type UpdateWellnessControlsMutationError = ErrorType<unknown>;
export type UpdateWellnessControlsMutationVariables = {
  data: BodyType<WellnessControls>;
};

/**
 * @summary Explicit purpose permissions and refresh controls
 */
export const useUpdateWellnessControls = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWellnessControls>>,
    TError,
    UpdateWellnessControlsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateWellnessControls>>,
  TError,
  UpdateWellnessControlsMutationVariables,
  TContext
> => {
  return useMutation(getUpdateWellnessControlsMutationOptions(options));
};

export const getRefreshWellnessSuggestionsUrl = () => {
  return `/api/wellness-suggestions/refresh`;
};

/**
 * @summary Generate local proposals without activating an intervention
 */
export const refreshWellnessSuggestions = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<WellnessView> => {
  return customFetch<WellnessView>(getRefreshWellnessSuggestionsUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRefreshWellnessSuggestionsMutationKey = () =>
  ["refreshWellnessSuggestions"] as const;

export const getRefreshWellnessSuggestionsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshWellnessSuggestions>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshWellnessSuggestions>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getRefreshWellnessSuggestionsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshWellnessSuggestions>>,
    void
  > = () => {
    return refreshWellnessSuggestions(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshWellnessSuggestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshWellnessSuggestions>>
>;

export type RefreshWellnessSuggestionsMutationError = ErrorType<unknown>;

/**
 * @summary Generate local proposals without activating an intervention
 */
export const useRefreshWellnessSuggestions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshWellnessSuggestions>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshWellnessSuggestions>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRefreshWellnessSuggestionsMutationOptions(options));
};

export const getDecideWellnessSuggestionUrl = () => {
  return `/api/wellness-suggestions/decision`;
};

/**
 * @summary Confirm consideration, dismiss, or undo a suggestion decision
 */
export const decideWellnessSuggestion = async (
  decideWellnessSuggestionBody: DecideWellnessSuggestionBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<WellnessView> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<WellnessView>(getDecideWellnessSuggestionUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(decideWellnessSuggestionBody),
  });
};

export const getDecideWellnessSuggestionMutationKey = () =>
  ["decideWellnessSuggestion"] as const;

export const getDecideWellnessSuggestionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decideWellnessSuggestion>>,
    TError,
    DecideWellnessSuggestionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof decideWellnessSuggestion>>,
  TError,
  DecideWellnessSuggestionMutationVariables,
  TContext
> => {
  const mutationKey = getDecideWellnessSuggestionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof decideWellnessSuggestion>>,
    DecideWellnessSuggestionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return decideWellnessSuggestion(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DecideWellnessSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof decideWellnessSuggestion>>
>;
export type DecideWellnessSuggestionMutationBody =
  BodyType<DecideWellnessSuggestionBody>;
export type DecideWellnessSuggestionMutationError = ErrorType<unknown>;
export type DecideWellnessSuggestionMutationVariables = {
  data: BodyType<DecideWellnessSuggestionBody>;
};

/**
 * @summary Confirm consideration, dismiss, or undo a suggestion decision
 */
export const useDecideWellnessSuggestion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof decideWellnessSuggestion>>,
    TError,
    DecideWellnessSuggestionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof decideWellnessSuggestion>>,
  TError,
  DecideWellnessSuggestionMutationVariables,
  TContext
> => {
  return useMutation(getDecideWellnessSuggestionMutationOptions(options));
};

export const getConfirmWellnessDocumentFactsUrl = () => {
  return `/api/wellness-suggestions/document-facts`;
};

/**
 * @summary Confirm limited structured routine facts from an owned document
 */
export const confirmWellnessDocumentFacts = async (
  confirmWellnessDocumentFactsBody: ConfirmWellnessDocumentFactsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<WellnessView> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<WellnessView>(getConfirmWellnessDocumentFactsUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(confirmWellnessDocumentFactsBody),
  });
};

export const getConfirmWellnessDocumentFactsMutationKey = () =>
  ["confirmWellnessDocumentFacts"] as const;

export const getConfirmWellnessDocumentFactsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmWellnessDocumentFacts>>,
    TError,
    ConfirmWellnessDocumentFactsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmWellnessDocumentFacts>>,
  TError,
  ConfirmWellnessDocumentFactsMutationVariables,
  TContext
> => {
  const mutationKey = getConfirmWellnessDocumentFactsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmWellnessDocumentFacts>>,
    ConfirmWellnessDocumentFactsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return confirmWellnessDocumentFacts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmWellnessDocumentFactsMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmWellnessDocumentFacts>>
>;
export type ConfirmWellnessDocumentFactsMutationBody =
  BodyType<ConfirmWellnessDocumentFactsBody>;
export type ConfirmWellnessDocumentFactsMutationError = ErrorType<unknown>;
export type ConfirmWellnessDocumentFactsMutationVariables = {
  data: BodyType<ConfirmWellnessDocumentFactsBody>;
};

/**
 * @summary Confirm limited structured routine facts from an owned document
 */
export const useConfirmWellnessDocumentFacts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmWellnessDocumentFacts>>,
    TError,
    ConfirmWellnessDocumentFactsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmWellnessDocumentFacts>>,
  TError,
  ConfirmWellnessDocumentFactsMutationVariables,
  TContext
> => {
  return useMutation(getConfirmWellnessDocumentFactsMutationOptions(options));
};

export const getReconcileStaffWelcomeUrl = (id: number) => {
  return `/api/admin/dashboard/staff/${id}/reconcile-welcome`;
};

/**
 * Admin-only, audited and notification-only. Missing or inconclusive provider evidence leaves retry blocked. Reconciliation never sends mail or changes access, roles or billing.
 * @summary Resolve an uncertain welcome email using verified provider evidence
 */
export const reconcileStaffWelcome = async (
  id: number,
  staffWelcomeEvidenceInput: StaffWelcomeEvidenceInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<StaffWelcomeReconciliation> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<StaffWelcomeReconciliation>(
    getReconcileStaffWelcomeUrl(id),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(staffWelcomeEvidenceInput),
    },
  );
};

export const getReconcileStaffWelcomeMutationKey = () =>
  ["reconcileStaffWelcome"] as const;

export const getReconcileStaffWelcomeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reconcileStaffWelcome>>,
    TError,
    ReconcileStaffWelcomeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reconcileStaffWelcome>>,
  TError,
  ReconcileStaffWelcomeMutationVariables,
  TContext
> => {
  const mutationKey = getReconcileStaffWelcomeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reconcileStaffWelcome>>,
    ReconcileStaffWelcomeMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return reconcileStaffWelcome(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReconcileStaffWelcomeMutationResult = NonNullable<
  Awaited<ReturnType<typeof reconcileStaffWelcome>>
>;
export type ReconcileStaffWelcomeMutationBody =
  BodyType<StaffWelcomeEvidenceInput>;
export type ReconcileStaffWelcomeMutationError = ErrorType<void>;
export type ReconcileStaffWelcomeMutationVariables = {
  id: number;
  data: BodyType<StaffWelcomeEvidenceInput>;
};

/**
 * @summary Resolve an uncertain welcome email using verified provider evidence
 */
export const useReconcileStaffWelcome = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reconcileStaffWelcome>>,
    TError,
    ReconcileStaffWelcomeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reconcileStaffWelcome>>,
  TError,
  ReconcileStaffWelcomeMutationVariables,
  TContext
> => {
  return useMutation(getReconcileStaffWelcomeMutationOptions(options));
};

export const getRecordGeneticKnowledgeDecisionUrl = () => {
  return `/api/admin/genetic-evidence/decisions`;
};

/**
 * Authors cannot approve their own versions. Reuse requestId on retries of the same decision; a committed replay returns its original decision without changing current knowledge or sending another notification.
 * @summary Record a qualified scientific review decision and notify the author
 */
export const recordGeneticKnowledgeDecision = async (
  geneticKnowledgeDecisionInput: GeneticKnowledgeDecisionInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<RecordGeneticKnowledgeDecision201> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<RecordGeneticKnowledgeDecision201>(
    getRecordGeneticKnowledgeDecisionUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(geneticKnowledgeDecisionInput),
    },
  );
};

export const getRecordGeneticKnowledgeDecisionMutationKey = () =>
  ["recordGeneticKnowledgeDecision"] as const;

export const getRecordGeneticKnowledgeDecisionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordGeneticKnowledgeDecision>>,
    TError,
    RecordGeneticKnowledgeDecisionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordGeneticKnowledgeDecision>>,
  TError,
  RecordGeneticKnowledgeDecisionMutationVariables,
  TContext
> => {
  const mutationKey = getRecordGeneticKnowledgeDecisionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordGeneticKnowledgeDecision>>,
    RecordGeneticKnowledgeDecisionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return recordGeneticKnowledgeDecision(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordGeneticKnowledgeDecisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordGeneticKnowledgeDecision>>
>;
export type RecordGeneticKnowledgeDecisionMutationBody =
  BodyType<GeneticKnowledgeDecisionInput>;
export type RecordGeneticKnowledgeDecisionMutationError = ErrorType<void>;
export type RecordGeneticKnowledgeDecisionMutationVariables = {
  data: BodyType<GeneticKnowledgeDecisionInput>;
};

/**
 * @summary Record a qualified scientific review decision and notify the author
 */
export const useRecordGeneticKnowledgeDecision = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordGeneticKnowledgeDecision>>,
    TError,
    RecordGeneticKnowledgeDecisionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordGeneticKnowledgeDecision>>,
  TError,
  RecordGeneticKnowledgeDecisionMutationVariables,
  TContext
> => {
  return useMutation(getRecordGeneticKnowledgeDecisionMutationOptions(options));
};

export const getGetGeneticReviewWorkUrl = () => {
  return `/api/admin/genetic-evidence/work`;
};

/**
 * @summary Inspect scientific reviewer assignments and the caller's private review inbox
 */
export const getGeneticReviewWork = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GeneticReviewWork> => {
  return customFetch<GeneticReviewWork>(getGetGeneticReviewWorkUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGeneticReviewWorkQueryKey = () => {
  return [`/api/admin/genetic-evidence/work`] as const;
};

export const getGetGeneticReviewWorkQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeneticReviewWork>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticReviewWork>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGeneticReviewWorkQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeneticReviewWork>>
  > = ({ signal }) => getGeneticReviewWork({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticReviewWork>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGeneticReviewWorkQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeneticReviewWork>>
>;
export type GetGeneticReviewWorkQueryError = ErrorType<void>;

/**
 * @summary Inspect scientific reviewer assignments and the caller's private review inbox
 */

export function useGetGeneticReviewWork<
  TData = Awaited<ReturnType<typeof getGeneticReviewWork>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticReviewWork>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGeneticReviewWorkQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAssignGeneticReviewWorkUrl = () => {
  return `/api/admin/genetic-evidence/assignments`;
};

/**
 * Omit reviewerUserId to claim. Draft authors cannot be assigned. Only the author can replace an existing assignee. Identical assignment retries do not create another notification.
 * @summary Claim or assign an undecided immutable knowledge version
 */
export const assignGeneticReviewWork = async (
  geneticReviewAssignmentInput: GeneticReviewAssignmentInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AssignGeneticReviewWork200> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AssignGeneticReviewWork200>(
    getAssignGeneticReviewWorkUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(geneticReviewAssignmentInput),
    },
  );
};

export const getAssignGeneticReviewWorkMutationKey = () =>
  ["assignGeneticReviewWork"] as const;

export const getAssignGeneticReviewWorkMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignGeneticReviewWork>>,
    TError,
    AssignGeneticReviewWorkMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignGeneticReviewWork>>,
  TError,
  AssignGeneticReviewWorkMutationVariables,
  TContext
> => {
  const mutationKey = getAssignGeneticReviewWorkMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignGeneticReviewWork>>,
    AssignGeneticReviewWorkMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return assignGeneticReviewWork(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignGeneticReviewWorkMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignGeneticReviewWork>>
>;
export type AssignGeneticReviewWorkMutationBody =
  BodyType<GeneticReviewAssignmentInput>;
export type AssignGeneticReviewWorkMutationError = ErrorType<void>;
export type AssignGeneticReviewWorkMutationVariables = {
  data: BodyType<GeneticReviewAssignmentInput>;
};

/**
 * @summary Claim or assign an undecided immutable knowledge version
 */
export const useAssignGeneticReviewWork = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignGeneticReviewWork>>,
    TError,
    AssignGeneticReviewWorkMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignGeneticReviewWork>>,
  TError,
  AssignGeneticReviewWorkMutationVariables,
  TContext
> => {
  return useMutation(getAssignGeneticReviewWorkMutationOptions(options));
};

export const getReadGeneticReviewNotificationUrl = () => {
  return `/api/admin/genetic-evidence/notifications/read`;
};

/**
 * @summary Mark one of the caller's review notifications read
 */
export const readGeneticReviewNotification = async (
  geneticReviewNotificationReadInput: GeneticReviewNotificationReadInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReadGeneticReviewNotification200> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ReadGeneticReviewNotification200>(
    getReadGeneticReviewNotificationUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(geneticReviewNotificationReadInput),
    },
  );
};

export const getReadGeneticReviewNotificationMutationKey = () =>
  ["readGeneticReviewNotification"] as const;

export const getReadGeneticReviewNotificationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof readGeneticReviewNotification>>,
    TError,
    ReadGeneticReviewNotificationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof readGeneticReviewNotification>>,
  TError,
  ReadGeneticReviewNotificationMutationVariables,
  TContext
> => {
  const mutationKey = getReadGeneticReviewNotificationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof readGeneticReviewNotification>>,
    ReadGeneticReviewNotificationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return readGeneticReviewNotification(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReadGeneticReviewNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof readGeneticReviewNotification>>
>;
export type ReadGeneticReviewNotificationMutationBody =
  BodyType<GeneticReviewNotificationReadInput>;
export type ReadGeneticReviewNotificationMutationError = ErrorType<void>;
export type ReadGeneticReviewNotificationMutationVariables = {
  data: BodyType<GeneticReviewNotificationReadInput>;
};

/**
 * @summary Mark one of the caller's review notifications read
 */
export const useReadGeneticReviewNotification = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof readGeneticReviewNotification>>,
    TError,
    ReadGeneticReviewNotificationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof readGeneticReviewNotification>>,
  TError,
  ReadGeneticReviewNotificationMutationVariables,
  TContext
> => {
  return useMutation(getReadGeneticReviewNotificationMutationOptions(options));
};

export const getListReviewerQualificationsUrl = () => {
  return `/api/admin/genetic-evidence/qualifications`;
};

/**
 * @summary Inspect reviewer qualification history and legacy migration candidates (operators only)
 */
export const listReviewerQualifications = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ReviewerQualificationRoster> => {
  return customFetch<ReviewerQualificationRoster>(
    getListReviewerQualificationsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListReviewerQualificationsQueryKey = () => {
  return [`/api/admin/genetic-evidence/qualifications`] as const;
};

export const getListReviewerQualificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listReviewerQualifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listReviewerQualifications>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListReviewerQualificationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listReviewerQualifications>>
  > = ({ signal }) => listReviewerQualifications({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listReviewerQualifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListReviewerQualificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listReviewerQualifications>>
>;
export type ListReviewerQualificationsQueryError = ErrorType<unknown>;

/**
 * @summary Inspect reviewer qualification history and legacy migration candidates (operators only)
 */

export function useListReviewerQualifications<
  TData = Awaited<ReturnType<typeof listReviewerQualifications>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listReviewerQualifications>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListReviewerQualificationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getChangeReviewerQualificationUrl = () => {
  return `/api/admin/genetic-evidence/qualifications`;
};

/**
 * @summary Append an operator-verified scope qualification change
 */
export const changeReviewerQualification = async (
  reviewerQualificationChange: ReviewerQualificationChange,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReviewerQualificationEvent> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ReviewerQualificationEvent>(
    getChangeReviewerQualificationUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(reviewerQualificationChange),
    },
  );
};

export const getChangeReviewerQualificationMutationKey = () =>
  ["changeReviewerQualification"] as const;

export const getChangeReviewerQualificationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeReviewerQualification>>,
    TError,
    ChangeReviewerQualificationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeReviewerQualification>>,
  TError,
  ChangeReviewerQualificationMutationVariables,
  TContext
> => {
  const mutationKey = getChangeReviewerQualificationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeReviewerQualification>>,
    ChangeReviewerQualificationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return changeReviewerQualification(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeReviewerQualificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeReviewerQualification>>
>;
export type ChangeReviewerQualificationMutationBody =
  BodyType<ReviewerQualificationChange>;
export type ChangeReviewerQualificationMutationError = ErrorType<void>;
export type ChangeReviewerQualificationMutationVariables = {
  data: BodyType<ReviewerQualificationChange>;
};

/**
 * @summary Append an operator-verified scope qualification change
 */
export const useChangeReviewerQualification = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeReviewerQualification>>,
    TError,
    ChangeReviewerQualificationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeReviewerQualification>>,
  TError,
  ChangeReviewerQualificationMutationVariables,
  TContext
> => {
  return useMutation(getChangeReviewerQualificationMutationOptions(options));
};

export const getCompareGeneticCatalogCandidatesUrl = (
  params: CompareGeneticCatalogCandidatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/genetic-evidence/catalog/compare?${stringifiedParams}`
    : `/api/admin/genetic-evidence/catalog/compare`;
};

/**
 * @summary Compare two retained source snapshots for the same candidate key
 */
export const compareGeneticCatalogCandidates = async (
  params: CompareGeneticCatalogCandidatesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GeneticCatalogComparison> => {
  return customFetch<GeneticCatalogComparison>(
    getCompareGeneticCatalogCandidatesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getCompareGeneticCatalogCandidatesQueryKey = (
  params?: CompareGeneticCatalogCandidatesParams,
) => {
  return [
    `/api/admin/genetic-evidence/catalog/compare`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCompareGeneticCatalogCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof compareGeneticCatalogCandidates>>,
  TError = ErrorType<void>,
>(
  params: CompareGeneticCatalogCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof compareGeneticCatalogCandidates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCompareGeneticCatalogCandidatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof compareGeneticCatalogCandidates>>
  > = ({ signal }) =>
    compareGeneticCatalogCandidates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof compareGeneticCatalogCandidates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompareGeneticCatalogCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof compareGeneticCatalogCandidates>>
>;
export type CompareGeneticCatalogCandidatesQueryError = ErrorType<void>;

/**
 * @summary Compare two retained source snapshots for the same candidate key
 */

export function useCompareGeneticCatalogCandidates<
  TData = Awaited<ReturnType<typeof compareGeneticCatalogCandidates>>,
  TError = ErrorType<void>,
>(
  params: CompareGeneticCatalogCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof compareGeneticCatalogCandidates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompareGeneticCatalogCandidatesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDownloadHealthReportEvidenceAppendixUrl = (id: string) => {
  return `/api/admin/dashboard/health-reports/${id}/appendix`;
};

/**
 * Human-admin-only audited JSONL export from the encrypted reviewed case snapshot. E IDs match summary evidence; X IDs identify excluded facts. Each evidence row preserves boundary, confidence, observation and provenance without new interpretations. No additional retained copy is created. The final end record includes a SHA-256 checksum of all preceding bytes. Exports are streamed with backpressure and a two-minute timeout; snapshots over 64 MiB or serialized rows over 1 MiB are refused, never truncated.
 * @summary Download the private full-evidence appendix
 */
export const downloadHealthReportEvidenceAppendix = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<Response> => {
  return customFetch<Response>(getDownloadHealthReportEvidenceAppendixUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getDownloadHealthReportEvidenceAppendixQueryKey = (id: string) => {
  return [`/api/admin/dashboard/health-reports/${id}/appendix`] as const;
};

export const getDownloadHealthReportEvidenceAppendixQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadHealthReportEvidenceAppendix>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadHealthReportEvidenceAppendix>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadHealthReportEvidenceAppendixQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadHealthReportEvidenceAppendix>>
  > = ({ signal }) =>
    downloadHealthReportEvidenceAppendix(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadHealthReportEvidenceAppendix>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadHealthReportEvidenceAppendixQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadHealthReportEvidenceAppendix>>
>;
export type DownloadHealthReportEvidenceAppendixQueryError = ErrorType<void>;

/**
 * @summary Download the private full-evidence appendix
 */

export function useDownloadHealthReportEvidenceAppendix<
  TData = Awaited<ReturnType<typeof downloadHealthReportEvidenceAppendix>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadHealthReportEvidenceAppendix>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadHealthReportEvidenceAppendixQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAdminHealthReportRetentionPolicyUrl = () => {
  return `/api/admin/dashboard/health-reports/retention-policy`;
};

/**
 * @summary View the retention policy for new document-only health reports
 */
export const getAdminHealthReportRetentionPolicy = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AdminHealthReportRetentionPolicy> => {
  return customFetch<AdminHealthReportRetentionPolicy>(
    getGetAdminHealthReportRetentionPolicyUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminHealthReportRetentionPolicyQueryKey = () => {
  return [`/api/admin/dashboard/health-reports/retention-policy`] as const;
};

export const getGetAdminHealthReportRetentionPolicyQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminHealthReportRetentionPolicy>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminHealthReportRetentionPolicy>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminHealthReportRetentionPolicyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminHealthReportRetentionPolicy>>
  > = ({ signal }) =>
    getAdminHealthReportRetentionPolicy({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminHealthReportRetentionPolicy>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminHealthReportRetentionPolicyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminHealthReportRetentionPolicy>>
>;
export type GetAdminHealthReportRetentionPolicyQueryError = ErrorType<unknown>;

/**
 * @summary View the retention policy for new document-only health reports
 */

export function useGetAdminHealthReportRetentionPolicy<
  TData = Awaited<ReturnType<typeof getAdminHealthReportRetentionPolicy>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminHealthReportRetentionPolicy>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetAdminHealthReportRetentionPolicyQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateAdminHealthReportRetentionPolicyUrl = () => {
  return `/api/admin/dashboard/health-reports/retention-policy`;
};

/**
 * @summary Change retention for new document-only health reports without rescheduling existing cases
 */
export const updateAdminHealthReportRetentionPolicy = async (
  adminHealthReportRetentionPolicyInput: AdminHealthReportRetentionPolicyInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AdminHealthReportRetentionPolicy> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AdminHealthReportRetentionPolicy>(
    getUpdateAdminHealthReportRetentionPolicyUrl(),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(adminHealthReportRetentionPolicyInput),
    },
  );
};

export const getUpdateAdminHealthReportRetentionPolicyMutationKey = () =>
  ["updateAdminHealthReportRetentionPolicy"] as const;

export const getUpdateAdminHealthReportRetentionPolicyMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminHealthReportRetentionPolicy>>,
    TError,
    UpdateAdminHealthReportRetentionPolicyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAdminHealthReportRetentionPolicy>>,
  TError,
  UpdateAdminHealthReportRetentionPolicyMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateAdminHealthReportRetentionPolicyMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAdminHealthReportRetentionPolicy>>,
    UpdateAdminHealthReportRetentionPolicyMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateAdminHealthReportRetentionPolicy(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAdminHealthReportRetentionPolicyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAdminHealthReportRetentionPolicy>>
>;
export type UpdateAdminHealthReportRetentionPolicyMutationBody =
  BodyType<AdminHealthReportRetentionPolicyInput>;
export type UpdateAdminHealthReportRetentionPolicyMutationError =
  ErrorType<void>;
export type UpdateAdminHealthReportRetentionPolicyMutationVariables = {
  data: BodyType<AdminHealthReportRetentionPolicyInput>;
};

/**
 * @summary Change retention for new document-only health reports without rescheduling existing cases
 */
export const useUpdateAdminHealthReportRetentionPolicy = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAdminHealthReportRetentionPolicy>>,
    TError,
    UpdateAdminHealthReportRetentionPolicyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAdminHealthReportRetentionPolicy>>,
  TError,
  UpdateAdminHealthReportRetentionPolicyMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateAdminHealthReportRetentionPolicyMutationOptions(options),
  );
};

export const getGetAcquisitionConsentUrl = () => {
  return `/api/acquisition/consent`;
};

export const getAcquisitionConsent = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionConsent> => {
  return customFetch<AcquisitionConsent>(getGetAcquisitionConsentUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAcquisitionConsentQueryKey = () => {
  return [`/api/acquisition/consent`] as const;
};

export const getGetAcquisitionConsentQueryOptions = <
  TData = Awaited<ReturnType<typeof getAcquisitionConsent>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionConsent>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAcquisitionConsentQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAcquisitionConsent>>
  > = ({ signal }) => getAcquisitionConsent({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionConsent>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAcquisitionConsentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAcquisitionConsent>>
>;
export type GetAcquisitionConsentQueryError = ErrorType<void>;

export function useGetAcquisitionConsent<
  TData = Awaited<ReturnType<typeof getAcquisitionConsent>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionConsent>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAcquisitionConsentQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSetAcquisitionConsentUrl = () => {
  return `/api/acquisition/consent`;
};

export const setAcquisitionConsent = async (
  acquisitionConsentInput: AcquisitionConsentInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionConsent> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AcquisitionConsent>(getSetAcquisitionConsentUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(acquisitionConsentInput),
  });
};

export const getSetAcquisitionConsentMutationKey = () =>
  ["setAcquisitionConsent"] as const;

export const getSetAcquisitionConsentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAcquisitionConsent>>,
    TError,
    SetAcquisitionConsentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAcquisitionConsent>>,
  TError,
  SetAcquisitionConsentMutationVariables,
  TContext
> => {
  const mutationKey = getSetAcquisitionConsentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAcquisitionConsent>>,
    SetAcquisitionConsentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return setAcquisitionConsent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAcquisitionConsentMutationResult = NonNullable<
  Awaited<ReturnType<typeof setAcquisitionConsent>>
>;
export type SetAcquisitionConsentMutationBody =
  BodyType<AcquisitionConsentInput>;
export type SetAcquisitionConsentMutationError = ErrorType<void>;
export type SetAcquisitionConsentMutationVariables = {
  data: BodyType<AcquisitionConsentInput>;
};

export const useSetAcquisitionConsent = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAcquisitionConsent>>,
    TError,
    SetAcquisitionConsentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setAcquisitionConsent>>,
  TError,
  SetAcquisitionConsentMutationVariables,
  TContext
> => {
  return useMutation(getSetAcquisitionConsentMutationOptions(options));
};

export const getCaptureAcquisitionTouchUrl = () => {
  return `/api/acquisition/touch`;
};

export const captureAcquisitionTouch = async (
  acquisitionTouchInput: AcquisitionTouchInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionOk> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AcquisitionOk>(getCaptureAcquisitionTouchUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(acquisitionTouchInput),
  });
};

export const getCaptureAcquisitionTouchMutationKey = () =>
  ["captureAcquisitionTouch"] as const;

export const getCaptureAcquisitionTouchMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof captureAcquisitionTouch>>,
    TError,
    CaptureAcquisitionTouchMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof captureAcquisitionTouch>>,
  TError,
  CaptureAcquisitionTouchMutationVariables,
  TContext
> => {
  const mutationKey = getCaptureAcquisitionTouchMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof captureAcquisitionTouch>>,
    CaptureAcquisitionTouchMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return captureAcquisitionTouch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaptureAcquisitionTouchMutationResult = NonNullable<
  Awaited<ReturnType<typeof captureAcquisitionTouch>>
>;
export type CaptureAcquisitionTouchMutationBody =
  BodyType<AcquisitionTouchInput>;
export type CaptureAcquisitionTouchMutationError = ErrorType<void>;
export type CaptureAcquisitionTouchMutationVariables = {
  data: BodyType<AcquisitionTouchInput>;
};

export const useCaptureAcquisitionTouch = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof captureAcquisitionTouch>>,
    TError,
    CaptureAcquisitionTouchMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof captureAcquisitionTouch>>,
  TError,
  CaptureAcquisitionTouchMutationVariables,
  TContext
> => {
  return useMutation(getCaptureAcquisitionTouchMutationOptions(options));
};

export const getCaptureAcquisitionEventUrl = () => {
  return `/api/acquisition/events`;
};

export const captureAcquisitionEvent = async (
  acquisitionEventInput: AcquisitionEventInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionOk> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AcquisitionOk>(getCaptureAcquisitionEventUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(acquisitionEventInput),
  });
};

export const getCaptureAcquisitionEventMutationKey = () =>
  ["captureAcquisitionEvent"] as const;

export const getCaptureAcquisitionEventMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof captureAcquisitionEvent>>,
    TError,
    CaptureAcquisitionEventMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof captureAcquisitionEvent>>,
  TError,
  CaptureAcquisitionEventMutationVariables,
  TContext
> => {
  const mutationKey = getCaptureAcquisitionEventMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof captureAcquisitionEvent>>,
    CaptureAcquisitionEventMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return captureAcquisitionEvent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaptureAcquisitionEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof captureAcquisitionEvent>>
>;
export type CaptureAcquisitionEventMutationBody =
  BodyType<AcquisitionEventInput>;
export type CaptureAcquisitionEventMutationError = ErrorType<void>;
export type CaptureAcquisitionEventMutationVariables = {
  data: BodyType<AcquisitionEventInput>;
};

export const useCaptureAcquisitionEvent = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof captureAcquisitionEvent>>,
    TError,
    CaptureAcquisitionEventMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof captureAcquisitionEvent>>,
  TError,
  CaptureAcquisitionEventMutationVariables,
  TContext
> => {
  return useMutation(getCaptureAcquisitionEventMutationOptions(options));
};

export const getCreateAcquisitionAssessmentUrl = () => {
  return `/api/acquisition/assessment`;
};

export const createAcquisitionAssessment = async (
  acquisitionAssessmentInput: AcquisitionAssessmentInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionAssessment> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AcquisitionAssessment>(
    getCreateAcquisitionAssessmentUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(acquisitionAssessmentInput),
    },
  );
};

export const getCreateAcquisitionAssessmentMutationKey = () =>
  ["createAcquisitionAssessment"] as const;

export const getCreateAcquisitionAssessmentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAcquisitionAssessment>>,
    TError,
    CreateAcquisitionAssessmentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAcquisitionAssessment>>,
  TError,
  CreateAcquisitionAssessmentMutationVariables,
  TContext
> => {
  const mutationKey = getCreateAcquisitionAssessmentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAcquisitionAssessment>>,
    CreateAcquisitionAssessmentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createAcquisitionAssessment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAcquisitionAssessmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAcquisitionAssessment>>
>;
export type CreateAcquisitionAssessmentMutationBody =
  BodyType<AcquisitionAssessmentInput>;
export type CreateAcquisitionAssessmentMutationError = ErrorType<void>;
export type CreateAcquisitionAssessmentMutationVariables = {
  data: BodyType<AcquisitionAssessmentInput>;
};

export const useCreateAcquisitionAssessment = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAcquisitionAssessment>>,
    TError,
    CreateAcquisitionAssessmentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAcquisitionAssessment>>,
  TError,
  CreateAcquisitionAssessmentMutationVariables,
  TContext
> => {
  return useMutation(getCreateAcquisitionAssessmentMutationOptions(options));
};

export const getGetAcquisitionPreviewUrl = () => {
  return `/api/acquisition/preview`;
};

export const getAcquisitionPreview = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionPreview> => {
  return customFetch<AcquisitionPreview>(getGetAcquisitionPreviewUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAcquisitionPreviewQueryKey = () => {
  return [`/api/acquisition/preview`] as const;
};

export const getGetAcquisitionPreviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getAcquisitionPreview>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionPreview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAcquisitionPreviewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAcquisitionPreview>>
  > = ({ signal }) => getAcquisitionPreview({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionPreview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAcquisitionPreviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAcquisitionPreview>>
>;
export type GetAcquisitionPreviewQueryError = ErrorType<void>;

export function useGetAcquisitionPreview<
  TData = Awaited<ReturnType<typeof getAcquisitionPreview>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionPreview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAcquisitionPreviewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDeleteAcquisitionPreviewUrl = () => {
  return `/api/acquisition/preview`;
};

export const deleteAcquisitionPreview = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionOk> => {
  return customFetch<AcquisitionOk>(getDeleteAcquisitionPreviewUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAcquisitionPreviewMutationKey = () =>
  ["deleteAcquisitionPreview"] as const;

export const getDeleteAcquisitionPreviewMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAcquisitionPreview>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAcquisitionPreview>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getDeleteAcquisitionPreviewMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAcquisitionPreview>>,
    void
  > = () => {
    return deleteAcquisitionPreview(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAcquisitionPreviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAcquisitionPreview>>
>;

export type DeleteAcquisitionPreviewMutationError = ErrorType<void>;

export const useDeleteAcquisitionPreview = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAcquisitionPreview>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAcquisitionPreview>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteAcquisitionPreviewMutationOptions(options));
};

export const getClaimAcquisitionMapUrl = () => {
  return `/api/acquisition/claim`;
};

export const claimAcquisitionMap = async (
  acquisitionClaimInput: AcquisitionClaimInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionOk> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AcquisitionOk>(getClaimAcquisitionMapUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(acquisitionClaimInput),
  });
};

export const getClaimAcquisitionMapMutationKey = () =>
  ["claimAcquisitionMap"] as const;

export const getClaimAcquisitionMapMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimAcquisitionMap>>,
    TError,
    ClaimAcquisitionMapMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof claimAcquisitionMap>>,
  TError,
  ClaimAcquisitionMapMutationVariables,
  TContext
> => {
  const mutationKey = getClaimAcquisitionMapMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof claimAcquisitionMap>>,
    ClaimAcquisitionMapMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return claimAcquisitionMap(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClaimAcquisitionMapMutationResult = NonNullable<
  Awaited<ReturnType<typeof claimAcquisitionMap>>
>;
export type ClaimAcquisitionMapMutationBody = BodyType<AcquisitionClaimInput>;
export type ClaimAcquisitionMapMutationError = ErrorType<void>;
export type ClaimAcquisitionMapMutationVariables = {
  data: BodyType<AcquisitionClaimInput>;
};

export const useClaimAcquisitionMap = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof claimAcquisitionMap>>,
    TError,
    ClaimAcquisitionMapMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof claimAcquisitionMap>>,
  TError,
  ClaimAcquisitionMapMutationVariables,
  TContext
> => {
  return useMutation(getClaimAcquisitionMapMutationOptions(options));
};

export const getGetAcquisitionMapsUrl = () => {
  return `/api/acquisition/maps`;
};

export const getAcquisitionMaps = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionMaps> => {
  return customFetch<AcquisitionMaps>(getGetAcquisitionMapsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAcquisitionMapsQueryKey = () => {
  return [`/api/acquisition/maps`] as const;
};

export const getGetAcquisitionMapsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAcquisitionMaps>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionMaps>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAcquisitionMapsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAcquisitionMaps>>
  > = ({ signal }) => getAcquisitionMaps({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionMaps>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAcquisitionMapsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAcquisitionMaps>>
>;
export type GetAcquisitionMapsQueryError = ErrorType<void>;

export function useGetAcquisitionMaps<
  TData = Awaited<ReturnType<typeof getAcquisitionMaps>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionMaps>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAcquisitionMapsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDeleteAcquisitionMapsUrl = () => {
  return `/api/acquisition/maps`;
};

export const deleteAcquisitionMaps = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionOk> => {
  return customFetch<AcquisitionOk>(getDeleteAcquisitionMapsUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAcquisitionMapsMutationKey = () =>
  ["deleteAcquisitionMaps"] as const;

export const getDeleteAcquisitionMapsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAcquisitionMaps>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAcquisitionMaps>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getDeleteAcquisitionMapsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAcquisitionMaps>>,
    void
  > = () => {
    return deleteAcquisitionMaps(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAcquisitionMapsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAcquisitionMaps>>
>;

export type DeleteAcquisitionMapsMutationError = ErrorType<void>;

export const useDeleteAcquisitionMaps = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAcquisitionMaps>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAcquisitionMaps>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteAcquisitionMapsMutationOptions(options));
};

export const getExportAcquisitionMapsUrl = () => {
  return `/api/acquisition/maps/export`;
};

export const exportAcquisitionMaps = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionMapsExport> => {
  return customFetch<AcquisitionMapsExport>(getExportAcquisitionMapsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getExportAcquisitionMapsQueryKey = () => {
  return [`/api/acquisition/maps/export`] as const;
};

export const getExportAcquisitionMapsQueryOptions = <
  TData = Awaited<ReturnType<typeof exportAcquisitionMaps>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportAcquisitionMaps>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportAcquisitionMapsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportAcquisitionMaps>>
  > = ({ signal }) => exportAcquisitionMaps({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportAcquisitionMaps>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportAcquisitionMapsQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportAcquisitionMaps>>
>;
export type ExportAcquisitionMapsQueryError = ErrorType<void>;

export function useExportAcquisitionMaps<
  TData = Awaited<ReturnType<typeof exportAcquisitionMaps>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportAcquisitionMaps>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportAcquisitionMapsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCaptureAcquisitionLeadUrl = () => {
  return `/api/acquisition/leads`;
};

export const captureAcquisitionLead = async (
  acquisitionLeadInput: AcquisitionLeadInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionOk> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AcquisitionOk>(getCaptureAcquisitionLeadUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(acquisitionLeadInput),
  });
};

export const getCaptureAcquisitionLeadMutationKey = () =>
  ["captureAcquisitionLead"] as const;

export const getCaptureAcquisitionLeadMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof captureAcquisitionLead>>,
    TError,
    CaptureAcquisitionLeadMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof captureAcquisitionLead>>,
  TError,
  CaptureAcquisitionLeadMutationVariables,
  TContext
> => {
  const mutationKey = getCaptureAcquisitionLeadMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof captureAcquisitionLead>>,
    CaptureAcquisitionLeadMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return captureAcquisitionLead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CaptureAcquisitionLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof captureAcquisitionLead>>
>;
export type CaptureAcquisitionLeadMutationBody = BodyType<AcquisitionLeadInput>;
export type CaptureAcquisitionLeadMutationError = ErrorType<void>;
export type CaptureAcquisitionLeadMutationVariables = {
  data: BodyType<AcquisitionLeadInput>;
};

export const useCaptureAcquisitionLead = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof captureAcquisitionLead>>,
    TError,
    CaptureAcquisitionLeadMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof captureAcquisitionLead>>,
  TError,
  CaptureAcquisitionLeadMutationVariables,
  TContext
> => {
  return useMutation(getCaptureAcquisitionLeadMutationOptions(options));
};

export const getWithdrawAcquisitionLeadUrl = () => {
  return `/api/acquisition/leads/withdraw`;
};

export const withdrawAcquisitionLead = async (
  acquisitionWithdrawalInput: AcquisitionWithdrawalInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionOk> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AcquisitionOk>(getWithdrawAcquisitionLeadUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(acquisitionWithdrawalInput),
  });
};

export const getWithdrawAcquisitionLeadMutationKey = () =>
  ["withdrawAcquisitionLead"] as const;

export const getWithdrawAcquisitionLeadMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof withdrawAcquisitionLead>>,
    TError,
    WithdrawAcquisitionLeadMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof withdrawAcquisitionLead>>,
  TError,
  WithdrawAcquisitionLeadMutationVariables,
  TContext
> => {
  const mutationKey = getWithdrawAcquisitionLeadMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof withdrawAcquisitionLead>>,
    WithdrawAcquisitionLeadMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return withdrawAcquisitionLead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WithdrawAcquisitionLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof withdrawAcquisitionLead>>
>;
export type WithdrawAcquisitionLeadMutationBody =
  BodyType<AcquisitionWithdrawalInput>;
export type WithdrawAcquisitionLeadMutationError = ErrorType<void>;
export type WithdrawAcquisitionLeadMutationVariables = {
  data: BodyType<AcquisitionWithdrawalInput>;
};

export const useWithdrawAcquisitionLead = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof withdrawAcquisitionLead>>,
    TError,
    WithdrawAcquisitionLeadMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof withdrawAcquisitionLead>>,
  TError,
  WithdrawAcquisitionLeadMutationVariables,
  TContext
> => {
  return useMutation(getWithdrawAcquisitionLeadMutationOptions(options));
};

export const getGetAcquisitionReportUrl = (
  params: GetAcquisitionReportParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/acquisition/admin/report?${stringifiedParams}`
    : `/api/acquisition/admin/report`;
};

export const getAcquisitionReport = async (
  params: GetAcquisitionReportParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionReport> => {
  return customFetch<AcquisitionReport>(getGetAcquisitionReportUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAcquisitionReportQueryKey = (
  params?: GetAcquisitionReportParams,
) => {
  return [
    `/api/acquisition/admin/report`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAcquisitionReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getAcquisitionReport>>,
  TError = ErrorType<void>,
>(
  params: GetAcquisitionReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAcquisitionReport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAcquisitionReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAcquisitionReport>>
  > = ({ signal }) =>
    getAcquisitionReport(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAcquisitionReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAcquisitionReport>>
>;
export type GetAcquisitionReportQueryError = ErrorType<void>;

export function useGetAcquisitionReport<
  TData = Awaited<ReturnType<typeof getAcquisitionReport>>,
  TError = ErrorType<void>,
>(
  params: GetAcquisitionReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAcquisitionReport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAcquisitionReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getExportAcquisitionPublicReportUrl = (
  params: ExportAcquisitionPublicReportParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/acquisition/admin/export?${stringifiedParams}`
    : `/api/acquisition/admin/export`;
};

export const exportAcquisitionPublicReport = async (
  params: ExportAcquisitionPublicReportParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getExportAcquisitionPublicReportUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getExportAcquisitionPublicReportQueryKey = (
  params?: ExportAcquisitionPublicReportParams,
) => {
  return [
    `/api/acquisition/admin/export`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExportAcquisitionPublicReportQueryOptions = <
  TData = Awaited<ReturnType<typeof exportAcquisitionPublicReport>>,
  TError = ErrorType<void>,
>(
  params: ExportAcquisitionPublicReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportAcquisitionPublicReport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportAcquisitionPublicReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportAcquisitionPublicReport>>
  > = ({ signal }) =>
    exportAcquisitionPublicReport(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportAcquisitionPublicReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportAcquisitionPublicReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportAcquisitionPublicReport>>
>;
export type ExportAcquisitionPublicReportQueryError = ErrorType<void>;

export function useExportAcquisitionPublicReport<
  TData = Awaited<ReturnType<typeof exportAcquisitionPublicReport>>,
  TError = ErrorType<void>,
>(
  params: ExportAcquisitionPublicReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportAcquisitionPublicReport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportAcquisitionPublicReportQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAcquisitionSyntheticUrl = () => {
  return `/api/acquisition/admin/synthetic`;
};

export const getAcquisitionSynthetic = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionSynthetic> => {
  return customFetch<AcquisitionSynthetic>(getGetAcquisitionSyntheticUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAcquisitionSyntheticQueryKey = () => {
  return [`/api/acquisition/admin/synthetic`] as const;
};

export const getGetAcquisitionSyntheticQueryOptions = <
  TData = Awaited<ReturnType<typeof getAcquisitionSynthetic>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionSynthetic>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAcquisitionSyntheticQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAcquisitionSynthetic>>
  > = ({ signal }) => getAcquisitionSynthetic({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionSynthetic>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAcquisitionSyntheticQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAcquisitionSynthetic>>
>;
export type GetAcquisitionSyntheticQueryError = ErrorType<void>;

export function useGetAcquisitionSynthetic<
  TData = Awaited<ReturnType<typeof getAcquisitionSynthetic>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionSynthetic>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAcquisitionSyntheticQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getImportAcquisitionCostsUrl = () => {
  return `/api/acquisition/admin/costs`;
};

export const importAcquisitionCosts = async (
  acquisitionCostInput: AcquisitionCostInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionCostResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AcquisitionCostResult>(getImportAcquisitionCostsUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(acquisitionCostInput),
  });
};

export const getImportAcquisitionCostsMutationKey = () =>
  ["importAcquisitionCosts"] as const;

export const getImportAcquisitionCostsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importAcquisitionCosts>>,
    TError,
    ImportAcquisitionCostsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importAcquisitionCosts>>,
  TError,
  ImportAcquisitionCostsMutationVariables,
  TContext
> => {
  const mutationKey = getImportAcquisitionCostsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importAcquisitionCosts>>,
    ImportAcquisitionCostsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return importAcquisitionCosts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportAcquisitionCostsMutationResult = NonNullable<
  Awaited<ReturnType<typeof importAcquisitionCosts>>
>;
export type ImportAcquisitionCostsMutationBody = BodyType<AcquisitionCostInput>;
export type ImportAcquisitionCostsMutationError = ErrorType<void>;
export type ImportAcquisitionCostsMutationVariables = {
  data: BodyType<AcquisitionCostInput>;
};

export const useImportAcquisitionCosts = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importAcquisitionCosts>>,
    TError,
    ImportAcquisitionCostsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importAcquisitionCosts>>,
  TError,
  ImportAcquisitionCostsMutationVariables,
  TContext
> => {
  return useMutation(getImportAcquisitionCostsMutationOptions(options));
};

export const getGetAcquisitionAffiliatesUrl = () => {
  return `/api/acquisition/admin/affiliates`;
};

export const getAcquisitionAffiliates = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionAffiliates> => {
  return customFetch<AcquisitionAffiliates>(getGetAcquisitionAffiliatesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAcquisitionAffiliatesQueryKey = () => {
  return [`/api/acquisition/admin/affiliates`] as const;
};

export const getGetAcquisitionAffiliatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAcquisitionAffiliates>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionAffiliates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAcquisitionAffiliatesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAcquisitionAffiliates>>
  > = ({ signal }) => getAcquisitionAffiliates({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionAffiliates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAcquisitionAffiliatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAcquisitionAffiliates>>
>;
export type GetAcquisitionAffiliatesQueryError = ErrorType<void>;

export function useGetAcquisitionAffiliates<
  TData = Awaited<ReturnType<typeof getAcquisitionAffiliates>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAcquisitionAffiliates>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAcquisitionAffiliatesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateAcquisitionAffiliateUrl = () => {
  return `/api/acquisition/admin/affiliates`;
};

export const createAcquisitionAffiliate = async (
  acquisitionAffiliateInput: AcquisitionAffiliateInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionAffiliate> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AcquisitionAffiliate>(getCreateAcquisitionAffiliateUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(acquisitionAffiliateInput),
  });
};

export const getCreateAcquisitionAffiliateMutationKey = () =>
  ["createAcquisitionAffiliate"] as const;

export const getCreateAcquisitionAffiliateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAcquisitionAffiliate>>,
    TError,
    CreateAcquisitionAffiliateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAcquisitionAffiliate>>,
  TError,
  CreateAcquisitionAffiliateMutationVariables,
  TContext
> => {
  const mutationKey = getCreateAcquisitionAffiliateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAcquisitionAffiliate>>,
    CreateAcquisitionAffiliateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createAcquisitionAffiliate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAcquisitionAffiliateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAcquisitionAffiliate>>
>;
export type CreateAcquisitionAffiliateMutationBody =
  BodyType<AcquisitionAffiliateInput>;
export type CreateAcquisitionAffiliateMutationError = ErrorType<void>;
export type CreateAcquisitionAffiliateMutationVariables = {
  data: BodyType<AcquisitionAffiliateInput>;
};

export const useCreateAcquisitionAffiliate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAcquisitionAffiliate>>,
    TError,
    CreateAcquisitionAffiliateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAcquisitionAffiliate>>,
  TError,
  CreateAcquisitionAffiliateMutationVariables,
  TContext
> => {
  return useMutation(getCreateAcquisitionAffiliateMutationOptions(options));
};

export const getUpdateAcquisitionAffiliateUrl = (code: string) => {
  return `/api/acquisition/admin/affiliates/${code}`;
};

export const updateAcquisitionAffiliate = async (
  code: string,
  acquisitionAffiliateInput: AcquisitionAffiliateInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AcquisitionOk> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AcquisitionOk>(getUpdateAcquisitionAffiliateUrl(code), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(acquisitionAffiliateInput),
  });
};

export const getUpdateAcquisitionAffiliateMutationKey = () =>
  ["updateAcquisitionAffiliate"] as const;

export const getUpdateAcquisitionAffiliateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAcquisitionAffiliate>>,
    TError,
    UpdateAcquisitionAffiliateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAcquisitionAffiliate>>,
  TError,
  UpdateAcquisitionAffiliateMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateAcquisitionAffiliateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAcquisitionAffiliate>>,
    UpdateAcquisitionAffiliateMutationVariables
  > = (props) => {
    const { code, data } = props ?? {};

    return updateAcquisitionAffiliate(code, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAcquisitionAffiliateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAcquisitionAffiliate>>
>;
export type UpdateAcquisitionAffiliateMutationBody =
  BodyType<AcquisitionAffiliateInput>;
export type UpdateAcquisitionAffiliateMutationError = ErrorType<void>;
export type UpdateAcquisitionAffiliateMutationVariables = {
  code: string;
  data: BodyType<AcquisitionAffiliateInput>;
};

export const useUpdateAcquisitionAffiliate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAcquisitionAffiliate>>,
    TError,
    UpdateAcquisitionAffiliateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAcquisitionAffiliate>>,
  TError,
  UpdateAcquisitionAffiliateMutationVariables,
  TContext
> => {
  return useMutation(getUpdateAcquisitionAffiliateMutationOptions(options));
};

export const getGetCoachPreferencesUrl = () => {
  return `/api/coach-preferences`;
};

export const getCoachPreferences = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachPreferenceState> => {
  return customFetch<CoachPreferenceState>(getGetCoachPreferencesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCoachPreferencesQueryKey = () => {
  return [`/api/coach-preferences`] as const;
};

export const getGetCoachPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoachPreferences>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCoachPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCoachPreferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCoachPreferences>>
  > = ({ signal }) => getCoachPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCoachPreferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCoachPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCoachPreferences>>
>;
export type GetCoachPreferencesQueryError = ErrorType<void>;

export function useGetCoachPreferences<
  TData = Awaited<ReturnType<typeof getCoachPreferences>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCoachPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCoachPreferencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getReplaceCoachPreferencesUrl = () => {
  return `/api/coach-preferences`;
};

export const replaceCoachPreferences = async (
  coachPreferenceInput: CoachPreferenceInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachPreferenceState> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CoachPreferenceState>(getReplaceCoachPreferencesUrl(), {
    ...options,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(coachPreferenceInput),
  });
};

export const getReplaceCoachPreferencesMutationKey = () =>
  ["replaceCoachPreferences"] as const;

export const getReplaceCoachPreferencesMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceCoachPreferences>>,
    TError,
    ReplaceCoachPreferencesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replaceCoachPreferences>>,
  TError,
  ReplaceCoachPreferencesMutationVariables,
  TContext
> => {
  const mutationKey = getReplaceCoachPreferencesMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replaceCoachPreferences>>,
    ReplaceCoachPreferencesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return replaceCoachPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplaceCoachPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof replaceCoachPreferences>>
>;
export type ReplaceCoachPreferencesMutationBody =
  BodyType<CoachPreferenceInput>;
export type ReplaceCoachPreferencesMutationError = ErrorType<void>;
export type ReplaceCoachPreferencesMutationVariables = {
  data: BodyType<CoachPreferenceInput>;
};

export const useReplaceCoachPreferences = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replaceCoachPreferences>>,
    TError,
    ReplaceCoachPreferencesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof replaceCoachPreferences>>,
  TError,
  ReplaceCoachPreferencesMutationVariables,
  TContext
> => {
  return useMutation(getReplaceCoachPreferencesMutationOptions(options));
};

export const getOfferCoachAlternativeUrl = () => {
  return `/api/coach-preferences/alternative`;
};

export const offerCoachAlternative = async (
  coachAlternativeInput: CoachAlternativeInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachAlternativeResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CoachAlternativeResult>(getOfferCoachAlternativeUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(coachAlternativeInput),
  });
};

export const getOfferCoachAlternativeMutationKey = () =>
  ["offerCoachAlternative"] as const;

export const getOfferCoachAlternativeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof offerCoachAlternative>>,
    TError,
    OfferCoachAlternativeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof offerCoachAlternative>>,
  TError,
  OfferCoachAlternativeMutationVariables,
  TContext
> => {
  const mutationKey = getOfferCoachAlternativeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof offerCoachAlternative>>,
    OfferCoachAlternativeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return offerCoachAlternative(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OfferCoachAlternativeMutationResult = NonNullable<
  Awaited<ReturnType<typeof offerCoachAlternative>>
>;
export type OfferCoachAlternativeMutationBody = BodyType<CoachAlternativeInput>;
export type OfferCoachAlternativeMutationError = ErrorType<void>;
export type OfferCoachAlternativeMutationVariables = {
  data: BodyType<CoachAlternativeInput>;
};

export const useOfferCoachAlternative = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof offerCoachAlternative>>,
    TError,
    OfferCoachAlternativeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof offerCoachAlternative>>,
  TError,
  OfferCoachAlternativeMutationVariables,
  TContext
> => {
  return useMutation(getOfferCoachAlternativeMutationOptions(options));
};

export const getGetPlanWorkflowUrl = () => {
  return `/api/plan-workflow`;
};

/**
 * @summary Read the authenticated member's plan, draft and live log reconciliation
 */
export const getPlanWorkflow = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PlanWorkflowEnvelope> => {
  return customFetch<PlanWorkflowEnvelope>(getGetPlanWorkflowUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPlanWorkflowQueryKey = () => {
  return [`/api/plan-workflow`] as const;
};

export const getGetPlanWorkflowQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlanWorkflow>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPlanWorkflow>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlanWorkflowQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanWorkflow>>> = ({
    signal,
  }) => getPlanWorkflow({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlanWorkflow>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlanWorkflowQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlanWorkflow>>
>;
export type GetPlanWorkflowQueryError = ErrorType<unknown>;

/**
 * @summary Read the authenticated member's plan, draft and live log reconciliation
 */

export function useGetPlanWorkflow<
  TData = Awaited<ReturnType<typeof getPlanWorkflow>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPlanWorkflow>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlanWorkflowQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getChangePlanWorkflowUrl = () => {
  return `/api/plan-workflow`;
};

/**
 * @summary Apply an explicit versioned command without creating intake
 */
export const changePlanWorkflow = async (
  planWorkflowMutation: PlanWorkflowMutation,
  options?: Parameters<typeof customFetch>[1],
): Promise<PlanWorkflowEnvelope> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PlanWorkflowEnvelope>(getChangePlanWorkflowUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(planWorkflowMutation),
  });
};

export const getChangePlanWorkflowMutationKey = () =>
  ["changePlanWorkflow"] as const;

export const getChangePlanWorkflowMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePlanWorkflow>>,
    TError,
    ChangePlanWorkflowMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePlanWorkflow>>,
  TError,
  ChangePlanWorkflowMutationVariables,
  TContext
> => {
  const mutationKey = getChangePlanWorkflowMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePlanWorkflow>>,
    ChangePlanWorkflowMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return changePlanWorkflow(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePlanWorkflowMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePlanWorkflow>>
>;
export type ChangePlanWorkflowMutationBody = BodyType<PlanWorkflowMutation>;
export type ChangePlanWorkflowMutationError = ErrorType<void>;
export type ChangePlanWorkflowMutationVariables = {
  data: BodyType<PlanWorkflowMutation>;
};

/**
 * @summary Apply an explicit versioned command without creating intake
 */
export const useChangePlanWorkflow = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePlanWorkflow>>,
    TError,
    ChangePlanWorkflowMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changePlanWorkflow>>,
  TError,
  ChangePlanWorkflowMutationVariables,
  TContext
> => {
  return useMutation(getChangePlanWorkflowMutationOptions(options));
};

export const getPreviewPlanWorkflowUrl = () => {
  return `/api/plan-workflow/preview`;
};

/**
 * @summary Calculate nutrient differences without editing a meal or logging consumption
 */
export const previewPlanWorkflow = async (
  planWorkflowPreviewInput: PlanWorkflowPreviewInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<PlanWorkflowPreview> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PlanWorkflowPreview>(getPreviewPlanWorkflowUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(planWorkflowPreviewInput),
  });
};

export const getPreviewPlanWorkflowMutationKey = () =>
  ["previewPlanWorkflow"] as const;

export const getPreviewPlanWorkflowMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewPlanWorkflow>>,
    TError,
    PreviewPlanWorkflowMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewPlanWorkflow>>,
  TError,
  PreviewPlanWorkflowMutationVariables,
  TContext
> => {
  const mutationKey = getPreviewPlanWorkflowMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewPlanWorkflow>>,
    PreviewPlanWorkflowMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return previewPlanWorkflow(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewPlanWorkflowMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewPlanWorkflow>>
>;
export type PreviewPlanWorkflowMutationBody =
  BodyType<PlanWorkflowPreviewInput>;
export type PreviewPlanWorkflowMutationError = ErrorType<unknown>;
export type PreviewPlanWorkflowMutationVariables = {
  data: BodyType<PlanWorkflowPreviewInput>;
};

/**
 * @summary Calculate nutrient differences without editing a meal or logging consumption
 */
export const usePreviewPlanWorkflow = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewPlanWorkflow>>,
    TError,
    PreviewPlanWorkflowMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewPlanWorkflow>>,
  TError,
  PreviewPlanWorkflowMutationVariables,
  TContext
> => {
  return useMutation(getPreviewPlanWorkflowMutationOptions(options));
};

export const getInspectNutritionRecoveryContextUrl = () => {
  return `/api/wearables/nutrition-context`;
};

/**
 * @summary Inspect seven days of descriptive nutrition and recovery context
 */
export const inspectNutritionRecoveryContext = async (
  nutritionContextOptIn: NutritionContextOptIn,
  options?: Parameters<typeof customFetch>[1],
): Promise<NutritionRecoveryContext> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<NutritionRecoveryContext>(
    getInspectNutritionRecoveryContextUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(nutritionContextOptIn),
    },
  );
};

export const getInspectNutritionRecoveryContextMutationKey = () =>
  ["inspectNutritionRecoveryContext"] as const;

export const getInspectNutritionRecoveryContextMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inspectNutritionRecoveryContext>>,
    TError,
    InspectNutritionRecoveryContextMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inspectNutritionRecoveryContext>>,
  TError,
  InspectNutritionRecoveryContextMutationVariables,
  TContext
> => {
  const mutationKey = getInspectNutritionRecoveryContextMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inspectNutritionRecoveryContext>>,
    InspectNutritionRecoveryContextMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return inspectNutritionRecoveryContext(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InspectNutritionRecoveryContextMutationResult = NonNullable<
  Awaited<ReturnType<typeof inspectNutritionRecoveryContext>>
>;
export type InspectNutritionRecoveryContextMutationBody =
  BodyType<NutritionContextOptIn>;
export type InspectNutritionRecoveryContextMutationError = ErrorType<void>;
export type InspectNutritionRecoveryContextMutationVariables = {
  data: BodyType<NutritionContextOptIn>;
};

/**
 * @summary Inspect seven days of descriptive nutrition and recovery context
 */
export const useInspectNutritionRecoveryContext = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inspectNutritionRecoveryContext>>,
    TError,
    InspectNutritionRecoveryContextMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof inspectNutritionRecoveryContext>>,
  TError,
  InspectNutritionRecoveryContextMutationVariables,
  TContext
> => {
  return useMutation(
    getInspectNutritionRecoveryContextMutationOptions(options),
  );
};

export const getGetNutritionProgressUrl = (
  params: GetNutritionProgressParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/progress?${stringifiedParams}`
    : `/api/dashboard/progress`;
};

/**
 * @summary Compare recorded nutrients in adjacent calendar windows without changing scores
 */
export const getNutritionProgress = async (
  params: GetNutritionProgressParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<NutritionProgress> => {
  return customFetch<NutritionProgress>(getGetNutritionProgressUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetNutritionProgressQueryKey = (
  params?: GetNutritionProgressParams,
) => {
  return [`/api/dashboard/progress`, ...(params ? [params] : [])] as const;
};

export const getGetNutritionProgressQueryOptions = <
  TData = Awaited<ReturnType<typeof getNutritionProgress>>,
  TError = ErrorType<void>,
>(
  params: GetNutritionProgressParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNutritionProgress>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNutritionProgressQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNutritionProgress>>
  > = ({ signal }) =>
    getNutritionProgress(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNutritionProgress>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNutritionProgressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNutritionProgress>>
>;
export type GetNutritionProgressQueryError = ErrorType<void>;

/**
 * @summary Compare recorded nutrients in adjacent calendar windows without changing scores
 */

export function useGetNutritionProgress<
  TData = Awaited<ReturnType<typeof getNutritionProgress>>,
  TError = ErrorType<void>,
>(
  params: GetNutritionProgressParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNutritionProgress>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNutritionProgressQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWomensHealthUrl = () => {
  return `/api/womens-health`;
};

export const getWomensHealth = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<WomensHealthView> => {
  return customFetch<WomensHealthView>(getGetWomensHealthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWomensHealthQueryKey = () => {
  return [`/api/womens-health`] as const;
};

export const getGetWomensHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getWomensHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWomensHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWomensHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWomensHealth>>> = ({
    signal,
  }) => getWomensHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWomensHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWomensHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWomensHealth>>
>;
export type GetWomensHealthQueryError = ErrorType<unknown>;

export function useGetWomensHealth<
  TData = Awaited<ReturnType<typeof getWomensHealth>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWomensHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWomensHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getChangeWomensHealthUrl = () => {
  return `/api/womens-health/command`;
};

export const changeWomensHealth = async (
  womensHealthCommand: WomensHealthCommand,
  options?: Parameters<typeof customFetch>[1],
): Promise<WomensHealthView> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<WomensHealthView>(getChangeWomensHealthUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(womensHealthCommand),
  });
};

export const getChangeWomensHealthMutationKey = () =>
  ["changeWomensHealth"] as const;

export const getChangeWomensHealthMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeWomensHealth>>,
    TError,
    ChangeWomensHealthMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeWomensHealth>>,
  TError,
  ChangeWomensHealthMutationVariables,
  TContext
> => {
  const mutationKey = getChangeWomensHealthMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeWomensHealth>>,
    ChangeWomensHealthMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return changeWomensHealth(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeWomensHealthMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeWomensHealth>>
>;
export type ChangeWomensHealthMutationBody = BodyType<WomensHealthCommand>;
export type ChangeWomensHealthMutationError = ErrorType<unknown>;
export type ChangeWomensHealthMutationVariables = {
  data: BodyType<WomensHealthCommand>;
};

export const useChangeWomensHealth = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeWomensHealth>>,
    TError,
    ChangeWomensHealthMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeWomensHealth>>,
  TError,
  ChangeWomensHealthMutationVariables,
  TContext
> => {
  return useMutation(getChangeWomensHealthMutationOptions(options));
};

export const getGetWomensHealthReferencesUrl = () => {
  return `/api/admin/womens-health-references`;
};

export const getWomensHealthReferences = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetWomensHealthReferences200> => {
  return customFetch<GetWomensHealthReferences200>(
    getGetWomensHealthReferencesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetWomensHealthReferencesQueryKey = () => {
  return [`/api/admin/womens-health-references`] as const;
};

export const getGetWomensHealthReferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getWomensHealthReferences>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWomensHealthReferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWomensHealthReferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWomensHealthReferences>>
  > = ({ signal }) => getWomensHealthReferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWomensHealthReferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWomensHealthReferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWomensHealthReferences>>
>;
export type GetWomensHealthReferencesQueryError = ErrorType<unknown>;

export function useGetWomensHealthReferences<
  TData = Awaited<ReturnType<typeof getWomensHealthReferences>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWomensHealthReferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWomensHealthReferencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getStageWomensHealthReferenceUrl = () => {
  return `/api/admin/womens-health-references`;
};

export const stageWomensHealthReference = async (
  womensHealthReferenceInput: WomensHealthReferenceInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<WomensHealthReferenceStage> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<WomensHealthReferenceStage>(
    getStageWomensHealthReferenceUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(womensHealthReferenceInput),
    },
  );
};

export const getStageWomensHealthReferenceMutationKey = () =>
  ["stageWomensHealthReference"] as const;

export const getStageWomensHealthReferenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stageWomensHealthReference>>,
    TError,
    StageWomensHealthReferenceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stageWomensHealthReference>>,
  TError,
  StageWomensHealthReferenceMutationVariables,
  TContext
> => {
  const mutationKey = getStageWomensHealthReferenceMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stageWomensHealthReference>>,
    StageWomensHealthReferenceMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return stageWomensHealthReference(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StageWomensHealthReferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof stageWomensHealthReference>>
>;
export type StageWomensHealthReferenceMutationBody =
  BodyType<WomensHealthReferenceInput>;
export type StageWomensHealthReferenceMutationError = ErrorType<unknown>;
export type StageWomensHealthReferenceMutationVariables = {
  data: BodyType<WomensHealthReferenceInput>;
};

export const useStageWomensHealthReference = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stageWomensHealthReference>>,
    TError,
    StageWomensHealthReferenceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof stageWomensHealthReference>>,
  TError,
  StageWomensHealthReferenceMutationVariables,
  TContext
> => {
  return useMutation(getStageWomensHealthReferenceMutationOptions(options));
};

export const getGetWomensHealthReferenceTemplateUrl = (
  params: GetWomensHealthReferenceTemplateParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/womens-health-references/template?${stringifiedParams}`
    : `/api/admin/womens-health-references/template`;
};

export const getWomensHealthReferenceTemplate = async (
  params: GetWomensHealthReferenceTemplateParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  return customFetch<string>(getGetWomensHealthReferenceTemplateUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetWomensHealthReferenceTemplateQueryKey = (
  params?: GetWomensHealthReferenceTemplateParams,
) => {
  return [
    `/api/admin/womens-health-references/template`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetWomensHealthReferenceTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getWomensHealthReferenceTemplate>>,
  TError = ErrorType<unknown>,
>(
  params: GetWomensHealthReferenceTemplateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWomensHealthReferenceTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetWomensHealthReferenceTemplateQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWomensHealthReferenceTemplate>>
  > = ({ signal }) =>
    getWomensHealthReferenceTemplate(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWomensHealthReferenceTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWomensHealthReferenceTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWomensHealthReferenceTemplate>>
>;
export type GetWomensHealthReferenceTemplateQueryError = ErrorType<unknown>;

export function useGetWomensHealthReferenceTemplate<
  TData = Awaited<ReturnType<typeof getWomensHealthReferenceTemplate>>,
  TError = ErrorType<unknown>,
>(
  params: GetWomensHealthReferenceTemplateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getWomensHealthReferenceTemplate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWomensHealthReferenceTemplateQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getApproveMobileHandoffUrl = () => {
  return `/api/mobile-auth/approve`;
};

/**
 * @summary Approve a one-use PKCE-bound mobile handoff with explicit browser consent
 */
export const approveMobileHandoff = async (
  mobileHandoffApproval: MobileHandoffApproval,
  options?: Parameters<typeof customFetch>[1],
): Promise<MobileHandoffCode> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<MobileHandoffCode>(getApproveMobileHandoffUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(mobileHandoffApproval),
  });
};

export const getApproveMobileHandoffMutationKey = () =>
  ["approveMobileHandoff"] as const;

export const getApproveMobileHandoffMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveMobileHandoff>>,
    TError,
    ApproveMobileHandoffMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveMobileHandoff>>,
  TError,
  ApproveMobileHandoffMutationVariables,
  TContext
> => {
  const mutationKey = getApproveMobileHandoffMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveMobileHandoff>>,
    ApproveMobileHandoffMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return approveMobileHandoff(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveMobileHandoffMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveMobileHandoff>>
>;
export type ApproveMobileHandoffMutationBody = BodyType<MobileHandoffApproval>;
export type ApproveMobileHandoffMutationError = ErrorType<void>;
export type ApproveMobileHandoffMutationVariables = {
  data: BodyType<MobileHandoffApproval>;
};

/**
 * @summary Approve a one-use PKCE-bound mobile handoff with explicit browser consent
 */
export const useApproveMobileHandoff = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveMobileHandoff>>,
    TError,
    ApproveMobileHandoffMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveMobileHandoff>>,
  TError,
  ApproveMobileHandoffMutationVariables,
  TContext
> => {
  return useMutation(getApproveMobileHandoffMutationOptions(options));
};

export const getRedeemMobileHandoffUrl = () => {
  return `/api/mobile-auth/redeem`;
};

/**
 * @summary Atomically consume a mobile handoff using its native-held verifier
 */
export const redeemMobileHandoff = async (
  mobileHandoffRedemption: MobileHandoffRedemption,
  options?: Parameters<typeof customFetch>[1],
): Promise<MobileHandoffTicket> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<MobileHandoffTicket>(getRedeemMobileHandoffUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(mobileHandoffRedemption),
  });
};

export const getRedeemMobileHandoffMutationKey = () =>
  ["redeemMobileHandoff"] as const;

export const getRedeemMobileHandoffMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redeemMobileHandoff>>,
    TError,
    RedeemMobileHandoffMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof redeemMobileHandoff>>,
  TError,
  RedeemMobileHandoffMutationVariables,
  TContext
> => {
  const mutationKey = getRedeemMobileHandoffMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redeemMobileHandoff>>,
    RedeemMobileHandoffMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return redeemMobileHandoff(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RedeemMobileHandoffMutationResult = NonNullable<
  Awaited<ReturnType<typeof redeemMobileHandoff>>
>;
export type RedeemMobileHandoffMutationBody = BodyType<MobileHandoffRedemption>;
export type RedeemMobileHandoffMutationError = ErrorType<void>;
export type RedeemMobileHandoffMutationVariables = {
  data: BodyType<MobileHandoffRedemption>;
};

/**
 * @summary Atomically consume a mobile handoff using its native-held verifier
 */
export const useRedeemMobileHandoff = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redeemMobileHandoff>>,
    TError,
    RedeemMobileHandoffMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof redeemMobileHandoff>>,
  TError,
  RedeemMobileHandoffMutationVariables,
  TContext
> => {
  return useMutation(getRedeemMobileHandoffMutationOptions(options));
};

export const getGetTemporaryProSummaryUrl = () => {
  return `/api/admin/temporary-pro`;
};

/**
 * Disabled without explicit human Clerk operator allowlist. Bearer authentication required. No-store responses; no activation.
 * @summary Read bounded operator-only Temporary Pro rollout summary
 */
export const getTemporaryProSummary = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<TemporaryProSummary> => {
  return customFetch<TemporaryProSummary>(getGetTemporaryProSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetTemporaryProSummaryQueryKey = () => {
  return [`/api/admin/temporary-pro`] as const;
};

export const getGetTemporaryProSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemporaryProSummary>>,
  TError = ErrorType<TemporaryProError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTemporaryProSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTemporaryProSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTemporaryProSummary>>
  > = ({ signal }) => getTemporaryProSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemporaryProSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTemporaryProSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemporaryProSummary>>
>;
export type GetTemporaryProSummaryQueryError = ErrorType<TemporaryProError>;

/**
 * @summary Read bounded operator-only Temporary Pro rollout summary
 */

export function useGetTemporaryProSummary<
  TData = Awaited<ReturnType<typeof getTemporaryProSummary>>,
  TError = ErrorType<TemporaryProError>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTemporaryProSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTemporaryProSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPreviewTemporaryProRolloutUrl = () => {
  return `/api/admin/temporary-pro/preview`;
};

/**
 * @summary Explicitly collect and persist a test/live mode matched inventory preview
 */
export const previewTemporaryProRollout = async (
  temporaryProAllowlist: TemporaryProAllowlist,
  options?: Parameters<typeof customFetch>[1],
): Promise<TemporaryProPreview> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<TemporaryProPreview>(getPreviewTemporaryProRolloutUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(temporaryProAllowlist),
  });
};

export const getPreviewTemporaryProRolloutMutationKey = () =>
  ["previewTemporaryProRollout"] as const;

export const getPreviewTemporaryProRolloutMutationOptions = <
  TError = ErrorType<TemporaryProError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewTemporaryProRollout>>,
    TError,
    PreviewTemporaryProRolloutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewTemporaryProRollout>>,
  TError,
  PreviewTemporaryProRolloutMutationVariables,
  TContext
> => {
  const mutationKey = getPreviewTemporaryProRolloutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewTemporaryProRollout>>,
    PreviewTemporaryProRolloutMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return previewTemporaryProRollout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewTemporaryProRolloutMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewTemporaryProRollout>>
>;
export type PreviewTemporaryProRolloutMutationBody =
  BodyType<TemporaryProAllowlist>;
export type PreviewTemporaryProRolloutMutationError =
  ErrorType<TemporaryProError>;
export type PreviewTemporaryProRolloutMutationVariables = {
  data: BodyType<TemporaryProAllowlist>;
};

/**
 * @summary Explicitly collect and persist a test/live mode matched inventory preview
 */
export const usePreviewTemporaryProRollout = <
  TError = ErrorType<TemporaryProError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewTemporaryProRollout>>,
    TError,
    PreviewTemporaryProRolloutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewTemporaryProRollout>>,
  TError,
  PreviewTemporaryProRolloutMutationVariables,
  TContext
> => {
  return useMutation(getPreviewTemporaryProRolloutMutationOptions(options));
};

export const getGetTemporaryProRolloutUrl = (
  rolloutId: string,
  params?: GetTemporaryProRolloutParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/temporary-pro/${rolloutId}?${stringifiedParams}`
    : `/api/admin/temporary-pro/${rolloutId}`;
};

/**
 * @summary Read rollout status with a bounded chronological page of recent evidence
 */
export const getTemporaryProRollout = async (
  rolloutId: string,
  params?: GetTemporaryProRolloutParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<TemporaryProStatus> => {
  return customFetch<TemporaryProStatus>(
    getGetTemporaryProRolloutUrl(rolloutId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTemporaryProRolloutQueryKey = (
  rolloutId: string,
  params?: GetTemporaryProRolloutParams,
) => {
  return [
    `/api/admin/temporary-pro/${rolloutId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetTemporaryProRolloutQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemporaryProRollout>>,
  TError = ErrorType<TemporaryProError>,
>(
  rolloutId: string,
  params?: GetTemporaryProRolloutParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTemporaryProRollout>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTemporaryProRolloutQueryKey(rolloutId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTemporaryProRollout>>
  > = ({ signal }) =>
    getTemporaryProRollout(rolloutId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: rolloutId !== null && rolloutId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemporaryProRollout>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTemporaryProRolloutQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemporaryProRollout>>
>;
export type GetTemporaryProRolloutQueryError = ErrorType<TemporaryProError>;

/**
 * @summary Read rollout status with a bounded chronological page of recent evidence
 */

export function useGetTemporaryProRollout<
  TData = Awaited<ReturnType<typeof getTemporaryProRollout>>,
  TError = ErrorType<TemporaryProError>,
>(
  rolloutId: string,
  params?: GetTemporaryProRolloutParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTemporaryProRollout>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTemporaryProRolloutQueryOptions(
    rolloutId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRepreviewTemporaryProRolloutUrl = (rolloutId: string) => {
  return `/api/admin/temporary-pro/${rolloutId}/repreview`;
};

/**
 * @summary Append an amendment preview without applying it
 */
export const repreviewTemporaryProRollout = async (
  rolloutId: string,
  temporaryProAmendmentInput?: TemporaryProAmendmentInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<TemporaryProAmendmentPreview> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<TemporaryProAmendmentPreview>(
    getRepreviewTemporaryProRolloutUrl(rolloutId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(temporaryProAmendmentInput),
    },
  );
};

export const getRepreviewTemporaryProRolloutMutationKey = () =>
  ["repreviewTemporaryProRollout"] as const;

export const getRepreviewTemporaryProRolloutMutationOptions = <
  TError = ErrorType<TemporaryProError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof repreviewTemporaryProRollout>>,
    TError,
    RepreviewTemporaryProRolloutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof repreviewTemporaryProRollout>>,
  TError,
  RepreviewTemporaryProRolloutMutationVariables,
  TContext
> => {
  const mutationKey = getRepreviewTemporaryProRolloutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof repreviewTemporaryProRollout>>,
    RepreviewTemporaryProRolloutMutationVariables
  > = (props) => {
    const { rolloutId, data } = props ?? {};

    return repreviewTemporaryProRollout(rolloutId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RepreviewTemporaryProRolloutMutationResult = NonNullable<
  Awaited<ReturnType<typeof repreviewTemporaryProRollout>>
>;
export type RepreviewTemporaryProRolloutMutationBody =
  | BodyType<TemporaryProAmendmentInput>
  | undefined;
export type RepreviewTemporaryProRolloutMutationError =
  ErrorType<TemporaryProError>;
export type RepreviewTemporaryProRolloutMutationVariables = {
  rolloutId: string;
  data?: BodyType<TemporaryProAmendmentInput>;
};

/**
 * @summary Append an amendment preview without applying it
 */
export const useRepreviewTemporaryProRollout = <
  TError = ErrorType<TemporaryProError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof repreviewTemporaryProRollout>>,
    TError,
    RepreviewTemporaryProRolloutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof repreviewTemporaryProRollout>>,
  TError,
  RepreviewTemporaryProRolloutMutationVariables,
  TContext
> => {
  return useMutation(getRepreviewTemporaryProRolloutMutationOptions(options));
};

export const getApplyTemporaryProRolloutUrl = (rolloutId: string) => {
  return `/api/admin/temporary-pro/${rolloutId}/apply`;
};

/**
 * @summary Explicitly approve exact inventory with server-bound pseudonymous owner
 */
export const applyTemporaryProRollout = async (
  rolloutId: string,
  temporaryProApprovalInput: TemporaryProApprovalInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<TemporaryProApplyResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<TemporaryProApplyResult>(
    getApplyTemporaryProRolloutUrl(rolloutId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(temporaryProApprovalInput),
    },
  );
};

export const getApplyTemporaryProRolloutMutationKey = () =>
  ["applyTemporaryProRollout"] as const;

export const getApplyTemporaryProRolloutMutationOptions = <
  TError = ErrorType<TemporaryProError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyTemporaryProRollout>>,
    TError,
    ApplyTemporaryProRolloutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyTemporaryProRollout>>,
  TError,
  ApplyTemporaryProRolloutMutationVariables,
  TContext
> => {
  const mutationKey = getApplyTemporaryProRolloutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyTemporaryProRollout>>,
    ApplyTemporaryProRolloutMutationVariables
  > = (props) => {
    const { rolloutId, data } = props ?? {};

    return applyTemporaryProRollout(rolloutId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyTemporaryProRolloutMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyTemporaryProRollout>>
>;
export type ApplyTemporaryProRolloutMutationBody =
  BodyType<TemporaryProApprovalInput>;
export type ApplyTemporaryProRolloutMutationError =
  ErrorType<TemporaryProError>;
export type ApplyTemporaryProRolloutMutationVariables = {
  rolloutId: string;
  data: BodyType<TemporaryProApprovalInput>;
};

/**
 * @summary Explicitly approve exact inventory with server-bound pseudonymous owner
 */
export const useApplyTemporaryProRollout = <
  TError = ErrorType<TemporaryProError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyTemporaryProRollout>>,
    TError,
    ApplyTemporaryProRolloutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyTemporaryProRollout>>,
  TError,
  ApplyTemporaryProRolloutMutationVariables,
  TContext
> => {
  return useMutation(getApplyTemporaryProRolloutMutationOptions(options));
};

export const getPreviewTemporaryProResumeUrl = (rolloutId: string) => {
  return `/api/admin/temporary-pro/${rolloutId}/resume-preview`;
};

/**
 * @summary Read-only resume report; never resume billing
 */
export const previewTemporaryProResume = async (
  rolloutId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<TemporaryProResumePreview> => {
  return customFetch<TemporaryProResumePreview>(
    getPreviewTemporaryProResumeUrl(rolloutId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPreviewTemporaryProResumeMutationKey = () =>
  ["previewTemporaryProResume"] as const;

export const getPreviewTemporaryProResumeMutationOptions = <
  TError = ErrorType<TemporaryProError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewTemporaryProResume>>,
    TError,
    PreviewTemporaryProResumeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewTemporaryProResume>>,
  TError,
  PreviewTemporaryProResumeMutationVariables,
  TContext
> => {
  const mutationKey = getPreviewTemporaryProResumeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewTemporaryProResume>>,
    PreviewTemporaryProResumeMutationVariables
  > = (props) => {
    const { rolloutId } = props ?? {};

    return previewTemporaryProResume(rolloutId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewTemporaryProResumeMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewTemporaryProResume>>
>;

export type PreviewTemporaryProResumeMutationError =
  ErrorType<TemporaryProError>;
export type PreviewTemporaryProResumeMutationVariables = { rolloutId: string };

/**
 * @summary Read-only resume report; never resume billing
 */
export const usePreviewTemporaryProResume = <
  TError = ErrorType<TemporaryProError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewTemporaryProResume>>,
    TError,
    PreviewTemporaryProResumeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewTemporaryProResume>>,
  TError,
  PreviewTemporaryProResumeMutationVariables,
  TContext
> => {
  return useMutation(getPreviewTemporaryProResumeMutationOptions(options));
};

export const getVerifyPaidSubscriptionUrl = () => {
  return `/api/stripe/verify-subscription`;
};

/**
 * Authenticated recovery using the member's server-owned billing identity. URL parameters are never proof of access.
 * @summary Verify existing Plate OS billing without creating a payment.
 */
export const verifyPaidSubscription = async (
  paidSubscriptionVerificationInput: PaidSubscriptionVerificationInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaidSubscriptionVerification> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PaidSubscriptionVerification>(
    getVerifyPaidSubscriptionUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(paidSubscriptionVerificationInput),
    },
  );
};

export const getVerifyPaidSubscriptionMutationKey = () =>
  ["verifyPaidSubscription"] as const;

export const getVerifyPaidSubscriptionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyPaidSubscription>>,
    TError,
    VerifyPaidSubscriptionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyPaidSubscription>>,
  TError,
  VerifyPaidSubscriptionMutationVariables,
  TContext
> => {
  const mutationKey = getVerifyPaidSubscriptionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyPaidSubscription>>,
    VerifyPaidSubscriptionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return verifyPaidSubscription(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyPaidSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyPaidSubscription>>
>;
export type VerifyPaidSubscriptionMutationBody =
  BodyType<PaidSubscriptionVerificationInput>;
export type VerifyPaidSubscriptionMutationError = ErrorType<void>;
export type VerifyPaidSubscriptionMutationVariables = {
  data: BodyType<PaidSubscriptionVerificationInput>;
};

/**
 * @summary Verify existing Plate OS billing without creating a payment.
 */
export const useVerifyPaidSubscription = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyPaidSubscription>>,
    TError,
    VerifyPaidSubscriptionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyPaidSubscription>>,
  TError,
  VerifyPaidSubscriptionMutationVariables,
  TContext
> => {
  return useMutation(getVerifyPaidSubscriptionMutationOptions(options));
};

export const getGetMemberBillingUrl = (params?: GetMemberBillingParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/stripe/billing?${stringifiedParams}`
    : `/api/stripe/billing`;
};

/**
 * @summary Read account-scoped subscription and invoice billing history
 */
export const getMemberBilling = async (
  params?: GetMemberBillingParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<MemberBilling> => {
  return customFetch<MemberBilling>(getGetMemberBillingUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetMemberBillingQueryKey = (
  params?: GetMemberBillingParams,
) => {
  return [`/api/stripe/billing`, ...(params ? [params] : [])] as const;
};

export const getGetMemberBillingQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemberBilling>>,
  TError = ErrorType<void>,
>(
  params?: GetMemberBillingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMemberBilling>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMemberBillingQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMemberBilling>>
  > = ({ signal }) => getMemberBilling(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemberBilling>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMemberBillingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemberBilling>>
>;
export type GetMemberBillingQueryError = ErrorType<void>;

/**
 * @summary Read account-scoped subscription and invoice billing history
 */

export function useGetMemberBilling<
  TData = Awaited<ReturnType<typeof getMemberBilling>>,
  TError = ErrorType<void>,
>(
  params?: GetMemberBillingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMemberBilling>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMemberBillingQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSearchAdminBillingSubscriptionsUrl = (
  params?: SearchAdminBillingSubscriptionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/billing/subscriptions?${stringifiedParams}`
    : `/api/admin/billing/subscriptions`;
};

/**
 * @summary Search and page billing subscriptions for human administrators
 */
export const searchAdminBillingSubscriptions = async (
  params?: SearchAdminBillingSubscriptionsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<AdminBillingSubscriptionPage> => {
  return customFetch<AdminBillingSubscriptionPage>(
    getSearchAdminBillingSubscriptionsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getSearchAdminBillingSubscriptionsQueryKey = (
  params?: SearchAdminBillingSubscriptionsParams,
) => {
  return [
    `/api/admin/billing/subscriptions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchAdminBillingSubscriptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchAdminBillingSubscriptions>>,
  TError = ErrorType<void>,
>(
  params?: SearchAdminBillingSubscriptionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchAdminBillingSubscriptions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSearchAdminBillingSubscriptionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchAdminBillingSubscriptions>>
  > = ({ signal }) =>
    searchAdminBillingSubscriptions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchAdminBillingSubscriptions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchAdminBillingSubscriptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchAdminBillingSubscriptions>>
>;
export type SearchAdminBillingSubscriptionsQueryError = ErrorType<void>;

/**
 * @summary Search and page billing subscriptions for human administrators
 */

export function useSearchAdminBillingSubscriptions<
  TData = Awaited<ReturnType<typeof searchAdminBillingSubscriptions>>,
  TError = ErrorType<void>,
>(
  params?: SearchAdminBillingSubscriptionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchAdminBillingSubscriptions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchAdminBillingSubscriptionsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAdminMemberBillingUrl = (
  userId: number,
  params?: GetAdminMemberBillingParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/billing/users/${userId}?${stringifiedParams}`
    : `/api/admin/billing/users/${userId}`;
};

/**
 * @summary Read one member's billing detail and recent operations
 */
export const getAdminMemberBilling = async (
  userId: number,
  params?: GetAdminMemberBillingParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<AdminMemberBilling> => {
  return customFetch<AdminMemberBilling>(
    getGetAdminMemberBillingUrl(userId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminMemberBillingQueryKey = (
  userId: number,
  params?: GetAdminMemberBillingParams,
) => {
  return [
    `/api/admin/billing/users/${userId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminMemberBillingQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminMemberBilling>>,
  TError = ErrorType<void>,
>(
  userId: number,
  params?: GetAdminMemberBillingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminMemberBilling>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminMemberBillingQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminMemberBilling>>
  > = ({ signal }) =>
    getAdminMemberBilling(userId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: userId !== null && userId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminMemberBilling>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminMemberBillingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminMemberBilling>>
>;
export type GetAdminMemberBillingQueryError = ErrorType<void>;

/**
 * @summary Read one member's billing detail and recent operations
 */

export function useGetAdminMemberBilling<
  TData = Awaited<ReturnType<typeof getAdminMemberBilling>>,
  TError = ErrorType<void>,
>(
  userId: number,
  params?: GetAdminMemberBillingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminMemberBilling>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminMemberBillingQueryOptions(
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPreviewAdminBillingRefundUrl = () => {
  return `/api/admin/billing/refund-previews`;
};

/**
 * @summary Calculate and bind a safe refund preview
 */
export const previewAdminBillingRefund = async (
  billingRefundPreviewInput: BillingRefundPreviewInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<BillingRefundPreview> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BillingRefundPreview>(getPreviewAdminBillingRefundUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(billingRefundPreviewInput),
  });
};

export const getPreviewAdminBillingRefundMutationKey = () =>
  ["previewAdminBillingRefund"] as const;

export const getPreviewAdminBillingRefundMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAdminBillingRefund>>,
    TError,
    PreviewAdminBillingRefundMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewAdminBillingRefund>>,
  TError,
  PreviewAdminBillingRefundMutationVariables,
  TContext
> => {
  const mutationKey = getPreviewAdminBillingRefundMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewAdminBillingRefund>>,
    PreviewAdminBillingRefundMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return previewAdminBillingRefund(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewAdminBillingRefundMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewAdminBillingRefund>>
>;
export type PreviewAdminBillingRefundMutationBody =
  BodyType<BillingRefundPreviewInput>;
export type PreviewAdminBillingRefundMutationError = ErrorType<void>;
export type PreviewAdminBillingRefundMutationVariables = {
  data: BodyType<BillingRefundPreviewInput>;
};

/**
 * @summary Calculate and bind a safe refund preview
 */
export const usePreviewAdminBillingRefund = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAdminBillingRefund>>,
    TError,
    PreviewAdminBillingRefundMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewAdminBillingRefund>>,
  TError,
  PreviewAdminBillingRefundMutationVariables,
  TContext
> => {
  return useMutation(getPreviewAdminBillingRefundMutationOptions(options));
};

export const getPreviewAdminBillingCancellationUrl = () => {
  return `/api/admin/billing/cancellation-previews`;
};

/**
 * @summary Resolve current subscription state and effective access-end date
 */
export const previewAdminBillingCancellation = async (
  billingCancellationPreviewInput: BillingCancellationPreviewInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<BillingCancellationPreview> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BillingCancellationPreview>(
    getPreviewAdminBillingCancellationUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(billingCancellationPreviewInput),
    },
  );
};

export const getPreviewAdminBillingCancellationMutationKey = () =>
  ["previewAdminBillingCancellation"] as const;

export const getPreviewAdminBillingCancellationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAdminBillingCancellation>>,
    TError,
    PreviewAdminBillingCancellationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewAdminBillingCancellation>>,
  TError,
  PreviewAdminBillingCancellationMutationVariables,
  TContext
> => {
  const mutationKey = getPreviewAdminBillingCancellationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewAdminBillingCancellation>>,
    PreviewAdminBillingCancellationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return previewAdminBillingCancellation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewAdminBillingCancellationMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewAdminBillingCancellation>>
>;
export type PreviewAdminBillingCancellationMutationBody =
  BodyType<BillingCancellationPreviewInput>;
export type PreviewAdminBillingCancellationMutationError = ErrorType<void>;
export type PreviewAdminBillingCancellationMutationVariables = {
  data: BodyType<BillingCancellationPreviewInput>;
};

/**
 * @summary Resolve current subscription state and effective access-end date
 */
export const usePreviewAdminBillingCancellation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAdminBillingCancellation>>,
    TError,
    PreviewAdminBillingCancellationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewAdminBillingCancellation>>,
  TError,
  PreviewAdminBillingCancellationMutationVariables,
  TContext
> => {
  return useMutation(
    getPreviewAdminBillingCancellationMutationOptions(options),
  );
};

export const getConfirmAdminBillingOperationUrl = () => {
  return `/api/admin/billing/operations`;
};

/**
 * @summary Confirm a previously previewed refund or cancellation
 */
export const confirmAdminBillingOperation = async (
  billingOperationInput: BillingOperationInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<BillingOperation> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BillingOperation>(getConfirmAdminBillingOperationUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(billingOperationInput),
  });
};

export const getConfirmAdminBillingOperationMutationKey = () =>
  ["confirmAdminBillingOperation"] as const;

export const getConfirmAdminBillingOperationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmAdminBillingOperation>>,
    TError,
    ConfirmAdminBillingOperationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmAdminBillingOperation>>,
  TError,
  ConfirmAdminBillingOperationMutationVariables,
  TContext
> => {
  const mutationKey = getConfirmAdminBillingOperationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmAdminBillingOperation>>,
    ConfirmAdminBillingOperationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return confirmAdminBillingOperation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmAdminBillingOperationMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmAdminBillingOperation>>
>;
export type ConfirmAdminBillingOperationMutationBody =
  BodyType<BillingOperationInput>;
export type ConfirmAdminBillingOperationMutationError = ErrorType<void>;
export type ConfirmAdminBillingOperationMutationVariables = {
  data: BodyType<BillingOperationInput>;
};

/**
 * @summary Confirm a previously previewed refund or cancellation
 */
export const useConfirmAdminBillingOperation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmAdminBillingOperation>>,
    TError,
    ConfirmAdminBillingOperationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmAdminBillingOperation>>,
  TError,
  ConfirmAdminBillingOperationMutationVariables,
  TContext
> => {
  return useMutation(getConfirmAdminBillingOperationMutationOptions(options));
};

export const getGetAdminBillingOperationUrl = (operationId: number) => {
  return `/api/admin/billing/operations/${operationId}`;
};

/**
 * @summary Read a durable billing operation
 */
export const getAdminBillingOperation = async (
  operationId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<BillingOperation> => {
  return customFetch<BillingOperation>(
    getGetAdminBillingOperationUrl(operationId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminBillingOperationQueryKey = (operationId: number) => {
  return [`/api/admin/billing/operations/${operationId}`] as const;
};

export const getGetAdminBillingOperationQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminBillingOperation>>,
  TError = ErrorType<void>,
>(
  operationId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminBillingOperation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminBillingOperationQueryKey(operationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminBillingOperation>>
  > = ({ signal }) =>
    getAdminBillingOperation(operationId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: operationId !== null && operationId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminBillingOperation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminBillingOperationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminBillingOperation>>
>;
export type GetAdminBillingOperationQueryError = ErrorType<void>;

/**
 * @summary Read a durable billing operation
 */

export function useGetAdminBillingOperation<
  TData = Awaited<ReturnType<typeof getAdminBillingOperation>>,
  TError = ErrorType<void>,
>(
  operationId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminBillingOperation>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminBillingOperationQueryOptions(
    operationId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetryAdminBillingOperationUrl = (operationId: number) => {
  return `/api/admin/billing/operations/${operationId}/retry`;
};

/**
 * @summary Safely reconcile an unresolved durable operation
 */
export const retryAdminBillingOperation = async (
  operationId: number,
  billingOperationRetryInput: BillingOperationRetryInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<BillingOperation> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BillingOperation>(
    getRetryAdminBillingOperationUrl(operationId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(billingOperationRetryInput),
    },
  );
};

export const getRetryAdminBillingOperationMutationKey = () =>
  ["retryAdminBillingOperation"] as const;

export const getRetryAdminBillingOperationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryAdminBillingOperation>>,
    TError,
    RetryAdminBillingOperationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryAdminBillingOperation>>,
  TError,
  RetryAdminBillingOperationMutationVariables,
  TContext
> => {
  const mutationKey = getRetryAdminBillingOperationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryAdminBillingOperation>>,
    RetryAdminBillingOperationMutationVariables
  > = (props) => {
    const { operationId, data } = props ?? {};

    return retryAdminBillingOperation(operationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryAdminBillingOperationMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryAdminBillingOperation>>
>;
export type RetryAdminBillingOperationMutationBody =
  BodyType<BillingOperationRetryInput>;
export type RetryAdminBillingOperationMutationError = ErrorType<void>;
export type RetryAdminBillingOperationMutationVariables = {
  operationId: number;
  data: BodyType<BillingOperationRetryInput>;
};

/**
 * @summary Safely reconcile an unresolved durable operation
 */
export const useRetryAdminBillingOperation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryAdminBillingOperation>>,
    TError,
    RetryAdminBillingOperationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryAdminBillingOperation>>,
  TError,
  RetryAdminBillingOperationMutationVariables,
  TContext
> => {
  return useMutation(getRetryAdminBillingOperationMutationOptions(options));
};

export const getGetAdminNotificationHealthUrl = () => {
  return `/api/admin/dashboard/notification-health`;
};

/**
 * @summary Read the token-free production push canary health summary.
 */
export const getAdminNotificationHealth = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AdminNotificationHealth> => {
  return customFetch<AdminNotificationHealth>(
    getGetAdminNotificationHealthUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminNotificationHealthQueryKey = () => {
  return [`/api/admin/dashboard/notification-health`] as const;
};

export const getGetAdminNotificationHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminNotificationHealth>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminNotificationHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminNotificationHealthQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminNotificationHealth>>
  > = ({ signal }) => getAdminNotificationHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminNotificationHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminNotificationHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminNotificationHealth>>
>;
export type GetAdminNotificationHealthQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Read the token-free production push canary health summary.
 */

export function useGetAdminNotificationHealth<
  TData = Awaited<ReturnType<typeof getAdminNotificationHealth>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAdminNotificationHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminNotificationHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRunAdminNotificationCheckUrl = () => {
  return `/api/admin/dashboard/notification-health/check`;
};

/**
 * @summary Run one allowlisted test-device canary, globally deduplicated for five minutes.
 */
export const runAdminNotificationCheck = async (
  adminNotificationCheckInput: AdminNotificationCheckInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AdminNotificationCheck> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AdminNotificationCheck>(
    getRunAdminNotificationCheckUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(adminNotificationCheckInput),
    },
  );
};

export const getRunAdminNotificationCheckMutationKey = () =>
  ["runAdminNotificationCheck"] as const;

export const getRunAdminNotificationCheckMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runAdminNotificationCheck>>,
    TError,
    RunAdminNotificationCheckMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runAdminNotificationCheck>>,
  TError,
  RunAdminNotificationCheckMutationVariables,
  TContext
> => {
  const mutationKey = getRunAdminNotificationCheckMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runAdminNotificationCheck>>,
    RunAdminNotificationCheckMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return runAdminNotificationCheck(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunAdminNotificationCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof runAdminNotificationCheck>>
>;
export type RunAdminNotificationCheckMutationBody =
  BodyType<AdminNotificationCheckInput>;
export type RunAdminNotificationCheckMutationError = ErrorType<void>;
export type RunAdminNotificationCheckMutationVariables = {
  data: BodyType<AdminNotificationCheckInput>;
};

/**
 * @summary Run one allowlisted test-device canary, globally deduplicated for five minutes.
 */
export const useRunAdminNotificationCheck = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runAdminNotificationCheck>>,
    TError,
    RunAdminNotificationCheckMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof runAdminNotificationCheck>>,
  TError,
  RunAdminNotificationCheckMutationVariables,
  TContext
> => {
  return useMutation(getRunAdminNotificationCheckMutationOptions(options));
};

export const getGetAdminNotificationCheckUrl = (runId: string) => {
  return `/api/admin/dashboard/notification-health/check/${runId}`;
};

/**
 * @summary Read token-free canary progress.
 */
export const getAdminNotificationCheck = async (
  runId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<PushCanaryStatusResponse> => {
  return customFetch<PushCanaryStatusResponse>(
    getGetAdminNotificationCheckUrl(runId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAdminNotificationCheckQueryKey = (runId: string) => {
  return [`/api/admin/dashboard/notification-health/check/${runId}`] as const;
};

export const getGetAdminNotificationCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminNotificationCheck>>,
  TError = ErrorType<void>,
>(
  runId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminNotificationCheck>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAdminNotificationCheckQueryKey(runId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAdminNotificationCheck>>
  > = ({ signal }) =>
    getAdminNotificationCheck(runId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: runId !== null && runId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminNotificationCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminNotificationCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminNotificationCheck>>
>;
export type GetAdminNotificationCheckQueryError = ErrorType<void>;

/**
 * @summary Read token-free canary progress.
 */

export function useGetAdminNotificationCheck<
  TData = Awaited<ReturnType<typeof getAdminNotificationCheck>>,
  TError = ErrorType<void>,
>(
  runId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminNotificationCheck>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminNotificationCheckQueryOptions(runId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSearchDelegationSubjectsUrl = (
  params: SearchDelegationSubjectsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/delegated-sessions/search?${stringifiedParams}`
    : `/api/admin/delegated-sessions/search`;
};

/**
 * @summary Search pseudonymous eligible delegation subjects
 */
export const searchDelegationSubjects = async (
  params: SearchDelegationSubjectsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<SearchDelegationSubjects200Item[]> => {
  return customFetch<SearchDelegationSubjects200Item[]>(
    getSearchDelegationSubjectsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getSearchDelegationSubjectsQueryKey = (
  params?: SearchDelegationSubjectsParams,
) => {
  return [
    `/api/admin/delegated-sessions/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchDelegationSubjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchDelegationSubjects>>,
  TError = ErrorType<void>,
>(
  params: SearchDelegationSubjectsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchDelegationSubjects>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchDelegationSubjectsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchDelegationSubjects>>
  > = ({ signal }) =>
    searchDelegationSubjects(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchDelegationSubjects>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchDelegationSubjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchDelegationSubjects>>
>;
export type SearchDelegationSubjectsQueryError = ErrorType<void>;

/**
 * @summary Search pseudonymous eligible delegation subjects
 */

export function useSearchDelegationSubjects<
  TData = Awaited<ReturnType<typeof searchDelegationSubjects>>,
  TError = ErrorType<void>,
>(
  params: SearchDelegationSubjectsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchDelegationSubjects>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchDelegationSubjectsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetDelegatedSessionHistoryUrl = (
  params?: GetDelegatedSessionHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/delegated-sessions/history?${stringifiedParams}`
    : `/api/admin/delegated-sessions/history`;
};

/**
 * @summary Review paginated delegated-session lifecycle and usage events
 */
export const getDelegatedSessionHistory = async (
  params?: GetDelegatedSessionHistoryParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DelegatedSessionHistoryPage> => {
  return customFetch<DelegatedSessionHistoryPage>(
    getGetDelegatedSessionHistoryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDelegatedSessionHistoryQueryKey = (
  params?: GetDelegatedSessionHistoryParams,
) => {
  return [
    `/api/admin/delegated-sessions/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDelegatedSessionHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDelegatedSessionHistory>>,
  TError = ErrorType<void>,
>(
  params?: GetDelegatedSessionHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDelegatedSessionHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDelegatedSessionHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDelegatedSessionHistory>>
  > = ({ signal }) =>
    getDelegatedSessionHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDelegatedSessionHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDelegatedSessionHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDelegatedSessionHistory>>
>;
export type GetDelegatedSessionHistoryQueryError = ErrorType<void>;

/**
 * @summary Review paginated delegated-session lifecycle and usage events
 */

export function useGetDelegatedSessionHistory<
  TData = Awaited<ReturnType<typeof getDelegatedSessionHistory>>,
  TError = ErrorType<void>,
>(
  params?: GetDelegatedSessionHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDelegatedSessionHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDelegatedSessionHistoryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getExportDelegatedSessionHistoryUrl = (
  params?: ExportDelegatedSessionHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/delegated-sessions/history/export?${stringifiedParams}`
    : `/api/admin/delegated-sessions/history/export`;
};

/**
 * Admin-only and blocked during delegated identity use. Exports all matching events, not just the displayed page. Refuses more than 1000 events or 2 MiB; narrow the filters rather than downloading a partial record. Subject labels are pseudonymous and cells are formula-injection-safe.
 * @summary Download filtered account-switch events as a timestamped CSV
 */
export const exportDelegatedSessionHistory = async (
  params?: ExportDelegatedSessionHistoryParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Blob> => {
  return customFetch<Blob>(getExportDelegatedSessionHistoryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getExportDelegatedSessionHistoryQueryKey = (
  params?: ExportDelegatedSessionHistoryParams,
) => {
  return [
    `/api/admin/delegated-sessions/history/export`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExportDelegatedSessionHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof exportDelegatedSessionHistory>>,
  TError = ErrorType<void>,
>(
  params?: ExportDelegatedSessionHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportDelegatedSessionHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportDelegatedSessionHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportDelegatedSessionHistory>>
  > = ({ signal }) =>
    exportDelegatedSessionHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportDelegatedSessionHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportDelegatedSessionHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportDelegatedSessionHistory>>
>;
export type ExportDelegatedSessionHistoryQueryError = ErrorType<void>;

/**
 * @summary Download filtered account-switch events as a timestamped CSV
 */

export function useExportDelegatedSessionHistory<
  TData = Awaited<ReturnType<typeof exportDelegatedSessionHistory>>,
  TError = ErrorType<void>,
>(
  params?: ExportDelegatedSessionHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof exportDelegatedSessionHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportDelegatedSessionHistoryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getStartDelegatedSessionUrl = () => {
  return `/api/admin/delegated-sessions`;
};

/**
 * @summary Start a short-lived delegated session
 */
export const startDelegatedSession = async (
  delegatedSessionInput: DelegatedSessionInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<DelegatedSession> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<DelegatedSession>(getStartDelegatedSessionUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(delegatedSessionInput),
  });
};

export const getStartDelegatedSessionMutationKey = () =>
  ["startDelegatedSession"] as const;

export const getStartDelegatedSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startDelegatedSession>>,
    TError,
    StartDelegatedSessionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startDelegatedSession>>,
  TError,
  StartDelegatedSessionMutationVariables,
  TContext
> => {
  const mutationKey = getStartDelegatedSessionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startDelegatedSession>>,
    StartDelegatedSessionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return startDelegatedSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartDelegatedSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof startDelegatedSession>>
>;
export type StartDelegatedSessionMutationBody = BodyType<DelegatedSessionInput>;
export type StartDelegatedSessionMutationError = ErrorType<void>;
export type StartDelegatedSessionMutationVariables = {
  data: BodyType<DelegatedSessionInput>;
};

/**
 * @summary Start a short-lived delegated session
 */
export const useStartDelegatedSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startDelegatedSession>>,
    TError,
    StartDelegatedSessionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startDelegatedSession>>,
  TError,
  StartDelegatedSessionMutationVariables,
  TContext
> => {
  return useMutation(getStartDelegatedSessionMutationOptions(options));
};

export const getGetCurrentDelegatedSessionUrl = () => {
  return `/api/admin/delegated-sessions/current`;
};

/**
 * @summary Validate and return the current delegated session
 */
export const getCurrentDelegatedSession = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<DelegatedSessionState> => {
  return customFetch<DelegatedSessionState>(
    getGetCurrentDelegatedSessionUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCurrentDelegatedSessionQueryKey = () => {
  return [`/api/admin/delegated-sessions/current`] as const;
};

export const getGetCurrentDelegatedSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentDelegatedSession>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentDelegatedSession>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCurrentDelegatedSessionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentDelegatedSession>>
  > = ({ signal }) => getCurrentDelegatedSession({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentDelegatedSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentDelegatedSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentDelegatedSession>>
>;
export type GetCurrentDelegatedSessionQueryError = ErrorType<void>;

/**
 * @summary Validate and return the current delegated session
 */

export function useGetCurrentDelegatedSession<
  TData = Awaited<ReturnType<typeof getCurrentDelegatedSession>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentDelegatedSession>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentDelegatedSessionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEndDelegatedSessionUrl = () => {
  return `/api/admin/delegated-sessions/end`;
};

/**
 * @summary Revoke the current delegated session
 */
export const endDelegatedSession = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<DelegatedSessionState> => {
  return customFetch<DelegatedSessionState>(getEndDelegatedSessionUrl(), {
    ...options,
    method: "POST",
  });
};

export const getEndDelegatedSessionMutationKey = () =>
  ["endDelegatedSession"] as const;

export const getEndDelegatedSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endDelegatedSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof endDelegatedSession>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getEndDelegatedSessionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endDelegatedSession>>,
    void
  > = () => {
    return endDelegatedSession(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EndDelegatedSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof endDelegatedSession>>
>;

export type EndDelegatedSessionMutationError = ErrorType<void>;

/**
 * @summary Revoke the current delegated session
 */
export const useEndDelegatedSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endDelegatedSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof endDelegatedSession>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getEndDelegatedSessionMutationOptions(options));
};

export const getGetCoachAccessStatusUrl = () => {
  return `/api/coach/access-status`;
};

/**
 * @summary Resolve the signed-in Coach entitlement
 */
export const getCoachAccessStatus = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachAccessStatus> => {
  return customFetch<CoachAccessStatus>(getGetCoachAccessStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCoachAccessStatusQueryKey = () => {
  return [`/api/coach/access-status`] as const;
};

export const getGetCoachAccessStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoachAccessStatus>>,
  TError = ErrorType<CoachAccessStatus>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCoachAccessStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCoachAccessStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCoachAccessStatus>>
  > = ({ signal }) => getCoachAccessStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCoachAccessStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCoachAccessStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCoachAccessStatus>>
>;
export type GetCoachAccessStatusQueryError = ErrorType<CoachAccessStatus>;

/**
 * @summary Resolve the signed-in Coach entitlement
 */

export function useGetCoachAccessStatus<
  TData = Awaited<ReturnType<typeof getCoachAccessStatus>>,
  TError = ErrorType<CoachAccessStatus>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCoachAccessStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCoachAccessStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetCoachDashboardUrl = () => {
  return `/api/coach/dashboard`;
};

/**
 * @summary Get the entitled Coach dashboard
 */
export const getCoachDashboard = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachDashboard> => {
  return customFetch<CoachDashboard>(getGetCoachDashboardUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCoachDashboardQueryKey = () => {
  return [`/api/coach/dashboard`] as const;
};

export const getGetCoachDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoachDashboard>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCoachDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCoachDashboardQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCoachDashboard>>
  > = ({ signal }) => getCoachDashboard({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCoachDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCoachDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCoachDashboard>>
>;
export type GetCoachDashboardQueryError = ErrorType<void>;

/**
 * @summary Get the entitled Coach dashboard
 */

export function useGetCoachDashboard<
  TData = Awaited<ReturnType<typeof getCoachDashboard>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCoachDashboard>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCoachDashboardQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListCoachManagedUsersUrl = () => {
  return `/api/coach/managed-users`;
};

/**
 * @summary List authoritative active managed users
 */
export const listCoachManagedUsers = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachManagedUsers> => {
  return customFetch<CoachManagedUsers>(getListCoachManagedUsersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCoachManagedUsersQueryKey = () => {
  return [`/api/coach/managed-users`] as const;
};

export const getListCoachManagedUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listCoachManagedUsers>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCoachManagedUsers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCoachManagedUsersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCoachManagedUsers>>
  > = ({ signal }) => listCoachManagedUsers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCoachManagedUsers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCoachManagedUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCoachManagedUsers>>
>;
export type ListCoachManagedUsersQueryError = ErrorType<void>;

/**
 * @summary List authoritative active managed users
 */

export function useListCoachManagedUsers<
  TData = Awaited<ReturnType<typeof listCoachManagedUsers>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCoachManagedUsers>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCoachManagedUsersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getQuoteCoachAssignmentUrl = () => {
  return `/api/coach/assignments/quote`;
};

/**
 * @summary Quote activation using the server-side active count
 */
export const quoteCoachAssignment = async (
  coachAssignmentTarget: CoachAssignmentTarget,
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachAssignmentQuote> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CoachAssignmentQuote>(getQuoteCoachAssignmentUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(coachAssignmentTarget),
  });
};

export const getQuoteCoachAssignmentMutationKey = () =>
  ["quoteCoachAssignment"] as const;

export const getQuoteCoachAssignmentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof quoteCoachAssignment>>,
    TError,
    QuoteCoachAssignmentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof quoteCoachAssignment>>,
  TError,
  QuoteCoachAssignmentMutationVariables,
  TContext
> => {
  const mutationKey = getQuoteCoachAssignmentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof quoteCoachAssignment>>,
    QuoteCoachAssignmentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return quoteCoachAssignment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuoteCoachAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof quoteCoachAssignment>>
>;
export type QuoteCoachAssignmentMutationBody = BodyType<CoachAssignmentTarget>;
export type QuoteCoachAssignmentMutationError = ErrorType<void>;
export type QuoteCoachAssignmentMutationVariables = {
  data: BodyType<CoachAssignmentTarget>;
};

/**
 * @summary Quote activation using the server-side active count
 */
export const useQuoteCoachAssignment = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof quoteCoachAssignment>>,
    TError,
    QuoteCoachAssignmentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof quoteCoachAssignment>>,
  TError,
  QuoteCoachAssignmentMutationVariables,
  TContext
> => {
  return useMutation(getQuoteCoachAssignmentMutationOptions(options));
};

export const getActivateCoachAssignmentUrl = () => {
  return `/api/coach/assignments/activate`;
};

/**
 * @summary Atomically bill and activate a managed user
 */
export const activateCoachAssignment = async (
  coachAssignmentMutation: CoachAssignmentMutation,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<void>(getActivateCoachAssignmentUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(coachAssignmentMutation),
  });
};

export const getActivateCoachAssignmentMutationKey = () =>
  ["activateCoachAssignment"] as const;

export const getActivateCoachAssignmentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateCoachAssignment>>,
    TError,
    ActivateCoachAssignmentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof activateCoachAssignment>>,
  TError,
  ActivateCoachAssignmentMutationVariables,
  TContext
> => {
  const mutationKey = getActivateCoachAssignmentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof activateCoachAssignment>>,
    ActivateCoachAssignmentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return activateCoachAssignment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActivateCoachAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof activateCoachAssignment>>
>;
export type ActivateCoachAssignmentMutationBody =
  BodyType<CoachAssignmentMutation>;
export type ActivateCoachAssignmentMutationError = ErrorType<void>;
export type ActivateCoachAssignmentMutationVariables = {
  data: BodyType<CoachAssignmentMutation>;
};

/**
 * @summary Atomically bill and activate a managed user
 */
export const useActivateCoachAssignment = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof activateCoachAssignment>>,
    TError,
    ActivateCoachAssignmentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof activateCoachAssignment>>,
  TError,
  ActivateCoachAssignmentMutationVariables,
  TContext
> => {
  return useMutation(getActivateCoachAssignmentMutationOptions(options));
};

export const getRemoveCoachManagedUserUrl = (managedUserId: number) => {
  return `/api/coach/managed-users/${managedUserId}/remove`;
};

/**
 * @summary Remove access immediately and decrease renewal quantity without credit
 */
export const removeCoachManagedUser = async (
  managedUserId: number,
  coachRemoveManagedUserBody: CoachRemoveManagedUserBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<void>(getRemoveCoachManagedUserUrl(managedUserId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(coachRemoveManagedUserBody),
  });
};

export const getRemoveCoachManagedUserMutationKey = () =>
  ["removeCoachManagedUser"] as const;

export const getRemoveCoachManagedUserMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeCoachManagedUser>>,
    TError,
    RemoveCoachManagedUserMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeCoachManagedUser>>,
  TError,
  RemoveCoachManagedUserMutationVariables,
  TContext
> => {
  const mutationKey = getRemoveCoachManagedUserMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeCoachManagedUser>>,
    RemoveCoachManagedUserMutationVariables
  > = (props) => {
    const { managedUserId, data } = props ?? {};

    return removeCoachManagedUser(managedUserId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveCoachManagedUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeCoachManagedUser>>
>;
export type RemoveCoachManagedUserMutationBody =
  BodyType<CoachRemoveManagedUserBody>;
export type RemoveCoachManagedUserMutationError = ErrorType<void>;
export type RemoveCoachManagedUserMutationVariables = {
  managedUserId: number;
  data: BodyType<CoachRemoveManagedUserBody>;
};

/**
 * @summary Remove access immediately and decrease renewal quantity without credit
 */
export const useRemoveCoachManagedUser = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeCoachManagedUser>>,
    TError,
    RemoveCoachManagedUserMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeCoachManagedUser>>,
  TError,
  RemoveCoachManagedUserMutationVariables,
  TContext
> => {
  return useMutation(getRemoveCoachManagedUserMutationOptions(options));
};

export const getCreateCoachCheckoutUrl = () => {
  return `/api/coach/checkout`;
};

/**
 * @summary Create automatic-tax Coach checkout with separate subscription items
 */
export const createCoachCheckout = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BillingUrl> => {
  return customFetch<BillingUrl>(getCreateCoachCheckoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getCreateCoachCheckoutMutationKey = () =>
  ["createCoachCheckout"] as const;

export const getCreateCoachCheckoutMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCoachCheckout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCoachCheckout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCreateCoachCheckoutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCoachCheckout>>,
    void
  > = () => {
    return createCoachCheckout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCoachCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCoachCheckout>>
>;

export type CreateCoachCheckoutMutationError = ErrorType<void>;

/**
 * @summary Create automatic-tax Coach checkout with separate subscription items
 */
export const useCreateCoachCheckout = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCoachCheckout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCoachCheckout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCreateCoachCheckoutMutationOptions(options));
};

export const getCreateCoachBillingRemediationUrl = () => {
  return `/api/coach/remediation`;
};

/**
 * @summary Create a billing portal session even while delinquent
 */
export const createCoachBillingRemediation = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BillingUrl> => {
  return customFetch<BillingUrl>(getCreateCoachBillingRemediationUrl(), {
    ...options,
    method: "POST",
  });
};

export const getCreateCoachBillingRemediationMutationKey = () =>
  ["createCoachBillingRemediation"] as const;

export const getCreateCoachBillingRemediationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCoachBillingRemediation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCoachBillingRemediation>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getCreateCoachBillingRemediationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCoachBillingRemediation>>,
    void
  > = () => {
    return createCoachBillingRemediation(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCoachBillingRemediationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCoachBillingRemediation>>
>;

export type CreateCoachBillingRemediationMutationError = ErrorType<void>;

/**
 * @summary Create a billing portal session even while delinquent
 */
export const useCreateCoachBillingRemediation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCoachBillingRemediation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCoachBillingRemediation>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getCreateCoachBillingRemediationMutationOptions(options));
};

export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

/**
 * @summary Health check
 */
export const healthCheck = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getBillingReadinessCheckUrl = () => {
  return `/api/healthz/billing`;
};

/**
 * Reports billing initialization readiness only, not member entitlement or subscription access. The response contains safe aggregate stage state only and excludes credentials, contact details, and raw billing payloads.
 * @summary Read operator billing initialization readiness
 */
export const billingReadinessCheck = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BillingReadiness> => {
  return customFetch<BillingReadiness>(getBillingReadinessCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getBillingReadinessCheckQueryKey = () => {
  return [`/api/healthz/billing`] as const;
};

export const getBillingReadinessCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof billingReadinessCheck>>,
  TError = ErrorType<BillingReadiness>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof billingReadinessCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingReadinessCheckQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billingReadinessCheck>>
  > = ({ signal }) => billingReadinessCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingReadinessCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BillingReadinessCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingReadinessCheck>>
>;
export type BillingReadinessCheckQueryError = ErrorType<BillingReadiness>;

/**
 * @summary Read operator billing initialization readiness
 */

export function useBillingReadinessCheck<
  TData = Awaited<ReturnType<typeof billingReadinessCheck>>,
  TError = ErrorType<BillingReadiness>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof billingReadinessCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBillingReadinessCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getBillingAlertCoordinationCheckUrl = () => {
  return `/api/healthz/billing-alert-coordination`;
};

/**
 * Bounded storage canary and safe process-local operation counters. Never releases alert claims, sends notifications, or checks member access.
 * @summary Check shared initialization alert coordination independently of billing
 */
export const billingAlertCoordinationCheck = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BillingAlertCoordination> => {
  return customFetch<BillingAlertCoordination>(
    getBillingAlertCoordinationCheckUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getBillingAlertCoordinationCheckQueryKey = () => {
  return [`/api/healthz/billing-alert-coordination`] as const;
};

export const getBillingAlertCoordinationCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof billingAlertCoordinationCheck>>,
  TError = ErrorType<BillingAlertCoordination>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof billingAlertCoordinationCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBillingAlertCoordinationCheckQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billingAlertCoordinationCheck>>
  > = ({ signal }) =>
    billingAlertCoordinationCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingAlertCoordinationCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BillingAlertCoordinationCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingAlertCoordinationCheck>>
>;
export type BillingAlertCoordinationCheckQueryError =
  ErrorType<BillingAlertCoordination>;

/**
 * @summary Check shared initialization alert coordination independently of billing
 */

export function useBillingAlertCoordinationCheck<
  TData = Awaited<ReturnType<typeof billingAlertCoordinationCheck>>,
  TError = ErrorType<BillingAlertCoordination>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof billingAlertCoordinationCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBillingAlertCoordinationCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getBillingAlertDeliveryCheckUrl = () => {
  return `/api/healthz/billing-alert-delivery`;
};

/**
 * Public bounded read of the shared delivery ledger, independent of the billing database. Never sends, retries, creates or resets an outage. Accepted means provider acceptance, not inbox delivery. Inactive means no recoverable intent, not proof that a generic alert was delivered.
 * @summary Read aggregate recoverable billing email delivery state
 */
export const billingAlertDeliveryCheck = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BillingAlertDelivery> => {
  return customFetch<BillingAlertDelivery>(getBillingAlertDeliveryCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getBillingAlertDeliveryCheckQueryKey = () => {
  return [`/api/healthz/billing-alert-delivery`] as const;
};

export const getBillingAlertDeliveryCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof billingAlertDeliveryCheck>>,
  TError = ErrorType<BillingAlertDelivery>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof billingAlertDeliveryCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBillingAlertDeliveryCheckQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billingAlertDeliveryCheck>>
  > = ({ signal }) => billingAlertDeliveryCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingAlertDeliveryCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BillingAlertDeliveryCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingAlertDeliveryCheck>>
>;
export type BillingAlertDeliveryCheckQueryError =
  ErrorType<BillingAlertDelivery>;

/**
 * @summary Read aggregate recoverable billing email delivery state
 */

export function useBillingAlertDeliveryCheck<
  TData = Awaited<ReturnType<typeof billingAlertDeliveryCheck>>,
  TError = ErrorType<BillingAlertDelivery>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof billingAlertDeliveryCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBillingAlertDeliveryCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getBillingSyncHealthCheckUrl = () => {
  return `/api/healthz/billing-sync`;
};

/**
 * Read-only observations, not initialization readiness, settlement or member access.
 * @summary Read aggregate ongoing billing synchronization evidence
 */
export const billingSyncHealthCheck = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BillingSyncHealth> => {
  return customFetch<BillingSyncHealth>(getBillingSyncHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getBillingSyncHealthCheckQueryKey = () => {
  return [`/api/healthz/billing-sync`] as const;
};

export const getBillingSyncHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof billingSyncHealthCheck>>,
  TError = ErrorType<BillingSyncHealth>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof billingSyncHealthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBillingSyncHealthCheckQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billingSyncHealthCheck>>
  > = ({ signal }) => billingSyncHealthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingSyncHealthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BillingSyncHealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingSyncHealthCheck>>
>;
export type BillingSyncHealthCheckQueryError = ErrorType<BillingSyncHealth>;

/**
 * @summary Read aggregate ongoing billing synchronization evidence
 */

export function useBillingSyncHealthCheck<
  TData = Awaited<ReturnType<typeof billingSyncHealthCheck>>,
  TError = ErrorType<BillingSyncHealth>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof billingSyncHealthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBillingSyncHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetOnboardingStatusUrl = () => {
  return `/api/auth/onboarding-status`;
};

/**
 * @summary Read historical signup progress without provisioning or identity reconciliation
 */
export const getOnboardingStatus = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<OnboardingStatus> => {
  return customFetch<OnboardingStatus>(getGetOnboardingStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetOnboardingStatusQueryKey = () => {
  return [`/api/auth/onboarding-status`] as const;
};

export const getGetOnboardingStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getOnboardingStatus>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOnboardingStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOnboardingStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOnboardingStatus>>
  > = ({ signal }) => getOnboardingStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOnboardingStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetOnboardingStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOnboardingStatus>>
>;
export type GetOnboardingStatusQueryError = ErrorType<void>;

/**
 * @summary Read historical signup progress without provisioning or identity reconciliation
 */

export function useGetOnboardingStatus<
  TData = Awaited<ReturnType<typeof getOnboardingStatus>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getOnboardingStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOnboardingStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRecordAgeIneligibilityUrl = () => {
  return `/api/auth/age-ineligible`;
};

/**
 * @summary Stop onboarding and schedule identity-only account deletion
 */
export const recordAgeIneligibility = async (
  ageIneligibilityInput: AgeIneligibilityInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<void>(getRecordAgeIneligibilityUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(ageIneligibilityInput),
  });
};

export const getRecordAgeIneligibilityMutationKey = () =>
  ["recordAgeIneligibility"] as const;

export const getRecordAgeIneligibilityMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordAgeIneligibility>>,
    TError,
    RecordAgeIneligibilityMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordAgeIneligibility>>,
  TError,
  RecordAgeIneligibilityMutationVariables,
  TContext
> => {
  const mutationKey = getRecordAgeIneligibilityMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordAgeIneligibility>>,
    RecordAgeIneligibilityMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return recordAgeIneligibility(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordAgeIneligibilityMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordAgeIneligibility>>
>;
export type RecordAgeIneligibilityMutationBody =
  BodyType<AgeIneligibilityInput>;
export type RecordAgeIneligibilityMutationError = ErrorType<void>;
export type RecordAgeIneligibilityMutationVariables = {
  data: BodyType<AgeIneligibilityInput>;
};

/**
 * @summary Stop onboarding and schedule identity-only account deletion
 */
export const useRecordAgeIneligibility = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordAgeIneligibility>>,
    TError,
    RecordAgeIneligibilityMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordAgeIneligibility>>,
  TError,
  RecordAgeIneligibilityMutationVariables,
  TContext
> => {
  return useMutation(getRecordAgeIneligibilityMutationOptions(options));
};

export const getRegisterUserUrl = () => {
  return `/api/auth/register`;
};

/**
 * @summary Register a new user
 */
export const registerUser = async (
  registerUserBody: RegisterUserBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<AuthResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AuthResponse>(getRegisterUserUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(registerUserBody),
  });
};

export const getRegisterUserMutationKey = () => ["registerUser"] as const;

export const getRegisterUserMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerUser>>,
    TError,
    RegisterUserMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerUser>>,
  TError,
  RegisterUserMutationVariables,
  TContext
> => {
  const mutationKey = getRegisterUserMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerUser>>,
    RegisterUserMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return registerUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerUser>>
>;
export type RegisterUserMutationBody = BodyType<RegisterUserBody>;
export type RegisterUserMutationError = ErrorType<ErrorResponse>;
export type RegisterUserMutationVariables = {
  data: BodyType<RegisterUserBody>;
};

/**
 * @summary Register a new user
 */
export const useRegisterUser = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerUser>>,
    TError,
    RegisterUserMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerUser>>,
  TError,
  RegisterUserMutationVariables,
  TContext
> => {
  return useMutation(getRegisterUserMutationOptions(options));
};

export const getLoginUserUrl = () => {
  return `/api/auth/login`;
};

/**
 * @summary Login user
 */
export const loginUser = async (
  loginUserBody: LoginUserBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<AuthResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AuthResponse>(getLoginUserUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(loginUserBody),
  });
};

export const getLoginUserMutationKey = () => ["loginUser"] as const;

export const getLoginUserMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginUser>>,
    TError,
    LoginUserMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginUser>>,
  TError,
  LoginUserMutationVariables,
  TContext
> => {
  const mutationKey = getLoginUserMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginUser>>,
    LoginUserMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return loginUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginUser>>
>;
export type LoginUserMutationBody = BodyType<LoginUserBody>;
export type LoginUserMutationError = ErrorType<ErrorResponse>;
export type LoginUserMutationVariables = { data: BodyType<LoginUserBody> };

/**
 * @summary Login user
 */
export const useLoginUser = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginUser>>,
    TError,
    LoginUserMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof loginUser>>,
  TError,
  LoginUserMutationVariables,
  TContext
> => {
  return useMutation(getLoginUserMutationOptions(options));
};

export const getLogoutUserUrl = () => {
  return `/api/auth/logout`;
};

/**
 * @summary Logout user
 */
export const logoutUser = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getLogoutUserUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutUserMutationKey = () => ["logoutUser"] as const;

export const getLogoutUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutUser>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logoutUser>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getLogoutUserMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logoutUser>>,
    void
  > = () => {
    return logoutUser(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof logoutUser>>
>;

export type LogoutUserMutationError = ErrorType<unknown>;

/**
 * @summary Logout user
 */
export const useLogoutUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutUser>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logoutUser>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutUserMutationOptions(options));
};

export const getForgotPasswordUrl = () => {
  return `/api/auth/forgot-password`;
};

/**
 * @summary Request a password reset token
 */
export const forgotPassword = async (
  forgotPasswordBody: ForgotPasswordBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<ForgotPasswordResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ForgotPasswordResponse>(getForgotPasswordUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(forgotPasswordBody),
  });
};

export const getForgotPasswordMutationKey = () => ["forgotPassword"] as const;

export const getForgotPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    ForgotPasswordMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  ForgotPasswordMutationVariables,
  TContext
> => {
  const mutationKey = getForgotPasswordMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof forgotPassword>>,
    ForgotPasswordMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return forgotPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof forgotPassword>>
>;
export type ForgotPasswordMutationBody = BodyType<ForgotPasswordBody>;
export type ForgotPasswordMutationError = ErrorType<unknown>;
export type ForgotPasswordMutationVariables = {
  data: BodyType<ForgotPasswordBody>;
};

/**
 * @summary Request a password reset token
 */
export const useForgotPassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    ForgotPasswordMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  ForgotPasswordMutationVariables,
  TContext
> => {
  return useMutation(getForgotPasswordMutationOptions(options));
};

export const getResetPasswordUrl = () => {
  return `/api/auth/reset-password`;
};

/**
 * @summary Reset password using a token
 */
export const resetPassword = async (
  resetPasswordBody: ResetPasswordBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<MessageResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<MessageResponse>(getResetPasswordUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(resetPasswordBody),
  });
};

export const getResetPasswordMutationKey = () => ["resetPassword"] as const;

export const getResetPasswordMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    ResetPasswordMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  ResetPasswordMutationVariables,
  TContext
> => {
  const mutationKey = getResetPasswordMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetPassword>>,
    ResetPasswordMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return resetPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetPassword>>
>;
export type ResetPasswordMutationBody = BodyType<ResetPasswordBody>;
export type ResetPasswordMutationError = ErrorType<ErrorResponse>;
export type ResetPasswordMutationVariables = {
  data: BodyType<ResetPasswordBody>;
};

/**
 * @summary Reset password using a token
 */
export const useResetPassword = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    ResetPasswordMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  ResetPasswordMutationVariables,
  TContext
> => {
  return useMutation(getResetPasswordMutationOptions(options));
};

export const getGetCurrentUserUrl = () => {
  return `/api/auth/me`;
};

/**
 * @summary Get current logged in user
 */
export const getCurrentUser = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<User> => {
  return customFetch<User>(getGetCurrentUserUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCurrentUserQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({
    signal,
  }) => getCurrentUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUser>>
>;
export type GetCurrentUserQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current logged in user
 */

export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateCurrentUserUrl = () => {
  return `/api/auth/me`;
};

/**
 * @summary Update current user profile
 */
export const updateCurrentUser = async (
  updateUserBody: UpdateUserBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<User> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<User>(getUpdateCurrentUserUrl(), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(updateUserBody),
  });
};

export const getUpdateCurrentUserMutationKey = () =>
  ["updateCurrentUser"] as const;

export const getUpdateCurrentUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    TError,
    UpdateCurrentUserMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCurrentUser>>,
  TError,
  UpdateCurrentUserMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateCurrentUserMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    UpdateCurrentUserMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateCurrentUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCurrentUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCurrentUser>>
>;
export type UpdateCurrentUserMutationBody = BodyType<UpdateUserBody>;
export type UpdateCurrentUserMutationError = ErrorType<unknown>;
export type UpdateCurrentUserMutationVariables = {
  data: BodyType<UpdateUserBody>;
};

/**
 * @summary Update current user profile
 */
export const useUpdateCurrentUser = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    TError,
    UpdateCurrentUserMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCurrentUser>>,
  TError,
  UpdateCurrentUserMutationVariables,
  TContext
> => {
  return useMutation(getUpdateCurrentUserMutationOptions(options));
};

export const getDeleteCurrentUserUrl = () => {
  return `/api/auth/me`;
};

/**
 * @summary Delete the current user's account row from the database
 */
export const deleteCurrentUser = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteCurrentUserUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCurrentUserMutationKey = () =>
  ["deleteCurrentUser"] as const;

export const getDeleteCurrentUserMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCurrentUser>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCurrentUser>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getDeleteCurrentUserMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCurrentUser>>,
    void
  > = () => {
    return deleteCurrentUser(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCurrentUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCurrentUser>>
>;

export type DeleteCurrentUserMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete the current user's account row from the database
 */
export const useDeleteCurrentUser = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCurrentUser>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCurrentUser>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteCurrentUserMutationOptions(options));
};

export const getGetMemberIntakeStatusUrl = () => {
  return `/api/intake/status`;
};

/**
 * @summary Read the authenticated member's intake verification status.
 */
export const getMemberIntakeStatus = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<MemberIntakeStatus> => {
  return customFetch<MemberIntakeStatus>(getGetMemberIntakeStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMemberIntakeStatusQueryKey = () => {
  return [`/api/intake/status`] as const;
};

export const getGetMemberIntakeStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getMemberIntakeStatus>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMemberIntakeStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMemberIntakeStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMemberIntakeStatus>>
  > = ({ signal }) => getMemberIntakeStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMemberIntakeStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMemberIntakeStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMemberIntakeStatus>>
>;
export type GetMemberIntakeStatusQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Read the authenticated member's intake verification status.
 */

export function useGetMemberIntakeStatus<
  TData = Awaited<ReturnType<typeof getMemberIntakeStatus>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMemberIntakeStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMemberIntakeStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getStartMemberIntakeUrl = () => {
  return `/api/intake/start`;
};

/**
 * @summary Create a short-lived hosted intake launch for the authenticated member.
 */
export const startMemberIntake = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<MemberIntakeStart> => {
  return customFetch<MemberIntakeStart>(getStartMemberIntakeUrl(), {
    ...options,
    method: "POST",
  });
};

export const getStartMemberIntakeMutationKey = () =>
  ["startMemberIntake"] as const;

export const getStartMemberIntakeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startMemberIntake>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startMemberIntake>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getStartMemberIntakeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startMemberIntake>>,
    void
  > = () => {
    return startMemberIntake(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartMemberIntakeMutationResult = NonNullable<
  Awaited<ReturnType<typeof startMemberIntake>>
>;

export type StartMemberIntakeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Create a short-lived hosted intake launch for the authenticated member.
 */
export const useStartMemberIntake = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startMemberIntake>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startMemberIntake>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getStartMemberIntakeMutationOptions(options));
};

export const getListFoodsUrl = (params?: ListFoodsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/foods?${stringifiedParams}`
    : `/api/foods`;
};

/**
 * @summary List all foods
 */
export const listFoods = async (
  params?: ListFoodsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Food[]> => {
  return customFetch<Food[]>(getListFoodsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListFoodsQueryKey = (params?: ListFoodsParams) => {
  return [`/api/foods`, ...(params ? [params] : [])] as const;
};

export const getListFoodsQueryOptions = <
  TData = Awaited<ReturnType<typeof listFoods>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFoodsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFoods>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFoodsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFoods>>> = ({
    signal,
  }) => listFoods(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFoods>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFoodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFoods>>
>;
export type ListFoodsQueryError = ErrorType<unknown>;

/**
 * @summary List all foods
 */

export function useListFoods<
  TData = Awaited<ReturnType<typeof listFoods>>,
  TError = ErrorType<unknown>,
>(
  params?: ListFoodsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listFoods>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFoodsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateFoodUrl = () => {
  return `/api/foods`;
};

/**
 * @summary Create a new food
 */
export const createFood = async (
  createFoodBody: CreateFoodBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Food> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<Food>(getCreateFoodUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(createFoodBody),
  });
};

export const getCreateFoodMutationKey = () => ["createFood"] as const;

export const getCreateFoodMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFood>>,
    TError,
    CreateFoodMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFood>>,
  TError,
  CreateFoodMutationVariables,
  TContext
> => {
  const mutationKey = getCreateFoodMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFood>>,
    CreateFoodMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createFood(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFoodMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFood>>
>;
export type CreateFoodMutationBody = BodyType<CreateFoodBody>;
export type CreateFoodMutationError = ErrorType<unknown>;
export type CreateFoodMutationVariables = { data: BodyType<CreateFoodBody> };

/**
 * @summary Create a new food
 */
export const useCreateFood = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFood>>,
    TError,
    CreateFoodMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createFood>>,
  TError,
  CreateFoodMutationVariables,
  TContext
> => {
  return useMutation(getCreateFoodMutationOptions(options));
};

export const getGetFoodUrl = (id: number) => {
  return `/api/foods/${id}`;
};

/**
 * @summary Get food by ID
 */
export const getFood = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Food> => {
  return customFetch<Food>(getGetFoodUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetFoodQueryKey = (id: number) => {
  return [`/api/foods/${id}`] as const;
};

export const getGetFoodQueryOptions = <
  TData = Awaited<ReturnType<typeof getFood>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFood>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFoodQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFood>>> = ({
    signal,
  }) => getFood(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getFood>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetFoodQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFood>>
>;
export type GetFoodQueryError = ErrorType<unknown>;

/**
 * @summary Get food by ID
 */

export function useGetFood<
  TData = Awaited<ReturnType<typeof getFood>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getFood>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFoodQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateFoodUrl = (id: number) => {
  return `/api/foods/${id}`;
};

/**
 * @summary Update food
 */
export const updateFood = async (
  id: number,
  updateFoodBody: UpdateFoodBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Food> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<Food>(getUpdateFoodUrl(id), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(updateFoodBody),
  });
};

export const getUpdateFoodMutationKey = () => ["updateFood"] as const;

export const getUpdateFoodMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFood>>,
    TError,
    UpdateFoodMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFood>>,
  TError,
  UpdateFoodMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateFoodMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFood>>,
    UpdateFoodMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return updateFood(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFoodMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFood>>
>;
export type UpdateFoodMutationBody = BodyType<UpdateFoodBody>;
export type UpdateFoodMutationError = ErrorType<unknown>;
export type UpdateFoodMutationVariables = {
  id: number;
  data: BodyType<UpdateFoodBody>;
};

/**
 * @summary Update food
 */
export const useUpdateFood = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFood>>,
    TError,
    UpdateFoodMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateFood>>,
  TError,
  UpdateFoodMutationVariables,
  TContext
> => {
  return useMutation(getUpdateFoodMutationOptions(options));
};

export const getDeleteFoodUrl = (id: number) => {
  return `/api/foods/${id}`;
};

/**
 * @summary Delete food
 */
export const deleteFood = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getDeleteFoodUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteFoodMutationKey = () => ["deleteFood"] as const;

export const getDeleteFoodMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFood>>,
    TError,
    DeleteFoodMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFood>>,
  TError,
  DeleteFoodMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteFoodMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFood>>,
    DeleteFoodMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return deleteFood(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFoodMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFood>>
>;

export type DeleteFoodMutationError = ErrorType<unknown>;
export type DeleteFoodMutationVariables = { id: number };

/**
 * @summary Delete food
 */
export const useDeleteFood = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFood>>,
    TError,
    DeleteFoodMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteFood>>,
  TError,
  DeleteFoodMutationVariables,
  TContext
> => {
  return useMutation(getDeleteFoodMutationOptions(options));
};

export const getListMetricsUrl = (params?: ListMetricsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/metrics?${stringifiedParams}`
    : `/api/metrics`;
};

/**
 * @summary List metric catalog
 */
export const listMetrics = async (
  params?: ListMetricsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Metric[]> => {
  return customFetch<Metric[]>(getListMetricsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMetricsQueryKey = (params?: ListMetricsParams) => {
  return [`/api/metrics`, ...(params ? [params] : [])] as const;
};

export const getListMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMetrics>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMetricsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMetrics>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMetricsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMetrics>>> = ({
    signal,
  }) => listMetrics(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMetrics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMetricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMetrics>>
>;
export type ListMetricsQueryError = ErrorType<unknown>;

/**
 * @summary List metric catalog
 */

export function useListMetrics<
  TData = Awaited<ReturnType<typeof listMetrics>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMetricsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMetrics>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMetricsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetMetricsPlateUrl = (params: GetMetricsPlateParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/metrics/plate?${stringifiedParams}`
    : `/api/metrics/plate`;
};

/**
 * Returns the canonical catalog inventory plus only the authenticated
 * member's date-scoped nutrition snapshots and consent-gated, audited
 * blood and genetic evidence. The response is private and must not be
 * cached. Legacy blood and DNA catalog inventory remains informational;
 * DNA actions require an exact approved rule match.
 * @summary Read the member-scoped nutrition, blood, and DNA plate inventory for a date
 */
export const getMetricsPlate = async (
  params: GetMetricsPlateParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<MetricsPlateResponse> => {
  return customFetch<MetricsPlateResponse>(getGetMetricsPlateUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetMetricsPlateQueryKey = (params?: GetMetricsPlateParams) => {
  return [`/api/metrics/plate`, ...(params ? [params] : [])] as const;
};

export const getGetMetricsPlateQueryOptions = <
  TData = Awaited<ReturnType<typeof getMetricsPlate>>,
  TError = ErrorType<ErrorResponse | void>,
>(
  params: GetMetricsPlateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMetricsPlate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMetricsPlateQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetricsPlate>>> = ({
    signal,
  }) => getMetricsPlate(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMetricsPlate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMetricsPlateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMetricsPlate>>
>;
export type GetMetricsPlateQueryError = ErrorType<ErrorResponse | void>;

/**
 * @summary Read the member-scoped nutrition, blood, and DNA plate inventory for a date
 */

export function useGetMetricsPlate<
  TData = Awaited<ReturnType<typeof getMetricsPlate>>,
  TError = ErrorType<ErrorResponse | void>,
>(
  params: GetMetricsPlateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMetricsPlate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMetricsPlateQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetMetricUrl = (slug: string) => {
  return `/api/metrics/${slug}`;
};

/**
 * @summary Get metric by slug
 */
export const getMetric = async (
  slug: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<Metric> => {
  return customFetch<Metric>(getGetMetricUrl(slug), {
    ...options,
    method: "GET",
  });
};

export const getGetMetricQueryKey = (slug: string) => {
  return [`/api/metrics/${slug}`] as const;
};

export const getGetMetricQueryOptions = <
  TData = Awaited<ReturnType<typeof getMetric>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMetric>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMetricQueryKey(slug);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetric>>> = ({
    signal,
  }) => getMetric(slug, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: slug !== null && slug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getMetric>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetMetricQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMetric>>
>;
export type GetMetricQueryError = ErrorType<unknown>;

/**
 * @summary Get metric by slug
 */

export function useGetMetric<
  TData = Awaited<ReturnType<typeof getMetric>>,
  TError = ErrorType<unknown>,
>(
  slug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMetric>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMetricQueryOptions(slug, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListEvidenceUrl = (params?: ListEvidenceParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/evidence?${stringifiedParams}`
    : `/api/evidence`;
};

/**
 * Returns up to 20,000 deduplicated evidence records.
 * If the response is truncated, `truncated: true` is set.
 * @summary List all evidence records
 */
export const listEvidence = async (
  params?: ListEvidenceParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<EvidenceListResponse> => {
  return customFetch<EvidenceListResponse>(getListEvidenceUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListEvidenceQueryKey = (params?: ListEvidenceParams) => {
  return [`/api/evidence`, ...(params ? [params] : [])] as const;
};

export const getListEvidenceQueryOptions = <
  TData = Awaited<ReturnType<typeof listEvidence>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEvidenceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEvidence>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListEvidenceQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvidence>>> = ({
    signal,
  }) => listEvidence(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listEvidence>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEvidenceQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEvidence>>
>;
export type ListEvidenceQueryError = ErrorType<unknown>;

/**
 * @summary List all evidence records
 */

export function useListEvidence<
  TData = Awaited<ReturnType<typeof listEvidence>>,
  TError = ErrorType<unknown>,
>(
  params?: ListEvidenceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEvidence>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListEvidenceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateEvidenceUrl = () => {
  return `/api/evidence`;
};

/**
 * @summary Create evidence record
 */
export const createEvidence = async (
  createEvidenceBody: CreateEvidenceBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<Evidence> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<Evidence>(getCreateEvidenceUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(createEvidenceBody),
  });
};

export const getCreateEvidenceMutationKey = () => ["createEvidence"] as const;

export const getCreateEvidenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEvidence>>,
    TError,
    CreateEvidenceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEvidence>>,
  TError,
  CreateEvidenceMutationVariables,
  TContext
> => {
  const mutationKey = getCreateEvidenceMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEvidence>>,
    CreateEvidenceMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createEvidence(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEvidenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEvidence>>
>;
export type CreateEvidenceMutationBody = BodyType<CreateEvidenceBody>;
export type CreateEvidenceMutationError = ErrorType<unknown>;
export type CreateEvidenceMutationVariables = {
  data: BodyType<CreateEvidenceBody>;
};

/**
 * @summary Create evidence record
 */
export const useCreateEvidence = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEvidence>>,
    TError,
    CreateEvidenceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEvidence>>,
  TError,
  CreateEvidenceMutationVariables,
  TContext
> => {
  return useMutation(getCreateEvidenceMutationOptions(options));
};

export const getGetEvidenceByFoodUrl = (foodId: number) => {
  return `/api/evidence/food/${foodId}`;
};

/**
 * @summary Get evidence by food ID
 */
export const getEvidenceByFood = async (
  foodId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Evidence[]> => {
  return customFetch<Evidence[]>(getGetEvidenceByFoodUrl(foodId), {
    ...options,
    method: "GET",
  });
};

export const getGetEvidenceByFoodQueryKey = (foodId: number) => {
  return [`/api/evidence/food/${foodId}`] as const;
};

export const getGetEvidenceByFoodQueryOptions = <
  TData = Awaited<ReturnType<typeof getEvidenceByFood>>,
  TError = ErrorType<unknown>,
>(
  foodId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEvidenceByFood>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEvidenceByFoodQueryKey(foodId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEvidenceByFood>>
  > = ({ signal }) => getEvidenceByFood(foodId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: foodId !== null && foodId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEvidenceByFood>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEvidenceByFoodQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEvidenceByFood>>
>;
export type GetEvidenceByFoodQueryError = ErrorType<unknown>;

/**
 * @summary Get evidence by food ID
 */

export function useGetEvidenceByFood<
  TData = Awaited<ReturnType<typeof getEvidenceByFood>>,
  TError = ErrorType<unknown>,
>(
  foodId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEvidenceByFood>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEvidenceByFoodQueryOptions(foodId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetMealReadRevisionUrl = () => {
  return `/api/logs/revision`;
};

/**
 * Authenticated account-only meal read revision. No meal contents or identifiers. Changes on log, referenced food, or snapshot row changes.
 */
export const getMealReadRevision = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GetMealReadRevision200> => {
  return customFetch<GetMealReadRevision200>(getGetMealReadRevisionUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMealReadRevisionQueryKey = () => {
  return [`/api/logs/revision`] as const;
};

export const getGetMealReadRevisionQueryOptions = <
  TData = Awaited<ReturnType<typeof getMealReadRevision>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMealReadRevision>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMealReadRevisionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMealReadRevision>>
  > = ({ signal }) => getMealReadRevision({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMealReadRevision>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMealReadRevisionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMealReadRevision>>
>;
export type GetMealReadRevisionQueryError = ErrorType<void>;

export function useGetMealReadRevision<
  TData = Awaited<ReturnType<typeof getMealReadRevision>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMealReadRevision>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMealReadRevisionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListLogsUrl = (params?: ListLogsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/logs?${stringifiedParams}`
    : `/api/logs`;
};

/**
 * Returns up to 5,000 log entries. If the response is truncated,
 * `truncated: true` is set and the user should narrow the date range.
 * @summary List food logs
 */
export const listLogs = async (
  params?: ListLogsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<FoodLogListResponse> => {
  return customFetch<FoodLogListResponse>(getListLogsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListLogsQueryKey = (params?: ListLogsParams) => {
  return [`/api/logs`, ...(params ? [params] : [])] as const;
};

export const getListLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listLogs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLogsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLogs>>> = ({
    signal,
  }) => listLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLogs>>
>;
export type ListLogsQueryError = ErrorType<unknown>;

/**
 * @summary List food logs
 */

export function useListLogs<
  TData = Awaited<ReturnType<typeof listLogs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLogsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateLogUrl = () => {
  return `/api/logs`;
};

/**
 * @summary Log a food entry
 */
export const createLog = async (
  createLogBody: CreateLogBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<FoodLog> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<FoodLog>(getCreateLogUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(createLogBody),
  });
};

export const getCreateLogMutationKey = () => ["createLog"] as const;

export const getCreateLogMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLog>>,
    TError,
    CreateLogMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createLog>>,
  TError,
  CreateLogMutationVariables,
  TContext
> => {
  const mutationKey = getCreateLogMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createLog>>,
    CreateLogMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createLog(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof createLog>>
>;
export type CreateLogMutationBody = BodyType<CreateLogBody>;
export type CreateLogMutationError = ErrorType<unknown>;
export type CreateLogMutationVariables = { data: BodyType<CreateLogBody> };

/**
 * @summary Log a food entry
 */
export const useCreateLog = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createLog>>,
    TError,
    CreateLogMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createLog>>,
  TError,
  CreateLogMutationVariables,
  TContext
> => {
  return useMutation(getCreateLogMutationOptions(options));
};

export const getCreateBatchLogsUrl = () => {
  return `/api/logs/batch`;
};

/**
 * Requires an authenticated member. Ownership comes from the session, never
 * the request. Review markers and notes are server-owned. Omitted logTime
 * remains unspecified. Sparse nutrition is retained without enrichment;
 * nutrients71 takes precedence over nutrients, including an empty object.
 * Unknown request fields are stripped by the server.
 * @summary Log a bounded batch of meal items
 */
export const createBatchLogs = async (
  createBatchLogsBody: CreateBatchLogsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<BatchLogsResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BatchLogsResponse>(getCreateBatchLogsUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(createBatchLogsBody),
  });
};

export const getCreateBatchLogsMutationKey = () => ["createBatchLogs"] as const;

export const getCreateBatchLogsMutationOptions = <
  TError = ErrorType<CreateBatchLogs400 | void | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBatchLogs>>,
    TError,
    CreateBatchLogsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBatchLogs>>,
  TError,
  CreateBatchLogsMutationVariables,
  TContext
> => {
  const mutationKey = getCreateBatchLogsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBatchLogs>>,
    CreateBatchLogsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createBatchLogs(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBatchLogsMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBatchLogs>>
>;
export type CreateBatchLogsMutationBody = BodyType<CreateBatchLogsBody>;
export type CreateBatchLogsMutationError = ErrorType<
  CreateBatchLogs400 | void | ErrorResponse
>;
export type CreateBatchLogsMutationVariables = {
  data: BodyType<CreateBatchLogsBody>;
};

/**
 * @summary Log a bounded batch of meal items
 */
export const useCreateBatchLogs = <
  TError = ErrorType<CreateBatchLogs400 | void | ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBatchLogs>>,
    TError,
    CreateBatchLogsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createBatchLogs>>,
  TError,
  CreateBatchLogsMutationVariables,
  TContext
> => {
  return useMutation(getCreateBatchLogsMutationOptions(options));
};

export const getUpdateLogUrl = (id: number) => {
  return `/api/logs/${id}`;
};

/**
 * @summary Update a log entry (serving size, quantity, etc.)
 */
export const updateLog = async (
  id: number,
  updateLogBody: UpdateLogBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<FoodLog> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<FoodLog>(getUpdateLogUrl(id), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(updateLogBody),
  });
};

export const getUpdateLogMutationKey = () => ["updateLog"] as const;

export const getUpdateLogMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLog>>,
    TError,
    UpdateLogMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLog>>,
  TError,
  UpdateLogMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateLogMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLog>>,
    UpdateLogMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLog(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLog>>
>;
export type UpdateLogMutationBody = BodyType<UpdateLogBody>;
export type UpdateLogMutationError = ErrorType<unknown>;
export type UpdateLogMutationVariables = {
  id: number;
  data: BodyType<UpdateLogBody>;
};

/**
 * @summary Update a log entry (serving size, quantity, etc.)
 */
export const useUpdateLog = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLog>>,
    TError,
    UpdateLogMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLog>>,
  TError,
  UpdateLogMutationVariables,
  TContext
> => {
  return useMutation(getUpdateLogMutationOptions(options));
};

export const getDeleteLogUrl = (id: number) => {
  return `/api/logs/${id}`;
};

/**
 * @summary Delete a log entry
 */
export const deleteLog = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getDeleteLogUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteLogMutationKey = () => ["deleteLog"] as const;

export const getDeleteLogMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLog>>,
    TError,
    DeleteLogMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLog>>,
  TError,
  DeleteLogMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteLogMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLog>>,
    DeleteLogMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return deleteLog(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLog>>
>;

export type DeleteLogMutationError = ErrorType<unknown>;
export type DeleteLogMutationVariables = { id: number };

/**
 * @summary Delete a log entry
 */
export const useDeleteLog = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLog>>,
    TError,
    DeleteLogMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLog>>,
  TError,
  DeleteLogMutationVariables,
  TContext
> => {
  return useMutation(getDeleteLogMutationOptions(options));
};

export const getListSnapCorrectionsUrl = () => {
  return `/api/logs/snap-corrections`;
};

/**
 * @summary List all snap-plate corrections the AI has learned for the current user
 */
export const listSnapCorrections = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ListSnapCorrections200> => {
  return customFetch<ListSnapCorrections200>(getListSnapCorrectionsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListSnapCorrectionsQueryKey = () => {
  return [`/api/logs/snap-corrections`] as const;
};

export const getListSnapCorrectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSnapCorrections>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSnapCorrections>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSnapCorrectionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSnapCorrections>>
  > = ({ signal }) => listSnapCorrections({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSnapCorrections>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSnapCorrectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSnapCorrections>>
>;
export type ListSnapCorrectionsQueryError = ErrorType<unknown>;

/**
 * @summary List all snap-plate corrections the AI has learned for the current user
 */

export function useListSnapCorrections<
  TData = Awaited<ReturnType<typeof listSnapCorrections>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listSnapCorrections>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSnapCorrectionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDeleteSnapCorrectionUrl = (id: number) => {
  return `/api/logs/snap-corrections/${id}`;
};

/**
 * @summary Delete a specific snap-plate correction
 */
export const deleteSnapCorrection = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<MessageResponse> => {
  return customFetch<MessageResponse>(getDeleteSnapCorrectionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteSnapCorrectionMutationKey = () =>
  ["deleteSnapCorrection"] as const;

export const getDeleteSnapCorrectionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSnapCorrection>>,
    TError,
    DeleteSnapCorrectionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSnapCorrection>>,
  TError,
  DeleteSnapCorrectionMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteSnapCorrectionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSnapCorrection>>,
    DeleteSnapCorrectionMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return deleteSnapCorrection(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteSnapCorrectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSnapCorrection>>
>;

export type DeleteSnapCorrectionMutationError = ErrorType<void>;
export type DeleteSnapCorrectionMutationVariables = { id: number };

/**
 * @summary Delete a specific snap-plate correction
 */
export const useDeleteSnapCorrection = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSnapCorrection>>,
    TError,
    DeleteSnapCorrectionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteSnapCorrection>>,
  TError,
  DeleteSnapCorrectionMutationVariables,
  TContext
> => {
  return useMutation(getDeleteSnapCorrectionMutationOptions(options));
};

export const getCreateSnapCorrectionUrl = () => {
  return `/api/logs/snap-correction`;
};

/**
 * @summary Record a user correction for a snap-plate log entry
 */
export const createSnapCorrection = async (
  snapCorrectionBody: SnapCorrectionBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<SnapCorrectionResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<SnapCorrectionResponse>(getCreateSnapCorrectionUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(snapCorrectionBody),
  });
};

export const getCreateSnapCorrectionMutationKey = () =>
  ["createSnapCorrection"] as const;

export const getCreateSnapCorrectionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSnapCorrection>>,
    TError,
    CreateSnapCorrectionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSnapCorrection>>,
  TError,
  CreateSnapCorrectionMutationVariables,
  TContext
> => {
  const mutationKey = getCreateSnapCorrectionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSnapCorrection>>,
    CreateSnapCorrectionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createSnapCorrection(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSnapCorrectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSnapCorrection>>
>;
export type CreateSnapCorrectionMutationBody = BodyType<SnapCorrectionBody>;
export type CreateSnapCorrectionMutationError = ErrorType<unknown>;
export type CreateSnapCorrectionMutationVariables = {
  data: BodyType<SnapCorrectionBody>;
};

/**
 * @summary Record a user correction for a snap-plate log entry
 */
export const useCreateSnapCorrection = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSnapCorrection>>,
    TError,
    CreateSnapCorrectionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSnapCorrection>>,
  TError,
  CreateSnapCorrectionMutationVariables,
  TContext
> => {
  return useMutation(getCreateSnapCorrectionMutationOptions(options));
};

export const getDeletePlateUrl = (
  mealSlot: string,
  params?: DeletePlateParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/logs/plate/${mealSlot}?${stringifiedParams}`
    : `/api/logs/plate/${mealSlot}`;
};

/**
 * @summary Delete all log entries for a meal slot on a given date
 */
export const deletePlate = async (
  mealSlot: string,
  params?: DeletePlateParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeletePlate200> => {
  return customFetch<DeletePlate200>(getDeletePlateUrl(mealSlot, params), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePlateMutationKey = () => ["deletePlate"] as const;

export const getDeletePlateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlate>>,
    TError,
    DeletePlateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePlate>>,
  TError,
  DeletePlateMutationVariables,
  TContext
> => {
  const mutationKey = getDeletePlateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePlate>>,
    DeletePlateMutationVariables
  > = (props) => {
    const { mealSlot, params } = props ?? {};

    return deletePlate(mealSlot, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePlateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePlate>>
>;

export type DeletePlateMutationError = ErrorType<unknown>;
export type DeletePlateMutationVariables = {
  mealSlot: string;
  params?: DeletePlateParams;
};

/**
 * @summary Delete all log entries for a meal slot on a given date
 */
export const useDeletePlate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlate>>,
    TError,
    DeletePlateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePlate>>,
  TError,
  DeletePlateMutationVariables,
  TContext
> => {
  return useMutation(getDeletePlateMutationOptions(options));
};

export const getGetSnapshotRangeUrl = (params?: GetSnapshotRangeParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/snapshots/range?${stringifiedParams}`
    : `/api/snapshots/range`;
};

/**
 * @summary Get snapshots for a date range (day/week/month/year)
 */
export const getSnapshotRange = async (
  params?: GetSnapshotRangeParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<SnapshotRange> => {
  return customFetch<SnapshotRange>(getGetSnapshotRangeUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetSnapshotRangeQueryKey = (
  params?: GetSnapshotRangeParams,
) => {
  return [`/api/snapshots/range`, ...(params ? [params] : [])] as const;
};

export const getGetSnapshotRangeQueryOptions = <
  TData = Awaited<ReturnType<typeof getSnapshotRange>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSnapshotRangeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSnapshotRange>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSnapshotRangeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSnapshotRange>>
  > = ({ signal }) => getSnapshotRange(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSnapshotRange>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSnapshotRangeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSnapshotRange>>
>;
export type GetSnapshotRangeQueryError = ErrorType<unknown>;

/**
 * @summary Get snapshots for a date range (day/week/month/year)
 */

export function useGetSnapshotRange<
  TData = Awaited<ReturnType<typeof getSnapshotRange>>,
  TError = ErrorType<unknown>,
>(
  params?: GetSnapshotRangeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSnapshotRange>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSnapshotRangeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetNutrientGoalScoreUrl = (
  params?: GetNutrientGoalScoreParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/snapshots/nutrient-goal-score?${stringifiedParams}`
    : `/api/snapshots/nutrient-goal-score`;
};

/**
 * Rolls up the per-nutrient daily adherence stored in daily snapshots into a single percentage for the current week and current month (period-to-date), honoring each nutrient's target direction (maximize / minimize / range). Days with no logged food are excluded so the score reflects logged days.
 * @summary Weekly & monthly nutrient goal score (% of all nutrient targets met)
 */
export const getNutrientGoalScore = async (
  params?: GetNutrientGoalScoreParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<NutrientGoalScoreResponse> => {
  return customFetch<NutrientGoalScoreResponse>(
    getGetNutrientGoalScoreUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNutrientGoalScoreQueryKey = (
  params?: GetNutrientGoalScoreParams,
) => {
  return [
    `/api/snapshots/nutrient-goal-score`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetNutrientGoalScoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getNutrientGoalScore>>,
  TError = ErrorType<unknown>,
>(
  params?: GetNutrientGoalScoreParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNutrientGoalScore>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNutrientGoalScoreQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNutrientGoalScore>>
  > = ({ signal }) =>
    getNutrientGoalScore(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNutrientGoalScore>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNutrientGoalScoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNutrientGoalScore>>
>;
export type GetNutrientGoalScoreQueryError = ErrorType<unknown>;

/**
 * @summary Weekly & monthly nutrient goal score (% of all nutrient targets met)
 */

export function useGetNutrientGoalScore<
  TData = Awaited<ReturnType<typeof getNutrientGoalScore>>,
  TError = ErrorType<unknown>,
>(
  params?: GetNutrientGoalScoreParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNutrientGoalScore>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNutrientGoalScoreQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSnapshotsUrl = (date: string) => {
  return `/api/snapshots/${date}`;
};

/**
 * @summary Get daily snapshots for a date
 */
export const getSnapshots = async (
  date: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<Snapshot[]> => {
  return customFetch<Snapshot[]>(getGetSnapshotsUrl(date), {
    ...options,
    method: "GET",
  });
};

export const getGetSnapshotsQueryKey = (date: string) => {
  return [`/api/snapshots/${date}`] as const;
};

export const getGetSnapshotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSnapshots>>,
  TError = ErrorType<unknown>,
>(
  date: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSnapshots>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSnapshotsQueryKey(date);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSnapshots>>> = ({
    signal,
  }) => getSnapshots(date, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: date !== null && date !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSnapshots>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSnapshotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSnapshots>>
>;
export type GetSnapshotsQueryError = ErrorType<unknown>;

/**
 * @summary Get daily snapshots for a date
 */

export function useGetSnapshots<
  TData = Awaited<ReturnType<typeof getSnapshots>>,
  TError = ErrorType<unknown>,
>(
  date: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSnapshots>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSnapshotsQueryOptions(date, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetMonthSnapshotsUrl = (year: number, month: number) => {
  return `/api/snapshots/month/${year}/${month}`;
};

/**
 * @summary Get snapshots for a month
 */
export const getMonthSnapshots = async (
  year: number,
  month: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Snapshot[]> => {
  return customFetch<Snapshot[]>(getGetMonthSnapshotsUrl(year, month), {
    ...options,
    method: "GET",
  });
};

export const getGetMonthSnapshotsQueryKey = (year: number, month: number) => {
  return [`/api/snapshots/month/${year}/${month}`] as const;
};

export const getGetMonthSnapshotsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMonthSnapshots>>,
  TError = ErrorType<unknown>,
>(
  year: number,
  month: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMonthSnapshots>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMonthSnapshotsQueryKey(year, month);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMonthSnapshots>>
  > = ({ signal }) =>
    getMonthSnapshots(year, month, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      year !== null &&
      year !== undefined &&
      month !== null &&
      month !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMonthSnapshots>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMonthSnapshotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMonthSnapshots>>
>;
export type GetMonthSnapshotsQueryError = ErrorType<unknown>;

/**
 * @summary Get snapshots for a month
 */

export function useGetMonthSnapshots<
  TData = Awaited<ReturnType<typeof getMonthSnapshots>>,
  TError = ErrorType<unknown>,
>(
  year: number,
  month: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMonthSnapshots>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMonthSnapshotsQueryOptions(year, month, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetForecastUrl = (params?: GetForecastParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/forecast?${stringifiedParams}`
    : `/api/forecast`;
};

/**
 * Forward-looking projection of where the user's priority health metrics and NRS are heading, derived deterministically from recent daily snapshots, wearables and NRS history. Degrades gracefully when there is not enough history (hasEnoughData=false).
 * @summary Predictive health forecast for the next 1-2 weeks
 */
export const getForecast = async (
  params?: GetForecastParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ForecastResult> => {
  return customFetch<ForecastResult>(getGetForecastUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetForecastQueryKey = (params?: GetForecastParams) => {
  return [`/api/forecast`, ...(params ? [params] : [])] as const;
};

export const getGetForecastQueryOptions = <
  TData = Awaited<ReturnType<typeof getForecast>>,
  TError = ErrorType<unknown>,
>(
  params?: GetForecastParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getForecast>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetForecastQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getForecast>>> = ({
    signal,
  }) => getForecast(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getForecast>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetForecastQueryResult = NonNullable<
  Awaited<ReturnType<typeof getForecast>>
>;
export type GetForecastQueryError = ErrorType<unknown>;

/**
 * @summary Predictive health forecast for the next 1-2 weeks
 */

export function useGetForecast<
  TData = Awaited<ReturnType<typeof getForecast>>,
  TError = ErrorType<unknown>,
>(
  params?: GetForecastParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getForecast>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetForecastQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPersonalizationCoreUrl = () => {
  return `/api/personalization-core`;
};

/**
 * Decides in one place what leads the user's plan: their genetic blueprint when DNA is present, otherwise their goals + body stats. Returns the lead source and the top drivers to highlight on the dashboard front door.
 * @summary Adaptive personalization core (DNA-led or goals-led)
 */
export const getPersonalizationCore = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PersonalizationCore> => {
  return customFetch<PersonalizationCore>(getGetPersonalizationCoreUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPersonalizationCoreQueryKey = () => {
  return [`/api/personalization-core`] as const;
};

export const getGetPersonalizationCoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getPersonalizationCore>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPersonalizationCore>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPersonalizationCoreQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPersonalizationCore>>
  > = ({ signal }) => getPersonalizationCore({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPersonalizationCore>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPersonalizationCoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPersonalizationCore>>
>;
export type GetPersonalizationCoreQueryError = ErrorType<unknown>;

/**
 * @summary Adaptive personalization core (DNA-led or goals-led)
 */

export function useGetPersonalizationCore<
  TData = Awaited<ReturnType<typeof getPersonalizationCore>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPersonalizationCore>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPersonalizationCoreQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetDashboardKpisUrl = (params?: GetDashboardKpisParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/kpis?${stringifiedParams}`
    : `/api/dashboard/kpis`;
};

/**
 * @summary Get dashboard KPIs for a date
 */
export const getDashboardKpis = async (
  params?: GetDashboardKpisParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DashboardKpis> => {
  return customFetch<DashboardKpis>(getGetDashboardKpisUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardKpisQueryKey = (
  params?: GetDashboardKpisParams,
) => {
  return [`/api/dashboard/kpis`, ...(params ? [params] : [])] as const;
};

export const getGetDashboardKpisQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardKpis>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDashboardKpisParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardKpis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDashboardKpisQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardKpis>>
  > = ({ signal }) => getDashboardKpis(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardKpis>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardKpisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardKpis>>
>;
export type GetDashboardKpisQueryError = ErrorType<unknown>;

/**
 * @summary Get dashboard KPIs for a date
 */

export function useGetDashboardKpis<
  TData = Awaited<ReturnType<typeof getDashboardKpis>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDashboardKpisParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDashboardKpis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardKpisQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetStatusDistributionUrl = (
  params?: GetStatusDistributionParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/status-distribution?${stringifiedParams}`
    : `/api/dashboard/status-distribution`;
};

/**
 * @summary Get distribution of nutrient statuses
 */
export const getStatusDistribution = async (
  params?: GetStatusDistributionParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<StatusCount[]> => {
  return customFetch<StatusCount[]>(getGetStatusDistributionUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetStatusDistributionQueryKey = (
  params?: GetStatusDistributionParams,
) => {
  return [
    `/api/dashboard/status-distribution`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStatusDistributionQueryOptions = <
  TData = Awaited<ReturnType<typeof getStatusDistribution>>,
  TError = ErrorType<unknown>,
>(
  params?: GetStatusDistributionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStatusDistribution>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStatusDistributionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStatusDistribution>>
  > = ({ signal }) =>
    getStatusDistribution(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStatusDistribution>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStatusDistributionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStatusDistribution>>
>;
export type GetStatusDistributionQueryError = ErrorType<unknown>;

/**
 * @summary Get distribution of nutrient statuses
 */

export function useGetStatusDistribution<
  TData = Awaited<ReturnType<typeof getStatusDistribution>>,
  TError = ErrorType<unknown>,
>(
  params?: GetStatusDistributionParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getStatusDistribution>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetStatusDistributionQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetGroupHealthUrl = (params?: GetGroupHealthParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/dashboard/group-health?${stringifiedParams}`
    : `/api/dashboard/group-health`;
};

/**
 * @summary Get health summary per metric group
 */
export const getGroupHealth = async (
  params?: GetGroupHealthParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GroupHealth[]> => {
  return customFetch<GroupHealth[]>(getGetGroupHealthUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetGroupHealthQueryKey = (params?: GetGroupHealthParams) => {
  return [`/api/dashboard/group-health`, ...(params ? [params] : [])] as const;
};

export const getGetGroupHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getGroupHealth>>,
  TError = ErrorType<unknown>,
>(
  params?: GetGroupHealthParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGroupHealth>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGroupHealthQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupHealth>>> = ({
    signal,
  }) => getGroupHealth(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGroupHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGroupHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGroupHealth>>
>;
export type GetGroupHealthQueryError = ErrorType<unknown>;

/**
 * @summary Get health summary per metric group
 */

export function useGetGroupHealth<
  TData = Awaited<ReturnType<typeof getGroupHealth>>,
  TError = ErrorType<unknown>,
>(
  params?: GetGroupHealthParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGroupHealth>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGroupHealthQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListGlossaryTermsUrl = (params?: ListGlossaryTermsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/glossary?${stringifiedParams}`
    : `/api/glossary`;
};

/**
 * @summary List all glossary terms
 */
export const listGlossaryTerms = async (
  params?: ListGlossaryTermsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GlossaryTerm[]> => {
  return customFetch<GlossaryTerm[]>(getListGlossaryTermsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListGlossaryTermsQueryKey = (
  params?: ListGlossaryTermsParams,
) => {
  return [`/api/glossary`, ...(params ? [params] : [])] as const;
};

export const getListGlossaryTermsQueryOptions = <
  TData = Awaited<ReturnType<typeof listGlossaryTerms>>,
  TError = ErrorType<unknown>,
>(
  params?: ListGlossaryTermsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGlossaryTerms>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListGlossaryTermsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listGlossaryTerms>>
  > = ({ signal }) => listGlossaryTerms(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGlossaryTerms>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGlossaryTermsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGlossaryTerms>>
>;
export type ListGlossaryTermsQueryError = ErrorType<unknown>;

/**
 * @summary List all glossary terms
 */

export function useListGlossaryTerms<
  TData = Awaited<ReturnType<typeof listGlossaryTerms>>,
  TError = ErrorType<unknown>,
>(
  params?: ListGlossaryTermsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listGlossaryTerms>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListGlossaryTermsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListContentFeedUrl = (params?: ListContentFeedParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/content/feed?${stringifiedParams}`
    : `/api/content/feed`;
};

/**
 * @summary List active curated Instagram videos for a surface
 */
export const listContentFeed = async (
  params?: ListContentFeedParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ContentFeedItem[]> => {
  return customFetch<ContentFeedItem[]>(getListContentFeedUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListContentFeedQueryKey = (params?: ListContentFeedParams) => {
  return [`/api/content/feed`, ...(params ? [params] : [])] as const;
};

export const getListContentFeedQueryOptions = <
  TData = Awaited<ReturnType<typeof listContentFeed>>,
  TError = ErrorType<unknown>,
>(
  params?: ListContentFeedParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContentFeed>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListContentFeedQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listContentFeed>>> = ({
    signal,
  }) => listContentFeed(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listContentFeed>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListContentFeedQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContentFeed>>
>;
export type ListContentFeedQueryError = ErrorType<unknown>;

/**
 * @summary List active curated Instagram videos for a surface
 */

export function useListContentFeed<
  TData = Awaited<ReturnType<typeof listContentFeed>>,
  TError = ErrorType<unknown>,
>(
  params?: ListContentFeedParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listContentFeed>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListContentFeedQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListGroceryHistoryUrl = () => {
  return `/api/grocery/history`;
};

/**
 * @summary List all grocery list history entries
 */
export const listGroceryHistory = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GroceryList[]> => {
  return customFetch<GroceryList[]>(getListGroceryHistoryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListGroceryHistoryQueryKey = () => {
  return [`/api/grocery/history`] as const;
};

export const getListGroceryHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listGroceryHistory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listGroceryHistory>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListGroceryHistoryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listGroceryHistory>>
  > = ({ signal }) => listGroceryHistory({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listGroceryHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListGroceryHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listGroceryHistory>>
>;
export type ListGroceryHistoryQueryError = ErrorType<unknown>;

/**
 * @summary List all grocery list history entries
 */

export function useListGroceryHistory<
  TData = Awaited<ReturnType<typeof listGroceryHistory>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listGroceryHistory>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListGroceryHistoryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetGroceryListDetailUrl = (id: number) => {
  return `/api/grocery/history/${id}`;
};

/**
 * @summary Get grocery list with items
 */
export const getGroceryListDetail = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GroceryListDetail> => {
  return customFetch<GroceryListDetail>(getGetGroceryListDetailUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGroceryListDetailQueryKey = (id: number) => {
  return [`/api/grocery/history/${id}`] as const;
};

export const getGetGroceryListDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getGroceryListDetail>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGroceryListDetail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGroceryListDetailQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGroceryListDetail>>
  > = ({ signal }) => getGroceryListDetail(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGroceryListDetail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGroceryListDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGroceryListDetail>>
>;
export type GetGroceryListDetailQueryError = ErrorType<unknown>;

/**
 * @summary Get grocery list with items
 */

export function useGetGroceryListDetail<
  TData = Awaited<ReturnType<typeof getGroceryListDetail>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGroceryListDetail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGroceryListDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getAcceptLegalDocsUrl = () => {
  return `/api/legal/accept`;
};

/**
 * @summary Record one or more legal-document acceptances for the current user
 */
export const acceptLegalDocs = async (
  acceptLegalBody: AcceptLegalBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<LegalAcceptanceList> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<LegalAcceptanceList>(getAcceptLegalDocsUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(acceptLegalBody),
  });
};

export const getAcceptLegalDocsMutationKey = () => ["acceptLegalDocs"] as const;

export const getAcceptLegalDocsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptLegalDocs>>,
    TError,
    AcceptLegalDocsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptLegalDocs>>,
  TError,
  AcceptLegalDocsMutationVariables,
  TContext
> => {
  const mutationKey = getAcceptLegalDocsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptLegalDocs>>,
    AcceptLegalDocsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return acceptLegalDocs(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptLegalDocsMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptLegalDocs>>
>;
export type AcceptLegalDocsMutationBody = BodyType<AcceptLegalBody>;
export type AcceptLegalDocsMutationError = ErrorType<ErrorResponse>;
export type AcceptLegalDocsMutationVariables = {
  data: BodyType<AcceptLegalBody>;
};

/**
 * @summary Record one or more legal-document acceptances for the current user
 */
export const useAcceptLegalDocs = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptLegalDocs>>,
    TError,
    AcceptLegalDocsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptLegalDocs>>,
  TError,
  AcceptLegalDocsMutationVariables,
  TContext
> => {
  return useMutation(getAcceptLegalDocsMutationOptions(options));
};

export const getGetLegalAcceptancesUrl = () => {
  return `/api/legal/acceptances`;
};

/**
 * @summary List the current user's legal acceptances (most recent first)
 */
export const getLegalAcceptances = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LegalAcceptanceList> => {
  return customFetch<LegalAcceptanceList>(getGetLegalAcceptancesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetLegalAcceptancesQueryKey = () => {
  return [`/api/legal/acceptances`] as const;
};

export const getGetLegalAcceptancesQueryOptions = <
  TData = Awaited<ReturnType<typeof getLegalAcceptances>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLegalAcceptances>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLegalAcceptancesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLegalAcceptances>>
  > = ({ signal }) => getLegalAcceptances({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLegalAcceptances>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLegalAcceptancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLegalAcceptances>>
>;
export type GetLegalAcceptancesQueryError = ErrorType<unknown>;

/**
 * @summary List the current user's legal acceptances (most recent first)
 */

export function useGetLegalAcceptances<
  TData = Awaited<ReturnType<typeof getLegalAcceptances>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLegalAcceptances>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLegalAcceptancesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getExportAccountDataUrl = () => {
  return `/api/account/export`;
};

/**
 * @summary Download a ZIP containing all of the current user's data (GDPR Art. 20)
 */
export const exportAccountData = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Blob> => {
  return customFetch<Blob>(getExportAccountDataUrl(), {
    ...options,
    method: "GET",
  });
};

export const getExportAccountDataQueryKey = () => {
  return [`/api/account/export`] as const;
};

export const getExportAccountDataQueryOptions = <
  TData = Awaited<ReturnType<typeof exportAccountData>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportAccountData>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportAccountDataQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportAccountData>>
  > = ({ signal }) => exportAccountData({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportAccountData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportAccountDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportAccountData>>
>;
export type ExportAccountDataQueryError = ErrorType<unknown>;

/**
 * @summary Download a ZIP containing all of the current user's data (GDPR Art. 20)
 */

export function useExportAccountData<
  TData = Awaited<ReturnType<typeof exportAccountData>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportAccountData>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportAccountDataQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetLatestAccountExportUrl = () => {
  return `/api/account/export-request`;
};

/**
 * @summary Get the current user's most recent durable account-export status
 */
export const getLatestAccountExport = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AccountExportLatestResponse> => {
  return customFetch<AccountExportLatestResponse>(
    getGetLatestAccountExportUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetLatestAccountExportQueryKey = () => {
  return [`/api/account/export-request`] as const;
};

export const getGetLatestAccountExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestAccountExport>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLatestAccountExport>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLatestAccountExportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLatestAccountExport>>
  > = ({ signal }) => getLatestAccountExport({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestAccountExport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLatestAccountExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLatestAccountExport>>
>;
export type GetLatestAccountExportQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the current user's most recent durable account-export status
 */

export function useGetLatestAccountExport<
  TData = Awaited<ReturnType<typeof getLatestAccountExport>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLatestAccountExport>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLatestAccountExportQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRequestAccountExportUrl = () => {
  return `/api/account/export-request`;
};

/**
 * @deprecated
 * @summary Email-based export requests are blocked; use the authenticated direct export
 */
export const requestAccountExport = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<AccountExportJob> => {
  return customFetch<AccountExportJob>(getRequestAccountExportUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRequestAccountExportMutationKey = () =>
  ["requestAccountExport"] as const;

export const getRequestAccountExportMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestAccountExport>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestAccountExport>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getRequestAccountExportMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestAccountExport>>,
    void
  > = () => {
    return requestAccountExport(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestAccountExportMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestAccountExport>>
>;

export type RequestAccountExportMutationError = ErrorType<ErrorResponse>;

/**
 * @deprecated
 * @summary Email-based export requests are blocked; use the authenticated direct export
 */
export const useRequestAccountExport = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestAccountExport>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestAccountExport>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRequestAccountExportMutationOptions(options));
};

export const getGetAccountExportUrl = (requestId: string) => {
  return `/api/account/export-request/${requestId}`;
};

/**
 * @summary Get one durable account-export request by its stable identifier
 */
export const getAccountExport = async (
  requestId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<AccountExportJob> => {
  return customFetch<AccountExportJob>(getGetAccountExportUrl(requestId), {
    ...options,
    method: "GET",
  });
};

export const getGetAccountExportQueryKey = (requestId: string) => {
  return [`/api/account/export-request/${requestId}`] as const;
};

export const getGetAccountExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountExport>>,
  TError = ErrorType<ErrorResponse>,
>(
  requestId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountExport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccountExportQueryKey(requestId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountExport>>
  > = ({ signal }) =>
    getAccountExport(requestId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: requestId !== null && requestId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountExport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountExport>>
>;
export type GetAccountExportQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get one durable account-export request by its stable identifier
 */

export function useGetAccountExport<
  TData = Awaited<ReturnType<typeof getAccountExport>>,
  TError = ErrorType<ErrorResponse>,
>(
  requestId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAccountExport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAccountExportQueryOptions(requestId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRetryAccountExportUrl = (requestId: string) => {
  return `/api/account/export-request/${requestId}/retry`;
};

/**
 * @deprecated
 * @summary Email retries are blocked; historical ready archives remain retrievable
 */
export const retryAccountExport = async (
  requestId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<AccountExportJob> => {
  return customFetch<AccountExportJob>(getRetryAccountExportUrl(requestId), {
    ...options,
    method: "POST",
  });
};

export const getRetryAccountExportMutationKey = () =>
  ["retryAccountExport"] as const;

export const getRetryAccountExportMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryAccountExport>>,
    TError,
    RetryAccountExportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryAccountExport>>,
  TError,
  RetryAccountExportMutationVariables,
  TContext
> => {
  const mutationKey = getRetryAccountExportMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryAccountExport>>,
    RetryAccountExportMutationVariables
  > = (props) => {
    const { requestId } = props ?? {};

    return retryAccountExport(requestId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryAccountExportMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryAccountExport>>
>;

export type RetryAccountExportMutationError = ErrorType<ErrorResponse>;
export type RetryAccountExportMutationVariables = { requestId: string };

/**
 * @deprecated
 * @summary Email retries are blocked; historical ready archives remain retrievable
 */
export const useRetryAccountExport = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryAccountExport>>,
    TError,
    RetryAccountExportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryAccountExport>>,
  TError,
  RetryAccountExportMutationVariables,
  TContext
> => {
  return useMutation(getRetryAccountExportMutationOptions(options));
};

export const getSnapPlateStreamUrl = () => {
  return `/api/neural/snap-plate/stream`;
};

/**
 * Submits one or more food images and streams identified food items as Server-Sent Events.
 * Each item is emitted as soon as the model identifies it, before the full analysis completes.
 * Uses `text/event-stream` response. Not standard OpenAPI — use the hand-written `streamSnapPlate` helper.
 * @summary Stream snap-plate food identification results via SSE
 */
export const snapPlateStream = async (
  snapPlateStreamBody: SnapPlateStreamBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<string>(getSnapPlateStreamUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(snapPlateStreamBody),
  });
};

export const getSnapPlateStreamMutationKey = () => ["snapPlateStream"] as const;

export const getSnapPlateStreamMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof snapPlateStream>>,
    TError,
    SnapPlateStreamMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof snapPlateStream>>,
  TError,
  SnapPlateStreamMutationVariables,
  TContext
> => {
  const mutationKey = getSnapPlateStreamMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof snapPlateStream>>,
    SnapPlateStreamMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return snapPlateStream(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SnapPlateStreamMutationResult = NonNullable<
  Awaited<ReturnType<typeof snapPlateStream>>
>;
export type SnapPlateStreamMutationBody = BodyType<SnapPlateStreamBody>;
export type SnapPlateStreamMutationError = ErrorType<ErrorResponse>;
export type SnapPlateStreamMutationVariables = {
  data: BodyType<SnapPlateStreamBody>;
};

/**
 * @summary Stream snap-plate food identification results via SSE
 */
export const useSnapPlateStream = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof snapPlateStream>>,
    TError,
    SnapPlateStreamMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof snapPlateStream>>,
  TError,
  SnapPlateStreamMutationVariables,
  TContext
> => {
  return useMutation(getSnapPlateStreamMutationOptions(options));
};

export const getDeleteAccountUrl = () => {
  return `/api/account`;
};

/**
 * @deprecated
 * @summary New deletion schedules are blocked until an approved recovery mechanism is available
 */
export const deleteAccount = async (
  deleteAccountBody: DeleteAccountBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<MessageResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<MessageResponse>(getDeleteAccountUrl(), {
    ...options,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(deleteAccountBody),
  });
};

export const getDeleteAccountMutationKey = () => ["deleteAccount"] as const;

export const getDeleteAccountMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccount>>,
    TError,
    DeleteAccountMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  DeleteAccountMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteAccountMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccount>>,
    DeleteAccountMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return deleteAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccount>>
>;
export type DeleteAccountMutationBody = BodyType<DeleteAccountBody>;
export type DeleteAccountMutationError = ErrorType<ErrorResponse>;
export type DeleteAccountMutationVariables = {
  data: BodyType<DeleteAccountBody>;
};

/**
 * @deprecated
 * @summary New deletion schedules are blocked until an approved recovery mechanism is available
 */
export const useDeleteAccount = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccount>>,
    TError,
    DeleteAccountMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccount>>,
  TError,
  DeleteAccountMutationVariables,
  TContext
> => {
  return useMutation(getDeleteAccountMutationOptions(options));
};

export const getGetGeneticViewUrl = () => {
  return `/api/genetics`;
};

/**
 * @summary Get the current user's DNA-informed nutrition view (consent status, results, guidance). Logs a view access.
 */
export const getGeneticView = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GeneticView> => {
  return customFetch<GeneticView>(getGetGeneticViewUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGeneticViewQueryKey = () => {
  return [`/api/genetics`] as const;
};

export const getGetGeneticViewQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeneticView>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticView>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGeneticViewQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeneticView>>> = ({
    signal,
  }) => getGeneticView({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticView>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGeneticViewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeneticView>>
>;
export type GetGeneticViewQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the current user's DNA-informed nutrition view (consent status, results, guidance). Logs a view access.
 */

export function useGetGeneticView<
  TData = Awaited<ReturnType<typeof getGeneticView>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticView>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGeneticViewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDeleteGeneticDataUrl = () => {
  return `/api/genetics`;
};

/**
 * @summary Permanently delete all of the current user's genetic data and optionally blood-lab readings as one coordinated operation. Revokes consent and records each deletion in the audit log.
 */
export const deleteGeneticData = async (
  geneticDeleteBody?: GeneticDeleteBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<GeneticDeleteResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GeneticDeleteResult>(getDeleteGeneticDataUrl(), {
    ...options,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(geneticDeleteBody),
  });
};

export const getDeleteGeneticDataMutationKey = () =>
  ["deleteGeneticData"] as const;

export const getDeleteGeneticDataMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGeneticData>>,
    TError,
    DeleteGeneticDataMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteGeneticData>>,
  TError,
  DeleteGeneticDataMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteGeneticDataMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteGeneticData>>,
    DeleteGeneticDataMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return deleteGeneticData(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteGeneticDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteGeneticData>>
>;
export type DeleteGeneticDataMutationBody =
  | BodyType<GeneticDeleteBody>
  | undefined;
export type DeleteGeneticDataMutationError = ErrorType<ErrorResponse>;
export type DeleteGeneticDataMutationVariables = {
  data?: BodyType<GeneticDeleteBody>;
};

/**
 * @summary Permanently delete all of the current user's genetic data and optionally blood-lab readings as one coordinated operation. Revokes consent and records each deletion in the audit log.
 */
export const useDeleteGeneticData = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteGeneticData>>,
    TError,
    DeleteGeneticDataMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteGeneticData>>,
  TError,
  DeleteGeneticDataMutationVariables,
  TContext
> => {
  return useMutation(getDeleteGeneticDataMutationOptions(options));
};

export const getGetGeneticNutritionReportPdfUrl = () => {
  return `/api/genetics/report.pdf`;
};

/**
 * @summary Download the current user's reviewed DNA Nutrition view as a PDF.
 */
export const getGeneticNutritionReportPdf = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Blob> => {
  return customFetch<Blob>(getGetGeneticNutritionReportPdfUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGeneticNutritionReportPdfQueryKey = () => {
  return [`/api/genetics/report.pdf`] as const;
};

export const getGetGeneticNutritionReportPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeneticNutritionReportPdf>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticNutritionReportPdf>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeneticNutritionReportPdfQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeneticNutritionReportPdf>>
  > = ({ signal }) =>
    getGeneticNutritionReportPdf({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticNutritionReportPdf>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGeneticNutritionReportPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeneticNutritionReportPdf>>
>;
export type GetGeneticNutritionReportPdfQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Download the current user's reviewed DNA Nutrition view as a PDF.
 */

export function useGetGeneticNutritionReportPdf<
  TData = Awaited<ReturnType<typeof getGeneticNutritionReportPdf>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticNutritionReportPdf>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGeneticNutritionReportPdfQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListHealthDocumentsUrl = (
  params?: ListHealthDocumentsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/health-documents?${stringifiedParams}`
    : `/api/health-documents`;
};

/**
 * @summary List the signed-in member's private health documents; organization only, not clinical interpretation.
 */
export const listHealthDocuments = async (
  params?: ListHealthDocumentsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<HealthDocumentList> => {
  return customFetch<HealthDocumentList>(getListHealthDocumentsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListHealthDocumentsQueryKey = (
  params?: ListHealthDocumentsParams,
) => {
  return [`/api/health-documents`, ...(params ? [params] : [])] as const;
};

export const getListHealthDocumentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listHealthDocuments>>,
  TError = ErrorType<void>,
>(
  params?: ListHealthDocumentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listHealthDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListHealthDocumentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHealthDocuments>>
  > = ({ signal }) =>
    listHealthDocuments(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHealthDocuments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListHealthDocumentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHealthDocuments>>
>;
export type ListHealthDocumentsQueryError = ErrorType<void>;

/**
 * @summary List the signed-in member's private health documents; organization only, not clinical interpretation.
 */

export function useListHealthDocuments<
  TData = Awaited<ReturnType<typeof listHealthDocuments>>,
  TError = ErrorType<void>,
>(
  params?: ListHealthDocumentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listHealthDocuments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListHealthDocumentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUploadHealthDocumentUrl = () => {
  return `/api/health-documents`;
};

/**
 * PDF (including scanned PDFs), JPG, PNG, or WebP only; maximum 10 MB per file. Without processing consent the original remains accessible as Other/review-needed. Classification never imports clinical data.
 * @summary Store a private encrypted original and optionally classify it after explicit health-data processing consent.
 */
export const uploadHealthDocument = async (
  healthDocumentUpload: HealthDocumentUpload,
  options?: Parameters<typeof customFetch>[1],
): Promise<HealthDocument> => {
  const formData = new FormData();
  formData.append(`file`, healthDocumentUpload.file);
  formData.append(
    `processingConsent`,
    healthDocumentUpload.processingConsent.toString(),
  );

  return customFetch<HealthDocument>(getUploadHealthDocumentUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadHealthDocumentMutationKey = () =>
  ["uploadHealthDocument"] as const;

export const getUploadHealthDocumentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadHealthDocument>>,
    TError,
    UploadHealthDocumentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadHealthDocument>>,
  TError,
  UploadHealthDocumentMutationVariables,
  TContext
> => {
  const mutationKey = getUploadHealthDocumentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadHealthDocument>>,
    UploadHealthDocumentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return uploadHealthDocument(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadHealthDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadHealthDocument>>
>;
export type UploadHealthDocumentMutationBody = BodyType<HealthDocumentUpload>;
export type UploadHealthDocumentMutationError = ErrorType<void>;
export type UploadHealthDocumentMutationVariables = {
  data: BodyType<HealthDocumentUpload>;
};

/**
 * @summary Store a private encrypted original and optionally classify it after explicit health-data processing consent.
 */
export const useUploadHealthDocument = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadHealthDocument>>,
    TError,
    UploadHealthDocumentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadHealthDocument>>,
  TError,
  UploadHealthDocumentMutationVariables,
  TContext
> => {
  return useMutation(getUploadHealthDocumentMutationOptions(options));
};

export const getUpdateHealthDocumentUrl = (id: string) => {
  return `/api/health-documents/${id}`;
};

/**
 * @summary Correct a private document's organizational metadata.
 */
export const updateHealthDocument = async (
  id: string,
  healthDocumentUpdate: HealthDocumentUpdate,
  options?: Parameters<typeof customFetch>[1],
): Promise<HealthDocument> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<HealthDocument>(getUpdateHealthDocumentUrl(id), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(healthDocumentUpdate),
  });
};

export const getUpdateHealthDocumentMutationKey = () =>
  ["updateHealthDocument"] as const;

export const getUpdateHealthDocumentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHealthDocument>>,
    TError,
    UpdateHealthDocumentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateHealthDocument>>,
  TError,
  UpdateHealthDocumentMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateHealthDocumentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateHealthDocument>>,
    UpdateHealthDocumentMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return updateHealthDocument(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateHealthDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateHealthDocument>>
>;
export type UpdateHealthDocumentMutationBody = BodyType<HealthDocumentUpdate>;
export type UpdateHealthDocumentMutationError = ErrorType<void>;
export type UpdateHealthDocumentMutationVariables = {
  id: string;
  data: BodyType<HealthDocumentUpdate>;
};

/**
 * @summary Correct a private document's organizational metadata.
 */
export const useUpdateHealthDocument = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHealthDocument>>,
    TError,
    UpdateHealthDocumentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateHealthDocument>>,
  TError,
  UpdateHealthDocumentMutationVariables,
  TContext
> => {
  return useMutation(getUpdateHealthDocumentMutationOptions(options));
};

export const getDeleteHealthDocumentUrl = (id: string) => {
  return `/api/health-documents/${id}`;
};

/**
 * @summary Remove a private original and any derived previews.
 */
export const deleteHealthDocument = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<HealthDocumentDeleteResult> => {
  return customFetch<HealthDocumentDeleteResult>(
    getDeleteHealthDocumentUrl(id),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteHealthDocumentMutationKey = () =>
  ["deleteHealthDocument"] as const;

export const getDeleteHealthDocumentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHealthDocument>>,
    TError,
    DeleteHealthDocumentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteHealthDocument>>,
  TError,
  DeleteHealthDocumentMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteHealthDocumentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteHealthDocument>>,
    DeleteHealthDocumentMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return deleteHealthDocument(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteHealthDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteHealthDocument>>
>;

export type DeleteHealthDocumentMutationError = ErrorType<void>;
export type DeleteHealthDocumentMutationVariables = { id: string };

/**
 * @summary Remove a private original and any derived previews.
 */
export const useDeleteHealthDocument = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHealthDocument>>,
    TError,
    DeleteHealthDocumentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteHealthDocument>>,
  TError,
  DeleteHealthDocumentMutationVariables,
  TContext
> => {
  return useMutation(getDeleteHealthDocumentMutationOptions(options));
};

export const getGetHealthDocumentFileUrl = (
  id: string,
  params?: GetHealthDocumentFileParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/health-documents/${id}/file?${stringifiedParams}`
    : `/api/health-documents/${id}/file`;
};

/**
 * @summary View or download the original private document after owner and audit checks.
 */
export const getHealthDocumentFile = async (
  id: string,
  params?: GetHealthDocumentFileParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Blob> => {
  return customFetch<Blob>(getGetHealthDocumentFileUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getGetHealthDocumentFileQueryKey = (
  id: string,
  params?: GetHealthDocumentFileParams,
) => {
  return [
    `/api/health-documents/${id}/file`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetHealthDocumentFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getHealthDocumentFile>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: GetHealthDocumentFileParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHealthDocumentFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHealthDocumentFileQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHealthDocumentFile>>
  > = ({ signal }) =>
    getHealthDocumentFile(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHealthDocumentFile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHealthDocumentFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHealthDocumentFile>>
>;
export type GetHealthDocumentFileQueryError = ErrorType<void>;

/**
 * @summary View or download the original private document after owner and audit checks.
 */

export function useGetHealthDocumentFile<
  TData = Awaited<ReturnType<typeof getHealthDocumentFile>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: GetHealthDocumentFileParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHealthDocumentFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetHealthDocumentFileQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getClassifySavedHealthDocumentUrl = (id: string) => {
  return `/api/health-documents/${id}/classify`;
};

/**
 * Extracts PDF text locally and may send scanned PDFs or images to OpenAI for transcription-only OCR. Does not alter original bytes or import lab or genetics data.
 * @summary Classify one saved original after fresh, explicit processing consent.
 */
export const classifySavedHealthDocument = async (
  id: string,
  healthDocumentClassificationConsent: HealthDocumentClassificationConsent,
  options?: Parameters<typeof customFetch>[1],
): Promise<HealthDocument> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<HealthDocument>(getClassifySavedHealthDocumentUrl(id), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(healthDocumentClassificationConsent),
  });
};

export const getClassifySavedHealthDocumentMutationKey = () =>
  ["classifySavedHealthDocument"] as const;

export const getClassifySavedHealthDocumentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof classifySavedHealthDocument>>,
    TError,
    ClassifySavedHealthDocumentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof classifySavedHealthDocument>>,
  TError,
  ClassifySavedHealthDocumentMutationVariables,
  TContext
> => {
  const mutationKey = getClassifySavedHealthDocumentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof classifySavedHealthDocument>>,
    ClassifySavedHealthDocumentMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return classifySavedHealthDocument(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClassifySavedHealthDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof classifySavedHealthDocument>>
>;
export type ClassifySavedHealthDocumentMutationBody =
  BodyType<HealthDocumentClassificationConsent>;
export type ClassifySavedHealthDocumentMutationError = ErrorType<void>;
export type ClassifySavedHealthDocumentMutationVariables = {
  id: string;
  data: BodyType<HealthDocumentClassificationConsent>;
};

/**
 * @summary Classify one saved original after fresh, explicit processing consent.
 */
export const useClassifySavedHealthDocument = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof classifySavedHealthDocument>>,
    TError,
    ClassifySavedHealthDocumentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof classifySavedHealthDocument>>,
  TError,
  ClassifySavedHealthDocumentMutationVariables,
  TContext
> => {
  return useMutation(getClassifySavedHealthDocumentMutationOptions(options));
};

export const getGetBloodLabsUrl = (params?: GetBloodLabsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/blood-labs?${stringifiedParams}`
    : `/api/blood-labs`;
};

/**
 * @summary Get the biomarker catalog, the user's latest reading per marker, and combined DNA×labs insights. Logs a view access.
 */
export const getBloodLabs = async (
  params?: GetBloodLabsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<BloodLabView> => {
  return customFetch<BloodLabView>(getGetBloodLabsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetBloodLabsQueryKey = (params?: GetBloodLabsParams) => {
  return [`/api/blood-labs`, ...(params ? [params] : [])] as const;
};

export const getGetBloodLabsQueryOptions = <
  TData = Awaited<ReturnType<typeof getBloodLabs>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetBloodLabsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBloodLabs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBloodLabsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBloodLabs>>> = ({
    signal,
  }) => getBloodLabs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBloodLabs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBloodLabsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBloodLabs>>
>;
export type GetBloodLabsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the biomarker catalog, the user's latest reading per marker, and combined DNA×labs insights. Logs a view access.
 */

export function useGetBloodLabs<
  TData = Awaited<ReturnType<typeof getBloodLabs>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetBloodLabsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBloodLabs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBloodLabsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSaveBloodLabUrl = () => {
  return `/api/blood-labs`;
};

/**
 * @summary Add or update a biomarker reading (latest value wins). Requires consent; audited like genetics.
 */
export const saveBloodLab = async (
  bloodLabSaveBody: BloodLabSaveBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<BloodLabSaveResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BloodLabSaveResult>(getSaveBloodLabUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(bloodLabSaveBody),
  });
};

export const getSaveBloodLabMutationKey = () => ["saveBloodLab"] as const;

export const getSaveBloodLabMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveBloodLab>>,
    TError,
    SaveBloodLabMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveBloodLab>>,
  TError,
  SaveBloodLabMutationVariables,
  TContext
> => {
  const mutationKey = getSaveBloodLabMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveBloodLab>>,
    SaveBloodLabMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return saveBloodLab(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveBloodLabMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveBloodLab>>
>;
export type SaveBloodLabMutationBody = BodyType<BloodLabSaveBody>;
export type SaveBloodLabMutationError = ErrorType<ErrorResponse>;
export type SaveBloodLabMutationVariables = {
  data: BodyType<BloodLabSaveBody>;
};

/**
 * @summary Add or update a biomarker reading (latest value wins). Requires consent; audited like genetics.
 */
export const useSaveBloodLab = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveBloodLab>>,
    TError,
    SaveBloodLabMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveBloodLab>>,
  TError,
  SaveBloodLabMutationVariables,
  TContext
> => {
  return useMutation(getSaveBloodLabMutationOptions(options));
};

export const getDeleteBloodLabsUrl = () => {
  return `/api/blood-labs`;
};

/**
 * @summary Permanently delete all of the current user's blood-lab readings (one-click). Records the deletion in the audit log.
 */
export const deleteBloodLabs = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<BloodLabDeleteResult> => {
  return customFetch<BloodLabDeleteResult>(getDeleteBloodLabsUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteBloodLabsMutationKey = () => ["deleteBloodLabs"] as const;

export const getDeleteBloodLabsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBloodLabs>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteBloodLabs>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getDeleteBloodLabsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteBloodLabs>>,
    void
  > = () => {
    return deleteBloodLabs(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteBloodLabsMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteBloodLabs>>
>;

export type DeleteBloodLabsMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Permanently delete all of the current user's blood-lab readings (one-click). Records the deletion in the audit log.
 */
export const useDeleteBloodLabs = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteBloodLabs>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteBloodLabs>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDeleteBloodLabsMutationOptions(options));
};

export const getExtractBloodLabReportUrl = () => {
  return `/api/blood-labs/extract`;
};

/**
 * @summary Upload a lab report (PDF or photo) and extract biomarker readings for review. Nothing is saved; the user confirms via import. Requires consent.
 */
export const extractBloodLabReport = async (
  bloodLabExtractBody: BloodLabExtractBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<BloodLabExtractResult | BloodLabExtractPendingResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BloodLabExtractResult | BloodLabExtractPendingResult>(
    getExtractBloodLabReportUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(bloodLabExtractBody),
    },
  );
};

export const getExtractBloodLabReportMutationKey = () =>
  ["extractBloodLabReport"] as const;

export const getExtractBloodLabReportMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractBloodLabReport>>,
    TError,
    ExtractBloodLabReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractBloodLabReport>>,
  TError,
  ExtractBloodLabReportMutationVariables,
  TContext
> => {
  const mutationKey = getExtractBloodLabReportMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractBloodLabReport>>,
    ExtractBloodLabReportMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return extractBloodLabReport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractBloodLabReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractBloodLabReport>>
>;
export type ExtractBloodLabReportMutationBody = BodyType<BloodLabExtractBody>;
export type ExtractBloodLabReportMutationError = ErrorType<ErrorResponse>;
export type ExtractBloodLabReportMutationVariables = {
  data: BodyType<BloodLabExtractBody>;
};

/**
 * @summary Upload a lab report (PDF or photo) and extract biomarker readings for review. Nothing is saved; the user confirms via import. Requires consent.
 */
export const useExtractBloodLabReport = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractBloodLabReport>>,
    TError,
    ExtractBloodLabReportMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof extractBloodLabReport>>,
  TError,
  ExtractBloodLabReportMutationVariables,
  TContext
> => {
  return useMutation(getExtractBloodLabReportMutationOptions(options));
};

export const getGetBloodLabExtractionUrl = (id: number) => {
  return `/api/blood-labs/extract/${id}`;
};

/**
 * @summary Retrieve a pending or recovered lab-report extraction for review. Nothing is saved until the user confirms via import.
 */
export const getBloodLabExtraction = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<
  BloodLabExtractionCompletedResult | BloodLabExtractionStatusResult
> => {
  return customFetch<
    BloodLabExtractionCompletedResult | BloodLabExtractionStatusResult
  >(getGetBloodLabExtractionUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetBloodLabExtractionQueryKey = (id: number) => {
  return [`/api/blood-labs/extract/${id}`] as const;
};

export const getGetBloodLabExtractionQueryOptions = <
  TData = Awaited<ReturnType<typeof getBloodLabExtraction>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBloodLabExtraction>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBloodLabExtractionQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBloodLabExtraction>>
  > = ({ signal }) => getBloodLabExtraction(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBloodLabExtraction>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBloodLabExtractionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBloodLabExtraction>>
>;
export type GetBloodLabExtractionQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Retrieve a pending or recovered lab-report extraction for review. Nothing is saved until the user confirms via import.
 */

export function useGetBloodLabExtraction<
  TData = Awaited<ReturnType<typeof getBloodLabExtraction>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBloodLabExtraction>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBloodLabExtractionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getImportBloodLabReadingsUrl = () => {
  return `/api/blood-labs/import`;
};

/**
 * @summary Save the reviewed readings from an extracted lab report (batched manual-entry path — same validation, encryption and consent gate).
 */
export const importBloodLabReadings = async (
  bloodLabImportBody: BloodLabImportBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<BloodLabSaveResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BloodLabSaveResult>(getImportBloodLabReadingsUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(bloodLabImportBody),
  });
};

export const getImportBloodLabReadingsMutationKey = () =>
  ["importBloodLabReadings"] as const;

export const getImportBloodLabReadingsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importBloodLabReadings>>,
    TError,
    ImportBloodLabReadingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importBloodLabReadings>>,
  TError,
  ImportBloodLabReadingsMutationVariables,
  TContext
> => {
  const mutationKey = getImportBloodLabReadingsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importBloodLabReadings>>,
    ImportBloodLabReadingsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return importBloodLabReadings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportBloodLabReadingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof importBloodLabReadings>>
>;
export type ImportBloodLabReadingsMutationBody = BodyType<BloodLabImportBody>;
export type ImportBloodLabReadingsMutationError = ErrorType<ErrorResponse>;
export type ImportBloodLabReadingsMutationVariables = {
  data: BodyType<BloodLabImportBody>;
};

/**
 * @summary Save the reviewed readings from an extracted lab report (batched manual-entry path — same validation, encryption and consent gate).
 */
export const useImportBloodLabReadings = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importBloodLabReadings>>,
    TError,
    ImportBloodLabReadingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importBloodLabReadings>>,
  TError,
  ImportBloodLabReadingsMutationVariables,
  TContext
> => {
  return useMutation(getImportBloodLabReadingsMutationOptions(options));
};

export const getGetGeneticCatalogUrl = () => {
  return `/api/genetics/catalog`;
};

/**
 * @summary List the supported nutrigenomic variants (knowledge base) including questionnaire questions
 */
export const getGeneticCatalog = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GeneticCatalogList> => {
  return customFetch<GeneticCatalogList>(getGetGeneticCatalogUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGeneticCatalogQueryKey = () => {
  return [`/api/genetics/catalog`] as const;
};

export const getGetGeneticCatalogQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeneticCatalog>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticCatalog>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGeneticCatalogQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeneticCatalog>>
  > = ({ signal }) => getGeneticCatalog({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticCatalog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGeneticCatalogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeneticCatalog>>
>;
export type GetGeneticCatalogQueryError = ErrorType<unknown>;

/**
 * @summary List the supported nutrigenomic variants (knowledge base) including questionnaire questions
 */

export function useGetGeneticCatalog<
  TData = Awaited<ReturnType<typeof getGeneticCatalog>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeneticCatalog>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGeneticCatalogQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSetGeneticConsentUrl = () => {
  return `/api/genetics/consent`;
};

/**
 * @summary Record the user's consent to process genetic data (required before any ingestion)
 */
export const setGeneticConsent = async (
  geneticConsentBody: GeneticConsentBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<GeneticConsentStatus> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GeneticConsentStatus>(getSetGeneticConsentUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(geneticConsentBody),
  });
};

export const getSetGeneticConsentMutationKey = () =>
  ["setGeneticConsent"] as const;

export const getSetGeneticConsentMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setGeneticConsent>>,
    TError,
    SetGeneticConsentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setGeneticConsent>>,
  TError,
  SetGeneticConsentMutationVariables,
  TContext
> => {
  const mutationKey = getSetGeneticConsentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setGeneticConsent>>,
    SetGeneticConsentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return setGeneticConsent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetGeneticConsentMutationResult = NonNullable<
  Awaited<ReturnType<typeof setGeneticConsent>>
>;
export type SetGeneticConsentMutationBody = BodyType<GeneticConsentBody>;
export type SetGeneticConsentMutationError = ErrorType<ErrorResponse>;
export type SetGeneticConsentMutationVariables = {
  data: BodyType<GeneticConsentBody>;
};

/**
 * @summary Record the user's consent to process genetic data (required before any ingestion)
 */
export const useSetGeneticConsent = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setGeneticConsent>>,
    TError,
    SetGeneticConsentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setGeneticConsent>>,
  TError,
  SetGeneticConsentMutationVariables,
  TContext
> => {
  return useMutation(getSetGeneticConsentMutationOptions(options));
};

export const getUploadGeneticFileUrl = () => {
  return `/api/genetics/upload`;
};

/**
 * @summary Upload a raw 23andMe / AncestryDNA export file. Parsed deterministically; only catalog rsIDs are stored. Requires consent.
 */
export const uploadGeneticFile = async (
  geneticUploadBody: GeneticUploadBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<GeneticUploadResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GeneticUploadResult>(getUploadGeneticFileUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(geneticUploadBody),
  });
};

export const getUploadGeneticFileMutationKey = () =>
  ["uploadGeneticFile"] as const;

export const getUploadGeneticFileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadGeneticFile>>,
    TError,
    UploadGeneticFileMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadGeneticFile>>,
  TError,
  UploadGeneticFileMutationVariables,
  TContext
> => {
  const mutationKey = getUploadGeneticFileMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadGeneticFile>>,
    UploadGeneticFileMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return uploadGeneticFile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadGeneticFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadGeneticFile>>
>;
export type UploadGeneticFileMutationBody = BodyType<GeneticUploadBody>;
export type UploadGeneticFileMutationError = ErrorType<ErrorResponse>;
export type UploadGeneticFileMutationVariables = {
  data: BodyType<GeneticUploadBody>;
};

/**
 * @summary Upload a raw 23andMe / AncestryDNA export file. Parsed deterministically; only catalog rsIDs are stored. Requires consent.
 */
export const useUploadGeneticFile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadGeneticFile>>,
    TError,
    UploadGeneticFileMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadGeneticFile>>,
  TError,
  UploadGeneticFileMutationVariables,
  TContext
> => {
  return useMutation(getUploadGeneticFileMutationOptions(options));
};

export const getSubmitGeneticQuestionnaireUrl = () => {
  return `/api/genetics/questionnaire`;
};

/**
 * @summary Submit guided questionnaire answers. Mapped to genotypes via the catalog. Requires consent.
 */
export const submitGeneticQuestionnaire = async (
  geneticQuestionnaireBody: GeneticQuestionnaireBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<GeneticIngestResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GeneticIngestResult>(getSubmitGeneticQuestionnaireUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(geneticQuestionnaireBody),
  });
};

export const getSubmitGeneticQuestionnaireMutationKey = () =>
  ["submitGeneticQuestionnaire"] as const;

export const getSubmitGeneticQuestionnaireMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitGeneticQuestionnaire>>,
    TError,
    SubmitGeneticQuestionnaireMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitGeneticQuestionnaire>>,
  TError,
  SubmitGeneticQuestionnaireMutationVariables,
  TContext
> => {
  const mutationKey = getSubmitGeneticQuestionnaireMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitGeneticQuestionnaire>>,
    SubmitGeneticQuestionnaireMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return submitGeneticQuestionnaire(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitGeneticQuestionnaireMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitGeneticQuestionnaire>>
>;
export type SubmitGeneticQuestionnaireMutationBody =
  BodyType<GeneticQuestionnaireBody>;
export type SubmitGeneticQuestionnaireMutationError = ErrorType<ErrorResponse>;
export type SubmitGeneticQuestionnaireMutationVariables = {
  data: BodyType<GeneticQuestionnaireBody>;
};

/**
 * @summary Submit guided questionnaire answers. Mapped to genotypes via the catalog. Requires consent.
 */
export const useSubmitGeneticQuestionnaire = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitGeneticQuestionnaire>>,
    TError,
    SubmitGeneticQuestionnaireMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitGeneticQuestionnaire>>,
  TError,
  SubmitGeneticQuestionnaireMutationVariables,
  TContext
> => {
  return useMutation(getSubmitGeneticQuestionnaireMutationOptions(options));
};

export const getLoadGeneticSampleUrl = () => {
  return `/api/genetics/sample`;
};

/**
 * @summary Load the built-in illustrative sample genetic profile. Requires consent.
 */
export const loadGeneticSample = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GeneticIngestResult> => {
  return customFetch<GeneticIngestResult>(getLoadGeneticSampleUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLoadGeneticSampleMutationKey = () =>
  ["loadGeneticSample"] as const;

export const getLoadGeneticSampleMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loadGeneticSample>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loadGeneticSample>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getLoadGeneticSampleMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loadGeneticSample>>,
    void
  > = () => {
    return loadGeneticSample(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoadGeneticSampleMutationResult = NonNullable<
  Awaited<ReturnType<typeof loadGeneticSample>>
>;

export type LoadGeneticSampleMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Load the built-in illustrative sample genetic profile. Requires consent.
 */
export const useLoadGeneticSample = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loadGeneticSample>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof loadGeneticSample>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLoadGeneticSampleMutationOptions(options));
};

export const getGetDnaDeepCommandMatrixUrl = (
  params?: GetDnaDeepCommandMatrixParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/deep-command/dna-matrix?${stringifiedParams}`
    : `/api/deep-command/dna-matrix`;
};

/**
 * @summary Reshape the current user's Deep Command Matrix with their DNA. Consent-gated and audited.
 */
export const getDnaDeepCommandMatrix = async (
  params?: GetDnaDeepCommandMatrixParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DnaDeepCommandMatrix> => {
  return customFetch<DnaDeepCommandMatrix>(
    getGetDnaDeepCommandMatrixUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDnaDeepCommandMatrixQueryKey = (
  params?: GetDnaDeepCommandMatrixParams,
) => {
  return [`/api/deep-command/dna-matrix`, ...(params ? [params] : [])] as const;
};

export const getGetDnaDeepCommandMatrixQueryOptions = <
  TData = Awaited<ReturnType<typeof getDnaDeepCommandMatrix>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetDnaDeepCommandMatrixParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDnaDeepCommandMatrix>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDnaDeepCommandMatrixQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDnaDeepCommandMatrix>>
  > = ({ signal }) =>
    getDnaDeepCommandMatrix(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDnaDeepCommandMatrix>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDnaDeepCommandMatrixQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDnaDeepCommandMatrix>>
>;
export type GetDnaDeepCommandMatrixQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Reshape the current user's Deep Command Matrix with their DNA. Consent-gated and audited.
 */

export function useGetDnaDeepCommandMatrix<
  TData = Awaited<ReturnType<typeof getDnaDeepCommandMatrix>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetDnaDeepCommandMatrixParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDnaDeepCommandMatrix>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDnaDeepCommandMatrixQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetDeepCommandMethodologyUrl = () => {
  return `/api/deep-command/methodology`;
};

/**
 * @summary Read versioned Deep Command nutrition-support methods and applicable references
 */
export const getDeepCommandMethodology = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<DeepCommandMethodologyResponse> => {
  return customFetch<DeepCommandMethodologyResponse>(
    getGetDeepCommandMethodologyUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDeepCommandMethodologyQueryKey = () => {
  return [`/api/deep-command/methodology`] as const;
};

export const getGetDeepCommandMethodologyQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeepCommandMethodology>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDeepCommandMethodology>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDeepCommandMethodologyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeepCommandMethodology>>
  > = ({ signal }) => getDeepCommandMethodology({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeepCommandMethodology>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDeepCommandMethodologyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeepCommandMethodology>>
>;
export type GetDeepCommandMethodologyQueryError = ErrorType<unknown>;

/**
 * @summary Read versioned Deep Command nutrition-support methods and applicable references
 */

export function useGetDeepCommandMethodology<
  TData = Awaited<ReturnType<typeof getDeepCommandMethodology>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDeepCommandMethodology>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDeepCommandMethodologyQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateDeepCommandAiPreferenceUrl = () => {
  return `/api/deep-command/ai-preferences`;
};

/**
 * @summary Explicitly enable or disable bounded Deep Command AI analysis
 */
export const updateDeepCommandAiPreference = async (
  deepCommandAiPreferenceRequest: DeepCommandAiPreferenceRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeepCommandAiPreferenceResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<DeepCommandAiPreferenceResponse>(
    getUpdateDeepCommandAiPreferenceUrl(),
    {
      ...options,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(deepCommandAiPreferenceRequest),
    },
  );
};

export const getUpdateDeepCommandAiPreferenceMutationKey = () =>
  ["updateDeepCommandAiPreference"] as const;

export const getUpdateDeepCommandAiPreferenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDeepCommandAiPreference>>,
    TError,
    UpdateDeepCommandAiPreferenceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDeepCommandAiPreference>>,
  TError,
  UpdateDeepCommandAiPreferenceMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateDeepCommandAiPreferenceMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDeepCommandAiPreference>>,
    UpdateDeepCommandAiPreferenceMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateDeepCommandAiPreference(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDeepCommandAiPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDeepCommandAiPreference>>
>;
export type UpdateDeepCommandAiPreferenceMutationBody =
  BodyType<DeepCommandAiPreferenceRequest>;
export type UpdateDeepCommandAiPreferenceMutationError = ErrorType<unknown>;
export type UpdateDeepCommandAiPreferenceMutationVariables = {
  data: BodyType<DeepCommandAiPreferenceRequest>;
};

/**
 * @summary Explicitly enable or disable bounded Deep Command AI analysis
 */
export const useUpdateDeepCommandAiPreference = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDeepCommandAiPreference>>,
    TError,
    UpdateDeepCommandAiPreferenceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateDeepCommandAiPreference>>,
  TError,
  UpdateDeepCommandAiPreferenceMutationVariables,
  TContext
> => {
  return useMutation(getUpdateDeepCommandAiPreferenceMutationOptions(options));
};

export const getGetDeepCommandAiAnalysisUrl = (
  params?: GetDeepCommandAiAnalysisParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/deep-command/ai-analysis?${stringifiedParams}`
    : `/api/deep-command/ai-analysis`;
};

/**
 * @summary Read the current owner/date scoped Deep Command AI result without invoking a model
 */
export const getDeepCommandAiAnalysis = async (
  params?: GetDeepCommandAiAnalysisParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeepCommandAiAnalysisStatus> => {
  return customFetch<DeepCommandAiAnalysisStatus>(
    getGetDeepCommandAiAnalysisUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDeepCommandAiAnalysisQueryKey = (
  params?: GetDeepCommandAiAnalysisParams,
) => {
  return [
    `/api/deep-command/ai-analysis`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDeepCommandAiAnalysisQueryOptions = <
  TData = Awaited<ReturnType<typeof getDeepCommandAiAnalysis>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDeepCommandAiAnalysisParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDeepCommandAiAnalysis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDeepCommandAiAnalysisQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDeepCommandAiAnalysis>>
  > = ({ signal }) =>
    getDeepCommandAiAnalysis(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDeepCommandAiAnalysis>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDeepCommandAiAnalysisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDeepCommandAiAnalysis>>
>;
export type GetDeepCommandAiAnalysisQueryError = ErrorType<unknown>;

/**
 * @summary Read the current owner/date scoped Deep Command AI result without invoking a model
 */

export function useGetDeepCommandAiAnalysis<
  TData = Awaited<ReturnType<typeof getDeepCommandAiAnalysis>>,
  TError = ErrorType<unknown>,
>(
  params?: GetDeepCommandAiAnalysisParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDeepCommandAiAnalysis>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDeepCommandAiAnalysisQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getRequestDeepCommandAiAnalysisUrl = () => {
  return `/api/deep-command/ai-analysis`;
};

/**
 * @summary Queue an idempotent analysis for the current input version or explicitly refresh it
 */
export const requestDeepCommandAiAnalysis = async (
  deepCommandAiAnalysisRequest: DeepCommandAiAnalysisRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeepCommandAiAnalysisStatus> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<DeepCommandAiAnalysisStatus>(
    getRequestDeepCommandAiAnalysisUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(deepCommandAiAnalysisRequest),
    },
  );
};

export const getRequestDeepCommandAiAnalysisMutationKey = () =>
  ["requestDeepCommandAiAnalysis"] as const;

export const getRequestDeepCommandAiAnalysisMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestDeepCommandAiAnalysis>>,
    TError,
    RequestDeepCommandAiAnalysisMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestDeepCommandAiAnalysis>>,
  TError,
  RequestDeepCommandAiAnalysisMutationVariables,
  TContext
> => {
  const mutationKey = getRequestDeepCommandAiAnalysisMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestDeepCommandAiAnalysis>>,
    RequestDeepCommandAiAnalysisMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return requestDeepCommandAiAnalysis(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestDeepCommandAiAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestDeepCommandAiAnalysis>>
>;
export type RequestDeepCommandAiAnalysisMutationBody =
  BodyType<DeepCommandAiAnalysisRequest>;
export type RequestDeepCommandAiAnalysisMutationError =
  ErrorType<ErrorResponse>;
export type RequestDeepCommandAiAnalysisMutationVariables = {
  data: BodyType<DeepCommandAiAnalysisRequest>;
};

/**
 * @summary Queue an idempotent analysis for the current input version or explicitly refresh it
 */
export const useRequestDeepCommandAiAnalysis = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestDeepCommandAiAnalysis>>,
    TError,
    RequestDeepCommandAiAnalysisMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestDeepCommandAiAnalysis>>,
  TError,
  RequestDeepCommandAiAnalysisMutationVariables,
  TContext
> => {
  return useMutation(getRequestDeepCommandAiAnalysisMutationOptions(options));
};

export const getListHealthSnapshotsUrl = () => {
  return `/api/health-snapshots`;
};

/**
 * @summary List the current user's monthly health-record snapshots (newest first). Purged periods are flagged.
 */
export const listHealthSnapshots = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<HealthSnapshotList> => {
  return customFetch<HealthSnapshotList>(getListHealthSnapshotsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListHealthSnapshotsQueryKey = () => {
  return [`/api/health-snapshots`] as const;
};

export const getListHealthSnapshotsQueryOptions = <
  TData = Awaited<ReturnType<typeof listHealthSnapshots>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listHealthSnapshots>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHealthSnapshotsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHealthSnapshots>>
  > = ({ signal }) => listHealthSnapshots({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHealthSnapshots>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListHealthSnapshotsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHealthSnapshots>>
>;
export type ListHealthSnapshotsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List the current user's monthly health-record snapshots (newest first). Purged periods are flagged.
 */

export function useListHealthSnapshots<
  TData = Awaited<ReturnType<typeof listHealthSnapshots>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listHealthSnapshots>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListHealthSnapshotsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetHealthSnapshotUrl = (id: number) => {
  return `/api/health-snapshots/${id}`;
};

/**
 * @summary Get one decoded monthly snapshot as a frozen, grid-ready payload. Logs a snapshot view access.
 */
export const getHealthSnapshot = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<HealthSnapshotDetail> => {
  return customFetch<HealthSnapshotDetail>(getGetHealthSnapshotUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetHealthSnapshotQueryKey = (id: number) => {
  return [`/api/health-snapshots/${id}`] as const;
};

export const getGetHealthSnapshotQueryOptions = <
  TData = Awaited<ReturnType<typeof getHealthSnapshot>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHealthSnapshot>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHealthSnapshotQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHealthSnapshot>>
  > = ({ signal }) => getHealthSnapshot(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHealthSnapshot>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHealthSnapshotQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHealthSnapshot>>
>;
export type GetHealthSnapshotQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get one decoded monthly snapshot as a frozen, grid-ready payload. Logs a snapshot view access.
 */

export function useGetHealthSnapshot<
  TData = Awaited<ReturnType<typeof getHealthSnapshot>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHealthSnapshot>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetHealthSnapshotQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetHealthSnapshotDownloadUrl = (id: number) => {
  return `/api/health-snapshots/${id}/download`;
};

/**
 * @summary Get a short-lived signed URL to download the raw encrypted snapshot archive. Logs a download access.
 */
export const getHealthSnapshotDownload = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<HealthSnapshotDownload> => {
  return customFetch<HealthSnapshotDownload>(
    getGetHealthSnapshotDownloadUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetHealthSnapshotDownloadQueryKey = (id: number) => {
  return [`/api/health-snapshots/${id}/download`] as const;
};

export const getGetHealthSnapshotDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getHealthSnapshotDownload>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHealthSnapshotDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetHealthSnapshotDownloadQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHealthSnapshotDownload>>
  > = ({ signal }) =>
    getHealthSnapshotDownload(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHealthSnapshotDownload>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHealthSnapshotDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHealthSnapshotDownload>>
>;
export type GetHealthSnapshotDownloadQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get a short-lived signed URL to download the raw encrypted snapshot archive. Logs a download access.
 */

export function useGetHealthSnapshotDownload<
  TData = Awaited<ReturnType<typeof getHealthSnapshotDownload>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getHealthSnapshotDownload>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetHealthSnapshotDownloadQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetIntelligenceContextUrl = () => {
  return `/api/intelligence`;
};

/**
 * @summary Get the unified cross-feature intelligence context: every active signal (nutrient deficiency, DNA flag, recovery, NRS movement, deep-command gap, streak/pattern) with a stable type, severity, plain-language reason, the data sources behind it, and a one-click cross-feature action.
 */
export const getIntelligenceContext = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<IntelligenceContext> => {
  return customFetch<IntelligenceContext>(getGetIntelligenceContextUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetIntelligenceContextQueryKey = () => {
  return [`/api/intelligence`] as const;
};

export const getGetIntelligenceContextQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntelligenceContext>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceContext>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIntelligenceContextQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntelligenceContext>>
  > = ({ signal }) => getIntelligenceContext({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceContext>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetIntelligenceContextQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntelligenceContext>>
>;
export type GetIntelligenceContextQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the unified cross-feature intelligence context: every active signal (nutrient deficiency, DNA flag, recovery, NRS movement, deep-command gap, streak/pattern) with a stable type, severity, plain-language reason, the data sources behind it, and a one-click cross-feature action.
 */

export function useGetIntelligenceContext<
  TData = Awaited<ReturnType<typeof getIntelligenceContext>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getIntelligenceContext>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetIntelligenceContextQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetCoachDismissalsUrl = () => {
  return `/api/coach-dismissals`;
};

/**
 * @summary List the ids of Coach AI signals the current user has dismissed and that have not yet expired. Used to hide dismissed items consistently on every device.
 */
export const getCoachDismissals = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachDismissals> => {
  return customFetch<CoachDismissals>(getGetCoachDismissalsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCoachDismissalsQueryKey = () => {
  return [`/api/coach-dismissals`] as const;
};

export const getGetCoachDismissalsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoachDismissals>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCoachDismissals>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCoachDismissalsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCoachDismissals>>
  > = ({ signal }) => getCoachDismissals({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCoachDismissals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCoachDismissalsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCoachDismissals>>
>;
export type GetCoachDismissalsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List the ids of Coach AI signals the current user has dismissed and that have not yet expired. Used to hide dismissed items consistently on every device.
 */

export function useGetCoachDismissals<
  TData = Awaited<ReturnType<typeof getCoachDismissals>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCoachDismissals>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCoachDismissalsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getDismissCoachSignalUrl = () => {
  return `/api/coach-dismissals`;
};

/**
 * @summary Dismiss a single Coach AI signal for the current user. Idempotent — re-dismissing the same signal refreshes its expiry.
 */
export const dismissCoachSignal = async (
  dismissCoachSignalBody: DismissCoachSignalBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachDismissals> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CoachDismissals>(getDismissCoachSignalUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(dismissCoachSignalBody),
  });
};

export const getDismissCoachSignalMutationKey = () =>
  ["dismissCoachSignal"] as const;

export const getDismissCoachSignalMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissCoachSignal>>,
    TError,
    DismissCoachSignalMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissCoachSignal>>,
  TError,
  DismissCoachSignalMutationVariables,
  TContext
> => {
  const mutationKey = getDismissCoachSignalMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissCoachSignal>>,
    DismissCoachSignalMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return dismissCoachSignal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissCoachSignalMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissCoachSignal>>
>;
export type DismissCoachSignalMutationBody = BodyType<DismissCoachSignalBody>;
export type DismissCoachSignalMutationError = ErrorType<ErrorResponse>;
export type DismissCoachSignalMutationVariables = {
  data: BodyType<DismissCoachSignalBody>;
};

/**
 * @summary Dismiss a single Coach AI signal for the current user. Idempotent — re-dismissing the same signal refreshes its expiry.
 */
export const useDismissCoachSignal = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissCoachSignal>>,
    TError,
    DismissCoachSignalMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissCoachSignal>>,
  TError,
  DismissCoachSignalMutationVariables,
  TContext
> => {
  return useMutation(getDismissCoachSignalMutationOptions(options));
};

export const getRestoreCoachSignalUrl = (signalId: string) => {
  return `/api/coach-dismissals/${signalId}`;
};

/**
 * @summary Undo a dismissal: remove a single Coach AI signal from the current user's dismissed set so it resurfaces in its correct priority position. Idempotent — undoing an already-absent dismissal is a no-op.
 */
export const restoreCoachSignal = async (
  signalId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachDismissals> => {
  return customFetch<CoachDismissals>(getRestoreCoachSignalUrl(signalId), {
    ...options,
    method: "DELETE",
  });
};

export const getRestoreCoachSignalMutationKey = () =>
  ["restoreCoachSignal"] as const;

export const getRestoreCoachSignalMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreCoachSignal>>,
    TError,
    RestoreCoachSignalMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreCoachSignal>>,
  TError,
  RestoreCoachSignalMutationVariables,
  TContext
> => {
  const mutationKey = getRestoreCoachSignalMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreCoachSignal>>,
    RestoreCoachSignalMutationVariables
  > = (props) => {
    const { signalId } = props ?? {};

    return restoreCoachSignal(signalId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreCoachSignalMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreCoachSignal>>
>;

export type RestoreCoachSignalMutationError = ErrorType<ErrorResponse>;
export type RestoreCoachSignalMutationVariables = { signalId: string };

/**
 * @summary Undo a dismissal: remove a single Coach AI signal from the current user's dismissed set so it resurfaces in its correct priority position. Idempotent — undoing an already-absent dismissal is a no-op.
 */
export const useRestoreCoachSignal = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreCoachSignal>>,
    TError,
    RestoreCoachSignalMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof restoreCoachSignal>>,
  TError,
  RestoreCoachSignalMutationVariables,
  TContext
> => {
  return useMutation(getRestoreCoachSignalMutationOptions(options));
};

export const getGetCoachAiRecommendationsUrl = () => {
  return `/api/coach-ai/recommendations`;
};

/**
 * @summary Generate the current ranked Coach AI action recommendations from the user's latest wearable signals, nutrition, and recent completions. Requires an active subscription.
 */
export const getCoachAiRecommendations = async (
  getCoachAiRecommendationsBody?: GetCoachAiRecommendationsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachAiRecommendationsResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CoachAiRecommendationsResponse>(
    getGetCoachAiRecommendationsUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(getCoachAiRecommendationsBody),
    },
  );
};

export const getGetCoachAiRecommendationsMutationKey = () =>
  ["getCoachAiRecommendations"] as const;

export const getGetCoachAiRecommendationsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getCoachAiRecommendations>>,
    TError,
    GetCoachAiRecommendationsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getCoachAiRecommendations>>,
  TError,
  GetCoachAiRecommendationsMutationVariables,
  TContext
> => {
  const mutationKey = getGetCoachAiRecommendationsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getCoachAiRecommendations>>,
    GetCoachAiRecommendationsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getCoachAiRecommendations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetCoachAiRecommendationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getCoachAiRecommendations>>
>;
export type GetCoachAiRecommendationsMutationBody =
  | BodyType<GetCoachAiRecommendationsBody>
  | undefined;
export type GetCoachAiRecommendationsMutationError = ErrorType<ErrorResponse>;
export type GetCoachAiRecommendationsMutationVariables = {
  data?: BodyType<GetCoachAiRecommendationsBody>;
};

/**
 * @summary Generate the current ranked Coach AI action recommendations from the user's latest wearable signals, nutrition, and recent completions. Requires an active subscription.
 */
export const useGetCoachAiRecommendations = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getCoachAiRecommendations>>,
    TError,
    GetCoachAiRecommendationsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getCoachAiRecommendations>>,
  TError,
  GetCoachAiRecommendationsMutationVariables,
  TContext
> => {
  return useMutation(getGetCoachAiRecommendationsMutationOptions(options));
};

export const getGetCoachAiCompletionsTodayUrl = () => {
  return `/api/coach-ai/completions/today`;
};

/**
 * @summary List Coach AI actions the user completed today, newest first.
 */
export const getCoachAiCompletionsToday = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachAiCompletionsToday> => {
  return customFetch<CoachAiCompletionsToday>(
    getGetCoachAiCompletionsTodayUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCoachAiCompletionsTodayQueryKey = () => {
  return [`/api/coach-ai/completions/today`] as const;
};

export const getGetCoachAiCompletionsTodayQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoachAiCompletionsToday>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCoachAiCompletionsToday>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCoachAiCompletionsTodayQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCoachAiCompletionsToday>>
  > = ({ signal }) => getCoachAiCompletionsToday({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCoachAiCompletionsToday>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCoachAiCompletionsTodayQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCoachAiCompletionsToday>>
>;
export type GetCoachAiCompletionsTodayQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List Coach AI actions the user completed today, newest first.
 */

export function useGetCoachAiCompletionsToday<
  TData = Awaited<ReturnType<typeof getCoachAiCompletionsToday>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCoachAiCompletionsToday>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCoachAiCompletionsTodayQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetCoachAiCompletionHistoryUrl = (
  params: GetCoachAiCompletionHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/coach-ai/completions/history?${stringifiedParams}`
    : `/api/coach-ai/completions/history`;
};

/**
 * @summary List completed Coach AI actions within a past UTC date range, newest first.
 */
export const getCoachAiCompletionHistory = async (
  params: GetCoachAiCompletionHistoryParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachAiCompletionHistory> => {
  return customFetch<CoachAiCompletionHistory>(
    getGetCoachAiCompletionHistoryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCoachAiCompletionHistoryQueryKey = (
  params?: GetCoachAiCompletionHistoryParams,
) => {
  return [
    `/api/coach-ai/completions/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCoachAiCompletionHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getCoachAiCompletionHistory>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetCoachAiCompletionHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCoachAiCompletionHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCoachAiCompletionHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCoachAiCompletionHistory>>
  > = ({ signal }) =>
    getCoachAiCompletionHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCoachAiCompletionHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCoachAiCompletionHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCoachAiCompletionHistory>>
>;
export type GetCoachAiCompletionHistoryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List completed Coach AI actions within a past UTC date range, newest first.
 */

export function useGetCoachAiCompletionHistory<
  TData = Awaited<ReturnType<typeof getCoachAiCompletionHistory>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetCoachAiCompletionHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCoachAiCompletionHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCoachAiCompletionHistoryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCompleteCoachAiActionUrl = () => {
  return `/api/coach-ai/completions`;
};

/**
 * @summary Record the completion of a Coach AI catalog action, with an action-specific payload (e.g. breathing protocol, quick-log grams, target bedtime).
 */
export const completeCoachAiAction = async (
  createCoachAiCompletionBody: CreateCoachAiCompletionBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachAiCompletionCreated> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CoachAiCompletionCreated>(getCompleteCoachAiActionUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(createCoachAiCompletionBody),
  });
};

export const getCompleteCoachAiActionMutationKey = () =>
  ["completeCoachAiAction"] as const;

export const getCompleteCoachAiActionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeCoachAiAction>>,
    TError,
    CompleteCoachAiActionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeCoachAiAction>>,
  TError,
  CompleteCoachAiActionMutationVariables,
  TContext
> => {
  const mutationKey = getCompleteCoachAiActionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeCoachAiAction>>,
    CompleteCoachAiActionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return completeCoachAiAction(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteCoachAiActionMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeCoachAiAction>>
>;
export type CompleteCoachAiActionMutationBody =
  BodyType<CreateCoachAiCompletionBody>;
export type CompleteCoachAiActionMutationError = ErrorType<ErrorResponse>;
export type CompleteCoachAiActionMutationVariables = {
  data: BodyType<CreateCoachAiCompletionBody>;
};

/**
 * @summary Record the completion of a Coach AI catalog action, with an action-specific payload (e.g. breathing protocol, quick-log grams, target bedtime).
 */
export const useCompleteCoachAiAction = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeCoachAiAction>>,
    TError,
    CompleteCoachAiActionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeCoachAiAction>>,
  TError,
  CompleteCoachAiActionMutationVariables,
  TContext
> => {
  return useMutation(getCompleteCoachAiActionMutationOptions(options));
};

export const getUndoCoachAiCompletionUrl = (id: number) => {
  return `/api/coach-ai/completions/${id}`;
};

/**
 * @summary Undo a Coach AI completion (and any food log it wrote). Used for the short post-completion undo window.
 */
export const undoCoachAiCompletion = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CoachAiUndoResult> => {
  return customFetch<CoachAiUndoResult>(getUndoCoachAiCompletionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getUndoCoachAiCompletionMutationKey = () =>
  ["undoCoachAiCompletion"] as const;

export const getUndoCoachAiCompletionMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof undoCoachAiCompletion>>,
    TError,
    UndoCoachAiCompletionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof undoCoachAiCompletion>>,
  TError,
  UndoCoachAiCompletionMutationVariables,
  TContext
> => {
  const mutationKey = getUndoCoachAiCompletionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof undoCoachAiCompletion>>,
    UndoCoachAiCompletionMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return undoCoachAiCompletion(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UndoCoachAiCompletionMutationResult = NonNullable<
  Awaited<ReturnType<typeof undoCoachAiCompletion>>
>;

export type UndoCoachAiCompletionMutationError = ErrorType<ErrorResponse>;
export type UndoCoachAiCompletionMutationVariables = { id: number };

/**
 * @summary Undo a Coach AI completion (and any food log it wrote). Used for the short post-completion undo window.
 */
export const useUndoCoachAiCompletion = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof undoCoachAiCompletion>>,
    TError,
    UndoCoachAiCompletionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof undoCoachAiCompletion>>,
  TError,
  UndoCoachAiCompletionMutationVariables,
  TContext
> => {
  return useMutation(getUndoCoachAiCompletionMutationOptions(options));
};

export const getGetNrsCurrentUrl = () => {
  return `/api/nrs/current`;
};

/**
 * @summary Get the current Neural Rank Score (NRS) and tier for the user
 */
export const getNrsCurrent = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<NrsCurrent> => {
  return customFetch<NrsCurrent>(getGetNrsCurrentUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetNrsCurrentQueryKey = () => {
  return [`/api/nrs/current`] as const;
};

export const getGetNrsCurrentQueryOptions = <
  TData = Awaited<ReturnType<typeof getNrsCurrent>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNrsCurrent>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNrsCurrentQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNrsCurrent>>> = ({
    signal,
  }) => getNrsCurrent({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNrsCurrent>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNrsCurrentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNrsCurrent>>
>;
export type GetNrsCurrentQueryError = ErrorType<unknown>;

/**
 * @summary Get the current Neural Rank Score (NRS) and tier for the user
 */

export function useGetNrsCurrent<
  TData = Awaited<ReturnType<typeof getNrsCurrent>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNrsCurrent>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNrsCurrentQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListRecentLogsUrl = (params?: ListRecentLogsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/logs/recent?${stringifiedParams}`
    : `/api/logs/recent`;
};

/**
 * @summary List the most recently logged foods
 */
export const listRecentLogs = async (
  params?: ListRecentLogsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<RecentLogItem[]> => {
  return customFetch<RecentLogItem[]>(getListRecentLogsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListRecentLogsQueryKey = (params?: ListRecentLogsParams) => {
  return [`/api/logs/recent`, ...(params ? [params] : [])] as const;
};

export const getListRecentLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listRecentLogs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRecentLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRecentLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRecentLogsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecentLogs>>> = ({
    signal,
  }) => listRecentLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRecentLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRecentLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRecentLogs>>
>;
export type ListRecentLogsQueryError = ErrorType<unknown>;

/**
 * @summary List the most recently logged foods
 */

export function useListRecentLogs<
  TData = Awaited<ReturnType<typeof listRecentLogs>>,
  TError = ErrorType<unknown>,
>(
  params?: ListRecentLogsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listRecentLogs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListRecentLogsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPlateTalkChatUrl = () => {
  return `/api/plate-talk`;
};

/**
 * @summary Send a text message to the Plate Talk conversational assistant
 */
export const plateTalkChat = async (
  plateTalkChatBody: PlateTalkChatBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PlateTalkChatResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PlateTalkChatResponse>(getPlateTalkChatUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(plateTalkChatBody),
  });
};

export const getPlateTalkChatMutationKey = () => ["plateTalkChat"] as const;

export const getPlateTalkChatMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plateTalkChat>>,
    TError,
    PlateTalkChatMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof plateTalkChat>>,
  TError,
  PlateTalkChatMutationVariables,
  TContext
> => {
  const mutationKey = getPlateTalkChatMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof plateTalkChat>>,
    PlateTalkChatMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return plateTalkChat(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlateTalkChatMutationResult = NonNullable<
  Awaited<ReturnType<typeof plateTalkChat>>
>;
export type PlateTalkChatMutationBody = BodyType<PlateTalkChatBody>;
export type PlateTalkChatMutationError = ErrorType<unknown>;
export type PlateTalkChatMutationVariables = {
  data: BodyType<PlateTalkChatBody>;
};

/**
 * @summary Send a text message to the Plate Talk conversational assistant
 */
export const usePlateTalkChat = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof plateTalkChat>>,
    TError,
    PlateTalkChatMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof plateTalkChat>>,
  TError,
  PlateTalkChatMutationVariables,
  TContext
> => {
  return useMutation(getPlateTalkChatMutationOptions(options));
};

export const getQuickLogFoodUrl = () => {
  return `/api/plate-talk/quick-log`;
};

/**
 * @summary Quickly analyze and log a food by name
 */
export const quickLogFood = async (
  quickLogBody: QuickLogBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<QuickLogResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<QuickLogResponse>(getQuickLogFoodUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(quickLogBody),
  });
};

export const getQuickLogFoodMutationKey = () => ["quickLogFood"] as const;

export const getQuickLogFoodMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof quickLogFood>>,
    TError,
    QuickLogFoodMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof quickLogFood>>,
  TError,
  QuickLogFoodMutationVariables,
  TContext
> => {
  const mutationKey = getQuickLogFoodMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof quickLogFood>>,
    QuickLogFoodMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return quickLogFood(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type QuickLogFoodMutationResult = NonNullable<
  Awaited<ReturnType<typeof quickLogFood>>
>;
export type QuickLogFoodMutationBody = BodyType<QuickLogBody>;
export type QuickLogFoodMutationError = ErrorType<unknown>;
export type QuickLogFoodMutationVariables = { data: BodyType<QuickLogBody> };

/**
 * @summary Quickly analyze and log a food by name
 */
export const useQuickLogFood = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof quickLogFood>>,
    TError,
    QuickLogFoodMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof quickLogFood>>,
  TError,
  QuickLogFoodMutationVariables,
  TContext
> => {
  return useMutation(getQuickLogFoodMutationOptions(options));
};

export const getLookupBarcodeUrl = () => {
  return `/api/plate-talk/barcode-lookup`;
};

/**
 * @summary Look up a product by barcode number or barcode photo
 */
export const lookupBarcode = async (
  barcodeLookupBody: BarcodeLookupBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<BarcodeLookupResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BarcodeLookupResponse>(getLookupBarcodeUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(barcodeLookupBody),
  });
};

export const getLookupBarcodeMutationKey = () => ["lookupBarcode"] as const;

export const getLookupBarcodeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupBarcode>>,
    TError,
    LookupBarcodeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof lookupBarcode>>,
  TError,
  LookupBarcodeMutationVariables,
  TContext
> => {
  const mutationKey = getLookupBarcodeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof lookupBarcode>>,
    LookupBarcodeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return lookupBarcode(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LookupBarcodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof lookupBarcode>>
>;
export type LookupBarcodeMutationBody = BodyType<BarcodeLookupBody>;
export type LookupBarcodeMutationError = ErrorType<unknown>;
export type LookupBarcodeMutationVariables = {
  data: BodyType<BarcodeLookupBody>;
};

/**
 * @summary Look up a product by barcode number or barcode photo
 */
export const useLookupBarcode = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof lookupBarcode>>,
    TError,
    LookupBarcodeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof lookupBarcode>>,
  TError,
  LookupBarcodeMutationVariables,
  TContext
> => {
  return useMutation(getLookupBarcodeMutationOptions(options));
};

export const getSearchFoodsUrl = (params: SearchFoodsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/plate-talk/food-search?${stringifiedParams}`
    : `/api/plate-talk/food-search`;
};

/**
 * @summary Search foods by name for quick logging
 */
export const searchFoods = async (
  params: SearchFoodsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<FoodSearchResponse> => {
  return customFetch<FoodSearchResponse>(getSearchFoodsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getSearchFoodsQueryKey = (params?: SearchFoodsParams) => {
  return [`/api/plate-talk/food-search`, ...(params ? [params] : [])] as const;
};

export const getSearchFoodsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchFoods>>,
  TError = ErrorType<unknown>,
>(
  params: SearchFoodsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchFoods>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchFoodsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchFoods>>> = ({
    signal,
  }) => searchFoods(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchFoods>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SearchFoodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchFoods>>
>;
export type SearchFoodsQueryError = ErrorType<unknown>;

/**
 * @summary Search foods by name for quick logging
 */

export function useSearchFoods<
  TData = Awaited<ReturnType<typeof searchFoods>>,
  TError = ErrorType<unknown>,
>(
  params: SearchFoodsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof searchFoods>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSearchFoodsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getIdentifyMealPhotoUrl = () => {
  return `/api/plate-talk/camera-identify`;
};

/**
 * @summary Identify foods from one or more meal photos
 */
export const identifyMealPhoto = async (
  cameraIdentifyBody: CameraIdentifyBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<CameraIdentifyResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CameraIdentifyResponse>(getIdentifyMealPhotoUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(cameraIdentifyBody),
  });
};

export const getIdentifyMealPhotoMutationKey = () =>
  ["identifyMealPhoto"] as const;

export const getIdentifyMealPhotoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof identifyMealPhoto>>,
    TError,
    IdentifyMealPhotoMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof identifyMealPhoto>>,
  TError,
  IdentifyMealPhotoMutationVariables,
  TContext
> => {
  const mutationKey = getIdentifyMealPhotoMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof identifyMealPhoto>>,
    IdentifyMealPhotoMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return identifyMealPhoto(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IdentifyMealPhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof identifyMealPhoto>>
>;
export type IdentifyMealPhotoMutationBody = BodyType<CameraIdentifyBody>;
export type IdentifyMealPhotoMutationError = ErrorType<unknown>;
export type IdentifyMealPhotoMutationVariables = {
  data: BodyType<CameraIdentifyBody>;
};

/**
 * @summary Identify foods from one or more meal photos
 */
export const useIdentifyMealPhoto = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof identifyMealPhoto>>,
    TError,
    IdentifyMealPhotoMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof identifyMealPhoto>>,
  TError,
  IdentifyMealPhotoMutationVariables,
  TContext
> => {
  return useMutation(getIdentifyMealPhotoMutationOptions(options));
};

export const getConfirmFoodLogUrl = () => {
  return `/api/plate-talk/confirm-log`;
};

/**
 * @summary Confirm and persist a set of identified foods
 */
export const confirmFoodLog = async (
  confirmLogBody: ConfirmLogBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<ConfirmLogResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ConfirmLogResponse>(getConfirmFoodLogUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(confirmLogBody),
  });
};

export const getConfirmFoodLogMutationKey = () => ["confirmFoodLog"] as const;

export const getConfirmFoodLogMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmFoodLog>>,
    TError,
    ConfirmFoodLogMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmFoodLog>>,
  TError,
  ConfirmFoodLogMutationVariables,
  TContext
> => {
  const mutationKey = getConfirmFoodLogMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmFoodLog>>,
    ConfirmFoodLogMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return confirmFoodLog(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmFoodLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmFoodLog>>
>;
export type ConfirmFoodLogMutationBody = BodyType<ConfirmLogBody>;
export type ConfirmFoodLogMutationError = ErrorType<ErrorResponse>;
export type ConfirmFoodLogMutationVariables = {
  data: BodyType<ConfirmLogBody>;
};

/**
 * @summary Confirm and persist a set of identified foods
 */
export const useConfirmFoodLog = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmFoodLog>>,
    TError,
    ConfirmFoodLogMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmFoodLog>>,
  TError,
  ConfirmFoodLogMutationVariables,
  TContext
> => {
  return useMutation(getConfirmFoodLogMutationOptions(options));
};

export const getScanReceiptUrl = () => {
  return `/api/plate-talk/receipt-scan`;
};

/**
 * @summary OCR a grocery receipt photo into an editable confirm-before-log proposal
 */
export const scanReceipt = async (
  receiptScanBody: ReceiptScanBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReceiptScanResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ReceiptScanResponse>(getScanReceiptUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(receiptScanBody),
  });
};

export const getScanReceiptMutationKey = () => ["scanReceipt"] as const;

export const getScanReceiptMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scanReceipt>>,
    TError,
    ScanReceiptMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scanReceipt>>,
  TError,
  ScanReceiptMutationVariables,
  TContext
> => {
  const mutationKey = getScanReceiptMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scanReceipt>>,
    ScanReceiptMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return scanReceipt(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScanReceiptMutationResult = NonNullable<
  Awaited<ReturnType<typeof scanReceipt>>
>;
export type ScanReceiptMutationBody = BodyType<ReceiptScanBody>;
export type ScanReceiptMutationError = ErrorType<unknown>;
export type ScanReceiptMutationVariables = { data: BodyType<ReceiptScanBody> };

/**
 * @summary OCR a grocery receipt photo into an editable confirm-before-log proposal
 */
export const useScanReceipt = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scanReceipt>>,
    TError,
    ScanReceiptMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof scanReceipt>>,
  TError,
  ScanReceiptMutationVariables,
  TContext
> => {
  return useMutation(getScanReceiptMutationOptions(options));
};

export const getGetReceiptScanStatusUrl = (id: number) => {
  return `/api/plate-talk/receipt-scan/${id}`;
};

/**
 * @summary Get durable receipt scan progress or its editable review proposal
 */
export const getReceiptScanStatus = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReceiptScanResponse> => {
  return customFetch<ReceiptScanResponse>(getGetReceiptScanStatusUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetReceiptScanStatusQueryKey = (id: number) => {
  return [`/api/plate-talk/receipt-scan/${id}`] as const;
};

export const getGetReceiptScanStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getReceiptScanStatus>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReceiptScanStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetReceiptScanStatusQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReceiptScanStatus>>
  > = ({ signal }) => getReceiptScanStatus(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReceiptScanStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReceiptScanStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReceiptScanStatus>>
>;
export type GetReceiptScanStatusQueryError = ErrorType<unknown>;

/**
 * @summary Get durable receipt scan progress or its editable review proposal
 */

export function useGetReceiptScanStatus<
  TData = Awaited<ReturnType<typeof getReceiptScanStatus>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getReceiptScanStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReceiptScanStatusQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetGlucoseReadingsUrl = (params?: GetGlucoseReadingsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/wearables/glucose/readings?${stringifiedParams}`
    : `/api/wearables/glucose/readings`;
};

/**
 * @summary Recent CGM glucose readings (mg/dL) for the current user, newest first. Sourced from Apple Health / Health Connect via the mobile app and the wearables sync. Returns an empty list (200) when none exist.
 */
export const getGlucoseReadings = async (
  params?: GetGlucoseReadingsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GlucoseReadingsResponse> => {
  return customFetch<GlucoseReadingsResponse>(
    getGetGlucoseReadingsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetGlucoseReadingsQueryKey = (
  params?: GetGlucoseReadingsParams,
) => {
  return [
    `/api/wearables/glucose/readings`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetGlucoseReadingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGlucoseReadings>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetGlucoseReadingsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGlucoseReadings>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGlucoseReadingsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGlucoseReadings>>
  > = ({ signal }) => getGlucoseReadings(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGlucoseReadings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGlucoseReadingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGlucoseReadings>>
>;
export type GetGlucoseReadingsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Recent CGM glucose readings (mg/dL) for the current user, newest first. Sourced from Apple Health / Health Connect via the mobile app and the wearables sync. Returns an empty list (200) when none exist.
 */

export function useGetGlucoseReadings<
  TData = Awaited<ReturnType<typeof getGlucoseReadings>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetGlucoseReadingsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGlucoseReadings>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGlucoseReadingsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetGlucoseMealResponseUrl = (
  params?: GetGlucoseMealResponseParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/wearables/glucose/meal-response?${stringifiedParams}`
    : `/api/wearables/glucose/meal-response`;
};

/**
 * @summary The glucose line plus each logged meal's post-meal excursion (baseline → peak → delta over ~2h), for the "how your meals affect your glucose" overlay on the Metrics page. Always 200 — returns an empty overlay when the user has no glucose readings or no timed meals in the window.
 */
export const getGlucoseMealResponse = async (
  params?: GetGlucoseMealResponseParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GlucoseMealResponse> => {
  return customFetch<GlucoseMealResponse>(
    getGetGlucoseMealResponseUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetGlucoseMealResponseQueryKey = (
  params?: GetGlucoseMealResponseParams,
) => {
  return [
    `/api/wearables/glucose/meal-response`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetGlucoseMealResponseQueryOptions = <
  TData = Awaited<ReturnType<typeof getGlucoseMealResponse>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetGlucoseMealResponseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGlucoseMealResponse>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGlucoseMealResponseQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGlucoseMealResponse>>
  > = ({ signal }) =>
    getGlucoseMealResponse(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGlucoseMealResponse>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGlucoseMealResponseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGlucoseMealResponse>>
>;
export type GetGlucoseMealResponseQueryError = ErrorType<ErrorResponse>;

/**
 * @summary The glucose line plus each logged meal's post-meal excursion (baseline → peak → delta over ~2h), for the "how your meals affect your glucose" overlay on the Metrics page. Always 200 — returns an empty overlay when the user has no glucose readings or no timed meals in the window.
 */

export function useGetGlucoseMealResponse<
  TData = Awaited<ReturnType<typeof getGlucoseMealResponse>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetGlucoseMealResponseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGlucoseMealResponse>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGlucoseMealResponseQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetLatestGlucoseUrl = () => {
  return `/api/wearables/glucose/latest`;
};

/**
 * @summary The single most recent glucose reading plus connection status, for the dashboard tile. `reading` is null when the user has no readings yet.
 */
export const getLatestGlucose = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LatestGlucoseResponse> => {
  return customFetch<LatestGlucoseResponse>(getGetLatestGlucoseUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetLatestGlucoseQueryKey = () => {
  return [`/api/wearables/glucose/latest`] as const;
};

export const getGetLatestGlucoseQueryOptions = <
  TData = Awaited<ReturnType<typeof getLatestGlucose>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLatestGlucose>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLatestGlucoseQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLatestGlucose>>
  > = ({ signal }) => getLatestGlucose({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLatestGlucose>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetLatestGlucoseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLatestGlucose>>
>;
export type GetLatestGlucoseQueryError = ErrorType<ErrorResponse>;

/**
 * @summary The single most recent glucose reading plus connection status, for the dashboard tile. `reading` is null when the user has no readings yet.
 */

export function useGetLatestGlucose<
  TData = Awaited<ReturnType<typeof getLatestGlucose>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getLatestGlucose>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetLatestGlucoseQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getImportGlucoseReadingsUrl = () => {
  return `/api/wearables/glucose/import`;
};

/**
 * @summary Import a batch of CGM glucose readings the mobile app pulled from Apple Health / Health Connect. Idempotent — re-importing the same readings updates them in place. Also marks the matching source as connected.
 */
export const importGlucoseReadings = async (
  importGlucoseBody: ImportGlucoseBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<ImportGlucoseResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ImportGlucoseResponse>(getImportGlucoseReadingsUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(importGlucoseBody),
  });
};

export const getImportGlucoseReadingsMutationKey = () =>
  ["importGlucoseReadings"] as const;

export const getImportGlucoseReadingsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importGlucoseReadings>>,
    TError,
    ImportGlucoseReadingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importGlucoseReadings>>,
  TError,
  ImportGlucoseReadingsMutationVariables,
  TContext
> => {
  const mutationKey = getImportGlucoseReadingsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importGlucoseReadings>>,
    ImportGlucoseReadingsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return importGlucoseReadings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportGlucoseReadingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof importGlucoseReadings>>
>;
export type ImportGlucoseReadingsMutationBody = BodyType<ImportGlucoseBody>;
export type ImportGlucoseReadingsMutationError = ErrorType<ErrorResponse>;
export type ImportGlucoseReadingsMutationVariables = {
  data: BodyType<ImportGlucoseBody>;
};

/**
 * @summary Import a batch of CGM glucose readings the mobile app pulled from Apple Health / Health Connect. Idempotent — re-importing the same readings updates them in place. Also marks the matching source as connected.
 */
export const useImportGlucoseReadings = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importGlucoseReadings>>,
    TError,
    ImportGlucoseReadingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importGlucoseReadings>>,
  TError,
  ImportGlucoseReadingsMutationVariables,
  TContext
> => {
  return useMutation(getImportGlucoseReadingsMutationOptions(options));
};

export const getDisconnectGlucoseUrl = (params?: DisconnectGlucoseParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/wearables/glucose/import?${stringifiedParams}`
    : `/api/wearables/glucose/import`;
};

/**
 * @summary Disconnect a glucose source so the mobile app stops importing. Revokes the matching connection; historical readings are kept. Idempotent.
 */
export const disconnectGlucose = async (
  params?: DisconnectGlucoseParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<DisconnectGlucoseResponse> => {
  return customFetch<DisconnectGlucoseResponse>(
    getDisconnectGlucoseUrl(params),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDisconnectGlucoseMutationKey = () =>
  ["disconnectGlucose"] as const;

export const getDisconnectGlucoseMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectGlucose>>,
    TError,
    DisconnectGlucoseMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectGlucose>>,
  TError,
  DisconnectGlucoseMutationVariables,
  TContext
> => {
  const mutationKey = getDisconnectGlucoseMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectGlucose>>,
    DisconnectGlucoseMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return disconnectGlucose(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectGlucoseMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectGlucose>>
>;

export type DisconnectGlucoseMutationError = ErrorType<ErrorResponse>;
export type DisconnectGlucoseMutationVariables = {
  params?: DisconnectGlucoseParams;
};

/**
 * @summary Disconnect a glucose source so the mobile app stops importing. Revokes the matching connection; historical readings are kept. Idempotent.
 */
export const useDisconnectGlucose = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectGlucose>>,
    TError,
    DisconnectGlucoseMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectGlucose>>,
  TError,
  DisconnectGlucoseMutationVariables,
  TContext
> => {
  return useMutation(getDisconnectGlucoseMutationOptions(options));
};

export const getListDnaReportsUrl = () => {
  return `/api/dna-reports`;
};

/**
 * @summary List the DNA Resource Center catalog of one-time-purchase reports with the caller's ownership status and per-report data readiness.
 */
export const listDnaReports = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<DnaReportCatalog> => {
  return customFetch<DnaReportCatalog>(getListDnaReportsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListDnaReportsQueryKey = () => {
  return [`/api/dna-reports`] as const;
};

export const getListDnaReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDnaReports>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDnaReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDnaReportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDnaReports>>> = ({
    signal,
  }) => listDnaReports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDnaReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDnaReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDnaReports>>
>;
export type ListDnaReportsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List the DNA Resource Center catalog of one-time-purchase reports with the caller's ownership status and per-report data readiness.
 */

export function useListDnaReports<
  TData = Awaited<ReturnType<typeof listDnaReports>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDnaReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDnaReportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateDnaReportCheckoutUrl = () => {
  return `/api/dna-reports/checkout`;
};

/**
 * @summary Start a one-time (mode=payment) Stripe Checkout session to buy a single report. Returns the hosted checkout URL.
 */
export const createDnaReportCheckout = async (
  dnaReportCheckoutInput: DnaReportCheckoutInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<DnaReportCheckoutResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<DnaReportCheckoutResult>(getCreateDnaReportCheckoutUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(dnaReportCheckoutInput),
  });
};

export const getCreateDnaReportCheckoutMutationKey = () =>
  ["createDnaReportCheckout"] as const;

export const getCreateDnaReportCheckoutMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDnaReportCheckout>>,
    TError,
    CreateDnaReportCheckoutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDnaReportCheckout>>,
  TError,
  CreateDnaReportCheckoutMutationVariables,
  TContext
> => {
  const mutationKey = getCreateDnaReportCheckoutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDnaReportCheckout>>,
    CreateDnaReportCheckoutMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createDnaReportCheckout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDnaReportCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDnaReportCheckout>>
>;
export type CreateDnaReportCheckoutMutationBody =
  BodyType<DnaReportCheckoutInput>;
export type CreateDnaReportCheckoutMutationError = ErrorType<ErrorResponse>;
export type CreateDnaReportCheckoutMutationVariables = {
  data: BodyType<DnaReportCheckoutInput>;
};

/**
 * @summary Start a one-time (mode=payment) Stripe Checkout session to buy a single report. Returns the hosted checkout URL.
 */
export const useCreateDnaReportCheckout = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDnaReportCheckout>>,
    TError,
    CreateDnaReportCheckoutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createDnaReportCheckout>>,
  TError,
  CreateDnaReportCheckoutMutationVariables,
  TContext
> => {
  return useMutation(getCreateDnaReportCheckoutMutationOptions(options));
};

export const getGetDnaReportUrl = (reportId: string) => {
  return `/api/dna-reports/${reportId}`;
};

/**
 * @summary Get the rendered content of an owned report (generated and cached on first open from the user's real data).
 */
export const getDnaReport = async (
  reportId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<DnaReportContent> => {
  return customFetch<DnaReportContent>(getGetDnaReportUrl(reportId), {
    ...options,
    method: "GET",
  });
};

export const getGetDnaReportQueryKey = (reportId: string) => {
  return [`/api/dna-reports/${reportId}`] as const;
};

export const getGetDnaReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getDnaReport>>,
  TError = ErrorType<ErrorResponse>,
>(
  reportId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDnaReport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDnaReportQueryKey(reportId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDnaReport>>> = ({
    signal,
  }) => getDnaReport(reportId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: reportId !== null && reportId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDnaReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDnaReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDnaReport>>
>;
export type GetDnaReportQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the rendered content of an owned report (generated and cached on first open from the user's real data).
 */

export function useGetDnaReport<
  TData = Awaited<ReturnType<typeof getDnaReport>>,
  TError = ErrorType<ErrorResponse>,
>(
  reportId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDnaReport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDnaReportQueryOptions(reportId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetDnaReportPdfUrl = (reportId: string) => {
  return `/api/dna-reports/${reportId}/pdf`;
};

/**
 * @summary Download an owned report as a PDF mirroring the on-screen content.
 */
export const getDnaReportPdf = async (
  reportId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<Blob> => {
  return customFetch<Blob>(getGetDnaReportPdfUrl(reportId), {
    ...options,
    method: "GET",
  });
};

export const getGetDnaReportPdfQueryKey = (reportId: string) => {
  return [`/api/dna-reports/${reportId}/pdf`] as const;
};

export const getGetDnaReportPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof getDnaReportPdf>>,
  TError = ErrorType<ErrorResponse>,
>(
  reportId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDnaReportPdf>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDnaReportPdfQueryKey(reportId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDnaReportPdf>>> = ({
    signal,
  }) => getDnaReportPdf(reportId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: reportId !== null && reportId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDnaReportPdf>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDnaReportPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDnaReportPdf>>
>;
export type GetDnaReportPdfQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Download an owned report as a PDF mirroring the on-screen content.
 */

export function useGetDnaReportPdf<
  TData = Awaited<ReturnType<typeof getDnaReportPdf>>,
  TError = ErrorType<ErrorResponse>,
>(
  reportId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDnaReportPdf>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDnaReportPdfQueryOptions(reportId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSmartSwapDashboardUrl = (date: string) => {
  return `/api/smart-swap/dashboard/${date}`;
};

/**
 * @summary Daily TEF / Smart Swap dashboard for a given date (calories, macros, meal TEF scores, swap insights).
 */
export const getSmartSwapDashboard = async (
  date: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<SmartSwapDashboard> => {
  return customFetch<SmartSwapDashboard>(getGetSmartSwapDashboardUrl(date), {
    ...options,
    method: "GET",
  });
};

export const getGetSmartSwapDashboardQueryKey = (date: string) => {
  return [`/api/smart-swap/dashboard/${date}`] as const;
};

export const getGetSmartSwapDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getSmartSwapDashboard>>,
  TError = ErrorType<ErrorResponse>,
>(
  date: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSmartSwapDashboard>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSmartSwapDashboardQueryKey(date);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSmartSwapDashboard>>
  > = ({ signal }) =>
    getSmartSwapDashboard(date, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: date !== null && date !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSmartSwapDashboard>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSmartSwapDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSmartSwapDashboard>>
>;
export type GetSmartSwapDashboardQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Daily TEF / Smart Swap dashboard for a given date (calories, macros, meal TEF scores, swap insights).
 */

export function useGetSmartSwapDashboard<
  TData = Awaited<ReturnType<typeof getSmartSwapDashboard>>,
  TError = ErrorType<ErrorResponse>,
>(
  date: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getSmartSwapDashboard>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSmartSwapDashboardQueryOptions(date, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetMicrobiomeSummaryUrl = (
  params?: GetMicrobiomeSummaryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/evidence/microbiome/summary?${stringifiedParams}`
    : `/api/evidence/microbiome/summary`;
};

/**
 * @summary Gut-microbiome evidence overview (totals, per-category top foods, powerhouse foods).
 */
export const getMicrobiomeSummary = async (
  params?: GetMicrobiomeSummaryParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<MicrobiomeSummary> => {
  return customFetch<MicrobiomeSummary>(getGetMicrobiomeSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetMicrobiomeSummaryQueryKey = (
  params?: GetMicrobiomeSummaryParams,
) => {
  return [
    `/api/evidence/microbiome/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMicrobiomeSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMicrobiomeSummary>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetMicrobiomeSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMicrobiomeSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMicrobiomeSummaryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMicrobiomeSummary>>
  > = ({ signal }) =>
    getMicrobiomeSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMicrobiomeSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMicrobiomeSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMicrobiomeSummary>>
>;
export type GetMicrobiomeSummaryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Gut-microbiome evidence overview (totals, per-category top foods, powerhouse foods).
 */

export function useGetMicrobiomeSummary<
  TData = Awaited<ReturnType<typeof getMicrobiomeSummary>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetMicrobiomeSummaryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMicrobiomeSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMicrobiomeSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetMicrobiomeCategoryUrl = (
  categoryId: string,
  params?: GetMicrobiomeCategoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/evidence/microbiome/category/${categoryId}?${stringifiedParams}`
    : `/api/evidence/microbiome/category/${categoryId}`;
};

/**
 * @summary Foods and grounded evidence for a single gut-microbiome category.
 */
export const getMicrobiomeCategory = async (
  categoryId: string,
  params?: GetMicrobiomeCategoryParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<MicrobiomeCategoryDetail> => {
  return customFetch<MicrobiomeCategoryDetail>(
    getGetMicrobiomeCategoryUrl(categoryId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetMicrobiomeCategoryQueryKey = (
  categoryId: string,
  params?: GetMicrobiomeCategoryParams,
) => {
  return [
    `/api/evidence/microbiome/category/${categoryId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMicrobiomeCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMicrobiomeCategory>>,
  TError = ErrorType<ErrorResponse>,
>(
  categoryId: string,
  params?: GetMicrobiomeCategoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMicrobiomeCategory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMicrobiomeCategoryQueryKey(categoryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMicrobiomeCategory>>
  > = ({ signal }) =>
    getMicrobiomeCategory(categoryId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: categoryId !== null && categoryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMicrobiomeCategory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMicrobiomeCategoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMicrobiomeCategory>>
>;
export type GetMicrobiomeCategoryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Foods and grounded evidence for a single gut-microbiome category.
 */

export function useGetMicrobiomeCategory<
  TData = Awaited<ReturnType<typeof getMicrobiomeCategory>>,
  TError = ErrorType<ErrorResponse>,
>(
  categoryId: string,
  params?: GetMicrobiomeCategoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMicrobiomeCategory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMicrobiomeCategoryQueryOptions(
    categoryId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWearablesSummaryUrl = () => {
  return `/api/wearables/summary`;
};

/**
 * @summary Latest sleep, recovery, and activity from the user's connected wearable (v1 Oura). Returns connected=false when none is linked.
 */
export const getWearablesSummary = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<WearablesSummary> => {
  return customFetch<WearablesSummary>(getGetWearablesSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWearablesSummaryQueryKey = () => {
  return [`/api/wearables/summary`] as const;
};

export const getGetWearablesSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getWearablesSummary>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWearablesSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWearablesSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWearablesSummary>>
  > = ({ signal }) => getWearablesSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWearablesSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWearablesSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWearablesSummary>>
>;
export type GetWearablesSummaryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Latest sleep, recovery, and activity from the user's connected wearable (v1 Oura). Returns connected=false when none is linked.
 */

export function useGetWearablesSummary<
  TData = Awaited<ReturnType<typeof getWearablesSummary>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWearablesSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWearablesSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWearablesStatusUrl = () => {
  return `/api/wearables/status`;
};

/**
 * @summary Per-provider connection status for the current user.
 */
export const getWearablesStatus = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<WearablesStatus> => {
  return customFetch<WearablesStatus>(getGetWearablesStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWearablesStatusQueryKey = () => {
  return [`/api/wearables/status`] as const;
};

export const getGetWearablesStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getWearablesStatus>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWearablesStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWearablesStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWearablesStatus>>
  > = ({ signal }) => getWearablesStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWearablesStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWearablesStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWearablesStatus>>
>;
export type GetWearablesStatusQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Per-provider connection status for the current user.
 */

export function useGetWearablesStatus<
  TData = Awaited<ReturnType<typeof getWearablesStatus>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWearablesStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWearablesStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetWearablesProvidersUrl = () => {
  return `/api/wearables/providers`;
};

/**
 * @summary Supported wearable providers and whether each is configured on the server.
 */
export const getWearablesProviders = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<WearablesProviders> => {
  return customFetch<WearablesProviders>(getGetWearablesProvidersUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetWearablesProvidersQueryKey = () => {
  return [`/api/wearables/providers`] as const;
};

export const getGetWearablesProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof getWearablesProviders>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWearablesProviders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWearablesProvidersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWearablesProviders>>
  > = ({ signal }) => getWearablesProviders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWearablesProviders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWearablesProvidersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWearablesProviders>>
>;
export type GetWearablesProvidersQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Supported wearable providers and whether each is configured on the server.
 */

export function useGetWearablesProviders<
  TData = Awaited<ReturnType<typeof getWearablesProviders>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getWearablesProviders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetWearablesProvidersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getConnectWearableUrl = (provider: string) => {
  return `/api/wearables/connect/${provider}`;
};

/**
 * @summary Start the OAuth connect flow for a wearable provider (v1 Oura). Returns the authorize URL the client opens. Web clients redirect back to the web app; mobile clients may pass a deep-link redirectUri to return into the Expo app.
 */
export const connectWearable = async (
  provider: string,
  wearablesConnectInput?: WearablesConnectInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<WearablesConnectResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<WearablesConnectResult>(getConnectWearableUrl(provider), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(wearablesConnectInput),
  });
};

export const getConnectWearableMutationKey = () => ["connectWearable"] as const;

export const getConnectWearableMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectWearable>>,
    TError,
    ConnectWearableMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof connectWearable>>,
  TError,
  ConnectWearableMutationVariables,
  TContext
> => {
  const mutationKey = getConnectWearableMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof connectWearable>>,
    ConnectWearableMutationVariables
  > = (props) => {
    const { provider, data } = props ?? {};

    return connectWearable(provider, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConnectWearableMutationResult = NonNullable<
  Awaited<ReturnType<typeof connectWearable>>
>;
export type ConnectWearableMutationBody =
  | BodyType<WearablesConnectInput>
  | undefined;
export type ConnectWearableMutationError = ErrorType<ErrorResponse>;
export type ConnectWearableMutationVariables = {
  provider: string;
  data?: BodyType<WearablesConnectInput>;
};

/**
 * @summary Start the OAuth connect flow for a wearable provider (v1 Oura). Returns the authorize URL the client opens. Web clients redirect back to the web app; mobile clients may pass a deep-link redirectUri to return into the Expo app.
 */
export const useConnectWearable = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectWearable>>,
    TError,
    ConnectWearableMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof connectWearable>>,
  TError,
  ConnectWearableMutationVariables,
  TContext
> => {
  return useMutation(getConnectWearableMutationOptions(options));
};

export const getDisconnectWearableUrl = (provider: string) => {
  return `/api/wearables/connect/${provider}`;
};

/**
 * @summary Disconnect a wearable provider (v1 Oura). Revokes the connection on the wearables backend and marks the local connection revoked so the client returns to the connect state. Idempotent.
 */
export const disconnectWearable = async (
  provider: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<WearablesDisconnectResult> => {
  return customFetch<WearablesDisconnectResult>(
    getDisconnectWearableUrl(provider),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDisconnectWearableMutationKey = () =>
  ["disconnectWearable"] as const;

export const getDisconnectWearableMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectWearable>>,
    TError,
    DisconnectWearableMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectWearable>>,
  TError,
  DisconnectWearableMutationVariables,
  TContext
> => {
  const mutationKey = getDisconnectWearableMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectWearable>>,
    DisconnectWearableMutationVariables
  > = (props) => {
    const { provider } = props ?? {};

    return disconnectWearable(provider, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectWearableMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectWearable>>
>;

export type DisconnectWearableMutationError = ErrorType<ErrorResponse>;
export type DisconnectWearableMutationVariables = { provider: string };

/**
 * @summary Disconnect a wearable provider (v1 Oura). Revokes the connection on the wearables backend and marks the local connection revoked so the client returns to the connect state. Idempotent.
 */
export const useDisconnectWearable = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectWearable>>,
    TError,
    DisconnectWearableMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectWearable>>,
  TError,
  DisconnectWearableMutationVariables,
  TContext
> => {
  return useMutation(getDisconnectWearableMutationOptions(options));
};

export const getRefreshWearableStatusUrl = (provider: string) => {
  return `/api/wearables/refresh-status/${provider}`;
};

/**
 * @summary Re-read the provider connection state from the wearables backend after an OAuth callback and update the local row. Polled by clients until the connection becomes active.
 */
export const refreshWearableStatus = async (
  provider: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<WearablesRefreshStatusResult> => {
  return customFetch<WearablesRefreshStatusResult>(
    getRefreshWearableStatusUrl(provider),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRefreshWearableStatusMutationKey = () =>
  ["refreshWearableStatus"] as const;

export const getRefreshWearableStatusMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshWearableStatus>>,
    TError,
    RefreshWearableStatusMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshWearableStatus>>,
  TError,
  RefreshWearableStatusMutationVariables,
  TContext
> => {
  const mutationKey = getRefreshWearableStatusMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshWearableStatus>>,
    RefreshWearableStatusMutationVariables
  > = (props) => {
    const { provider } = props ?? {};

    return refreshWearableStatus(provider, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshWearableStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshWearableStatus>>
>;

export type RefreshWearableStatusMutationError = ErrorType<ErrorResponse>;
export type RefreshWearableStatusMutationVariables = { provider: string };

/**
 * @summary Re-read the provider connection state from the wearables backend after an OAuth callback and update the local row. Polled by clients until the connection becomes active.
 */
export const useRefreshWearableStatus = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshWearableStatus>>,
    TError,
    RefreshWearableStatusMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshWearableStatus>>,
  TError,
  RefreshWearableStatusMutationVariables,
  TContext
> => {
  return useMutation(getRefreshWearableStatusMutationOptions(options));
};

export const getUploadProgressPhotoUrl = () => {
  return `/api/progress-photos`;
};

/**
 * @summary Upload a daily progress photo (body or meal). Meal photos are analyzed with the snap-plate AI pipeline and staged as a confirm-before-log proposal (same pendingId contract as Plate Talk confirm-log).
 */
export const uploadProgressPhoto = async (
  uploadProgressPhotoRequest: UploadProgressPhotoRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<UploadProgressPhotoResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<UploadProgressPhotoResponse>(getUploadProgressPhotoUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(uploadProgressPhotoRequest),
  });
};

export const getUploadProgressPhotoMutationKey = () =>
  ["uploadProgressPhoto"] as const;

export const getUploadProgressPhotoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadProgressPhoto>>,
    TError,
    UploadProgressPhotoMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadProgressPhoto>>,
  TError,
  UploadProgressPhotoMutationVariables,
  TContext
> => {
  const mutationKey = getUploadProgressPhotoMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadProgressPhoto>>,
    UploadProgressPhotoMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return uploadProgressPhoto(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadProgressPhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadProgressPhoto>>
>;
export type UploadProgressPhotoMutationBody =
  BodyType<UploadProgressPhotoRequest>;
export type UploadProgressPhotoMutationError = ErrorType<ErrorResponse>;
export type UploadProgressPhotoMutationVariables = {
  data: BodyType<UploadProgressPhotoRequest>;
};

/**
 * @summary Upload a daily progress photo (body or meal). Meal photos are analyzed with the snap-plate AI pipeline and staged as a confirm-before-log proposal (same pendingId contract as Plate Talk confirm-log).
 */
export const useUploadProgressPhoto = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadProgressPhoto>>,
    TError,
    UploadProgressPhotoMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadProgressPhoto>>,
  TError,
  UploadProgressPhotoMutationVariables,
  TContext
> => {
  return useMutation(getUploadProgressPhotoMutationOptions(options));
};

export const getListProgressPhotosUrl = (params?: ListProgressPhotosParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/progress-photos?${stringifiedParams}`
    : `/api/progress-photos`;
};

/**
 * @summary List progress photos with streak stats.
 */
export const listProgressPhotos = async (
  params?: ListProgressPhotosParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ProgressPhotoListResponse> => {
  return customFetch<ProgressPhotoListResponse>(
    getListProgressPhotosUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListProgressPhotosQueryKey = (
  params?: ListProgressPhotosParams,
) => {
  return [`/api/progress-photos`, ...(params ? [params] : [])] as const;
};

export const getListProgressPhotosQueryOptions = <
  TData = Awaited<ReturnType<typeof listProgressPhotos>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListProgressPhotosParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProgressPhotos>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListProgressPhotosQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listProgressPhotos>>
  > = ({ signal }) => listProgressPhotos(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProgressPhotos>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProgressPhotosQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProgressPhotos>>
>;
export type ListProgressPhotosQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List progress photos with streak stats.
 */

export function useListProgressPhotos<
  TData = Awaited<ReturnType<typeof listProgressPhotos>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListProgressPhotosParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProgressPhotos>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProgressPhotosQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateProgressPhotoUrl = (id: number) => {
  return `/api/progress-photos/${id}`;
};

/**
 * @summary Update a body progress photo's pose label.
 */
export const updateProgressPhoto = async (
  id: number,
  progressPhotoUpdate: ProgressPhotoUpdate,
  options?: Parameters<typeof customFetch>[1],
): Promise<ProgressPhoto> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ProgressPhoto>(getUpdateProgressPhotoUrl(id), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(progressPhotoUpdate),
  });
};

export const getUpdateProgressPhotoMutationKey = () =>
  ["updateProgressPhoto"] as const;

export const getUpdateProgressPhotoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProgressPhoto>>,
    TError,
    UpdateProgressPhotoMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProgressPhoto>>,
  TError,
  UpdateProgressPhotoMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateProgressPhotoMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProgressPhoto>>,
    UpdateProgressPhotoMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return updateProgressPhoto(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProgressPhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProgressPhoto>>
>;
export type UpdateProgressPhotoMutationBody = BodyType<ProgressPhotoUpdate>;
export type UpdateProgressPhotoMutationError = ErrorType<ErrorResponse>;
export type UpdateProgressPhotoMutationVariables = {
  id: number;
  data: BodyType<ProgressPhotoUpdate>;
};

/**
 * @summary Update a body progress photo's pose label.
 */
export const useUpdateProgressPhoto = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProgressPhoto>>,
    TError,
    UpdateProgressPhotoMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProgressPhoto>>,
  TError,
  UpdateProgressPhotoMutationVariables,
  TContext
> => {
  return useMutation(getUpdateProgressPhotoMutationOptions(options));
};

export const getDeleteProgressPhotoUrl = (id: number) => {
  return `/api/progress-photos/${id}`;
};

/**
 * @summary Delete a progress photo (removes the stored object and the record).
 */
export const deleteProgressPhoto = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<SuccessResponse> => {
  return customFetch<SuccessResponse>(getDeleteProgressPhotoUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteProgressPhotoMutationKey = () =>
  ["deleteProgressPhoto"] as const;

export const getDeleteProgressPhotoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProgressPhoto>>,
    TError,
    DeleteProgressPhotoMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteProgressPhoto>>,
  TError,
  DeleteProgressPhotoMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteProgressPhotoMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteProgressPhoto>>,
    DeleteProgressPhotoMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return deleteProgressPhoto(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteProgressPhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteProgressPhoto>>
>;

export type DeleteProgressPhotoMutationError = ErrorType<ErrorResponse>;
export type DeleteProgressPhotoMutationVariables = { id: number };

/**
 * @summary Delete a progress photo (removes the stored object and the record).
 */
export const useDeleteProgressPhoto = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteProgressPhoto>>,
    TError,
    DeleteProgressPhotoMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteProgressPhoto>>,
  TError,
  DeleteProgressPhotoMutationVariables,
  TContext
> => {
  return useMutation(getDeleteProgressPhotoMutationOptions(options));
};

export const getCreateGoalRouteUrl = () => {
  return `/api/goal-routes`;
};

/**
 * @summary Save a staged goal route proposed by Plate Talk. Replaces any existing active route (the old one is marked abandoned) — at most one active route per user.
 */
export const createGoalRoute = async (
  createGoalRouteRequest: CreateGoalRouteRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CreateGoalRouteResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CreateGoalRouteResponse>(getCreateGoalRouteUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(createGoalRouteRequest),
  });
};

export const getCreateGoalRouteMutationKey = () => ["createGoalRoute"] as const;

export const getCreateGoalRouteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoalRoute>>,
    TError,
    CreateGoalRouteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createGoalRoute>>,
  TError,
  CreateGoalRouteMutationVariables,
  TContext
> => {
  const mutationKey = getCreateGoalRouteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createGoalRoute>>,
    CreateGoalRouteMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createGoalRoute(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateGoalRouteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createGoalRoute>>
>;
export type CreateGoalRouteMutationBody = BodyType<CreateGoalRouteRequest>;
export type CreateGoalRouteMutationError = ErrorType<ErrorResponse>;
export type CreateGoalRouteMutationVariables = {
  data: BodyType<CreateGoalRouteRequest>;
};

/**
 * @summary Save a staged goal route proposed by Plate Talk. Replaces any existing active route (the old one is marked abandoned) — at most one active route per user.
 */
export const useCreateGoalRoute = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createGoalRoute>>,
    TError,
    CreateGoalRouteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createGoalRoute>>,
  TError,
  CreateGoalRouteMutationVariables,
  TContext
> => {
  return useMutation(getCreateGoalRouteMutationOptions(options));
};

export const getGetActiveGoalRouteUrl = () => {
  return `/api/goal-routes/active`;
};

/**
 * @summary Get the user's active goal route (null when none).
 */
export const getActiveGoalRoute = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ActiveGoalRouteResponse> => {
  return customFetch<ActiveGoalRouteResponse>(getGetActiveGoalRouteUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetActiveGoalRouteQueryKey = () => {
  return [`/api/goal-routes/active`] as const;
};

export const getGetActiveGoalRouteQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveGoalRoute>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getActiveGoalRoute>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveGoalRouteQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveGoalRoute>>
  > = ({ signal }) => getActiveGoalRoute({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveGoalRoute>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActiveGoalRouteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveGoalRoute>>
>;
export type GetActiveGoalRouteQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get the user's active goal route (null when none).
 */

export function useGetActiveGoalRoute<
  TData = Awaited<ReturnType<typeof getActiveGoalRoute>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getActiveGoalRoute>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetActiveGoalRouteQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateGoalRouteUrl = (id: number) => {
  return `/api/goal-routes/${id}`;
};

/**
 * @summary Update a goal route: toggle a stage's done status, or set the route's overall status (completed / abandoned).
 */
export const updateGoalRoute = async (
  id: number,
  updateGoalRouteRequest: UpdateGoalRouteRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<UpdateGoalRouteResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<UpdateGoalRouteResponse>(getUpdateGoalRouteUrl(id), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(updateGoalRouteRequest),
  });
};

export const getUpdateGoalRouteMutationKey = () => ["updateGoalRoute"] as const;

export const getUpdateGoalRouteMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGoalRoute>>,
    TError,
    UpdateGoalRouteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGoalRoute>>,
  TError,
  UpdateGoalRouteMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateGoalRouteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGoalRoute>>,
    UpdateGoalRouteMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGoalRoute(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGoalRouteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGoalRoute>>
>;
export type UpdateGoalRouteMutationBody = BodyType<UpdateGoalRouteRequest>;
export type UpdateGoalRouteMutationError = ErrorType<ErrorResponse>;
export type UpdateGoalRouteMutationVariables = {
  id: number;
  data: BodyType<UpdateGoalRouteRequest>;
};

/**
 * @summary Update a goal route: toggle a stage's done status, or set the route's overall status (completed / abandoned).
 */
export const useUpdateGoalRoute = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGoalRoute>>,
    TError,
    UpdateGoalRouteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGoalRoute>>,
  TError,
  UpdateGoalRouteMutationVariables,
  TContext
> => {
  return useMutation(getUpdateGoalRouteMutationOptions(options));
};

export const getRegisterPushTokenUrl = () => {
  return `/api/push/register`;
};

/**
 * @summary Register (or refresh) this device's Expo push token.
 */
export const registerPushToken = async (
  registerPushTokenRequest: RegisterPushTokenRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SuccessResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<SuccessResponse>(getRegisterPushTokenUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(registerPushTokenRequest),
  });
};

export const getRegisterPushTokenMutationKey = () =>
  ["registerPushToken"] as const;

export const getRegisterPushTokenMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerPushToken>>,
    TError,
    RegisterPushTokenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerPushToken>>,
  TError,
  RegisterPushTokenMutationVariables,
  TContext
> => {
  const mutationKey = getRegisterPushTokenMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerPushToken>>,
    RegisterPushTokenMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return registerPushToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterPushTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerPushToken>>
>;
export type RegisterPushTokenMutationBody = BodyType<RegisterPushTokenRequest>;
export type RegisterPushTokenMutationError = ErrorType<ErrorResponse>;
export type RegisterPushTokenMutationVariables = {
  data: BodyType<RegisterPushTokenRequest>;
};

/**
 * @summary Register (or refresh) this device's Expo push token.
 */
export const useRegisterPushToken = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerPushToken>>,
    TError,
    RegisterPushTokenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerPushToken>>,
  TError,
  RegisterPushTokenMutationVariables,
  TContext
> => {
  return useMutation(getRegisterPushTokenMutationOptions(options));
};

export const getUnregisterPushTokenUrl = () => {
  return `/api/push/register`;
};

/**
 * @summary Unregister this device's Expo push token.
 */
export const unregisterPushToken = async (
  unregisterPushTokenRequest: UnregisterPushTokenRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SuccessResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<SuccessResponse>(getUnregisterPushTokenUrl(), {
    ...options,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(unregisterPushTokenRequest),
  });
};

export const getUnregisterPushTokenMutationKey = () =>
  ["unregisterPushToken"] as const;

export const getUnregisterPushTokenMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unregisterPushToken>>,
    TError,
    UnregisterPushTokenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unregisterPushToken>>,
  TError,
  UnregisterPushTokenMutationVariables,
  TContext
> => {
  const mutationKey = getUnregisterPushTokenMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unregisterPushToken>>,
    UnregisterPushTokenMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return unregisterPushToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnregisterPushTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof unregisterPushToken>>
>;
export type UnregisterPushTokenMutationBody =
  BodyType<UnregisterPushTokenRequest>;
export type UnregisterPushTokenMutationError = ErrorType<ErrorResponse>;
export type UnregisterPushTokenMutationVariables = {
  data: BodyType<UnregisterPushTokenRequest>;
};

/**
 * @summary Unregister this device's Expo push token.
 */
export const useUnregisterPushToken = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unregisterPushToken>>,
    TError,
    UnregisterPushTokenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unregisterPushToken>>,
  TError,
  UnregisterPushTokenMutationVariables,
  TContext
> => {
  return useMutation(getUnregisterPushTokenMutationOptions(options));
};

export const getGetPushSettingsUrl = () => {
  return `/api/push/settings`;
};

/**
 * @summary Current push-notification settings for the calling user.
 */
export const getPushSettings = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PushSettingsResponse> => {
  return customFetch<PushSettingsResponse>(getGetPushSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPushSettingsQueryKey = () => {
  return [`/api/push/settings`] as const;
};

export const getGetPushSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPushSettings>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPushSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPushSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPushSettings>>> = ({
    signal,
  }) => getPushSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPushSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPushSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPushSettings>>
>;
export type GetPushSettingsQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Current push-notification settings for the calling user.
 */

export function useGetPushSettings<
  TData = Awaited<ReturnType<typeof getPushSettings>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPushSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPushSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdatePushSettingsUrl = () => {
  return `/api/push/settings`;
};

/**
 * @summary Update push-notification settings (applies to all devices).
 */
export const updatePushSettings = async (
  updatePushSettingsRequest: UpdatePushSettingsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<PushSettingsUpdateResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PushSettingsUpdateResponse>(getUpdatePushSettingsUrl(), {
    ...options,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(updatePushSettingsRequest),
  });
};

export const getUpdatePushSettingsMutationKey = () =>
  ["updatePushSettings"] as const;

export const getUpdatePushSettingsMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePushSettings>>,
    TError,
    UpdatePushSettingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePushSettings>>,
  TError,
  UpdatePushSettingsMutationVariables,
  TContext
> => {
  const mutationKey = getUpdatePushSettingsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePushSettings>>,
    UpdatePushSettingsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updatePushSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePushSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePushSettings>>
>;
export type UpdatePushSettingsMutationBody =
  BodyType<UpdatePushSettingsRequest>;
export type UpdatePushSettingsMutationError = ErrorType<ErrorResponse>;
export type UpdatePushSettingsMutationVariables = {
  data: BodyType<UpdatePushSettingsRequest>;
};

/**
 * @summary Update push-notification settings (applies to all devices).
 */
export const useUpdatePushSettings = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePushSettings>>,
    TError,
    UpdatePushSettingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePushSettings>>,
  TError,
  UpdatePushSettingsMutationVariables,
  TContext
> => {
  return useMutation(getUpdatePushSettingsMutationOptions(options));
};

export const getGetPushPreferencesUrl = () => {
  return `/api/push/preferences`;
};

/**
 * @summary Per-category push-notification preferences for the calling user.
 */
export const getPushPreferences = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PushPreferencesResponse> => {
  return customFetch<PushPreferencesResponse>(getGetPushPreferencesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPushPreferencesQueryKey = () => {
  return [`/api/push/preferences`] as const;
};

export const getGetPushPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPushPreferences>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPushPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPushPreferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPushPreferences>>
  > = ({ signal }) => getPushPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPushPreferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPushPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPushPreferences>>
>;
export type GetPushPreferencesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Per-category push-notification preferences for the calling user.
 */

export function useGetPushPreferences<
  TData = Awaited<ReturnType<typeof getPushPreferences>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPushPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPushPreferencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdatePushPreferencesUrl = () => {
  return `/api/push/preferences`;
};

/**
 * @summary Update per-category push preferences (partial update; upserts defaults).
 */
export const updatePushPreferences = async (
  updatePushPreferencesRequest: UpdatePushPreferencesRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<PushPreferencesResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PushPreferencesResponse>(getUpdatePushPreferencesUrl(), {
    ...options,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(updatePushPreferencesRequest),
  });
};

export const getUpdatePushPreferencesMutationKey = () =>
  ["updatePushPreferences"] as const;

export const getUpdatePushPreferencesMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePushPreferences>>,
    TError,
    UpdatePushPreferencesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePushPreferences>>,
  TError,
  UpdatePushPreferencesMutationVariables,
  TContext
> => {
  const mutationKey = getUpdatePushPreferencesMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePushPreferences>>,
    UpdatePushPreferencesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updatePushPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePushPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePushPreferences>>
>;
export type UpdatePushPreferencesMutationBody =
  BodyType<UpdatePushPreferencesRequest>;
export type UpdatePushPreferencesMutationError = ErrorType<ErrorResponse>;
export type UpdatePushPreferencesMutationVariables = {
  data: BodyType<UpdatePushPreferencesRequest>;
};

/**
 * @summary Update per-category push preferences (partial update; upserts defaults).
 */
export const useUpdatePushPreferences = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePushPreferences>>,
    TError,
    UpdatePushPreferencesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePushPreferences>>,
  TError,
  UpdatePushPreferencesMutationVariables,
  TContext
> => {
  return useMutation(getUpdatePushPreferencesMutationOptions(options));
};

export const getSendTestPushUrl = () => {
  return `/api/push/test`;
};

/**
 * @summary Send an on-demand test push to the calling user's requesting device. Bypasses category preferences, quiet hours, and the dedupe ledger, but respects the PUSH_SEND_ENABLED delivery gate and exercises the real delivery path (dead-token pruning, delayed receipt checks).
 */
export const sendTestPush = async (
  sendTestPushRequest: SendTestPushRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SendTestPushResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<SendTestPushResponse>(getSendTestPushUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(sendTestPushRequest),
  });
};

export const getSendTestPushMutationKey = () => ["sendTestPush"] as const;

export const getSendTestPushMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTestPush>>,
    TError,
    SendTestPushMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendTestPush>>,
  TError,
  SendTestPushMutationVariables,
  TContext
> => {
  const mutationKey = getSendTestPushMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendTestPush>>,
    SendTestPushMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return sendTestPush(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendTestPushMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendTestPush>>
>;
export type SendTestPushMutationBody = BodyType<SendTestPushRequest>;
export type SendTestPushMutationError = ErrorType<ErrorResponse>;
export type SendTestPushMutationVariables = {
  data: BodyType<SendTestPushRequest>;
};

/**
 * @summary Send an on-demand test push to the calling user's requesting device. Bypasses category preferences, quiet hours, and the dedupe ledger, but respects the PUSH_SEND_ENABLED delivery gate and exercises the real delivery path (dead-token pruning, delayed receipt checks).
 */
export const useSendTestPush = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTestPush>>,
    TError,
    SendTestPushMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendTestPush>>,
  TError,
  SendTestPushMutationVariables,
  TContext
> => {
  return useMutation(getSendTestPushMutationOptions(options));
};

export const getGetTestPushDeliveryUrl = (testId: string) => {
  return `/api/push/test/${testId}`;
};

/**
 * @summary Check Expo's delivery receipt for a test notification.
 */
export const getTestPushDelivery = async (
  testId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<TestPushDeliveryResponse> => {
  return customFetch<TestPushDeliveryResponse>(
    getGetTestPushDeliveryUrl(testId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTestPushDeliveryQueryKey = (testId: string) => {
  return [`/api/push/test/${testId}`] as const;
};

export const getGetTestPushDeliveryQueryOptions = <
  TData = Awaited<ReturnType<typeof getTestPushDelivery>>,
  TError = ErrorType<ErrorResponse>,
>(
  testId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTestPushDelivery>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTestPushDeliveryQueryKey(testId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTestPushDelivery>>
  > = ({ signal }) =>
    getTestPushDelivery(testId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: testId !== null && testId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTestPushDelivery>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTestPushDeliveryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTestPushDelivery>>
>;
export type GetTestPushDeliveryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Check Expo's delivery receipt for a test notification.
 */

export function useGetTestPushDelivery<
  TData = Awaited<ReturnType<typeof getTestPushDelivery>>,
  TError = ErrorType<ErrorResponse>,
>(
  testId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTestPushDelivery>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTestPushDeliveryQueryOptions(testId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdatePushCanaryRegistrationUrl = () => {
  return `/api/push/canary/registration`;
};

/**
 * @summary Explicitly enable or disable this approved test device as a push canary.
 */
export const updatePushCanaryRegistration = async (
  pushCanaryRegistrationRequest: PushCanaryRegistrationRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<PushCanaryRegistrationResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<PushCanaryRegistrationResponse>(
    getUpdatePushCanaryRegistrationUrl(),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(pushCanaryRegistrationRequest),
    },
  );
};

export const getUpdatePushCanaryRegistrationMutationKey = () =>
  ["updatePushCanaryRegistration"] as const;

export const getUpdatePushCanaryRegistrationMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePushCanaryRegistration>>,
    TError,
    UpdatePushCanaryRegistrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePushCanaryRegistration>>,
  TError,
  UpdatePushCanaryRegistrationMutationVariables,
  TContext
> => {
  const mutationKey = getUpdatePushCanaryRegistrationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePushCanaryRegistration>>,
    UpdatePushCanaryRegistrationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updatePushCanaryRegistration(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePushCanaryRegistrationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePushCanaryRegistration>>
>;
export type UpdatePushCanaryRegistrationMutationBody =
  BodyType<PushCanaryRegistrationRequest>;
export type UpdatePushCanaryRegistrationMutationError =
  ErrorType<ErrorResponse>;
export type UpdatePushCanaryRegistrationMutationVariables = {
  data: BodyType<PushCanaryRegistrationRequest>;
};

/**
 * @summary Explicitly enable or disable this approved test device as a push canary.
 */
export const useUpdatePushCanaryRegistration = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePushCanaryRegistration>>,
    TError,
    UpdatePushCanaryRegistrationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePushCanaryRegistration>>,
  TError,
  UpdatePushCanaryRegistrationMutationVariables,
  TContext
> => {
  return useMutation(getUpdatePushCanaryRegistrationMutationOptions(options));
};

export const getConfirmPushCanaryOpenUrl = () => {
  return `/api/push/canary/open`;
};

/**
 * @summary Confirm that a canary notification opened its validated route.
 */
export const confirmPushCanaryOpen = async (
  pushCanaryOpenRequest: PushCanaryOpenRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SuccessResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<SuccessResponse>(getConfirmPushCanaryOpenUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(pushCanaryOpenRequest),
  });
};

export const getConfirmPushCanaryOpenMutationKey = () =>
  ["confirmPushCanaryOpen"] as const;

export const getConfirmPushCanaryOpenMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmPushCanaryOpen>>,
    TError,
    ConfirmPushCanaryOpenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmPushCanaryOpen>>,
  TError,
  ConfirmPushCanaryOpenMutationVariables,
  TContext
> => {
  const mutationKey = getConfirmPushCanaryOpenMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmPushCanaryOpen>>,
    ConfirmPushCanaryOpenMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return confirmPushCanaryOpen(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmPushCanaryOpenMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmPushCanaryOpen>>
>;
export type ConfirmPushCanaryOpenMutationBody = BodyType<PushCanaryOpenRequest>;
export type ConfirmPushCanaryOpenMutationError = ErrorType<ErrorResponse>;
export type ConfirmPushCanaryOpenMutationVariables = {
  data: BodyType<PushCanaryOpenRequest>;
};

/**
 * @summary Confirm that a canary notification opened its validated route.
 */
export const useConfirmPushCanaryOpen = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmPushCanaryOpen>>,
    TError,
    ConfirmPushCanaryOpenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmPushCanaryOpen>>,
  TError,
  ConfirmPushCanaryOpenMutationVariables,
  TContext
> => {
  return useMutation(getConfirmPushCanaryOpenMutationOptions(options));
};

export const getGetPushCanaryStatusUrl = (runId: string) => {
  return `/api/push/canary/${runId}`;
};

/**
 * @summary Read a canary run owned by the calling test account.
 */
export const getPushCanaryStatus = async (
  runId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<PushCanaryStatusResponse> => {
  return customFetch<PushCanaryStatusResponse>(
    getGetPushCanaryStatusUrl(runId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPushCanaryStatusQueryKey = (runId: string) => {
  return [`/api/push/canary/${runId}`] as const;
};

export const getGetPushCanaryStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getPushCanaryStatus>>,
  TError = ErrorType<ErrorResponse>,
>(
  runId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPushCanaryStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPushCanaryStatusQueryKey(runId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPushCanaryStatus>>
  > = ({ signal }) => getPushCanaryStatus(runId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: runId !== null && runId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPushCanaryStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPushCanaryStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPushCanaryStatus>>
>;
export type GetPushCanaryStatusQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Read a canary run owned by the calling test account.
 */

export function useGetPushCanaryStatus<
  TData = Awaited<ReturnType<typeof getPushCanaryStatus>>,
  TError = ErrorType<ErrorResponse>,
>(
  runId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getPushCanaryStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPushCanaryStatusQueryOptions(runId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPushHistoryUrl = () => {
  return `/api/push/history`;
};

/**
 * @summary List push notifications sent to the calling user.
 */
export const getPushHistory = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PushHistoryResponse> => {
  return customFetch<PushHistoryResponse>(getGetPushHistoryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPushHistoryQueryKey = () => {
  return [`/api/push/history`] as const;
};

export const getGetPushHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getPushHistory>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPushHistory>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPushHistoryQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPushHistory>>> = ({
    signal,
  }) => getPushHistory({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPushHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPushHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPushHistory>>
>;
export type GetPushHistoryQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List push notifications sent to the calling user.
 */

export function useGetPushHistory<
  TData = Awaited<ReturnType<typeof getPushHistory>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPushHistory>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPushHistoryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateProgressTimelapseUrl = () => {
  return `/api/progress-photos/timelapse`;
};

/**
 * @summary Start async generation of a 30-day timelapse MP4 (Pro only). Poll the returned videoId for progress and the signed download URL.
 */
export const createProgressTimelapse = async (
  createTimelapseRequest?: CreateTimelapseRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CreateTimelapseResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CreateTimelapseResponse>(getCreateProgressTimelapseUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(createTimelapseRequest),
  });
};

export const getCreateProgressTimelapseMutationKey = () =>
  ["createProgressTimelapse"] as const;

export const getCreateProgressTimelapseMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProgressTimelapse>>,
    TError,
    CreateProgressTimelapseMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProgressTimelapse>>,
  TError,
  CreateProgressTimelapseMutationVariables,
  TContext
> => {
  const mutationKey = getCreateProgressTimelapseMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProgressTimelapse>>,
    CreateProgressTimelapseMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createProgressTimelapse(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProgressTimelapseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProgressTimelapse>>
>;
export type CreateProgressTimelapseMutationBody =
  | BodyType<CreateTimelapseRequest>
  | undefined;
export type CreateProgressTimelapseMutationError = ErrorType<ErrorResponse>;
export type CreateProgressTimelapseMutationVariables = {
  data?: BodyType<CreateTimelapseRequest>;
};

/**
 * @summary Start async generation of a 30-day timelapse MP4 (Pro only). Poll the returned videoId for progress and the signed download URL.
 */
export const useCreateProgressTimelapse = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProgressTimelapse>>,
    TError,
    CreateProgressTimelapseMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createProgressTimelapse>>,
  TError,
  CreateProgressTimelapseMutationVariables,
  TContext
> => {
  return useMutation(getCreateProgressTimelapseMutationOptions(options));
};

export const getListProgressTimelapsesUrl = () => {
  return `/api/progress-photos/timelapse`;
};

/**
 * @summary List the user's timelapse videos (most recent first).
 */
export const listProgressTimelapses = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ProgressVideoListResponse> => {
  return customFetch<ProgressVideoListResponse>(
    getListProgressTimelapsesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListProgressTimelapsesQueryKey = () => {
  return [`/api/progress-photos/timelapse`] as const;
};

export const getListProgressTimelapsesQueryOptions = <
  TData = Awaited<ReturnType<typeof listProgressTimelapses>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listProgressTimelapses>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListProgressTimelapsesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listProgressTimelapses>>
  > = ({ signal }) => listProgressTimelapses({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProgressTimelapses>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProgressTimelapsesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProgressTimelapses>>
>;
export type ListProgressTimelapsesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary List the user's timelapse videos (most recent first).
 */

export function useListProgressTimelapses<
  TData = Awaited<ReturnType<typeof listProgressTimelapses>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listProgressTimelapses>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProgressTimelapsesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetProgressTimelapseUrl = (id: number) => {
  return `/api/progress-photos/timelapse/${id}`;
};

/**
 * @summary Poll one timelapse job. When status is ready, includes a short-lived signed URL for playback/download.
 */
export const getProgressTimelapse = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<ProgressVideoStatusResponse> => {
  return customFetch<ProgressVideoStatusResponse>(
    getGetProgressTimelapseUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetProgressTimelapseQueryKey = (id: number) => {
  return [`/api/progress-photos/timelapse/${id}`] as const;
};

export const getGetProgressTimelapseQueryOptions = <
  TData = Awaited<ReturnType<typeof getProgressTimelapse>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProgressTimelapse>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetProgressTimelapseQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getProgressTimelapse>>
  > = ({ signal }) => getProgressTimelapse(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProgressTimelapse>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProgressTimelapseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProgressTimelapse>>
>;
export type GetProgressTimelapseQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Poll one timelapse job. When status is ready, includes a short-lived signed URL for playback/download.
 */

export function useGetProgressTimelapse<
  TData = Awaited<ReturnType<typeof getProgressTimelapse>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProgressTimelapse>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProgressTimelapseQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListRecipesUrl = () => {
  return `/api/recipes`;
};

export const listRecipes = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Recipe[]> => {
  return customFetch<Recipe[]>(getListRecipesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListRecipesQueryKey = () => {
  return [`/api/recipes`] as const;
};

export const getListRecipesQueryOptions = <
  TData = Awaited<ReturnType<typeof listRecipes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listRecipes>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRecipesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecipes>>> = ({
    signal,
  }) => listRecipes({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRecipes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRecipesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRecipes>>
>;
export type ListRecipesQueryError = ErrorType<unknown>;

export function useListRecipes<
  TData = Awaited<ReturnType<typeof listRecipes>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listRecipes>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListRecipesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateRecipeUrl = () => {
  return `/api/recipes`;
};

export const createRecipe = async (
  recipeInput: RecipeInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<Recipe> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<Recipe>(getCreateRecipeUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(recipeInput),
  });
};

export const getCreateRecipeMutationKey = () => ["createRecipe"] as const;

export const getCreateRecipeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRecipe>>,
    TError,
    CreateRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createRecipe>>,
  TError,
  CreateRecipeMutationVariables,
  TContext
> => {
  const mutationKey = getCreateRecipeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createRecipe>>,
    CreateRecipeMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createRecipe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createRecipe>>
>;
export type CreateRecipeMutationBody = BodyType<RecipeInput>;
export type CreateRecipeMutationError = ErrorType<unknown>;
export type CreateRecipeMutationVariables = { data: BodyType<RecipeInput> };

export const useCreateRecipe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createRecipe>>,
    TError,
    CreateRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createRecipe>>,
  TError,
  CreateRecipeMutationVariables,
  TContext
> => {
  return useMutation(getCreateRecipeMutationOptions(options));
};

export const getReconcileFoodIdentityUrl = () => {
  return `/api/foods/reconcile`;
};

export const reconcileFoodIdentity = async (
  foodIdentityInput: FoodIdentityInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReconcileFoodIdentity200> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ReconcileFoodIdentity200>(getReconcileFoodIdentityUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(foodIdentityInput),
  });
};

export const getReconcileFoodIdentityMutationKey = () =>
  ["reconcileFoodIdentity"] as const;

export const getReconcileFoodIdentityMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reconcileFoodIdentity>>,
    TError,
    ReconcileFoodIdentityMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reconcileFoodIdentity>>,
  TError,
  ReconcileFoodIdentityMutationVariables,
  TContext
> => {
  const mutationKey = getReconcileFoodIdentityMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reconcileFoodIdentity>>,
    ReconcileFoodIdentityMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return reconcileFoodIdentity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReconcileFoodIdentityMutationResult = NonNullable<
  Awaited<ReturnType<typeof reconcileFoodIdentity>>
>;
export type ReconcileFoodIdentityMutationBody = BodyType<FoodIdentityInput>;
export type ReconcileFoodIdentityMutationError = ErrorType<unknown>;
export type ReconcileFoodIdentityMutationVariables = {
  data: BodyType<FoodIdentityInput>;
};

export const useReconcileFoodIdentity = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reconcileFoodIdentity>>,
    TError,
    ReconcileFoodIdentityMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reconcileFoodIdentity>>,
  TError,
  ReconcileFoodIdentityMutationVariables,
  TContext
> => {
  return useMutation(getReconcileFoodIdentityMutationOptions(options));
};

export const getCorrectFoodUrl = (id: number) => {
  return `/api/foods/${id}/corrections`;
};

export const correctFood = async (
  id: number,
  foodCorrectionInput: FoodCorrectionInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<Food> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<Food>(getCorrectFoodUrl(id), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(foodCorrectionInput),
  });
};

export const getCorrectFoodMutationKey = () => ["correctFood"] as const;

export const getCorrectFoodMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctFood>>,
    TError,
    CorrectFoodMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof correctFood>>,
  TError,
  CorrectFoodMutationVariables,
  TContext
> => {
  const mutationKey = getCorrectFoodMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof correctFood>>,
    CorrectFoodMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return correctFood(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CorrectFoodMutationResult = NonNullable<
  Awaited<ReturnType<typeof correctFood>>
>;
export type CorrectFoodMutationBody = BodyType<FoodCorrectionInput>;
export type CorrectFoodMutationError = ErrorType<unknown>;
export type CorrectFoodMutationVariables = {
  id: number;
  data: BodyType<FoodCorrectionInput>;
};

export const useCorrectFood = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctFood>>,
    TError,
    CorrectFoodMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof correctFood>>,
  TError,
  CorrectFoodMutationVariables,
  TContext
> => {
  return useMutation(getCorrectFoodMutationOptions(options));
};

export const getGetRecipeUrl = (id: number) => {
  return `/api/recipes/${id}`;
};

export const getRecipe = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Recipe> => {
  return customFetch<Recipe>(getGetRecipeUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetRecipeQueryKey = (id: number) => {
  return [`/api/recipes/${id}`] as const;
};

export const getGetRecipeQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecipe>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecipe>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecipeQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecipe>>> = ({
    signal,
  }) => getRecipe(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getRecipe>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetRecipeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecipe>>
>;
export type GetRecipeQueryError = ErrorType<unknown>;

export function useGetRecipe<
  TData = Awaited<ReturnType<typeof getRecipe>>,
  TError = ErrorType<unknown>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecipe>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecipeQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateRecipeUrl = (id: number) => {
  return `/api/recipes/${id}`;
};

export const updateRecipe = async (
  id: number,
  recipeInput: RecipeInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<Recipe> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<Recipe>(getUpdateRecipeUrl(id), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(recipeInput),
  });
};

export const getUpdateRecipeMutationKey = () => ["updateRecipe"] as const;

export const getUpdateRecipeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRecipe>>,
    TError,
    UpdateRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRecipe>>,
  TError,
  UpdateRecipeMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateRecipeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRecipe>>,
    UpdateRecipeMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return updateRecipe(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRecipe>>
>;
export type UpdateRecipeMutationBody = BodyType<RecipeInput>;
export type UpdateRecipeMutationError = ErrorType<unknown>;
export type UpdateRecipeMutationVariables = {
  id: number;
  data: BodyType<RecipeInput>;
};

export const useUpdateRecipe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRecipe>>,
    TError,
    UpdateRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateRecipe>>,
  TError,
  UpdateRecipeMutationVariables,
  TContext
> => {
  return useMutation(getUpdateRecipeMutationOptions(options));
};

export const getDeleteRecipeUrl = (id: number) => {
  return `/api/recipes/${id}`;
};

export const deleteRecipe = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteRecipeUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteRecipeMutationKey = () => ["deleteRecipe"] as const;

export const getDeleteRecipeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRecipe>>,
    TError,
    DeleteRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRecipe>>,
  TError,
  DeleteRecipeMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteRecipeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRecipe>>,
    DeleteRecipeMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return deleteRecipe(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRecipe>>
>;

export type DeleteRecipeMutationError = ErrorType<unknown>;
export type DeleteRecipeMutationVariables = { id: number };

export const useDeleteRecipe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRecipe>>,
    TError,
    DeleteRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteRecipe>>,
  TError,
  DeleteRecipeMutationVariables,
  TContext
> => {
  return useMutation(getDeleteRecipeMutationOptions(options));
};

export const getDuplicateRecipeUrl = (id: number) => {
  return `/api/recipes/${id}/duplicate`;
};

export const duplicateRecipe = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Recipe> => {
  return customFetch<Recipe>(getDuplicateRecipeUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getDuplicateRecipeMutationKey = () => ["duplicateRecipe"] as const;

export const getDuplicateRecipeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateRecipe>>,
    TError,
    DuplicateRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof duplicateRecipe>>,
  TError,
  DuplicateRecipeMutationVariables,
  TContext
> => {
  const mutationKey = getDuplicateRecipeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof duplicateRecipe>>,
    DuplicateRecipeMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return duplicateRecipe(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DuplicateRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof duplicateRecipe>>
>;

export type DuplicateRecipeMutationError = ErrorType<unknown>;
export type DuplicateRecipeMutationVariables = { id: number };

export const useDuplicateRecipe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof duplicateRecipe>>,
    TError,
    DuplicateRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof duplicateRecipe>>,
  TError,
  DuplicateRecipeMutationVariables,
  TContext
> => {
  return useMutation(getDuplicateRecipeMutationOptions(options));
};

export const getArchiveRecipeUrl = (id: number) => {
  return `/api/recipes/${id}/archive`;
};

export const archiveRecipe = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<Recipe> => {
  return customFetch<Recipe>(getArchiveRecipeUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getArchiveRecipeMutationKey = () => ["archiveRecipe"] as const;

export const getArchiveRecipeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveRecipe>>,
    TError,
    ArchiveRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveRecipe>>,
  TError,
  ArchiveRecipeMutationVariables,
  TContext
> => {
  const mutationKey = getArchiveRecipeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveRecipe>>,
    ArchiveRecipeMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return archiveRecipe(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveRecipe>>
>;

export type ArchiveRecipeMutationError = ErrorType<unknown>;
export type ArchiveRecipeMutationVariables = { id: number };

export const useArchiveRecipe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveRecipe>>,
    TError,
    ArchiveRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveRecipe>>,
  TError,
  ArchiveRecipeMutationVariables,
  TContext
> => {
  return useMutation(getArchiveRecipeMutationOptions(options));
};

export const getShareRecipeUrl = (id: number) => {
  return `/api/recipes/${id}/share`;
};

export const shareRecipe = async (
  id: number,
  recipeShareInput: RecipeShareInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<RecipeShare> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<RecipeShare>(getShareRecipeUrl(id), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(recipeShareInput),
  });
};

export const getShareRecipeMutationKey = () => ["shareRecipe"] as const;

export const getShareRecipeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shareRecipe>>,
    TError,
    ShareRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof shareRecipe>>,
  TError,
  ShareRecipeMutationVariables,
  TContext
> => {
  const mutationKey = getShareRecipeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shareRecipe>>,
    ShareRecipeMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return shareRecipe(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShareRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof shareRecipe>>
>;
export type ShareRecipeMutationBody = BodyType<RecipeShareInput>;
export type ShareRecipeMutationError = ErrorType<unknown>;
export type ShareRecipeMutationVariables = {
  id: number;
  data: BodyType<RecipeShareInput>;
};

export const useShareRecipe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shareRecipe>>,
    TError,
    ShareRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof shareRecipe>>,
  TError,
  ShareRecipeMutationVariables,
  TContext
> => {
  return useMutation(getShareRecipeMutationOptions(options));
};

export const getLogRecipeUrl = (id: number) => {
  return `/api/recipes/${id}/log`;
};

export const logRecipe = async (
  id: number,
  nutritionLogInput: NutritionLogInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<LogRecipe201> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<LogRecipe201>(getLogRecipeUrl(id), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(nutritionLogInput),
  });
};

export const getLogRecipeMutationKey = () => ["logRecipe"] as const;

export const getLogRecipeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logRecipe>>,
    TError,
    LogRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logRecipe>>,
  TError,
  LogRecipeMutationVariables,
  TContext
> => {
  const mutationKey = getLogRecipeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logRecipe>>,
    LogRecipeMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return logRecipe(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof logRecipe>>
>;
export type LogRecipeMutationBody = BodyType<NutritionLogInput>;
export type LogRecipeMutationError = ErrorType<unknown>;
export type LogRecipeMutationVariables = {
  id: number;
  data: BodyType<NutritionLogInput>;
};

export const useLogRecipe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logRecipe>>,
    TError,
    LogRecipeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logRecipe>>,
  TError,
  LogRecipeMutationVariables,
  TContext
> => {
  return useMutation(getLogRecipeMutationOptions(options));
};

export const getListReusableMealsUrl = () => {
  return `/api/reusable-meals`;
};

export const listReusableMeals = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ReusableMeal[]> => {
  return customFetch<ReusableMeal[]>(getListReusableMealsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListReusableMealsQueryKey = () => {
  return [`/api/reusable-meals`] as const;
};

export const getListReusableMealsQueryOptions = <
  TData = Awaited<ReturnType<typeof listReusableMeals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listReusableMeals>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListReusableMealsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listReusableMeals>>
  > = ({ signal }) => listReusableMeals({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listReusableMeals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListReusableMealsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listReusableMeals>>
>;
export type ListReusableMealsQueryError = ErrorType<unknown>;

export function useListReusableMeals<
  TData = Awaited<ReturnType<typeof listReusableMeals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listReusableMeals>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListReusableMealsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateReusableMealUrl = () => {
  return `/api/reusable-meals`;
};

export const createReusableMeal = async (
  reusableMealInput: ReusableMealInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReusableMeal> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ReusableMeal>(getCreateReusableMealUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(reusableMealInput),
  });
};

export const getCreateReusableMealMutationKey = () =>
  ["createReusableMeal"] as const;

export const getCreateReusableMealMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReusableMeal>>,
    TError,
    CreateReusableMealMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createReusableMeal>>,
  TError,
  CreateReusableMealMutationVariables,
  TContext
> => {
  const mutationKey = getCreateReusableMealMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createReusableMeal>>,
    CreateReusableMealMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createReusableMeal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateReusableMealMutationResult = NonNullable<
  Awaited<ReturnType<typeof createReusableMeal>>
>;
export type CreateReusableMealMutationBody = BodyType<ReusableMealInput>;
export type CreateReusableMealMutationError = ErrorType<unknown>;
export type CreateReusableMealMutationVariables = {
  data: BodyType<ReusableMealInput>;
};

export const useCreateReusableMeal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createReusableMeal>>,
    TError,
    CreateReusableMealMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createReusableMeal>>,
  TError,
  CreateReusableMealMutationVariables,
  TContext
> => {
  return useMutation(getCreateReusableMealMutationOptions(options));
};

export const getUpdateReusableMealUrl = (id: number) => {
  return `/api/reusable-meals/${id}`;
};

export const updateReusableMeal = async (
  id: number,
  reusableMealInput: ReusableMealInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReusableMeal> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ReusableMeal>(getUpdateReusableMealUrl(id), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(reusableMealInput),
  });
};

export const getUpdateReusableMealMutationKey = () =>
  ["updateReusableMeal"] as const;

export const getUpdateReusableMealMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReusableMeal>>,
    TError,
    UpdateReusableMealMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReusableMeal>>,
  TError,
  UpdateReusableMealMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateReusableMealMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReusableMeal>>,
    UpdateReusableMealMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return updateReusableMeal(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReusableMealMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReusableMeal>>
>;
export type UpdateReusableMealMutationBody = BodyType<ReusableMealInput>;
export type UpdateReusableMealMutationError = ErrorType<unknown>;
export type UpdateReusableMealMutationVariables = {
  id: number;
  data: BodyType<ReusableMealInput>;
};

export const useUpdateReusableMeal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReusableMeal>>,
    TError,
    UpdateReusableMealMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateReusableMeal>>,
  TError,
  UpdateReusableMealMutationVariables,
  TContext
> => {
  return useMutation(getUpdateReusableMealMutationOptions(options));
};

export const getDeleteReusableMealUrl = (id: number) => {
  return `/api/reusable-meals/${id}`;
};

export const deleteReusableMeal = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteReusableMealUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteReusableMealMutationKey = () =>
  ["deleteReusableMeal"] as const;

export const getDeleteReusableMealMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReusableMeal>>,
    TError,
    DeleteReusableMealMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReusableMeal>>,
  TError,
  DeleteReusableMealMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteReusableMealMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReusableMeal>>,
    DeleteReusableMealMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return deleteReusableMeal(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReusableMealMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReusableMeal>>
>;

export type DeleteReusableMealMutationError = ErrorType<unknown>;
export type DeleteReusableMealMutationVariables = { id: number };

export const useDeleteReusableMeal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReusableMeal>>,
    TError,
    DeleteReusableMealMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteReusableMeal>>,
  TError,
  DeleteReusableMealMutationVariables,
  TContext
> => {
  return useMutation(getDeleteReusableMealMutationOptions(options));
};

export const getLogReusableMealUrl = (id: number) => {
  return `/api/reusable-meals/${id}/log`;
};

export const logReusableMeal = async (
  id: number,
  nutritionLogInput: NutritionLogInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<LogReusableMeal201> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<LogReusableMeal201>(getLogReusableMealUrl(id), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(nutritionLogInput),
  });
};

export const getLogReusableMealMutationKey = () => ["logReusableMeal"] as const;

export const getLogReusableMealMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logReusableMeal>>,
    TError,
    LogReusableMealMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logReusableMeal>>,
  TError,
  LogReusableMealMutationVariables,
  TContext
> => {
  const mutationKey = getLogReusableMealMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logReusableMeal>>,
    LogReusableMealMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return logReusableMeal(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogReusableMealMutationResult = NonNullable<
  Awaited<ReturnType<typeof logReusableMeal>>
>;
export type LogReusableMealMutationBody = BodyType<NutritionLogInput>;
export type LogReusableMealMutationError = ErrorType<unknown>;
export type LogReusableMealMutationVariables = {
  id: number;
  data: BodyType<NutritionLogInput>;
};

export const useLogReusableMeal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logReusableMeal>>,
    TError,
    LogReusableMealMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logReusableMeal>>,
  TError,
  LogReusableMealMutationVariables,
  TContext
> => {
  return useMutation(getLogReusableMealMutationOptions(options));
};

export const getListNutritionTargetsUrl = () => {
  return `/api/nutrition-targets`;
};

export const listNutritionTargets = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<NutritionTarget[]> => {
  return customFetch<NutritionTarget[]>(getListNutritionTargetsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListNutritionTargetsQueryKey = () => {
  return [`/api/nutrition-targets`] as const;
};

export const getListNutritionTargetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listNutritionTargets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listNutritionTargets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNutritionTargetsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNutritionTargets>>
  > = ({ signal }) => listNutritionTargets({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNutritionTargets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNutritionTargetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNutritionTargets>>
>;
export type ListNutritionTargetsQueryError = ErrorType<unknown>;

export function useListNutritionTargets<
  TData = Awaited<ReturnType<typeof listNutritionTargets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listNutritionTargets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNutritionTargetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpsertNutritionTargetUrl = () => {
  return `/api/nutrition-targets`;
};

export const upsertNutritionTarget = async (
  nutritionTargetInput: NutritionTargetInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<NutritionTarget> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<NutritionTarget>(getUpsertNutritionTargetUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(nutritionTargetInput),
  });
};

export const getUpsertNutritionTargetMutationKey = () =>
  ["upsertNutritionTarget"] as const;

export const getUpsertNutritionTargetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertNutritionTarget>>,
    TError,
    UpsertNutritionTargetMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertNutritionTarget>>,
  TError,
  UpsertNutritionTargetMutationVariables,
  TContext
> => {
  const mutationKey = getUpsertNutritionTargetMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertNutritionTarget>>,
    UpsertNutritionTargetMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return upsertNutritionTarget(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertNutritionTargetMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertNutritionTarget>>
>;
export type UpsertNutritionTargetMutationBody = BodyType<NutritionTargetInput>;
export type UpsertNutritionTargetMutationError = ErrorType<unknown>;
export type UpsertNutritionTargetMutationVariables = {
  data: BodyType<NutritionTargetInput>;
};

export const useUpsertNutritionTarget = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertNutritionTarget>>,
    TError,
    UpsertNutritionTargetMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertNutritionTarget>>,
  TError,
  UpsertNutritionTargetMutationVariables,
  TContext
> => {
  return useMutation(getUpsertNutritionTargetMutationOptions(options));
};

export const getDeleteNutritionTargetUrl = (id: number) => {
  return `/api/nutrition-targets/${id}`;
};

export const deleteNutritionTarget = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteNutritionTargetUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteNutritionTargetMutationKey = () =>
  ["deleteNutritionTarget"] as const;

export const getDeleteNutritionTargetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNutritionTarget>>,
    TError,
    DeleteNutritionTargetMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNutritionTarget>>,
  TError,
  DeleteNutritionTargetMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteNutritionTargetMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNutritionTarget>>,
    DeleteNutritionTargetMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return deleteNutritionTarget(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNutritionTargetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNutritionTarget>>
>;

export type DeleteNutritionTargetMutationError = ErrorType<unknown>;
export type DeleteNutritionTargetMutationVariables = { id: number };

export const useDeleteNutritionTarget = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNutritionTarget>>,
    TError,
    DeleteNutritionTargetMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteNutritionTarget>>,
  TError,
  DeleteNutritionTargetMutationVariables,
  TContext
> => {
  return useMutation(getDeleteNutritionTargetMutationOptions(options));
};

export const getGetNutritionReportUrl = (params: GetNutritionReportParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/nutrition-reports?${stringifiedParams}`
    : `/api/nutrition-reports`;
};

export const getNutritionReport = async (
  params: GetNutritionReportParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<NutritionReport> => {
  return customFetch<NutritionReport>(getGetNutritionReportUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetNutritionReportQueryKey = (
  params?: GetNutritionReportParams,
) => {
  return [`/api/nutrition-reports`, ...(params ? [params] : [])] as const;
};

export const getGetNutritionReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getNutritionReport>>,
  TError = ErrorType<unknown>,
>(
  params: GetNutritionReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNutritionReport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNutritionReportQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNutritionReport>>
  > = ({ signal }) => getNutritionReport(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNutritionReport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNutritionReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNutritionReport>>
>;
export type GetNutritionReportQueryError = ErrorType<unknown>;

export function useGetNutritionReport<
  TData = Awaited<ReturnType<typeof getNutritionReport>>,
  TError = ErrorType<unknown>,
>(
  params: GetNutritionReportParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNutritionReport>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNutritionReportQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCopyNutritionLogsUrl = () => {
  return `/api/logs/copy`;
};

export const copyNutritionLogs = async (
  copyLogsInput: CopyLogsInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<CopyNutritionLogs201> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CopyNutritionLogs201>(getCopyNutritionLogsUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(copyLogsInput),
  });
};

export const getCopyNutritionLogsMutationKey = () =>
  ["copyNutritionLogs"] as const;

export const getCopyNutritionLogsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyNutritionLogs>>,
    TError,
    CopyNutritionLogsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyNutritionLogs>>,
  TError,
  CopyNutritionLogsMutationVariables,
  TContext
> => {
  const mutationKey = getCopyNutritionLogsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyNutritionLogs>>,
    CopyNutritionLogsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return copyNutritionLogs(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CopyNutritionLogsMutationResult = NonNullable<
  Awaited<ReturnType<typeof copyNutritionLogs>>
>;
export type CopyNutritionLogsMutationBody = BodyType<CopyLogsInput>;
export type CopyNutritionLogsMutationError = ErrorType<unknown>;
export type CopyNutritionLogsMutationVariables = {
  data: BodyType<CopyLogsInput>;
};

export const useCopyNutritionLogs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyNutritionLogs>>,
    TError,
    CopyNutritionLogsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof copyNutritionLogs>>,
  TError,
  CopyNutritionLogsMutationVariables,
  TContext
> => {
  return useMutation(getCopyNutritionLogsMutationOptions(options));
};

export const getImportNutritionLogsUrl = () => {
  return `/api/logs/import`;
};

export const importNutritionLogs = async (
  nutritionImportInput: NutritionImportInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<ImportNutritionLogs201> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ImportNutritionLogs201>(getImportNutritionLogsUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(nutritionImportInput),
  });
};

export const getImportNutritionLogsMutationKey = () =>
  ["importNutritionLogs"] as const;

export const getImportNutritionLogsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importNutritionLogs>>,
    TError,
    ImportNutritionLogsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importNutritionLogs>>,
  TError,
  ImportNutritionLogsMutationVariables,
  TContext
> => {
  const mutationKey = getImportNutritionLogsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importNutritionLogs>>,
    ImportNutritionLogsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return importNutritionLogs(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportNutritionLogsMutationResult = NonNullable<
  Awaited<ReturnType<typeof importNutritionLogs>>
>;
export type ImportNutritionLogsMutationBody = BodyType<NutritionImportInput>;
export type ImportNutritionLogsMutationError = ErrorType<unknown>;
export type ImportNutritionLogsMutationVariables = {
  data: BodyType<NutritionImportInput>;
};

export const useImportNutritionLogs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importNutritionLogs>>,
    TError,
    ImportNutritionLogsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importNutritionLogs>>,
  TError,
  ImportNutritionLogsMutationVariables,
  TContext
> => {
  return useMutation(getImportNutritionLogsMutationOptions(options));
};

export const getBulkUpdateNutritionLogsUrl = () => {
  return `/api/logs/bulk`;
};

export const bulkUpdateNutritionLogs = async (
  bulkLogUpdateInput: BulkLogUpdateInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<BulkUpdateNutritionLogs200> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BulkUpdateNutritionLogs200>(
    getBulkUpdateNutritionLogsUrl(),
    {
      ...options,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(bulkLogUpdateInput),
    },
  );
};

export const getBulkUpdateNutritionLogsMutationKey = () =>
  ["bulkUpdateNutritionLogs"] as const;

export const getBulkUpdateNutritionLogsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateNutritionLogs>>,
    TError,
    BulkUpdateNutritionLogsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUpdateNutritionLogs>>,
  TError,
  BulkUpdateNutritionLogsMutationVariables,
  TContext
> => {
  const mutationKey = getBulkUpdateNutritionLogsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUpdateNutritionLogs>>,
    BulkUpdateNutritionLogsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return bulkUpdateNutritionLogs(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUpdateNutritionLogsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkUpdateNutritionLogs>>
>;
export type BulkUpdateNutritionLogsMutationBody = BodyType<BulkLogUpdateInput>;
export type BulkUpdateNutritionLogsMutationError = ErrorType<unknown>;
export type BulkUpdateNutritionLogsMutationVariables = {
  data: BodyType<BulkLogUpdateInput>;
};

export const useBulkUpdateNutritionLogs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateNutritionLogs>>,
    TError,
    BulkUpdateNutritionLogsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof bulkUpdateNutritionLogs>>,
  TError,
  BulkUpdateNutritionLogsMutationVariables,
  TContext
> => {
  return useMutation(getBulkUpdateNutritionLogsMutationOptions(options));
};

export const getListInterventionsUrl = () => {
  return `/api/interventions`;
};

export const listInterventions = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Intervention[]> => {
  return customFetch<Intervention[]>(getListInterventionsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListInterventionsQueryKey = () => {
  return [`/api/interventions`] as const;
};

export const getListInterventionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listInterventions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInterventions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInterventionsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInterventions>>
  > = ({ signal }) => listInterventions({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInterventions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInterventionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInterventions>>
>;
export type ListInterventionsQueryError = ErrorType<unknown>;

export function useListInterventions<
  TData = Awaited<ReturnType<typeof listInterventions>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInterventions>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInterventionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetInterventionTimelineUrl = () => {
  return `/api/interventions/timeline`;
};

export const getInterventionTimeline = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<InterventionTimelineEntry[]> => {
  return customFetch<InterventionTimelineEntry[]>(
    getGetInterventionTimelineUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetInterventionTimelineQueryKey = () => {
  return [`/api/interventions/timeline`] as const;
};

export const getGetInterventionTimelineQueryOptions = <
  TData = Awaited<ReturnType<typeof getInterventionTimeline>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getInterventionTimeline>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetInterventionTimelineQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInterventionTimeline>>
  > = ({ signal }) => getInterventionTimeline({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInterventionTimeline>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInterventionTimelineQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInterventionTimeline>>
>;
export type GetInterventionTimelineQueryError = ErrorType<unknown>;

export function useGetInterventionTimeline<
  TData = Awaited<ReturnType<typeof getInterventionTimeline>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getInterventionTimeline>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInterventionTimelineQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateInterventionRecommendationUrl = () => {
  return `/api/interventions/recommendations`;
};

export const createInterventionRecommendation = async (
  interventionRecommendationInput: InterventionRecommendationInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<Intervention> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<Intervention>(getCreateInterventionRecommendationUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(interventionRecommendationInput),
  });
};

export const getCreateInterventionRecommendationMutationKey = () =>
  ["createInterventionRecommendation"] as const;

export const getCreateInterventionRecommendationMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInterventionRecommendation>>,
    TError,
    CreateInterventionRecommendationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInterventionRecommendation>>,
  TError,
  CreateInterventionRecommendationMutationVariables,
  TContext
> => {
  const mutationKey = getCreateInterventionRecommendationMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInterventionRecommendation>>,
    CreateInterventionRecommendationMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createInterventionRecommendation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInterventionRecommendationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInterventionRecommendation>>
>;
export type CreateInterventionRecommendationMutationBody =
  BodyType<InterventionRecommendationInput>;
export type CreateInterventionRecommendationMutationError = ErrorType<void>;
export type CreateInterventionRecommendationMutationVariables = {
  data: BodyType<InterventionRecommendationInput>;
};

export const useCreateInterventionRecommendation = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInterventionRecommendation>>,
    TError,
    CreateInterventionRecommendationMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInterventionRecommendation>>,
  TError,
  CreateInterventionRecommendationMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateInterventionRecommendationMutationOptions(options),
  );
};

export const getMaterializeCoachActionInterventionUrl = (actionId: string) => {
  return `/api/interventions/drafts/coach-actions/${actionId}`;
};

export const materializeCoachActionIntervention = async (
  actionId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<Intervention> => {
  return customFetch<Intervention>(
    getMaterializeCoachActionInterventionUrl(actionId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getMaterializeCoachActionInterventionMutationKey = () =>
  ["materializeCoachActionIntervention"] as const;

export const getMaterializeCoachActionInterventionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof materializeCoachActionIntervention>>,
    TError,
    MaterializeCoachActionInterventionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof materializeCoachActionIntervention>>,
  TError,
  MaterializeCoachActionInterventionMutationVariables,
  TContext
> => {
  const mutationKey = getMaterializeCoachActionInterventionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof materializeCoachActionIntervention>>,
    MaterializeCoachActionInterventionMutationVariables
  > = (props) => {
    const { actionId } = props ?? {};

    return materializeCoachActionIntervention(actionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MaterializeCoachActionInterventionMutationResult = NonNullable<
  Awaited<ReturnType<typeof materializeCoachActionIntervention>>
>;

export type MaterializeCoachActionInterventionMutationError = ErrorType<void>;
export type MaterializeCoachActionInterventionMutationVariables = {
  actionId: string;
};

export const useMaterializeCoachActionIntervention = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof materializeCoachActionIntervention>>,
    TError,
    MaterializeCoachActionInterventionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof materializeCoachActionIntervention>>,
  TError,
  MaterializeCoachActionInterventionMutationVariables,
  TContext
> => {
  return useMutation(
    getMaterializeCoachActionInterventionMutationOptions(options),
  );
};

export const getAnnotateInterventionContextUrl = (id: number) => {
  return `/api/interventions/${id}/context`;
};

export const annotateInterventionContext = async (
  id: number,
  interventionContextInput: InterventionContextInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<InterventionEvent> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<InterventionEvent>(getAnnotateInterventionContextUrl(id), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(interventionContextInput),
  });
};

export const getAnnotateInterventionContextMutationKey = () =>
  ["annotateInterventionContext"] as const;

export const getAnnotateInterventionContextMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof annotateInterventionContext>>,
    TError,
    AnnotateInterventionContextMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof annotateInterventionContext>>,
  TError,
  AnnotateInterventionContextMutationVariables,
  TContext
> => {
  const mutationKey = getAnnotateInterventionContextMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof annotateInterventionContext>>,
    AnnotateInterventionContextMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return annotateInterventionContext(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnnotateInterventionContextMutationResult = NonNullable<
  Awaited<ReturnType<typeof annotateInterventionContext>>
>;
export type AnnotateInterventionContextMutationBody =
  BodyType<InterventionContextInput>;
export type AnnotateInterventionContextMutationError = ErrorType<void>;
export type AnnotateInterventionContextMutationVariables = {
  id: number;
  data: BodyType<InterventionContextInput>;
};

export const useAnnotateInterventionContext = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof annotateInterventionContext>>,
    TError,
    AnnotateInterventionContextMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof annotateInterventionContext>>,
  TError,
  AnnotateInterventionContextMutationVariables,
  TContext
> => {
  return useMutation(getAnnotateInterventionContextMutationOptions(options));
};

export const getActOnInterventionUrl = (id: number) => {
  return `/api/interventions/${id}/actions`;
};

export const actOnIntervention = async (
  id: number,
  interventionActionInput: InterventionActionInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<Intervention> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<Intervention>(getActOnInterventionUrl(id), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(interventionActionInput),
  });
};

export const getActOnInterventionMutationKey = () =>
  ["actOnIntervention"] as const;

export const getActOnInterventionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof actOnIntervention>>,
    TError,
    ActOnInterventionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof actOnIntervention>>,
  TError,
  ActOnInterventionMutationVariables,
  TContext
> => {
  const mutationKey = getActOnInterventionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof actOnIntervention>>,
    ActOnInterventionMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return actOnIntervention(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActOnInterventionMutationResult = NonNullable<
  Awaited<ReturnType<typeof actOnIntervention>>
>;
export type ActOnInterventionMutationBody = BodyType<InterventionActionInput>;
export type ActOnInterventionMutationError = ErrorType<void>;
export type ActOnInterventionMutationVariables = {
  id: number;
  data: BodyType<InterventionActionInput>;
};

export const useActOnIntervention = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof actOnIntervention>>,
    TError,
    ActOnInterventionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof actOnIntervention>>,
  TError,
  ActOnInterventionMutationVariables,
  TContext
> => {
  return useMutation(getActOnInterventionMutationOptions(options));
};

export const getRecordInterventionAdherenceUrl = (id: number) => {
  return `/api/interventions/${id}/adherence`;
};

export const recordInterventionAdherence = async (
  id: number,
  interventionAdherenceInput: InterventionAdherenceInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<InterventionAdherenceObservation> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<InterventionAdherenceObservation>(
    getRecordInterventionAdherenceUrl(id),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(interventionAdherenceInput),
    },
  );
};

export const getRecordInterventionAdherenceMutationKey = () =>
  ["recordInterventionAdherence"] as const;

export const getRecordInterventionAdherenceMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordInterventionAdherence>>,
    TError,
    RecordInterventionAdherenceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recordInterventionAdherence>>,
  TError,
  RecordInterventionAdherenceMutationVariables,
  TContext
> => {
  const mutationKey = getRecordInterventionAdherenceMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordInterventionAdherence>>,
    RecordInterventionAdherenceMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return recordInterventionAdherence(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecordInterventionAdherenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordInterventionAdherence>>
>;
export type RecordInterventionAdherenceMutationBody =
  BodyType<InterventionAdherenceInput>;
export type RecordInterventionAdherenceMutationError = ErrorType<void>;
export type RecordInterventionAdherenceMutationVariables = {
  id: number;
  data: BodyType<InterventionAdherenceInput>;
};

export const useRecordInterventionAdherence = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordInterventionAdherence>>,
    TError,
    RecordInterventionAdherenceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordInterventionAdherence>>,
  TError,
  RecordInterventionAdherenceMutationVariables,
  TContext
> => {
  return useMutation(getRecordInterventionAdherenceMutationOptions(options));
};

export const getRefreshInterventionAdherenceUrl = (id: number) => {
  return `/api/interventions/${id}/adherence/refresh`;
};

export const refreshInterventionAdherence = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<InterventionAdherenceObservation[]> => {
  return customFetch<InterventionAdherenceObservation[]>(
    getRefreshInterventionAdherenceUrl(id),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRefreshInterventionAdherenceMutationKey = () =>
  ["refreshInterventionAdherence"] as const;

export const getRefreshInterventionAdherenceMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshInterventionAdherence>>,
    TError,
    RefreshInterventionAdherenceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshInterventionAdherence>>,
  TError,
  RefreshInterventionAdherenceMutationVariables,
  TContext
> => {
  const mutationKey = getRefreshInterventionAdherenceMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshInterventionAdherence>>,
    RefreshInterventionAdherenceMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return refreshInterventionAdherence(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshInterventionAdherenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshInterventionAdherence>>
>;

export type RefreshInterventionAdherenceMutationError = ErrorType<void>;
export type RefreshInterventionAdherenceMutationVariables = { id: number };

export const useRefreshInterventionAdherence = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshInterventionAdherence>>,
    TError,
    RefreshInterventionAdherenceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshInterventionAdherence>>,
  TError,
  RefreshInterventionAdherenceMutationVariables,
  TContext
> => {
  return useMutation(getRefreshInterventionAdherenceMutationOptions(options));
};

export const getAnalyzeInterventionOutcomeUrl = (id: number) => {
  return `/api/interventions/${id}/analyses`;
};

export const analyzeInterventionOutcome = async (
  id: number,
  interventionOutcomeInput: InterventionOutcomeInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<InterventionOutcomeAnalysis> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<InterventionOutcomeAnalysis>(
    getAnalyzeInterventionOutcomeUrl(id),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(interventionOutcomeInput),
    },
  );
};

export const getAnalyzeInterventionOutcomeMutationKey = () =>
  ["analyzeInterventionOutcome"] as const;

export const getAnalyzeInterventionOutcomeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeInterventionOutcome>>,
    TError,
    AnalyzeInterventionOutcomeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeInterventionOutcome>>,
  TError,
  AnalyzeInterventionOutcomeMutationVariables,
  TContext
> => {
  const mutationKey = getAnalyzeInterventionOutcomeMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeInterventionOutcome>>,
    AnalyzeInterventionOutcomeMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return analyzeInterventionOutcome(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeInterventionOutcomeMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeInterventionOutcome>>
>;
export type AnalyzeInterventionOutcomeMutationBody =
  BodyType<InterventionOutcomeInput>;
export type AnalyzeInterventionOutcomeMutationError = ErrorType<void>;
export type AnalyzeInterventionOutcomeMutationVariables = {
  id: number;
  data: BodyType<InterventionOutcomeInput>;
};

export const useAnalyzeInterventionOutcome = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeInterventionOutcome>>,
    TError,
    AnalyzeInterventionOutcomeMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeInterventionOutcome>>,
  TError,
  AnalyzeInterventionOutcomeMutationVariables,
  TContext
> => {
  return useMutation(getAnalyzeInterventionOutcomeMutationOptions(options));
};

export const getUpdateInterventionLearningConsentUrl = () => {
  return `/api/interventions/learning-consent`;
};

export const updateInterventionLearningConsent = async (
  interventionLearningConsentInput: InterventionLearningConsentInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<InterventionLearningConsent> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<InterventionLearningConsent>(
    getUpdateInterventionLearningConsentUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(interventionLearningConsentInput),
    },
  );
};

export const getUpdateInterventionLearningConsentMutationKey = () =>
  ["updateInterventionLearningConsent"] as const;

export const getUpdateInterventionLearningConsentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInterventionLearningConsent>>,
    TError,
    UpdateInterventionLearningConsentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateInterventionLearningConsent>>,
  TError,
  UpdateInterventionLearningConsentMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateInterventionLearningConsentMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateInterventionLearningConsent>>,
    UpdateInterventionLearningConsentMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateInterventionLearningConsent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateInterventionLearningConsentMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateInterventionLearningConsent>>
>;
export type UpdateInterventionLearningConsentMutationBody =
  BodyType<InterventionLearningConsentInput>;
export type UpdateInterventionLearningConsentMutationError = ErrorType<unknown>;
export type UpdateInterventionLearningConsentMutationVariables = {
  data: BodyType<InterventionLearningConsentInput>;
};

export const useUpdateInterventionLearningConsent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateInterventionLearningConsent>>,
    TError,
    UpdateInterventionLearningConsentMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateInterventionLearningConsent>>,
  TError,
  UpdateInterventionLearningConsentMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateInterventionLearningConsentMutationOptions(options),
  );
};

export const getGetInterventionCohortOutcomeUrl = (
  recommendationKey: string,
  metricKey: string,
) => {
  return `/api/interventions/cohort/${recommendationKey}/${metricKey}`;
};

export const getInterventionCohortOutcome = async (
  recommendationKey: string,
  metricKey: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<InterventionCohortOutcome> => {
  return customFetch<InterventionCohortOutcome>(
    getGetInterventionCohortOutcomeUrl(recommendationKey, metricKey),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetInterventionCohortOutcomeQueryKey = (
  recommendationKey: string,
  metricKey: string,
) => {
  return [
    `/api/interventions/cohort/${recommendationKey}/${metricKey}`,
  ] as const;
};

export const getGetInterventionCohortOutcomeQueryOptions = <
  TData = Awaited<ReturnType<typeof getInterventionCohortOutcome>>,
  TError = ErrorType<void>,
>(
  recommendationKey: string,
  metricKey: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInterventionCohortOutcome>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetInterventionCohortOutcomeQueryKey(recommendationKey, metricKey);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInterventionCohortOutcome>>
  > = ({ signal }) =>
    getInterventionCohortOutcome(recommendationKey, metricKey, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      recommendationKey !== null &&
      recommendationKey !== undefined &&
      metricKey !== null &&
      metricKey !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInterventionCohortOutcome>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInterventionCohortOutcomeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInterventionCohortOutcome>>
>;
export type GetInterventionCohortOutcomeQueryError = ErrorType<void>;

export function useGetInterventionCohortOutcome<
  TData = Awaited<ReturnType<typeof getInterventionCohortOutcome>>,
  TError = ErrorType<void>,
>(
  recommendationKey: string,
  metricKey: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInterventionCohortOutcome>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInterventionCohortOutcomeQueryOptions(
    recommendationKey,
    metricKey,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getStartVoiceSessionUrl = () => {
  return `/api/voice/sessions`;
};

/**
 * @summary Start an authenticated, short-lived LiveKit voice session
 */
export const startVoiceSession = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<VoiceSession> => {
  return customFetch<VoiceSession>(getStartVoiceSessionUrl(), {
    ...options,
    method: "POST",
  });
};

export const getStartVoiceSessionMutationKey = () =>
  ["startVoiceSession"] as const;

export const getStartVoiceSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startVoiceSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startVoiceSession>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getStartVoiceSessionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startVoiceSession>>,
    void
  > = () => {
    return startVoiceSession(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartVoiceSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof startVoiceSession>>
>;

export type StartVoiceSessionMutationError = ErrorType<void>;

/**
 * @summary Start an authenticated, short-lived LiveKit voice session
 */
export const useStartVoiceSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startVoiceSession>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startVoiceSession>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getStartVoiceSessionMutationOptions(options));
};

export const getGetVoiceSessionUrl = (id: string) => {
  return `/api/voice/sessions/${id}`;
};

export const getVoiceSession = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<VoiceSessionState> => {
  return customFetch<VoiceSessionState>(getGetVoiceSessionUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetVoiceSessionQueryKey = (id: string) => {
  return [`/api/voice/sessions/${id}`] as const;
};

export const getGetVoiceSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getVoiceSession>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVoiceSession>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVoiceSessionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVoiceSession>>> = ({
    signal,
  }) => getVoiceSession(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVoiceSession>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVoiceSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVoiceSession>>
>;
export type GetVoiceSessionQueryError = ErrorType<void>;

export function useGetVoiceSession<
  TData = Awaited<ReturnType<typeof getVoiceSession>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVoiceSession>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVoiceSessionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getEndVoiceSessionUrl = (id: string) => {
  return `/api/voice/sessions/${id}/end`;
};

export const endVoiceSession = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEndVoiceSessionUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getEndVoiceSessionMutationKey = () => ["endVoiceSession"] as const;

export const getEndVoiceSessionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endVoiceSession>>,
    TError,
    EndVoiceSessionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof endVoiceSession>>,
  TError,
  EndVoiceSessionMutationVariables,
  TContext
> => {
  const mutationKey = getEndVoiceSessionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endVoiceSession>>,
    EndVoiceSessionMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return endVoiceSession(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EndVoiceSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof endVoiceSession>>
>;

export type EndVoiceSessionMutationError = ErrorType<void>;
export type EndVoiceSessionMutationVariables = { id: string };

export const useEndVoiceSession = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endVoiceSession>>,
    TError,
    EndVoiceSessionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof endVoiceSession>>,
  TError,
  EndVoiceSessionMutationVariables,
  TContext
> => {
  return useMutation(getEndVoiceSessionMutationOptions(options));
};

export const getGetVoiceProposalUrl = (id: string) => {
  return `/api/voice/proposals/${id}`;
};

export const getVoiceProposal = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<VoiceProposal> => {
  return customFetch<VoiceProposal>(getGetVoiceProposalUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetVoiceProposalQueryKey = (id: string) => {
  return [`/api/voice/proposals/${id}`] as const;
};

export const getGetVoiceProposalQueryOptions = <
  TData = Awaited<ReturnType<typeof getVoiceProposal>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVoiceProposal>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVoiceProposalQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVoiceProposal>>
  > = ({ signal }) => getVoiceProposal(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVoiceProposal>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVoiceProposalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVoiceProposal>>
>;
export type GetVoiceProposalQueryError = ErrorType<void>;

export function useGetVoiceProposal<
  TData = Awaited<ReturnType<typeof getVoiceProposal>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getVoiceProposal>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVoiceProposalQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getConfirmVoiceAdminProposalUrl = (id: string) => {
  return `/api/voice/proposals/${id}`;
};

export const confirmVoiceAdminProposal = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getConfirmVoiceAdminProposalUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getConfirmVoiceAdminProposalMutationKey = () =>
  ["confirmVoiceAdminProposal"] as const;

export const getConfirmVoiceAdminProposalMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmVoiceAdminProposal>>,
    TError,
    ConfirmVoiceAdminProposalMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmVoiceAdminProposal>>,
  TError,
  ConfirmVoiceAdminProposalMutationVariables,
  TContext
> => {
  const mutationKey = getConfirmVoiceAdminProposalMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmVoiceAdminProposal>>,
    ConfirmVoiceAdminProposalMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return confirmVoiceAdminProposal(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmVoiceAdminProposalMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmVoiceAdminProposal>>
>;

export type ConfirmVoiceAdminProposalMutationError = ErrorType<void>;
export type ConfirmVoiceAdminProposalMutationVariables = { id: string };

export const useConfirmVoiceAdminProposal = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmVoiceAdminProposal>>,
    TError,
    ConfirmVoiceAdminProposalMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmVoiceAdminProposal>>,
  TError,
  ConfirmVoiceAdminProposalMutationVariables,
  TContext
> => {
  return useMutation(getConfirmVoiceAdminProposalMutationOptions(options));
};

export const getGetVoiceHealthUrl = () => {
  return `/api/voice/health`;
};

export const getVoiceHealth = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<VoiceHealth> => {
  return customFetch<VoiceHealth>(getGetVoiceHealthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetVoiceHealthQueryKey = () => {
  return [`/api/voice/health`] as const;
};

export const getGetVoiceHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getVoiceHealth>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getVoiceHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVoiceHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVoiceHealth>>> = ({
    signal,
  }) => getVoiceHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVoiceHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVoiceHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVoiceHealth>>
>;
export type GetVoiceHealthQueryError = ErrorType<void>;

export function useGetVoiceHealth<
  TData = Awaited<ReturnType<typeof getVoiceHealth>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getVoiceHealth>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVoiceHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateVoiceControlsUrl = () => {
  return `/api/voice/controls`;
};

export const updateVoiceControls = async (
  updateVoiceControlsBody: UpdateVoiceControlsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<void>(getUpdateVoiceControlsUrl(), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(updateVoiceControlsBody),
  });
};

export const getUpdateVoiceControlsMutationKey = () =>
  ["updateVoiceControls"] as const;

export const getUpdateVoiceControlsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVoiceControls>>,
    TError,
    UpdateVoiceControlsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVoiceControls>>,
  TError,
  UpdateVoiceControlsMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateVoiceControlsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVoiceControls>>,
    UpdateVoiceControlsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateVoiceControls(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVoiceControlsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVoiceControls>>
>;
export type UpdateVoiceControlsMutationBody = BodyType<UpdateVoiceControlsBody>;
export type UpdateVoiceControlsMutationError = ErrorType<void>;
export type UpdateVoiceControlsMutationVariables = {
  data: BodyType<UpdateVoiceControlsBody>;
};

export const useUpdateVoiceControls = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVoiceControls>>,
    TError,
    UpdateVoiceControlsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVoiceControls>>,
  TError,
  UpdateVoiceControlsMutationVariables,
  TContext
> => {
  return useMutation(getUpdateVoiceControlsMutationOptions(options));
};

export const getListCrmDefinitionsUrl = (params?: ListCrmDefinitionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/dashboard/audience/crm/definitions?${stringifiedParams}`
    : `/api/admin/dashboard/audience/crm/definitions`;
};

export const listCrmDefinitions = async (
  params?: ListCrmDefinitionsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<CrmDefinitionsResponse> => {
  return customFetch<CrmDefinitionsResponse>(getListCrmDefinitionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCrmDefinitionsQueryKey = (
  params?: ListCrmDefinitionsParams,
) => {
  return [
    `/api/admin/dashboard/audience/crm/definitions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListCrmDefinitionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCrmDefinitions>>,
  TError = ErrorType<void>,
>(
  params?: ListCrmDefinitionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCrmDefinitions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCrmDefinitionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCrmDefinitions>>
  > = ({ signal }) => listCrmDefinitions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCrmDefinitions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCrmDefinitionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCrmDefinitions>>
>;
export type ListCrmDefinitionsQueryError = ErrorType<void>;

export function useListCrmDefinitions<
  TData = Awaited<ReturnType<typeof listCrmDefinitions>>,
  TError = ErrorType<void>,
>(
  params?: ListCrmDefinitionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCrmDefinitions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCrmDefinitionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateCrmDefinitionUrl = () => {
  return `/api/admin/dashboard/audience/crm/definitions`;
};

export const createCrmDefinition = async (
  crmDefinitionInput: CrmDefinitionInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<CrmDefinitionResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CrmDefinitionResponse>(getCreateCrmDefinitionUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(crmDefinitionInput),
  });
};

export const getCreateCrmDefinitionMutationKey = () =>
  ["createCrmDefinition"] as const;

export const getCreateCrmDefinitionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCrmDefinition>>,
    TError,
    CreateCrmDefinitionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCrmDefinition>>,
  TError,
  CreateCrmDefinitionMutationVariables,
  TContext
> => {
  const mutationKey = getCreateCrmDefinitionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCrmDefinition>>,
    CreateCrmDefinitionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createCrmDefinition(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCrmDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCrmDefinition>>
>;
export type CreateCrmDefinitionMutationBody = BodyType<CrmDefinitionInput>;
export type CreateCrmDefinitionMutationError = ErrorType<void>;
export type CreateCrmDefinitionMutationVariables = {
  data: BodyType<CrmDefinitionInput>;
};

export const useCreateCrmDefinition = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCrmDefinition>>,
    TError,
    CreateCrmDefinitionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCrmDefinition>>,
  TError,
  CreateCrmDefinitionMutationVariables,
  TContext
> => {
  return useMutation(getCreateCrmDefinitionMutationOptions(options));
};

export const getUpdateCrmDefinitionUrl = (id: number) => {
  return `/api/admin/dashboard/audience/crm/definitions/${id}`;
};

export const updateCrmDefinition = async (
  id: number,
  crmDefinitionUpdate: CrmDefinitionUpdate,
  options?: Parameters<typeof customFetch>[1],
): Promise<CrmDefinitionResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CrmDefinitionResponse>(getUpdateCrmDefinitionUrl(id), {
    ...options,
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(crmDefinitionUpdate),
  });
};

export const getUpdateCrmDefinitionMutationKey = () =>
  ["updateCrmDefinition"] as const;

export const getUpdateCrmDefinitionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCrmDefinition>>,
    TError,
    UpdateCrmDefinitionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCrmDefinition>>,
  TError,
  UpdateCrmDefinitionMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateCrmDefinitionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCrmDefinition>>,
    UpdateCrmDefinitionMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCrmDefinition(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCrmDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCrmDefinition>>
>;
export type UpdateCrmDefinitionMutationBody = BodyType<CrmDefinitionUpdate>;
export type UpdateCrmDefinitionMutationError = ErrorType<void>;
export type UpdateCrmDefinitionMutationVariables = {
  id: number;
  data: BodyType<CrmDefinitionUpdate>;
};

export const useUpdateCrmDefinition = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCrmDefinition>>,
    TError,
    UpdateCrmDefinitionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCrmDefinition>>,
  TError,
  UpdateCrmDefinitionMutationVariables,
  TContext
> => {
  return useMutation(getUpdateCrmDefinitionMutationOptions(options));
};

export const getDeleteCrmDefinitionUrl = (id: number) => {
  return `/api/admin/dashboard/audience/crm/definitions/${id}`;
};

export const deleteCrmDefinition = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteCrmDefinitionUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCrmDefinitionMutationKey = () =>
  ["deleteCrmDefinition"] as const;

export const getDeleteCrmDefinitionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCrmDefinition>>,
    TError,
    DeleteCrmDefinitionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCrmDefinition>>,
  TError,
  DeleteCrmDefinitionMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteCrmDefinitionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCrmDefinition>>,
    DeleteCrmDefinitionMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return deleteCrmDefinition(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCrmDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCrmDefinition>>
>;

export type DeleteCrmDefinitionMutationError = ErrorType<void>;
export type DeleteCrmDefinitionMutationVariables = { id: number };

export const useDeleteCrmDefinition = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCrmDefinition>>,
    TError,
    DeleteCrmDefinitionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCrmDefinition>>,
  TError,
  DeleteCrmDefinitionMutationVariables,
  TContext
> => {
  return useMutation(getDeleteCrmDefinitionMutationOptions(options));
};

export const getAssignCrmDefinitionUrl = () => {
  return `/api/admin/dashboard/audience/crm/assignments`;
};

export const assignCrmDefinition = async (
  crmAssignmentInput: CrmAssignmentInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<CrmAssignmentResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CrmAssignmentResult>(getAssignCrmDefinitionUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(crmAssignmentInput),
  });
};

export const getAssignCrmDefinitionMutationKey = () =>
  ["assignCrmDefinition"] as const;

export const getAssignCrmDefinitionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignCrmDefinition>>,
    TError,
    AssignCrmDefinitionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignCrmDefinition>>,
  TError,
  AssignCrmDefinitionMutationVariables,
  TContext
> => {
  const mutationKey = getAssignCrmDefinitionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignCrmDefinition>>,
    AssignCrmDefinitionMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return assignCrmDefinition(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignCrmDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignCrmDefinition>>
>;
export type AssignCrmDefinitionMutationBody = BodyType<CrmAssignmentInput>;
export type AssignCrmDefinitionMutationError = ErrorType<void>;
export type AssignCrmDefinitionMutationVariables = {
  data: BodyType<CrmAssignmentInput>;
};

export const useAssignCrmDefinition = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignCrmDefinition>>,
    TError,
    AssignCrmDefinitionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof assignCrmDefinition>>,
  TError,
  AssignCrmDefinitionMutationVariables,
  TContext
> => {
  return useMutation(getAssignCrmDefinitionMutationOptions(options));
};

export const getListCrmMemberAssignmentsUrl = (id: number) => {
  return `/api/admin/dashboard/audience/crm/members/${id}/assignments`;
};

export const listCrmMemberAssignments = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<CrmMemberAssignmentsResponse> => {
  return customFetch<CrmMemberAssignmentsResponse>(
    getListCrmMemberAssignmentsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListCrmMemberAssignmentsQueryKey = (id: number) => {
  return [
    `/api/admin/dashboard/audience/crm/members/${id}/assignments`,
  ] as const;
};

export const getListCrmMemberAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCrmMemberAssignments>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCrmMemberAssignments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCrmMemberAssignmentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCrmMemberAssignments>>
  > = ({ signal }) =>
    listCrmMemberAssignments(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCrmMemberAssignments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCrmMemberAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCrmMemberAssignments>>
>;
export type ListCrmMemberAssignmentsQueryError = ErrorType<void>;

export function useListCrmMemberAssignments<
  TData = Awaited<ReturnType<typeof listCrmMemberAssignments>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCrmMemberAssignments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCrmMemberAssignmentsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getListCrmSavedAudiencesUrl = () => {
  return `/api/admin/dashboard/audience/crm/saved-audiences`;
};

export const listCrmSavedAudiences = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CrmSavedAudiencesResponse> => {
  return customFetch<CrmSavedAudiencesResponse>(getListCrmSavedAudiencesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCrmSavedAudiencesQueryKey = () => {
  return [`/api/admin/dashboard/audience/crm/saved-audiences`] as const;
};

export const getListCrmSavedAudiencesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCrmSavedAudiences>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCrmSavedAudiences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCrmSavedAudiencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCrmSavedAudiences>>
  > = ({ signal }) => listCrmSavedAudiences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCrmSavedAudiences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCrmSavedAudiencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCrmSavedAudiences>>
>;
export type ListCrmSavedAudiencesQueryError = ErrorType<void>;

export function useListCrmSavedAudiences<
  TData = Awaited<ReturnType<typeof listCrmSavedAudiences>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCrmSavedAudiences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCrmSavedAudiencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateCrmSavedAudienceUrl = () => {
  return `/api/admin/dashboard/audience/crm/saved-audiences`;
};

export const createCrmSavedAudience = async (
  crmSavedAudienceInput: CrmSavedAudienceInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<CrmSavedAudienceResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CrmSavedAudienceResponse>(getCreateCrmSavedAudienceUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(crmSavedAudienceInput),
  });
};

export const getCreateCrmSavedAudienceMutationKey = () =>
  ["createCrmSavedAudience"] as const;

export const getCreateCrmSavedAudienceMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCrmSavedAudience>>,
    TError,
    CreateCrmSavedAudienceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCrmSavedAudience>>,
  TError,
  CreateCrmSavedAudienceMutationVariables,
  TContext
> => {
  const mutationKey = getCreateCrmSavedAudienceMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCrmSavedAudience>>,
    CreateCrmSavedAudienceMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createCrmSavedAudience(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCrmSavedAudienceMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCrmSavedAudience>>
>;
export type CreateCrmSavedAudienceMutationBody =
  BodyType<CrmSavedAudienceInput>;
export type CreateCrmSavedAudienceMutationError = ErrorType<void>;
export type CreateCrmSavedAudienceMutationVariables = {
  data: BodyType<CrmSavedAudienceInput>;
};

export const useCreateCrmSavedAudience = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCrmSavedAudience>>,
    TError,
    CreateCrmSavedAudienceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCrmSavedAudience>>,
  TError,
  CreateCrmSavedAudienceMutationVariables,
  TContext
> => {
  return useMutation(getCreateCrmSavedAudienceMutationOptions(options));
};

export const getUpdateCrmSavedAudienceUrl = (id: number) => {
  return `/api/admin/dashboard/audience/crm/saved-audiences/${id}`;
};

export const updateCrmSavedAudience = async (
  id: number,
  crmSavedAudienceUpdate: CrmSavedAudienceUpdate,
  options?: Parameters<typeof customFetch>[1],
): Promise<CrmSavedAudienceResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CrmSavedAudienceResponse>(
    getUpdateCrmSavedAudienceUrl(id),
    {
      ...options,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(crmSavedAudienceUpdate),
    },
  );
};

export const getUpdateCrmSavedAudienceMutationKey = () =>
  ["updateCrmSavedAudience"] as const;

export const getUpdateCrmSavedAudienceMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCrmSavedAudience>>,
    TError,
    UpdateCrmSavedAudienceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCrmSavedAudience>>,
  TError,
  UpdateCrmSavedAudienceMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateCrmSavedAudienceMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCrmSavedAudience>>,
    UpdateCrmSavedAudienceMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCrmSavedAudience(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCrmSavedAudienceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCrmSavedAudience>>
>;
export type UpdateCrmSavedAudienceMutationBody =
  BodyType<CrmSavedAudienceUpdate>;
export type UpdateCrmSavedAudienceMutationError = ErrorType<void>;
export type UpdateCrmSavedAudienceMutationVariables = {
  id: number;
  data: BodyType<CrmSavedAudienceUpdate>;
};

export const useUpdateCrmSavedAudience = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCrmSavedAudience>>,
    TError,
    UpdateCrmSavedAudienceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCrmSavedAudience>>,
  TError,
  UpdateCrmSavedAudienceMutationVariables,
  TContext
> => {
  return useMutation(getUpdateCrmSavedAudienceMutationOptions(options));
};

export const getDeleteCrmSavedAudienceUrl = (id: number) => {
  return `/api/admin/dashboard/audience/crm/saved-audiences/${id}`;
};

export const deleteCrmSavedAudience = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteCrmSavedAudienceUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteCrmSavedAudienceMutationKey = () =>
  ["deleteCrmSavedAudience"] as const;

export const getDeleteCrmSavedAudienceMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCrmSavedAudience>>,
    TError,
    DeleteCrmSavedAudienceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCrmSavedAudience>>,
  TError,
  DeleteCrmSavedAudienceMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteCrmSavedAudienceMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCrmSavedAudience>>,
    DeleteCrmSavedAudienceMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return deleteCrmSavedAudience(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCrmSavedAudienceMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCrmSavedAudience>>
>;

export type DeleteCrmSavedAudienceMutationError = ErrorType<void>;
export type DeleteCrmSavedAudienceMutationVariables = { id: number };

export const useDeleteCrmSavedAudience = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCrmSavedAudience>>,
    TError,
    DeleteCrmSavedAudienceMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteCrmSavedAudience>>,
  TError,
  DeleteCrmSavedAudienceMutationVariables,
  TContext
> => {
  return useMutation(getDeleteCrmSavedAudienceMutationOptions(options));
};

export const getSyncCrmMembersUrl = () => {
  return `/api/admin/dashboard/audience/crm/sync`;
};

export const syncCrmMembers = async (
  crmSyncInput: CrmSyncInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<CrmSyncResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CrmSyncResult>(getSyncCrmMembersUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(crmSyncInput),
  });
};

export const getSyncCrmMembersMutationKey = () => ["syncCrmMembers"] as const;

export const getSyncCrmMembersMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncCrmMembers>>,
    TError,
    SyncCrmMembersMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncCrmMembers>>,
  TError,
  SyncCrmMembersMutationVariables,
  TContext
> => {
  const mutationKey = getSyncCrmMembersMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncCrmMembers>>,
    SyncCrmMembersMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return syncCrmMembers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncCrmMembersMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncCrmMembers>>
>;
export type SyncCrmMembersMutationBody = BodyType<CrmSyncInput>;
export type SyncCrmMembersMutationError = ErrorType<void>;
export type SyncCrmMembersMutationVariables = { data: BodyType<CrmSyncInput> };

export const useSyncCrmMembers = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncCrmMembers>>,
    TError,
    SyncCrmMembersMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncCrmMembers>>,
  TError,
  SyncCrmMembersMutationVariables,
  TContext
> => {
  return useMutation(getSyncCrmMembersMutationOptions(options));
};

export const getGetCrmStatusUrl = () => {
  return `/api/admin/dashboard/audience/crm/status`;
};

export const getCrmStatus = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CrmStatus> => {
  return customFetch<CrmStatus>(getGetCrmStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCrmStatusQueryKey = () => {
  return [`/api/admin/dashboard/audience/crm/status`] as const;
};

export const getGetCrmStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getCrmStatus>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCrmStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCrmStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCrmStatus>>> = ({
    signal,
  }) => getCrmStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCrmStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCrmStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCrmStatus>>
>;
export type GetCrmStatusQueryError = ErrorType<void>;

export function useGetCrmStatus<
  TData = Awaited<ReturnType<typeof getCrmStatus>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCrmStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCrmStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSetCrmMemberPermissionUrl = (id: number) => {
  return `/api/admin/dashboard/audience/crm/members/${id}/permission`;
};

export const setCrmMemberPermission = async (
  id: number,
  crmPermissionInput: CrmPermissionInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<CrmPermission> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<CrmPermission>(getSetCrmMemberPermissionUrl(id), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(crmPermissionInput),
  });
};

export const getSetCrmMemberPermissionMutationKey = () =>
  ["setCrmMemberPermission"] as const;

export const getSetCrmMemberPermissionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setCrmMemberPermission>>,
    TError,
    SetCrmMemberPermissionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setCrmMemberPermission>>,
  TError,
  SetCrmMemberPermissionMutationVariables,
  TContext
> => {
  const mutationKey = getSetCrmMemberPermissionMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setCrmMemberPermission>>,
    SetCrmMemberPermissionMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return setCrmMemberPermission(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetCrmMemberPermissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof setCrmMemberPermission>>
>;
export type SetCrmMemberPermissionMutationBody = BodyType<CrmPermissionInput>;
export type SetCrmMemberPermissionMutationError = ErrorType<void>;
export type SetCrmMemberPermissionMutationVariables = {
  id: number;
  data: BodyType<CrmPermissionInput>;
};

export const useSetCrmMemberPermission = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setCrmMemberPermission>>,
    TError,
    SetCrmMemberPermissionMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setCrmMemberPermission>>,
  TError,
  SetCrmMemberPermissionMutationVariables,
  TContext
> => {
  return useMutation(getSetCrmMemberPermissionMutationOptions(options));
};

export const getGetMarketingPreferencesUrl = () => {
  return `/api/audience/preferences`;
};

export const getMarketingPreferences = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<MarketingPreferences> => {
  return customFetch<MarketingPreferences>(getGetMarketingPreferencesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMarketingPreferencesQueryKey = () => {
  return [`/api/audience/preferences`] as const;
};

export const getGetMarketingPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMarketingPreferences>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMarketingPreferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMarketingPreferences>>
  > = ({ signal }) => getMarketingPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingPreferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMarketingPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMarketingPreferences>>
>;
export type GetMarketingPreferencesQueryError = ErrorType<void>;

export function useGetMarketingPreferences<
  TData = Awaited<ReturnType<typeof getMarketingPreferences>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMarketingPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMarketingPreferencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateMarketingPreferencesUrl = () => {
  return `/api/audience/preferences`;
};

export const updateMarketingPreferences = async (
  marketingPreferencesInput: MarketingPreferencesInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<MarketingPreference> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<MarketingPreference>(getUpdateMarketingPreferencesUrl(), {
    ...options,
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(marketingPreferencesInput),
  });
};

export const getUpdateMarketingPreferencesMutationKey = () =>
  ["updateMarketingPreferences"] as const;

export const getUpdateMarketingPreferencesMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMarketingPreferences>>,
    TError,
    UpdateMarketingPreferencesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMarketingPreferences>>,
  TError,
  UpdateMarketingPreferencesMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateMarketingPreferencesMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMarketingPreferences>>,
    UpdateMarketingPreferencesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return updateMarketingPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMarketingPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMarketingPreferences>>
>;
export type UpdateMarketingPreferencesMutationBody =
  BodyType<MarketingPreferencesInput>;
export type UpdateMarketingPreferencesMutationError = ErrorType<void>;
export type UpdateMarketingPreferencesMutationVariables = {
  data: BodyType<MarketingPreferencesInput>;
};

export const useUpdateMarketingPreferences = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMarketingPreferences>>,
    TError,
    UpdateMarketingPreferencesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMarketingPreferences>>,
  TError,
  UpdateMarketingPreferencesMutationVariables,
  TContext
> => {
  return useMutation(getUpdateMarketingPreferencesMutationOptions(options));
};

export const getGetGmailOverviewUrl = () => {
  return `/api/admin/dashboard/audience/gmail`;
};

export const getGmailOverview = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailOverview> => {
  return customFetch<GmailOverview>(getGetGmailOverviewUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetGmailOverviewQueryKey = () => {
  return [`/api/admin/dashboard/audience/gmail`] as const;
};

export const getGetGmailOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getGmailOverview>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGmailOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGmailOverviewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGmailOverview>>
  > = ({ signal }) => getGmailOverview({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGmailOverview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGmailOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGmailOverview>>
>;
export type GetGmailOverviewQueryError = ErrorType<void>;

export function useGetGmailOverview<
  TData = Awaited<ReturnType<typeof getGmailOverview>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGmailOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGmailOverviewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getConnectWorkspaceGmailUrl = () => {
  return `/api/admin/dashboard/audience/gmail/workspace/connect`;
};

export const connectWorkspaceGmail = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailWorkspaceConnectionResult> => {
  return customFetch<GmailWorkspaceConnectionResult>(
    getConnectWorkspaceGmailUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getConnectWorkspaceGmailMutationKey = () =>
  ["connectWorkspaceGmail"] as const;

export const getConnectWorkspaceGmailMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectWorkspaceGmail>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof connectWorkspaceGmail>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getConnectWorkspaceGmailMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof connectWorkspaceGmail>>,
    void
  > = () => {
    return connectWorkspaceGmail(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConnectWorkspaceGmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof connectWorkspaceGmail>>
>;

export type ConnectWorkspaceGmailMutationError = ErrorType<void>;

export const useConnectWorkspaceGmail = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectWorkspaceGmail>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof connectWorkspaceGmail>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getConnectWorkspaceGmailMutationOptions(options));
};

export const getStartGmailConnectUrl = () => {
  return `/api/admin/dashboard/audience/gmail/start`;
};

export const startGmailConnect = async (
  gmailConnectInput: GmailConnectInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailConnectResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GmailConnectResult>(getStartGmailConnectUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(gmailConnectInput),
  });
};

export const getStartGmailConnectMutationKey = () =>
  ["startGmailConnect"] as const;

export const getStartGmailConnectMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startGmailConnect>>,
    TError,
    StartGmailConnectMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startGmailConnect>>,
  TError,
  StartGmailConnectMutationVariables,
  TContext
> => {
  const mutationKey = getStartGmailConnectMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startGmailConnect>>,
    StartGmailConnectMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return startGmailConnect(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartGmailConnectMutationResult = NonNullable<
  Awaited<ReturnType<typeof startGmailConnect>>
>;
export type StartGmailConnectMutationBody = BodyType<GmailConnectInput>;
export type StartGmailConnectMutationError = ErrorType<void>;
export type StartGmailConnectMutationVariables = {
  data: BodyType<GmailConnectInput>;
};

export const useStartGmailConnect = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startGmailConnect>>,
    TError,
    StartGmailConnectMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startGmailConnect>>,
  TError,
  StartGmailConnectMutationVariables,
  TContext
> => {
  return useMutation(getStartGmailConnectMutationOptions(options));
};

export const getDisconnectGmailUrl = (id: number) => {
  return `/api/admin/dashboard/audience/gmail/${id}`;
};

export const disconnectGmail = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailDisconnectResult> => {
  return customFetch<GmailDisconnectResult>(getDisconnectGmailUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDisconnectGmailMutationKey = () => ["disconnectGmail"] as const;

export const getDisconnectGmailMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectGmail>>,
    TError,
    DisconnectGmailMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectGmail>>,
  TError,
  DisconnectGmailMutationVariables,
  TContext
> => {
  const mutationKey = getDisconnectGmailMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectGmail>>,
    DisconnectGmailMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return disconnectGmail(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectGmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectGmail>>
>;

export type DisconnectGmailMutationError = ErrorType<void>;
export type DisconnectGmailMutationVariables = { id: number };

export const useDisconnectGmail = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectGmail>>,
    TError,
    DisconnectGmailMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof disconnectGmail>>,
  TError,
  DisconnectGmailMutationVariables,
  TContext
> => {
  return useMutation(getDisconnectGmailMutationOptions(options));
};

export const getRecoverGmailReplyUrl = (id: number) => {
  return `/api/admin/dashboard/audience/gmail/${id}/recover-reply`;
};

export const recoverGmailReply = async (
  id: number,
  gmailReplyRecoveryInput: GmailReplyRecoveryInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailReplyRecoveryResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GmailReplyRecoveryResult>(getRecoverGmailReplyUrl(id), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(gmailReplyRecoveryInput),
  });
};

export const getRecoverGmailReplyMutationKey = () =>
  ["recoverGmailReply"] as const;

export const getRecoverGmailReplyMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recoverGmailReply>>,
    TError,
    RecoverGmailReplyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof recoverGmailReply>>,
  TError,
  RecoverGmailReplyMutationVariables,
  TContext
> => {
  const mutationKey = getRecoverGmailReplyMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recoverGmailReply>>,
    RecoverGmailReplyMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return recoverGmailReply(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RecoverGmailReplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof recoverGmailReply>>
>;
export type RecoverGmailReplyMutationBody = BodyType<GmailReplyRecoveryInput>;
export type RecoverGmailReplyMutationError = ErrorType<void>;
export type RecoverGmailReplyMutationVariables = {
  id: number;
  data: BodyType<GmailReplyRecoveryInput>;
};

export const useRecoverGmailReply = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recoverGmailReply>>,
    TError,
    RecoverGmailReplyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof recoverGmailReply>>,
  TError,
  RecoverGmailReplyMutationVariables,
  TContext
> => {
  return useMutation(getRecoverGmailReplyMutationOptions(options));
};

export const getSyncGmailUrl = (id: number) => {
  return `/api/admin/dashboard/audience/gmail/${id}/sync`;
};

export const syncGmail = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailSyncResult> => {
  return customFetch<GmailSyncResult>(getSyncGmailUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSyncGmailMutationKey = () => ["syncGmail"] as const;

export const getSyncGmailMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncGmail>>,
    TError,
    SyncGmailMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncGmail>>,
  TError,
  SyncGmailMutationVariables,
  TContext
> => {
  const mutationKey = getSyncGmailMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncGmail>>,
    SyncGmailMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return syncGmail(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncGmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncGmail>>
>;

export type SyncGmailMutationError = ErrorType<void>;
export type SyncGmailMutationVariables = { id: number };

export const useSyncGmail = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncGmail>>,
    TError,
    SyncGmailMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncGmail>>,
  TError,
  SyncGmailMutationVariables,
  TContext
> => {
  return useMutation(getSyncGmailMutationOptions(options));
};

export const getGetGmailLabelsUrl = (id: number) => {
  return `/api/admin/dashboard/audience/gmail/${id}/labels`;
};

export const getGmailLabels = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailLabelsResponse> => {
  return customFetch<GmailLabelsResponse>(getGetGmailLabelsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetGmailLabelsQueryKey = (id: number) => {
  return [`/api/admin/dashboard/audience/gmail/${id}/labels`] as const;
};

export const getGetGmailLabelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGmailLabels>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGmailLabels>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGmailLabelsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGmailLabels>>> = ({
    signal,
  }) => getGmailLabels(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGmailLabels>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGmailLabelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGmailLabels>>
>;
export type GetGmailLabelsQueryError = ErrorType<void>;

export function useGetGmailLabels<
  TData = Awaited<ReturnType<typeof getGmailLabels>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGmailLabels>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGmailLabelsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetGmailLabelMappingsUrl = (id: number) => {
  return `/api/admin/dashboard/audience/gmail/${id}/label-mappings`;
};

export const getGmailLabelMappings = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailLabelMappingsResponse> => {
  return customFetch<GmailLabelMappingsResponse>(
    getGetGmailLabelMappingsUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetGmailLabelMappingsQueryKey = (id: number) => {
  return [`/api/admin/dashboard/audience/gmail/${id}/label-mappings`] as const;
};

export const getGetGmailLabelMappingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGmailLabelMappings>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGmailLabelMappings>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGmailLabelMappingsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGmailLabelMappings>>
  > = ({ signal }) => getGmailLabelMappings(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGmailLabelMappings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGmailLabelMappingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGmailLabelMappings>>
>;
export type GetGmailLabelMappingsQueryError = ErrorType<void>;

export function useGetGmailLabelMappings<
  TData = Awaited<ReturnType<typeof getGmailLabelMappings>>,
  TError = ErrorType<void>,
>(
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGmailLabelMappings>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGmailLabelMappingsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateGmailLabelMappingsUrl = (id: number) => {
  return `/api/admin/dashboard/audience/gmail/${id}/label-mappings`;
};

export const updateGmailLabelMappings = async (
  id: number,
  gmailLabelMappingsInput: GmailLabelMappingsInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailLabelMappingsResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GmailLabelMappingsResponse>(
    getUpdateGmailLabelMappingsUrl(id),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(gmailLabelMappingsInput),
    },
  );
};

export const getUpdateGmailLabelMappingsMutationKey = () =>
  ["updateGmailLabelMappings"] as const;

export const getUpdateGmailLabelMappingsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGmailLabelMappings>>,
    TError,
    UpdateGmailLabelMappingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateGmailLabelMappings>>,
  TError,
  UpdateGmailLabelMappingsMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateGmailLabelMappingsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateGmailLabelMappings>>,
    UpdateGmailLabelMappingsMutationVariables
  > = (props) => {
    const { id, data } = props ?? {};

    return updateGmailLabelMappings(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateGmailLabelMappingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateGmailLabelMappings>>
>;
export type UpdateGmailLabelMappingsMutationBody =
  BodyType<GmailLabelMappingsInput>;
export type UpdateGmailLabelMappingsMutationError = ErrorType<void>;
export type UpdateGmailLabelMappingsMutationVariables = {
  id: number;
  data: BodyType<GmailLabelMappingsInput>;
};

export const useUpdateGmailLabelMappings = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateGmailLabelMappings>>,
    TError,
    UpdateGmailLabelMappingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateGmailLabelMappings>>,
  TError,
  UpdateGmailLabelMappingsMutationVariables,
  TContext
> => {
  return useMutation(getUpdateGmailLabelMappingsMutationOptions(options));
};

export const getGetGmailThreadsUrl = (params?: GetGmailThreadsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/dashboard/audience/gmail/threads?${stringifiedParams}`
    : `/api/admin/dashboard/audience/gmail/threads`;
};

export const getGmailThreads = async (
  params?: GetGmailThreadsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailThreadsResponse> => {
  return customFetch<GmailThreadsResponse>(getGetGmailThreadsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetGmailThreadsQueryKey = (params?: GetGmailThreadsParams) => {
  return [
    `/api/admin/dashboard/audience/gmail/threads`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetGmailThreadsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGmailThreads>>,
  TError = ErrorType<void>,
>(
  params?: GetGmailThreadsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGmailThreads>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetGmailThreadsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGmailThreads>>> = ({
    signal,
  }) => getGmailThreads(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGmailThreads>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGmailThreadsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGmailThreads>>
>;
export type GetGmailThreadsQueryError = ErrorType<void>;

export function useGetGmailThreads<
  TData = Awaited<ReturnType<typeof getGmailThreads>>,
  TError = ErrorType<void>,
>(
  params?: GetGmailThreadsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGmailThreads>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGmailThreadsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetGmailThreadUrl = (threadId: number) => {
  return `/api/admin/dashboard/audience/gmail/threads/${threadId}`;
};

export const getGmailThread = async (
  threadId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailThreadResponse> => {
  return customFetch<GmailThreadResponse>(getGetGmailThreadUrl(threadId), {
    ...options,
    method: "GET",
  });
};

export const getGetGmailThreadQueryKey = (threadId: number) => {
  return [`/api/admin/dashboard/audience/gmail/threads/${threadId}`] as const;
};

export const getGetGmailThreadQueryOptions = <
  TData = Awaited<ReturnType<typeof getGmailThread>>,
  TError = ErrorType<void>,
>(
  threadId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGmailThread>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGmailThreadQueryKey(threadId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGmailThread>>> = ({
    signal,
  }) => getGmailThread(threadId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: threadId !== null && threadId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getGmailThread>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetGmailThreadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGmailThread>>
>;
export type GetGmailThreadQueryError = ErrorType<void>;

export function useGetGmailThread<
  TData = Awaited<ReturnType<typeof getGmailThread>>,
  TError = ErrorType<void>,
>(
  threadId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGmailThread>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetGmailThreadQueryOptions(threadId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getSetGmailThreadLabelsUrl = (threadId: number) => {
  return `/api/admin/dashboard/audience/gmail/threads/${threadId}/labels`;
};

export const setGmailThreadLabels = async (
  threadId: number,
  gmailThreadLabelsInput: GmailThreadLabelsInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailLabelsUpdated> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GmailLabelsUpdated>(getSetGmailThreadLabelsUrl(threadId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(gmailThreadLabelsInput),
  });
};

export const getSetGmailThreadLabelsMutationKey = () =>
  ["setGmailThreadLabels"] as const;

export const getSetGmailThreadLabelsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setGmailThreadLabels>>,
    TError,
    SetGmailThreadLabelsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setGmailThreadLabels>>,
  TError,
  SetGmailThreadLabelsMutationVariables,
  TContext
> => {
  const mutationKey = getSetGmailThreadLabelsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setGmailThreadLabels>>,
    SetGmailThreadLabelsMutationVariables
  > = (props) => {
    const { threadId, data } = props ?? {};

    return setGmailThreadLabels(threadId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetGmailThreadLabelsMutationResult = NonNullable<
  Awaited<ReturnType<typeof setGmailThreadLabels>>
>;
export type SetGmailThreadLabelsMutationBody = BodyType<GmailThreadLabelsInput>;
export type SetGmailThreadLabelsMutationError = ErrorType<void>;
export type SetGmailThreadLabelsMutationVariables = {
  threadId: number;
  data: BodyType<GmailThreadLabelsInput>;
};

export const useSetGmailThreadLabels = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setGmailThreadLabels>>,
    TError,
    SetGmailThreadLabelsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setGmailThreadLabels>>,
  TError,
  SetGmailThreadLabelsMutationVariables,
  TContext
> => {
  return useMutation(getSetGmailThreadLabelsMutationOptions(options));
};

export const getReplyGmailThreadUrl = (threadId: number) => {
  return `/api/admin/dashboard/audience/gmail/threads/${threadId}/reply`;
};

export const replyGmailThread = async (
  threadId: number,
  gmailReplyInput: GmailReplyInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<GmailReplyResult> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<GmailReplyResult>(getReplyGmailThreadUrl(threadId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(gmailReplyInput),
  });
};

export const getReplyGmailThreadMutationKey = () =>
  ["replyGmailThread"] as const;

export const getReplyGmailThreadMutationOptions = <
  TError = ErrorType<void | GmailMailboxBudgetPause>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replyGmailThread>>,
    TError,
    ReplyGmailThreadMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof replyGmailThread>>,
  TError,
  ReplyGmailThreadMutationVariables,
  TContext
> => {
  const mutationKey = getReplyGmailThreadMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof replyGmailThread>>,
    ReplyGmailThreadMutationVariables
  > = (props) => {
    const { threadId, data } = props ?? {};

    return replyGmailThread(threadId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReplyGmailThreadMutationResult = NonNullable<
  Awaited<ReturnType<typeof replyGmailThread>>
>;
export type ReplyGmailThreadMutationBody = BodyType<GmailReplyInput>;
export type ReplyGmailThreadMutationError =
  ErrorType<void | GmailMailboxBudgetPause>;
export type ReplyGmailThreadMutationVariables = {
  threadId: number;
  data: BodyType<GmailReplyInput>;
};

export const useReplyGmailThread = <
  TError = ErrorType<void | GmailMailboxBudgetPause>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof replyGmailThread>>,
    TError,
    ReplyGmailThreadMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof replyGmailThread>>,
  TError,
  ReplyGmailThreadMutationVariables,
  TContext
> => {
  return useMutation(getReplyGmailThreadMutationOptions(options));
};

export const getResolveGmailThreadReplyUrl = (
  threadId: number,
  replyRequestId: number,
) => {
  return `/api/admin/dashboard/audience/gmail/threads/${threadId}/replies/${replyRequestId}/resolve`;
};

/**
 * @summary Record an owner-admin review without sending email
 */
export const resolveGmailThreadReply = async (
  threadId: number,
  replyRequestId: number,
  gmailReplyResolutionInput: GmailReplyResolutionInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<ResolveGmailThreadReply200> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<ResolveGmailThreadReply200>(
    getResolveGmailThreadReplyUrl(threadId, replyRequestId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(gmailReplyResolutionInput),
    },
  );
};

export const getResolveGmailThreadReplyMutationKey = () =>
  ["resolveGmailThreadReply"] as const;

export const getResolveGmailThreadReplyMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveGmailThreadReply>>,
    TError,
    ResolveGmailThreadReplyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolveGmailThreadReply>>,
  TError,
  ResolveGmailThreadReplyMutationVariables,
  TContext
> => {
  const mutationKey = getResolveGmailThreadReplyMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolveGmailThreadReply>>,
    ResolveGmailThreadReplyMutationVariables
  > = (props) => {
    const { threadId, replyRequestId, data } = props ?? {};

    return resolveGmailThreadReply(
      threadId,
      replyRequestId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolveGmailThreadReplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolveGmailThreadReply>>
>;
export type ResolveGmailThreadReplyMutationBody =
  BodyType<GmailReplyResolutionInput>;
export type ResolveGmailThreadReplyMutationError = ErrorType<void>;
export type ResolveGmailThreadReplyMutationVariables = {
  threadId: number;
  replyRequestId: number;
  data: BodyType<GmailReplyResolutionInput>;
};

/**
 * @summary Record an owner-admin review without sending email
 */
export const useResolveGmailThreadReply = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveGmailThreadReply>>,
    TError,
    ResolveGmailThreadReplyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resolveGmailThreadReply>>,
  TError,
  ResolveGmailThreadReplyMutationVariables,
  TContext
> => {
  return useMutation(getResolveGmailThreadReplyMutationOptions(options));
};

export const getCompleteGmailConnectUrl = (
  params: CompleteGmailConnectParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/gmail/callback?${stringifiedParams}`
    : `/api/gmail/callback`;
};

export const completeGmailConnect = async (
  params: CompleteGmailConnectParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<unknown> => {
  return customFetch<unknown>(getCompleteGmailConnectUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCompleteGmailConnectQueryKey = (
  params?: CompleteGmailConnectParams,
) => {
  return [`/api/gmail/callback`, ...(params ? [params] : [])] as const;
};

export const getCompleteGmailConnectQueryOptions = <
  TData = Awaited<ReturnType<typeof completeGmailConnect>>,
  TError = ErrorType<void>,
>(
  params: CompleteGmailConnectParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof completeGmailConnect>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCompleteGmailConnectQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof completeGmailConnect>>
  > = ({ signal }) =>
    completeGmailConnect(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof completeGmailConnect>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CompleteGmailConnectQueryResult = NonNullable<
  Awaited<ReturnType<typeof completeGmailConnect>>
>;
export type CompleteGmailConnectQueryError = ErrorType<void>;

export function useCompleteGmailConnect<
  TData = Awaited<ReturnType<typeof completeGmailConnect>>,
  TError = ErrorType<void>,
>(
  params: CompleteGmailConnectParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof completeGmailConnect>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCompleteGmailConnectQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPreviewAudienceCampaignUrl = () => {
  return `/api/admin/dashboard/audience/campaigns/preview`;
};

export const previewAudienceCampaign = async (
  audienceCampaignPreviewInput: AudienceCampaignPreviewInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AudienceCampaignPreview> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AudienceCampaignPreview>(getPreviewAudienceCampaignUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(audienceCampaignPreviewInput),
  });
};

export const getPreviewAudienceCampaignMutationKey = () =>
  ["previewAudienceCampaign"] as const;

export const getPreviewAudienceCampaignMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAudienceCampaign>>,
    TError,
    PreviewAudienceCampaignMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewAudienceCampaign>>,
  TError,
  PreviewAudienceCampaignMutationVariables,
  TContext
> => {
  const mutationKey = getPreviewAudienceCampaignMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewAudienceCampaign>>,
    PreviewAudienceCampaignMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return previewAudienceCampaign(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewAudienceCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewAudienceCampaign>>
>;
export type PreviewAudienceCampaignMutationBody =
  BodyType<AudienceCampaignPreviewInput>;
export type PreviewAudienceCampaignMutationError = ErrorType<void>;
export type PreviewAudienceCampaignMutationVariables = {
  data: BodyType<AudienceCampaignPreviewInput>;
};

export const usePreviewAudienceCampaign = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAudienceCampaign>>,
    TError,
    PreviewAudienceCampaignMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewAudienceCampaign>>,
  TError,
  PreviewAudienceCampaignMutationVariables,
  TContext
> => {
  return useMutation(getPreviewAudienceCampaignMutationOptions(options));
};

export const getListAudienceCampaignsUrl = (
  params?: ListAudienceCampaignsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/dashboard/audience/campaigns?${stringifiedParams}`
    : `/api/admin/dashboard/audience/campaigns`;
};

export const listAudienceCampaigns = async (
  params?: ListAudienceCampaignsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<AudienceCampaignList> => {
  return customFetch<AudienceCampaignList>(
    getListAudienceCampaignsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListAudienceCampaignsQueryKey = (
  params?: ListAudienceCampaignsParams,
) => {
  return [
    `/api/admin/dashboard/audience/campaigns`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAudienceCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAudienceCampaigns>>,
  TError = ErrorType<void>,
>(
  params?: ListAudienceCampaignsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAudienceCampaigns>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAudienceCampaignsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAudienceCampaigns>>
  > = ({ signal }) =>
    listAudienceCampaigns(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAudienceCampaigns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAudienceCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAudienceCampaigns>>
>;
export type ListAudienceCampaignsQueryError = ErrorType<void>;

export function useListAudienceCampaigns<
  TData = Awaited<ReturnType<typeof listAudienceCampaigns>>,
  TError = ErrorType<void>,
>(
  params?: ListAudienceCampaignsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAudienceCampaigns>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAudienceCampaignsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCreateAudienceCampaignUrl = () => {
  return `/api/admin/dashboard/audience/campaigns`;
};

export const createAudienceCampaign = async (
  audienceCampaignSendInput: AudienceCampaignSendInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AudienceCampaignResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AudienceCampaignResponse>(getCreateAudienceCampaignUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(audienceCampaignSendInput),
  });
};

export const getCreateAudienceCampaignMutationKey = () =>
  ["createAudienceCampaign"] as const;

export const getCreateAudienceCampaignMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAudienceCampaign>>,
    TError,
    CreateAudienceCampaignMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAudienceCampaign>>,
  TError,
  CreateAudienceCampaignMutationVariables,
  TContext
> => {
  const mutationKey = getCreateAudienceCampaignMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAudienceCampaign>>,
    CreateAudienceCampaignMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createAudienceCampaign(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAudienceCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAudienceCampaign>>
>;
export type CreateAudienceCampaignMutationBody =
  BodyType<AudienceCampaignSendInput>;
export type CreateAudienceCampaignMutationError = ErrorType<void>;
export type CreateAudienceCampaignMutationVariables = {
  data: BodyType<AudienceCampaignSendInput>;
};

export const useCreateAudienceCampaign = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAudienceCampaign>>,
    TError,
    CreateAudienceCampaignMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAudienceCampaign>>,
  TError,
  CreateAudienceCampaignMutationVariables,
  TContext
> => {
  return useMutation(getCreateAudienceCampaignMutationOptions(options));
};

export const getCreateAudienceCampaignDraftUrl = () => {
  return `/api/admin/dashboard/audience/campaigns/drafts`;
};

export const createAudienceCampaignDraft = async (
  audienceCampaignDraftInput: AudienceCampaignDraftInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AudienceCampaignResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AudienceCampaignResponse>(
    getCreateAudienceCampaignDraftUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(audienceCampaignDraftInput),
    },
  );
};

export const getCreateAudienceCampaignDraftMutationKey = () =>
  ["createAudienceCampaignDraft"] as const;

export const getCreateAudienceCampaignDraftMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAudienceCampaignDraft>>,
    TError,
    CreateAudienceCampaignDraftMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAudienceCampaignDraft>>,
  TError,
  CreateAudienceCampaignDraftMutationVariables,
  TContext
> => {
  const mutationKey = getCreateAudienceCampaignDraftMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAudienceCampaignDraft>>,
    CreateAudienceCampaignDraftMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createAudienceCampaignDraft(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAudienceCampaignDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAudienceCampaignDraft>>
>;
export type CreateAudienceCampaignDraftMutationBody =
  BodyType<AudienceCampaignDraftInput>;
export type CreateAudienceCampaignDraftMutationError = ErrorType<void>;
export type CreateAudienceCampaignDraftMutationVariables = {
  data: BodyType<AudienceCampaignDraftInput>;
};

export const useCreateAudienceCampaignDraft = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAudienceCampaignDraft>>,
    TError,
    CreateAudienceCampaignDraftMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAudienceCampaignDraft>>,
  TError,
  CreateAudienceCampaignDraftMutationVariables,
  TContext
> => {
  return useMutation(getCreateAudienceCampaignDraftMutationOptions(options));
};

export const getGetAudienceCampaignUrl = (campaignId: number) => {
  return `/api/admin/dashboard/audience/campaigns/${campaignId}`;
};

export const getAudienceCampaign = async (
  campaignId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<AudienceCampaignDetail> => {
  return customFetch<AudienceCampaignDetail>(
    getGetAudienceCampaignUrl(campaignId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAudienceCampaignQueryKey = (campaignId: number) => {
  return [`/api/admin/dashboard/audience/campaigns/${campaignId}`] as const;
};

export const getGetAudienceCampaignQueryOptions = <
  TData = Awaited<ReturnType<typeof getAudienceCampaign>>,
  TError = ErrorType<void>,
>(
  campaignId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAudienceCampaign>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAudienceCampaignQueryKey(campaignId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAudienceCampaign>>
  > = ({ signal }) =>
    getAudienceCampaign(campaignId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: campaignId !== null && campaignId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAudienceCampaign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAudienceCampaignQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAudienceCampaign>>
>;
export type GetAudienceCampaignQueryError = ErrorType<void>;

export function useGetAudienceCampaign<
  TData = Awaited<ReturnType<typeof getAudienceCampaign>>,
  TError = ErrorType<void>,
>(
  campaignId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAudienceCampaign>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAudienceCampaignQueryOptions(campaignId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getUpdateAudienceCampaignDraftUrl = (campaignId: number) => {
  return `/api/admin/dashboard/audience/campaigns/${campaignId}/draft`;
};

export const updateAudienceCampaignDraft = async (
  campaignId: number,
  audienceCampaignDraftInput: AudienceCampaignDraftInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<AudienceCampaignResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AudienceCampaignResponse>(
    getUpdateAudienceCampaignDraftUrl(campaignId),
    {
      ...options,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(audienceCampaignDraftInput),
    },
  );
};

export const getUpdateAudienceCampaignDraftMutationKey = () =>
  ["updateAudienceCampaignDraft"] as const;

export const getUpdateAudienceCampaignDraftMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAudienceCampaignDraft>>,
    TError,
    UpdateAudienceCampaignDraftMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAudienceCampaignDraft>>,
  TError,
  UpdateAudienceCampaignDraftMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateAudienceCampaignDraftMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAudienceCampaignDraft>>,
    UpdateAudienceCampaignDraftMutationVariables
  > = (props) => {
    const { campaignId, data } = props ?? {};

    return updateAudienceCampaignDraft(campaignId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAudienceCampaignDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAudienceCampaignDraft>>
>;
export type UpdateAudienceCampaignDraftMutationBody =
  BodyType<AudienceCampaignDraftInput>;
export type UpdateAudienceCampaignDraftMutationError = ErrorType<void>;
export type UpdateAudienceCampaignDraftMutationVariables = {
  campaignId: number;
  data: BodyType<AudienceCampaignDraftInput>;
};

export const useUpdateAudienceCampaignDraft = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAudienceCampaignDraft>>,
    TError,
    UpdateAudienceCampaignDraftMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateAudienceCampaignDraft>>,
  TError,
  UpdateAudienceCampaignDraftMutationVariables,
  TContext
> => {
  return useMutation(getUpdateAudienceCampaignDraftMutationOptions(options));
};

export const getSendAudienceCampaignDraftUrl = (campaignId: number) => {
  return `/api/admin/dashboard/audience/campaigns/${campaignId}/send`;
};

export const sendAudienceCampaignDraft = async (
  campaignId: number,
  audienceCampaignConfirmation: AudienceCampaignConfirmation,
  options?: Parameters<typeof customFetch>[1],
): Promise<AudienceCampaignResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AudienceCampaignResponse>(
    getSendAudienceCampaignDraftUrl(campaignId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(audienceCampaignConfirmation),
    },
  );
};

export const getSendAudienceCampaignDraftMutationKey = () =>
  ["sendAudienceCampaignDraft"] as const;

export const getSendAudienceCampaignDraftMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendAudienceCampaignDraft>>,
    TError,
    SendAudienceCampaignDraftMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendAudienceCampaignDraft>>,
  TError,
  SendAudienceCampaignDraftMutationVariables,
  TContext
> => {
  const mutationKey = getSendAudienceCampaignDraftMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendAudienceCampaignDraft>>,
    SendAudienceCampaignDraftMutationVariables
  > = (props) => {
    const { campaignId, data } = props ?? {};

    return sendAudienceCampaignDraft(campaignId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendAudienceCampaignDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendAudienceCampaignDraft>>
>;
export type SendAudienceCampaignDraftMutationBody =
  BodyType<AudienceCampaignConfirmation>;
export type SendAudienceCampaignDraftMutationError = ErrorType<void>;
export type SendAudienceCampaignDraftMutationVariables = {
  campaignId: number;
  data: BodyType<AudienceCampaignConfirmation>;
};

export const useSendAudienceCampaignDraft = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendAudienceCampaignDraft>>,
    TError,
    SendAudienceCampaignDraftMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendAudienceCampaignDraft>>,
  TError,
  SendAudienceCampaignDraftMutationVariables,
  TContext
> => {
  return useMutation(getSendAudienceCampaignDraftMutationOptions(options));
};

export const getPreviewAudienceCampaignRetryUrl = (campaignId: number) => {
  return `/api/admin/dashboard/audience/campaigns/${campaignId}/retry/preview`;
};

export const previewAudienceCampaignRetry = async (
  campaignId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<AudienceCampaignPreview> => {
  return customFetch<AudienceCampaignPreview>(
    getPreviewAudienceCampaignRetryUrl(campaignId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPreviewAudienceCampaignRetryMutationKey = () =>
  ["previewAudienceCampaignRetry"] as const;

export const getPreviewAudienceCampaignRetryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAudienceCampaignRetry>>,
    TError,
    PreviewAudienceCampaignRetryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewAudienceCampaignRetry>>,
  TError,
  PreviewAudienceCampaignRetryMutationVariables,
  TContext
> => {
  const mutationKey = getPreviewAudienceCampaignRetryMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewAudienceCampaignRetry>>,
    PreviewAudienceCampaignRetryMutationVariables
  > = (props) => {
    const { campaignId } = props ?? {};

    return previewAudienceCampaignRetry(campaignId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewAudienceCampaignRetryMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewAudienceCampaignRetry>>
>;

export type PreviewAudienceCampaignRetryMutationError = ErrorType<void>;
export type PreviewAudienceCampaignRetryMutationVariables = {
  campaignId: number;
};

export const usePreviewAudienceCampaignRetry = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewAudienceCampaignRetry>>,
    TError,
    PreviewAudienceCampaignRetryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewAudienceCampaignRetry>>,
  TError,
  PreviewAudienceCampaignRetryMutationVariables,
  TContext
> => {
  return useMutation(getPreviewAudienceCampaignRetryMutationOptions(options));
};

export const getRetryAudienceCampaignUrl = (campaignId: number) => {
  return `/api/admin/dashboard/audience/campaigns/${campaignId}/retry`;
};

export const retryAudienceCampaign = async (
  campaignId: number,
  audienceCampaignConfirmation: AudienceCampaignConfirmation,
  options?: Parameters<typeof customFetch>[1],
): Promise<AudienceCampaignRetryResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AudienceCampaignRetryResponse>(
    getRetryAudienceCampaignUrl(campaignId),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(audienceCampaignConfirmation),
    },
  );
};

export const getRetryAudienceCampaignMutationKey = () =>
  ["retryAudienceCampaign"] as const;

export const getRetryAudienceCampaignMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryAudienceCampaign>>,
    TError,
    RetryAudienceCampaignMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryAudienceCampaign>>,
  TError,
  RetryAudienceCampaignMutationVariables,
  TContext
> => {
  const mutationKey = getRetryAudienceCampaignMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryAudienceCampaign>>,
    RetryAudienceCampaignMutationVariables
  > = (props) => {
    const { campaignId, data } = props ?? {};

    return retryAudienceCampaign(campaignId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryAudienceCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryAudienceCampaign>>
>;
export type RetryAudienceCampaignMutationBody =
  BodyType<AudienceCampaignConfirmation>;
export type RetryAudienceCampaignMutationError = ErrorType<void>;
export type RetryAudienceCampaignMutationVariables = {
  campaignId: number;
  data: BodyType<AudienceCampaignConfirmation>;
};

export const useRetryAudienceCampaign = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryAudienceCampaign>>,
    TError,
    RetryAudienceCampaignMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryAudienceCampaign>>,
  TError,
  RetryAudienceCampaignMutationVariables,
  TContext
> => {
  return useMutation(getRetryAudienceCampaignMutationOptions(options));
};

export const getStartResultDiscoveryUrl = () => {
  return `/api/discovery`;
};

export const startResultDiscovery = async (
  discoveryInput: DiscoveryInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<DiscoveryJob> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<DiscoveryJob>(getStartResultDiscoveryUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(discoveryInput),
  });
};

export const getStartResultDiscoveryMutationKey = () =>
  ["startResultDiscovery"] as const;

export const getStartResultDiscoveryMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startResultDiscovery>>,
    TError,
    StartResultDiscoveryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startResultDiscovery>>,
  TError,
  StartResultDiscoveryMutationVariables,
  TContext
> => {
  const mutationKey = getStartResultDiscoveryMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startResultDiscovery>>,
    StartResultDiscoveryMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return startResultDiscovery(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartResultDiscoveryMutationResult = NonNullable<
  Awaited<ReturnType<typeof startResultDiscovery>>
>;
export type StartResultDiscoveryMutationBody = BodyType<DiscoveryInput>;
export type StartResultDiscoveryMutationError = ErrorType<void>;
export type StartResultDiscoveryMutationVariables = {
  data: BodyType<DiscoveryInput>;
};

export const useStartResultDiscovery = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startResultDiscovery>>,
    TError,
    StartResultDiscoveryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startResultDiscovery>>,
  TError,
  StartResultDiscoveryMutationVariables,
  TContext
> => {
  return useMutation(getStartResultDiscoveryMutationOptions(options));
};

export const getWithdrawResultDiscoveryUrl = () => {
  return `/api/discovery`;
};

export const withdrawResultDiscovery = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getWithdrawResultDiscoveryUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getWithdrawResultDiscoveryMutationKey = () =>
  ["withdrawResultDiscovery"] as const;

export const getWithdrawResultDiscoveryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof withdrawResultDiscovery>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof withdrawResultDiscovery>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = getWithdrawResultDiscoveryMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof withdrawResultDiscovery>>,
    void
  > = () => {
    return withdrawResultDiscovery(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WithdrawResultDiscoveryMutationResult = NonNullable<
  Awaited<ReturnType<typeof withdrawResultDiscovery>>
>;

export type WithdrawResultDiscoveryMutationError = ErrorType<unknown>;

export const useWithdrawResultDiscovery = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof withdrawResultDiscovery>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof withdrawResultDiscovery>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getWithdrawResultDiscoveryMutationOptions(options));
};

export const getGetResultDiscoveryUrl = (id: string) => {
  return `/api/discovery/${id}`;
};

export const getResultDiscovery = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<DiscoveryJob> => {
  return customFetch<DiscoveryJob>(getGetResultDiscoveryUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetResultDiscoveryQueryKey = (id: string) => {
  return [`/api/discovery/${id}`] as const;
};

export const getGetResultDiscoveryQueryOptions = <
  TData = Awaited<ReturnType<typeof getResultDiscovery>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getResultDiscovery>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetResultDiscoveryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getResultDiscovery>>
  > = ({ signal }) => getResultDiscovery(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getResultDiscovery>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetResultDiscoveryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getResultDiscovery>>
>;
export type GetResultDiscoveryQueryError = ErrorType<void>;

export function useGetResultDiscovery<
  TData = Awaited<ReturnType<typeof getResultDiscovery>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getResultDiscovery>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetResultDiscoveryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCancelResultDiscoveryUrl = (id: string) => {
  return `/api/discovery/${id}`;
};

export const cancelResultDiscovery = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getCancelResultDiscoveryUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getCancelResultDiscoveryMutationKey = () =>
  ["cancelResultDiscovery"] as const;

export const getCancelResultDiscoveryMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelResultDiscovery>>,
    TError,
    CancelResultDiscoveryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelResultDiscovery>>,
  TError,
  CancelResultDiscoveryMutationVariables,
  TContext
> => {
  const mutationKey = getCancelResultDiscoveryMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelResultDiscovery>>,
    CancelResultDiscoveryMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return cancelResultDiscovery(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelResultDiscoveryMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelResultDiscovery>>
>;

export type CancelResultDiscoveryMutationError = ErrorType<unknown>;
export type CancelResultDiscoveryMutationVariables = { id: string };

export const useCancelResultDiscovery = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelResultDiscovery>>,
    TError,
    CancelResultDiscoveryMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelResultDiscovery>>,
  TError,
  CancelResultDiscoveryMutationVariables,
  TContext
> => {
  return useMutation(getCancelResultDiscoveryMutationOptions(options));
};

export const getListDiscoveryResearchUrl = () => {
  return `/api/admin/discovery`;
};

export const listDiscoveryResearch = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<DiscoveryResearch[]> => {
  return customFetch<DiscoveryResearch[]>(getListDiscoveryResearchUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListDiscoveryResearchQueryKey = () => {
  return [`/api/admin/discovery`] as const;
};

export const getListDiscoveryResearchQueryOptions = <
  TData = Awaited<ReturnType<typeof listDiscoveryResearch>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDiscoveryResearch>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDiscoveryResearchQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDiscoveryResearch>>
  > = ({ signal }) => listDiscoveryResearch({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDiscoveryResearch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDiscoveryResearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDiscoveryResearch>>
>;
export type ListDiscoveryResearchQueryError = ErrorType<unknown>;

export function useListDiscoveryResearch<
  TData = Awaited<ReturnType<typeof listDiscoveryResearch>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDiscoveryResearch>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDiscoveryResearchQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getReviewDiscoveryResearchUrl = () => {
  return `/api/admin/discovery`;
};

export const reviewDiscoveryResearch = async (
  discoveryReviewInput: DiscoveryReviewInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<void>(getReviewDiscoveryResearchUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(discoveryReviewInput),
  });
};

export const getReviewDiscoveryResearchMutationKey = () =>
  ["reviewDiscoveryResearch"] as const;

export const getReviewDiscoveryResearchMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviewDiscoveryResearch>>,
    TError,
    ReviewDiscoveryResearchMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reviewDiscoveryResearch>>,
  TError,
  ReviewDiscoveryResearchMutationVariables,
  TContext
> => {
  const mutationKey = getReviewDiscoveryResearchMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reviewDiscoveryResearch>>,
    ReviewDiscoveryResearchMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return reviewDiscoveryResearch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReviewDiscoveryResearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof reviewDiscoveryResearch>>
>;
export type ReviewDiscoveryResearchMutationBody =
  BodyType<DiscoveryReviewInput>;
export type ReviewDiscoveryResearchMutationError = ErrorType<void>;
export type ReviewDiscoveryResearchMutationVariables = {
  data: BodyType<DiscoveryReviewInput>;
};

export const useReviewDiscoveryResearch = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reviewDiscoveryResearch>>,
    TError,
    ReviewDiscoveryResearchMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reviewDiscoveryResearch>>,
  TError,
  ReviewDiscoveryResearchMutationVariables,
  TContext
> => {
  return useMutation(getReviewDiscoveryResearchMutationOptions(options));
};

export const getWithdrawDiscoveryResearchUrl = () => {
  return `/api/admin/discovery/withdraw`;
};

export const withdrawDiscoveryResearch = async (
  discoveryWithdrawalInput: DiscoveryWithdrawalInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<void>(getWithdrawDiscoveryResearchUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(discoveryWithdrawalInput),
  });
};

export const getWithdrawDiscoveryResearchMutationKey = () =>
  ["withdrawDiscoveryResearch"] as const;

export const getWithdrawDiscoveryResearchMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof withdrawDiscoveryResearch>>,
    TError,
    WithdrawDiscoveryResearchMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof withdrawDiscoveryResearch>>,
  TError,
  WithdrawDiscoveryResearchMutationVariables,
  TContext
> => {
  const mutationKey = getWithdrawDiscoveryResearchMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof withdrawDiscoveryResearch>>,
    WithdrawDiscoveryResearchMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return withdrawDiscoveryResearch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WithdrawDiscoveryResearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof withdrawDiscoveryResearch>>
>;
export type WithdrawDiscoveryResearchMutationBody =
  BodyType<DiscoveryWithdrawalInput>;
export type WithdrawDiscoveryResearchMutationError = ErrorType<void>;
export type WithdrawDiscoveryResearchMutationVariables = {
  data: BodyType<DiscoveryWithdrawalInput>;
};

export const useWithdrawDiscoveryResearch = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof withdrawDiscoveryResearch>>,
    TError,
    WithdrawDiscoveryResearchMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof withdrawDiscoveryResearch>>,
  TError,
  WithdrawDiscoveryResearchMutationVariables,
  TContext
> => {
  return useMutation(getWithdrawDiscoveryResearchMutationOptions(options));
};

export const getImportDiscoveryResearchUrl = () => {
  return `/api/admin/discovery/import`;
};

export const importDiscoveryResearch = async (
  discoveryResearchImport: DiscoveryResearchImport,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<void>(getImportDiscoveryResearchUrl(), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers),
    },
    body: JSON.stringify(discoveryResearchImport),
  });
};

export const getImportDiscoveryResearchMutationKey = () =>
  ["importDiscoveryResearch"] as const;

export const getImportDiscoveryResearchMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importDiscoveryResearch>>,
    TError,
    ImportDiscoveryResearchMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importDiscoveryResearch>>,
  TError,
  ImportDiscoveryResearchMutationVariables,
  TContext
> => {
  const mutationKey = getImportDiscoveryResearchMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importDiscoveryResearch>>,
    ImportDiscoveryResearchMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return importDiscoveryResearch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportDiscoveryResearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof importDiscoveryResearch>>
>;
export type ImportDiscoveryResearchMutationBody =
  BodyType<DiscoveryResearchImport>;
export type ImportDiscoveryResearchMutationError = ErrorType<void>;
export type ImportDiscoveryResearchMutationVariables = {
  data: BodyType<DiscoveryResearchImport>;
};

export const useImportDiscoveryResearch = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importDiscoveryResearch>>,
    TError,
    ImportDiscoveryResearchMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof importDiscoveryResearch>>,
  TError,
  ImportDiscoveryResearchMutationVariables,
  TContext
> => {
  return useMutation(getImportDiscoveryResearchMutationOptions(options));
};
